import { MDBDataTable } from 'mdbreact'
import React, { Component } from 'react'
import '../CSS/Table.css'

class SearchTable extends Component {
  constructor (props) {
    super(props)

    this.data = {

      columns: [
        {
          label: 'Title',
          field: 'title',
          sort: 'asc',
          width: 300
        },
        {
          label: 'Topic',
          field: 'topic',
          sort: 'asc',
          width: 150
        },
        {
          label: 'Year',
          field: 'year',
          sort: 'asc',
          width: 100
        },
        {
          label: 'Intensity',
          field: 'intensity',
          sort: 'asc',
          width: 150
        },
        {
          label: 'Sector',
          field: 'sector',
          sort: 'asc',
          width: 150
        },
        {
          label: 'Region',
          field: 'region',
          sort: 'asc',
          width: 150
        },
        {
          label: 'Pestle',
          field: 'pestle',
          sort: 'asc',
          width: 150
        }
      ],

      rows: [
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'gas',
          insight: 'Annual Energy Outlook',
          url: 'http://www.eia.gov/outlooks/aeo/pdf/0383(2017).pdf',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'January, 20 2017 03:51:25',
          published: 'January, 09 2017 00:00:00',
          country: 'United States of America',
          relevance: 2,
          pestle: 'Industries',
          source: 'EIA',
          title: 'U.S. natural gas consumption is expected to increase during much of the projection period.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Annual Energy Outlook',
          url: 'http://www.eia.gov/outlooks/aeo/pdf/0383(2017).pdf',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'January, 20 2017 03:51:24',
          published: 'January, 09 2017 00:00:00',
          country: 'United States of America',
          relevance: 2,
          pestle: 'Industries',
          source: 'EIA',
          title: 'Reference case U.S. crude oil production is projected to recover from recent declines.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'consumption',
          insight: 'Annual Energy Outlook',
          url: 'http://www.eia.gov/outlooks/aeo/pdf/0383(2017).pdf',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'January, 20 2017 03:51:23',
          published: 'January, 09 2017 00:00:00',
          country: 'United States of America',
          relevance: 2,
          pestle: 'Industries',
          source: 'EIA',
          title: 'U.S. petroleum consumption is projected to remain below the 2005 level.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Environment',
          topic: 'oil',
          insight: 'WRI Partnership Aims to Foster Supply Chain Transparency, Zero-Deforestation Strategies',
          url: 'http://www.sustainablebrands.com/news_and_views/supply_chain/sustainable_brands/wri_partnership_aims_foster_supply_chain_transparency',
          region: 'Central America',
          start_year: '',
          impact: '',
          added: 'January, 20 2017 03:26:40',
          published: 'January, 18 2017 00:00:00',
          country: 'Mexico',
          relevance: 3,
          pestle: 'Environmental',
          source: 'sustainablebrands.com',
          title: 'Mars, Unilever, Cargill and Mondelēz are already using GFW Commodities to assess deforestation risks in their palm oil, soy and cocoa supply chains across a collective area of land the size of Mexico.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: '',
          topic: 'market',
          insight: 'N-Hexane Market Hit at a CAGR of 5% by 2024 - PMR Report',
          url: 'http://www.sbwire.com/press-releases/n-hexane-market-hit-at-a-cagr-of-5-by-2024-pmr-report-761520.htm',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'January, 19 2017 00:55:54',
          published: 'January, 18 2017 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'SBWire',
          title: 'Polymerization will remain top 3 end-users in global n-Hexane Market.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'N-Hexane Market Hit at a CAGR of 5% by 2024 - PMR Report',
          url: 'http://www.sbwire.com/press-releases/n-hexane-market-hit-at-a-cagr-of-5-by-2024-pmr-report-761520.htm',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'January, 19 2017 00:55:52',
          published: 'January, 18 2017 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'SBWire',
          title: 'High demand for n-Hexane in oil extraction owing to its effectiveness and high yield is expected to propel the global n-Hexane Market.',
          likelihood: 3
        },
        {
          end_year: 2027,
          intensity: 60,
          sector: 'Government',
          topic: 'market',
          insight: 'E-Boats, Anyone? Electric Boat Market To Reach $20 Billion By 2027, According To New Study',
          url: 'https://cleantechnica.com/2017/01/12/e-boats-anyone-electric-boat-market-reach-20b-2027-according-new-study/',
          region: '',
          start_year: '',
          impact: 3,
          added: 'January, 18 2017 02:23:13',
          published: 'January, 13 2017 00:00:00',
          country: '',
          relevance: 5,
          pestle: 'Political',
          source: 'CleanTechnica',
          title: 'The market for non-military electric watercraft and marine motors will balloon to over $20 billion worldwide by 2027.',
          likelihood: 4
        },
        {
          end_year: 2018,
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Oil prices will be much more volatile in 2017',
          url: 'http://www.news.tracanada.ca/2017/01/16/oil-prices-will-be-much-more-volatile-in-2017/',
          region: 'World',
          start_year: 2017,
          impact: '',
          added: 'January, 17 2017 04:19:59',
          published: 'January, 16 2017 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'TRAC News',
          title: 'Global oil prices will witness much more volatility in 2017 even though markets may rebalance in the first half of the year if output cuts pledged by producers are implemented.',
          likelihood: 4
        },
        {
          end_year: 2018,
          intensity: 16,
          sector: '',
          topic: 'gdp',
          insight: "IMF affirms Nigeria's recovery from recession, with 0.8% growth forecast",
          url: 'http://www.vanguardngr.com/2017/01/imf-affirms-nigerias-recovery-recession-0-8-growth-forecast/',
          region: 'Western Africa',
          start_year: 2017,
          impact: '',
          added: 'January, 17 2017 03:25:45',
          published: 'January, 16 2017 00:00:00',
          country: 'Nigeria',
          relevance: 4,
          pestle: 'Economic',
          source: 'Vanguard News',
          title: 'Nigeria Gross Domestic Product will grow by 0.8 percent in 2017 and 2.3 percent in 2018.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Aerospace & defence',
          topic: 'war',
          insight: 'Lebanon: No Land for Beginning Politicians',
          url: 'https://www.avimelamed.com/2017/01/07/lebanon-no-land-for-beginning-politicians/',
          region: 'Western Asia',
          start_year: '',
          impact: '',
          added: 'January, 17 2017 03:18:22',
          published: 'January, 07 2017 00:00:00',
          country: 'Lebanon',
          relevance: 2,
          pestle: 'Political',
          source: 'Avi Melamed',
          title: 'A war in Lebanon will increase the already heavy economic burden Saudi Arabia is carrying.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Manufacturing',
          topic: 'production',
          insight: 'The Slow Road Back: Oil & Gas Industry Outlook for 2017',
          url: 'http://deloitte.wsj.com/riskandcompliance/2017/01/10/the-slow-road-back-oil-gas-industry-outlook-for-2017/',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'January, 17 2017 02:21:11',
          published: '',
          country: 'United States of America',
          relevance: 2,
          pestle: 'Industries',
          source: 'WSJ',
          title: 'U.S. production could begin to ramp back up following the rig count upturn.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Retail',
          topic: 'export',
          insight: 'The Slow Road Back: Oil & Gas Industry Outlook for 2017',
          url: 'http://deloitte.wsj.com/riskandcompliance/2017/01/10/the-slow-road-back-oil-gas-industry-outlook-for-2017/',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'January, 17 2017 02:21:10',
          published: '',
          country: 'United States of America',
          relevance: 2,
          pestle: 'Economic',
          source: 'WSJ',
          title: 'More U.S. LNG (liquified natural gas) export capacity is expected to hit the market.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'NM oil patch outlook',
          url: 'https://www.abqjournal.com/928238/nm-oil-patch-outlook.html',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'January, 17 2017 01:51:12',
          published: 'January, 16 2017 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'Abq',
          title: '2017 could be another record-breaking year in oil production.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'NM oil patch outlook',
          url: 'https://www.abqjournal.com/928238/nm-oil-patch-outlook.html',
          region: '',
          start_year: '',
          impact: '',
          added: 'January, 17 2017 01:51:10',
          published: 'January, 16 2017 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'Abq',
          title: 'Oil prices could climb above $60 quite rapidly.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'OPEC sees market stability in 2017, Venezuela aims for $70 price',
          url: 'http://www.reuters.com/article/us-venezuela-opec-idUSKBN1502JJ',
          region: 'Eastern Europe',
          start_year: '',
          impact: '',
          added: 'January, 17 2017 01:17:33',
          published: 'January, 17 2017 00:00:00',
          country: 'Russia',
          relevance: 3,
          pestle: 'Industries',
          source: 'Reuters',
          title: 'OPEC, Russia and other non-members of the producer group will curtail oil output by nearly 1.8 million bpd.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: "Cargill's quest for fish food grows, enriching canola in Montana and growing protein in tank",
          url: 'http://www.startribune.com/cargill-s-quest-for-fish-food-grows-enriching-canola-in-montana-and-growing-protein-in-tank/410681245/',
          region: 'World',
          start_year: 2019,
          impact: '',
          added: 'January, 17 2017 00:55:16',
          published: 'January, 14 2017 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'Star Tribune',
          title: "Industry demand for fish oil will bypass the world's fish oil supply in 2019.",
          likelihood: 4
        },
        {
          end_year: 2025,
          intensity: 9,
          sector: 'Energy',
          topic: 'battery',
          insight: 'How Electric Trucks Will Shape The Auto Transport Industry',
          url: 'http://evobsession.com/electric-trucks-will-shape-auto-transport-industry/',
          region: '',
          start_year: '',
          impact: '',
          added: 'January, 16 2017 05:54:47',
          published: 'January, 10 2017 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Technological',
          source: 'EV Obsession',
          title: 'Experts predict the costs of replacing electric batteries will decrease by 2.5x by 2025.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Financial services',
          topic: '',
          insight: 'Energy Roundup',
          url: 'http://newsletters.creamermedia.co.za/p/m/s/twitter/7XjRADu9PZG2CxYa/eFHTX9e0XGozciPE/',
          region: 'World',
          start_year: 2017,
          impact: '',
          added: 'January, 16 2017 03:42:24',
          published: '',
          country: '',
          relevance: 4,
          pestle: '',
          source: 'creamermedia',
          title: 'The global investment cycle will show the first signs of growth in 2017, since 2014, as confidence the oil and gas sector will start to return, with exploration and production spend set to rise by 3% to $450-billion.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Aerospace & defence',
          topic: 'biofuel',
          insight: 'The Peak Oil President?',
          url: 'http://www.resilience.org/stories/2017-01-11/the-peak-oil-president/',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'January, 16 2017 02:25:00',
          published: 'January, 11 2017 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Political',
          source: 'Resilience',
          title: 'While in the past decade downturns in output from old oilfields were replaced with new production enabling steady overall conventional oil supplies, replacement of production is much more doubtful in the immediate years ahead.',
          likelihood: 2
        },
        {
          end_year: 2040,
          intensity: 8,
          sector: 'Energy',
          topic: 'oil',
          insight: 'The Peak Oil President?',
          url: 'http://www.resilience.org/stories/2017-01-11/the-peak-oil-president/',
          region: 'Western Asia',
          start_year: '',
          impact: '',
          added: 'January, 16 2017 02:24:59',
          published: 'January, 11 2017 00:00:00',
          country: 'Saudi Arabia',
          relevance: 4,
          pestle: 'Industries',
          source: 'Resilience',
          title: 'By 2040, the world could need to replace over 4 times the current crude oil output of Saudi Arabia (or more than 40 mbd).',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 8,
          sector: 'Financial services',
          topic: 'policy',
          insight: 'World Bank Forecasts Nigeria To Exit Recession In 2017',
          url: 'https://www.thenews.ng/2017/01/world-bank-forecasts-nigeria-to-exit-recession-in-2017/',
          region: 'Central Africa',
          start_year: '',
          impact: '',
          added: 'January, 15 2017 05:21:39',
          published: 'January, 13 2017 00:00:00',
          country: 'Angola',
          relevance: 2,
          pestle: 'Economic',
          source: 'TheNews.NG',
          title: 'Angola is projected to expand at a moderate 1.2 percent pace as high inflation and tight policy continue to weigh on consumption and investment.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: '',
          topic: 'economy',
          insight: 'World Bank Forecasts Nigeria To Exit Recession In 2017',
          url: 'https://www.thenews.ng/2017/01/world-bank-forecasts-nigeria-to-exit-recession-in-2017/',
          region: 'World',
          start_year: 2017,
          impact: '',
          added: 'January, 15 2017 05:21:36',
          published: 'January, 13 2017 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'TheNews.NG',
          title: 'The global economy will accelerate moderately to 2.7 percent in 2017.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Support services',
          topic: 'market',
          insight: 'Paris department stores expect rebound in 2017, growth forecast for luxury markets',
          url: 'http://za.fashionnetwork.com/news/Paris-department-stores-expect-rebound-in-2017-growth-forecast-for-luxury-markets,779908.html',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'January, 15 2017 04:36:06',
          published: 'January, 13 2017 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'FashionNetwork.com',
          title: 'Analysts at Exane BNP Paribas for their part are expecting a rise in demand on the main luxury goods markets in 2017.',
          likelihood: 4
        },
        {
          end_year: 2200,
          intensity: 24,
          sector: '',
          topic: 'strategy',
          insight: 'Goldman Sachs Maps Out Its Top Ten Market Themes for 2017',
          url: 'https://www.bloomberg.com/news/articles/2016-11-17/goldman-sachs-maps-out-its-top-ten-market-themes-for-2017',
          region: 'Northern America',
          start_year: 2017,
          impact: '',
          added: 'January, 15 2017 03:50:31',
          published: '',
          country: 'United States of America',
          relevance: 6,
          pestle: 'Organization',
          source: 'Bloomberg Business',
          title: 'Expect that modest improvements in the macroeconomic backdrop will help lift S&P 500 operating EPS by 10 percent to $116 and they have a year-end S&P 500 target of 2200.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Key events for 2017; Global growth conditions continue to improve ,',
          url: 'https://www.yesbank.in/pdf/monthly_market_presentation_january_2017',
          region: 'World',
          start_year: 2017,
          impact: '',
          added: 'January, 15 2017 03:07:03',
          published: 'January, 12 2017 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'Yes Bank',
          title: 'Oil prices in 2017 will be a function of producers sticking to the production cuts and recovery in global demand conditions.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Key events for 2017; Global growth conditions continue to improve ,',
          url: 'https://www.yesbank.in/pdf/monthly_market_presentation_january_2017',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'January, 15 2017 03:07:02',
          published: 'January, 12 2017 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'Yes Bank',
          title: 'The rise in crude oil prices will play a key role in shaping global inflation dynamics.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'gas',
          insight: 'Egypt Petroleum Show (EGYPS 2017)',
          url: 'http://www.egyps.com/media/530316/egyps-show-preview-online-8117.pdf',
          region: 'Northern Africa',
          start_year: '',
          impact: '',
          added: 'January, 15 2017 03:06:36',
          published: 'January, 08 2017 00:00:00',
          country: 'Egypt',
          relevance: 2,
          pestle: 'Economic',
          source: 'EGYPS',
          title: "The future success of the transformation of Egypt's oil and gas industry will further be related to the diversification of energy resources and liberalisation of the North Africa region's energy markets.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'gas',
          insight: 'US Dollar: Will It Impact Natural Gas Prices?',
          url: 'http://marketrealist.com/2017/01/us-dollar-will-impact-natural-gas-prices/',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'January, 15 2017 02:41:44',
          published: 'January, 12 2017 00:00:00',
          country: 'United States of America',
          relevance: 3,
          pestle: 'Industries',
          source: 'marketrealist',
          title: "Natural gas prices could develop a relationship with the US Dollar Index that's similar to the relationship between crude oil and the US Dollar Index.",
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: '',
          topic: 'market',
          insight: 'US dollar moves dominated Sterling during the European session on Thursday.',
          url: 'https://www.pdqfx.com/latest-news/13-01-2017',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'January, 15 2017 02:40:46',
          published: '',
          country: '',
          relevance: 2,
          pestle: 'Political',
          source: 'PDQFX news',
          title: 'Brexit fears and global market trends will tend to dominate in the short term.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 72,
          sector: 'Information Technology',
          topic: 'robot',
          insight: '21 research reports forecast double-digit growth for robotics industry',
          url: 'https://www.therobotreport.com/news/21-research-reports-forecast-double-digit-growth-for-robotics-industry',
          region: 'World',
          start_year: 2022,
          impact: 3,
          added: 'January, 14 2017 03:35:43',
          published: 'September, 01 2017 00:00:00',
          country: '',
          relevance: 6,
          pestle: 'Economic',
          source: 'therobotreport',
          title: 'Global logistics robots market is expected to grow to around $11.18 billion in 2022.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'World economic forecasts are for US to double growth to about 3.6% per year and China to gradually slow from 6.7 to 6.1%',
          url: 'http://www.nextbigfuture.com/2017/01/world-economic-forecasts-are-for-us-to.html',
          region: '',
          start_year: '',
          impact: '',
          added: 'January, 14 2017 03:29:12',
          published: 'January, 11 2017 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'nextbigfuture',
          title: 'orld trade volumes are seen rising 3.6% this year, followed by 4.0% in 2018, and crude oil prices are expected to average $55 per barrel.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Global Growth Edges Up to 2.7 Percent Despite Weak Investment',
          url: 'http://www.worldbank.org/en/news/press-release/2017/01/10/global-growth-edges-up-to-2-7-percent-despite-weak-investment',
          region: 'Southern Africa',
          start_year: '',
          impact: '',
          added: 'January, 13 2017 03:59:33',
          published: 'January, 10 2017 00:00:00',
          country: 'South Africa',
          relevance: 2,
          pestle: 'Economic',
          source: 'World Bank',
          title: 'Growth in South Africa and oil exporters is expected to be weaker.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 16,
          sector: '',
          topic: 'growth',
          insight: 'Global Growth Edges Up to 2.7 Percent Despite Weak Investment',
          url: 'http://www.worldbank.org/en/news/press-release/2017/01/10/global-growth-edges-up-to-2-7-percent-despite-weak-investment',
          region: 'Southern Asia',
          start_year: 2017,
          impact: '',
          added: 'January, 13 2017 03:59:31',
          published: 'January, 10 2017 00:00:00',
          country: 'India',
          relevance: 4,
          pestle: 'Economic',
          source: 'World Bank',
          title: 'South Asia: Regional growth is expected to pick up modestly to 7.1 percent in 2017 with continued support from strong growth in India.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: '',
          topic: 'growth',
          insight: 'Global Growth Edges Up to 2.7 Percent Despite Weak Investment',
          url: 'http://www.worldbank.org/en/news/press-release/2017/01/10/global-growth-edges-up-to-2-7-percent-despite-weak-investment',
          region: 'Western Asia',
          start_year: 2017,
          impact: '',
          added: 'January, 13 2017 03:59:30',
          published: 'January, 10 2017 00:00:00',
          country: 'Saudi Arabia',
          relevance: 4,
          pestle: 'Economic',
          source: 'World Bank',
          title: 'Saudi Arabia is forecast to accelerate modestly to a 1.6 percent growth rate in 2017.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 8,
          sector: '',
          topic: 'growth',
          insight: 'Global Growth Edges Up to 2.7 Percent Despite Weak Investment',
          url: 'http://www.worldbank.org/en/news/press-release/2017/01/10/global-growth-edges-up-to-2-7-percent-despite-weak-investment',
          region: 'Eastern Europe',
          start_year: '',
          impact: '',
          added: 'January, 13 2017 03:59:27',
          published: 'January, 10 2017 00:00:00',
          country: 'Ukraine',
          relevance: 2,
          pestle: 'Economic',
          source: 'World Bank',
          title: 'Growth in Ukraine is projected to accelerate to a 2 percent rate.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 8,
          sector: '',
          topic: 'economic',
          insight: 'Global Growth Edges Up to 2.7 Percent Despite Weak Investment',
          url: 'http://www.worldbank.org/en/news/press-release/2017/01/10/global-growth-edges-up-to-2-7-percent-despite-weak-investment',
          region: 'Central Asia',
          start_year: '',
          impact: '',
          added: 'January, 13 2017 03:59:27',
          published: 'January, 10 2017 00:00:00',
          country: 'Azerbaijan',
          relevance: 2,
          pestle: 'Economic',
          source: 'World Bank',
          title: 'Azerbaijan is expected to expand 1.2 percent and Kazakhstan is anticipated to grow by 2.2 percent as commodity prices stabilize and as economic imbalances narrow.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'energy',
          insight: '2017: The Year When The World Economy Starts Coming Apart',
          url: 'http://www.zerohedge.com/news/2017-01-11/2017-year-when-world-economy-starts-coming-apart',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'January, 13 2017 02:05:53',
          published: 'January, 11 2017 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'Zero Hedge',
          title: 'Shrinking energy consumption per capita puts the world (or individual countries in the world) at the risk of recession.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 12,
          sector: '',
          topic: '',
          insight: 'Oil Gains - Pares Earlier Losses off Newfound Optimism',
          url: 'http://www.rigzone.com/news/oil_gas/a/148078/Oil_Gains_Pares_Earlier_Losses_off_Newfound_Optimism',
          region: 'World',
          start_year: 2017,
          impact: '',
          added: 'January, 13 2017 01:23:24',
          published: 'January, 11 2017 00:00:00',
          country: '',
          relevance: 3,
          pestle: '',
          source: 'Rigzone',
          title: 'Not until mid- 1Q of 2017 will there be definitive signs regarding whether the coordinated output cut of 1.8 million barrels per day is actually winnowing down global supply.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 18,
          sector: 'Healthcare',
          topic: 'oil',
          insight: 'Does Nutella Cause Cancer? Beloved Chocolate Spread Has Potentially Carcinogenic Contaminant, European Food Safety Authority Warns',
          url: 'http://www.ibtimes.com/does-nutella-cause-cancer-beloved-chocolate-spread-has-potentially-carcinogenic-2474146',
          region: '',
          start_year: '',
          impact: 3,
          added: 'January, 12 2017 03:21:59',
          published: 'January, 11 2017 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Healthcare',
          source: 'International Business Times',
          title: 'The debate over potential risks comes as European officials are pressuring the $44 billion palm oil industry to list edible oil as a cancer risk.',
          likelihood: 2
        },
        {
          end_year: 2018,
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Press Room',
          url: 'http://www.eia.gov/radio/',
          region: 'Northern America',
          start_year: 2017,
          impact: '',
          added: 'January, 12 2017 01:42:10',
          published: 'January, 11 2017 00:00:00',
          country: 'United States of America',
          relevance: 4,
          pestle: 'Industries',
          source: 'DOE EIA 2013 Energy Conference',
          title: 'U.S. crude oil production next year is expected to top 7 million barrels per day for the first time since 1992.',
          likelihood: 4
        },
        {
          end_year: 2019,
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Press Room',
          url: 'http://www.eia.gov/radio/',
          region: 'Northern America',
          start_year: 2017,
          impact: '',
          added: 'January, 12 2017 01:42:08',
          published: 'January, 11 2017 00:00:00',
          country: 'United States of America',
          relevance: 4,
          pestle: 'Industries',
          source: 'DOE EIA 2013 Energy Conference',
          title: 'The current wide price gap between a key U.S. and a world benchmark crude oil is expected to narrow significantly over the next two years.',
          likelihood: 4
        },
        {
          end_year: 2019,
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Press Room',
          url: 'http://www.eia.gov/radio/',
          region: 'Northern America',
          start_year: 2017,
          impact: '',
          added: 'January, 12 2017 01:42:08',
          published: 'January, 11 2017 00:00:00',
          country: 'United States of America',
          relevance: 4,
          pestle: 'Industries',
          source: 'DOE EIA 2013 Energy Conference',
          title: 'U.S. crude oil production is expected to keep rising over the next two years.',
          likelihood: 4
        },
        {
          end_year: 2019,
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Press Room',
          url: 'http://www.eia.gov/radio/',
          region: 'Northern America',
          start_year: 2017,
          impact: '',
          added: 'January, 12 2017 01:42:07',
          published: 'January, 11 2017 00:00:00',
          country: 'United States of America',
          relevance: 4,
          pestle: 'Industries',
          source: 'DOE EIA 2013 Energy Conference',
          title: 'The United States will need fewer oil imports over the next two years because of rising U.S. oil production.',
          likelihood: 4
        },
        {
          end_year: 2018,
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Press Room',
          url: 'http://www.eia.gov/radio/',
          region: 'Northern America',
          start_year: 2017,
          impact: '',
          added: 'January, 12 2017 01:42:05',
          published: 'January, 11 2017 00:00:00',
          country: 'United States of America',
          relevance: 4,
          pestle: 'Economic',
          source: 'DOE EIA 2013 Energy Conference',
          title: 'The United States will rely less on imports of crude oil and petroleum products to meet domestic demand next year.',
          likelihood: 4
        },
        {
          end_year: 2019,
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Press Room',
          url: 'http://www.eia.gov/radio/',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'January, 12 2017 01:42:02',
          published: 'January, 11 2017 00:00:00',
          country: 'United States of America',
          relevance: 4,
          pestle: 'Industries',
          source: 'DOE EIA 2013 Energy Conference',
          title: 'U.S. crude oil production over the next two years is expected to grow to its highest level since the early 1970s.',
          likelihood: 4
        },
        {
          end_year: 2019,
          intensity: 20,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Press Room',
          url: 'http://www.eia.gov/radio/',
          region: 'Northern America',
          start_year: 2017,
          impact: '',
          added: 'January, 12 2017 01:42:01',
          published: 'January, 11 2017 00:00:00',
          country: 'United States of America',
          relevance: 5,
          pestle: 'Economic',
          source: 'DOE EIA 2013 Energy Conference',
          title: 'Rising U.S. crude oil production will help non-OPEC supply growth exceed global demand growth for the next two years.',
          likelihood: 4
        },
        {
          end_year: 2020,
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Press Room',
          url: 'http://www.eia.gov/radio/',
          region: 'Northern America',
          start_year: 2017,
          impact: '',
          added: 'January, 12 2017 01:42:00',
          published: 'January, 11 2017 00:00:00',
          country: 'United States of America',
          relevance: 4,
          pestle: 'Industries',
          source: 'DOE EIA 2013 Energy Conference',
          title: 'U.S. production of tight crude oil is expected to make up a larger share of total U.S. oil output in the years ahead.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Press Room',
          url: 'http://www.eia.gov/radio/',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'January, 12 2017 01:41:55',
          published: 'January, 11 2017 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'DOE EIA 2013 Energy Conference',
          title: 'Global oil production is expected to continue to exceed oil demand.',
          likelihood: 3
        },
        {
          end_year: 2018,
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Press Room',
          url: 'http://www.eia.gov/radio/',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'January, 12 2017 01:41:54',
          published: 'January, 11 2017 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'DOE EIA 2013 Energy Conference',
          title: 'Growing domestic U.S. oil production has contributed to a significant decline in petroleum liquid imports and is expected to average 9.5 million barrels per day next year.',
          likelihood: 4
        },
        {
          end_year: 2019,
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Press Room',
          url: 'http://www.eia.gov/radio/',
          region: 'Northern America',
          start_year: 2017,
          impact: '',
          added: 'January, 12 2017 01:41:54',
          published: 'January, 11 2017 00:00:00',
          country: 'United States of America',
          relevance: 4,
          pestle: 'Industries',
          source: 'DOE EIA 2013 Energy Conference',
          title: "High U.S. crude oil production will help further reduce America's reliance on oil imports during the next two years.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Press Room',
          url: 'http://www.eia.gov/radio/',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'January, 12 2017 01:41:52',
          published: 'January, 11 2017 00:00:00',
          country: 'United States of America',
          relevance: 2,
          pestle: 'Industries',
          source: 'DOE EIA 2013 Energy Conference',
          title: 'U.S. commercial crude oil inventories which are already at the highest level since 1930 are expected to continue growing over the next two months.',
          likelihood: 3
        },
        {
          end_year: 2018,
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Press Room',
          url: 'http://www.eia.gov/radio/',
          region: '',
          start_year: '',
          impact: '',
          added: 'January, 12 2017 01:41:50',
          published: 'January, 11 2017 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'DOE EIA 2013 Energy Conference',
          title: 'Oil production is expected to be about the same next year as in 2015.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Press Room',
          url: 'http://www.eia.gov/radio/',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'January, 12 2017 01:41:47',
          published: 'January, 11 2017 00:00:00',
          country: 'United States of America',
          relevance: 2,
          pestle: 'Industries',
          source: 'DOE EIA 2013 Energy Conference',
          title: 'U.S. crude oil production has been more resilient to lower oil prices since mid-2014 than many had expected.',
          likelihood: 3
        },
        {
          end_year: 2018,
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Press Room',
          url: 'http://www.eia.gov/radio/',
          region: 'Northern America',
          start_year: 2017,
          impact: '',
          added: 'January, 12 2017 01:41:43',
          published: 'January, 11 2017 00:00:00',
          country: 'United States of America',
          relevance: 4,
          pestle: 'Industries',
          source: 'DOE EIA 2013 Energy Conference',
          title: 'U.S. monthly crude oil production is expected to decline through the middle of next year in response to low prices.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 8,
          sector: '',
          topic: '',
          insight: 'Press Room',
          url: 'http://www.eia.gov/radio/',
          region: '',
          start_year: '',
          impact: '',
          added: 'January, 12 2017 01:41:41',
          published: 'January, 11 2017 00:00:00',
          country: '',
          relevance: 2,
          pestle: '',
          source: 'DOE EIA 2013 Energy Conference',
          title: 'U.S. households that rely on electric heat will see their average bill decline by about $30.',
          likelihood: 4
        },
        {
          end_year: 2018,
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Press Room',
          url: 'http://www.eia.gov/radio/',
          region: '',
          start_year: '',
          impact: '',
          added: 'January, 12 2017 01:41:36',
          published: 'January, 11 2017 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'DOE EIA 2013 Energy Conference',
          title: 'Total oil production from countries outside of OPEC is expected to decline next year for the first time since 2008.',
          likelihood: 4
        },
        {
          end_year: 2019,
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Press Room',
          url: 'http://www.eia.gov/radio/',
          region: 'World',
          start_year: 2017,
          impact: '',
          added: 'January, 12 2017 01:41:30',
          published: 'January, 11 2017 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'DOE EIA 2013 Energy Conference',
          title: 'Global oil inventories are expected to continue strong growth over the next two years which should keep oil prices low.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Press Room',
          url: 'http://www.eia.gov/radio/',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'January, 12 2017 01:41:28',
          published: 'January, 11 2017 00:00:00',
          country: 'United States of America',
          relevance: 2,
          pestle: 'Industries',
          source: 'DOE EIA 2013 Energy Conference',
          title: 'Record high U.S. oil inventories along with growing global oil production are expected to keep crude oil prices low.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Press Room',
          url: 'http://www.eia.gov/radio/',
          region: 'World',
          start_year: 2017,
          impact: '',
          added: 'January, 12 2017 01:41:24',
          published: 'January, 11 2017 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'DOE EIA 2013 Energy Conference',
          title: 'World oil production is expected to increase at a slower rate than the increase in oil demand requiring a bite out of oil inventories in late 2017.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Aerospace & defence',
          topic: 'oil',
          insight: 'Press Room',
          url: 'http://www.eia.gov/radio/',
          region: 'Eastern Asia',
          start_year: '',
          impact: '',
          added: 'January, 12 2017 01:41:22',
          published: 'January, 11 2017 00:00:00',
          country: 'China',
          relevance: 2,
          pestle: 'Political',
          source: 'DOE EIA 2013 Energy Conference',
          title: 'Higher global oil demand growth will be led by stronger fuel consumption in China and India.',
          likelihood: 3
        },
        {
          end_year: 2018,
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Press Room',
          url: 'http://www.eia.gov/radio/',
          region: 'World',
          start_year: 2017,
          impact: '',
          added: 'January, 12 2017 01:41:11',
          published: 'January, 11 2017 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'DOE EIA 2013 Energy Conference',
          title: 'Global oil use is expected to increase by 1.6 million barrels per day next year.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Press Room',
          url: 'http://www.eia.gov/radio/',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'January, 12 2017 01:41:09',
          published: 'January, 11 2017 00:00:00',
          country: 'United States of America',
          relevance: 2,
          pestle: 'Economic',
          source: 'DOE EIA 2013 Energy Conference',
          title: 'A stronger economy in the United States and in other countries will lead to higher global oil demand during 2017 than previously expected.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 8,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Press Room',
          url: 'http://www.eia.gov/radio/',
          region: '',
          start_year: '',
          impact: '',
          added: 'January, 12 2017 01:41:09',
          published: 'January, 11 2017 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'DOE EIA 2013 Energy Conference',
          title: 'Oil prices above $50 could encourage major oil producing countries that are not members of OPEC to boost their output.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Press Room',
          url: 'http://www.eia.gov/radio/',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'January, 12 2017 01:41:08',
          published: 'January, 11 2017 00:00:00',
          country: 'United States of America',
          relevance: 2,
          pestle: 'Industries',
          source: 'DOE EIA 2013 Energy Conference',
          title: 'Production could increase in some U.S. regions that have tight oil.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Press Room',
          url: 'http://www.eia.gov/radio/',
          region: 'Northern America',
          start_year: 2017,
          impact: '',
          added: 'January, 12 2017 01:41:01',
          published: 'January, 11 2017 00:00:00',
          country: 'United States of America',
          relevance: 4,
          pestle: 'Industries',
          source: 'DOE EIA 2013 Energy Conference',
          title: 'U.S. oil production is expected to average 9 million barrels per day in 2017.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Press Room',
          url: 'http://www.eia.gov/radio/',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'January, 12 2017 01:41:01',
          published: 'January, 11 2017 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'DOE EIA 2013 Energy Conference',
          title: 'Most of the growth in oil output during the last quarter of 2016 came from drilling in the federal waters of the Gulf of Mexico, according to EIA. Higher average oil prices in 2017 compared with last year are expected to support more production in the coming months.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Nigeria: Getting the Nigerian Economy Out of Recession',
          url: 'http://allafrica.com/stories/201701090977.html',
          region: '',
          start_year: '',
          impact: '',
          added: 'January, 12 2017 01:31:52',
          published: 'January, 09 2017 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'AllAfrica',
          title: 'Oil benchmark of $42.5 a barrel is realistic given the current and projected near term price of above $55 a barrel.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Energy Department Launches New Manufacturing USA Institute Focused on Recycling and Reusing Materials',
          url: 'https://energy.gov/articles/energy-department-launches-new-manufacturing-usa-institute-focused-recycling-and-reusing',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'January, 12 2017 01:13:25',
          published: 'January, 04 2017 00:00:00',
          country: 'United States of America',
          relevance: 2,
          pestle: 'Social',
          source: 'Energy.gov Website',
          title: 'The research and deployment of cost-effective technologies that could reduce the energy used in materials production could offer energy savings of up to 1.6 quadrillion BTU annually in the U.S. - more than the electricity, oil and other energy consumed by New Hampshire, Hawaii, Delaware.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'gas',
          insight: 'Fracking Protesters Are Putin Puppets',
          url: 'http://www.acsh.org/news/2017/01/09/fracking-protesters-are-putin-puppets-10707',
          region: 'Eastern Europe',
          start_year: '',
          impact: '',
          added: 'January, 12 2017 01:03:24',
          published: 'January, 09 2017 00:00:00',
          country: 'Russia',
          relevance: 2,
          pestle: 'Economic',
          source: 'AMERICAN COUNCIL ON SCIENCE AND HEALTH',
          title: "Russia's economy could face collapse if oil and gas prices fall too far.",
          likelihood: 2
        },
        {
          end_year: 2022,
          intensity: 16,
          sector: 'Retail',
          topic: 'export',
          insight: 'Asian stocks set for gains following metals surge: Markets wrap',
          url: 'http://www.thejakartapost.com/news/2017/01/11/asian-stocks-set-for-gains-following-metals-surge-markets-wrap.html',
          region: 'World',
          start_year: 2017,
          impact: '',
          added: 'January, 11 2017 03:08:02',
          published: 'January, 11 2017 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'The Jakarta Post',
          title: "The fastest pace of growth for Chinese producer prices in five years propelled gains in industrial metals and other raw materials amid prospects the world's second-largest economy will export inflation around the world via its supply chains.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 8,
          sector: '',
          topic: 'economy',
          insight: 'Will Latin America Regain Prosperity in 2017?',
          url: 'http://knowledge.wharton.upenn.edu/article/will-latin-america-nations-regain-prosperity-2017/',
          region: 'South America',
          start_year: '',
          impact: '',
          added: 'January, 11 2017 02:16:54',
          published: 'January, 03 2017 00:00:00',
          country: 'Colombia',
          relevance: 2,
          pestle: 'Economic',
          source: 'Wharton',
          title: "The consensus of analysts was that Colombia's economy will grow by 2.5%.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 9,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Growth, Trump, and debt in Africa: Key economic trends to watch in 2017',
          url: 'http://africanarguments.org/2017/01/09/growth-trump-and-debt-in-africa-key-economic-trends-to-watch-in-2017/',
          region: 'Western Africa',
          start_year: '',
          impact: '',
          added: 'January, 10 2017 01:10:54',
          published: 'January, 09 2017 00:00:00',
          country: 'Niger',
          relevance: 3,
          pestle: 'Industries',
          source: 'African Arguments',
          title: "Oil output and Nigeria's ability to curb militancy in the Niger Delta will matter.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: '',
          topic: 'market',
          insight: 'Crude oil is sliding after Iraq said its exports reached a record high',
          url: 'http://uk.businessinsider.com/crude-oil-price-january-9-2017-2017-1?r=US&IR=T',
          region: '',
          start_year: 2018,
          impact: '',
          added: 'January, 10 2017 00:54:15',
          published: 'January, 09 2017 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'Business Insider',
          title: 'Dealers add that the additional rigs and recent uptick in hedging activity to protect future output for 2018 and beyond could put more pressure into the market.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Manufacturing',
          topic: 'production',
          insight: 'New Year To Ring In Higher Gas Prices',
          url: 'http://www.cstoredecisions.com/2016/12/27/new-year-ring-higher-gas-prices/',
          region: 'Northern Africa',
          start_year: '',
          impact: '',
          added: 'January, 09 2017 05:07:33',
          published: 'December, 27 2016 00:00:00',
          country: 'Libya',
          relevance: 3,
          pestle: 'Industries',
          source: 'Convenience Store Decisions',
          title: "Speculation abounds that increased production in Libya could counter OPEC's anticipated cuts.",
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Information Technology',
          topic: 'food',
          insight: 'Mixed Reality will be most important tech of 2017',
          url: 'http://thenextweb.com/insider/2017/01/07/mixed-reality-will-be-most-important-tech-of-2017/',
          region: '',
          start_year: '',
          impact: '',
          added: 'January, 09 2017 01:51:06',
          published: 'January, 07 2017 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Technological',
          source: 'The Next Web',
          title: "Food products like Hellman's Mayonnaise or Extra Virgin Olive Oil will be able to deliver exclusive 3D recipe tutorials given by a Rachel Ray hologram.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Home',
          url: 'http://ciiradio.com/',
          region: '',
          start_year: '',
          impact: '',
          added: 'January, 08 2017 07:31:37',
          published: 'January, 05 2017 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'Cii Radio',
          title: "The world's largest private power production company warns the sector that renewables could drive the oil price as low as $10 a barrel.",
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Support services',
          topic: 'administration',
          insight: 'January 1, 2016 newsletter',
          url: 'http://globalmoneytrends.com/wp-content/uploads/2016/12/January-1-2017-GMT-newsletter.pdf',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'January, 08 2017 07:25:13',
          published: 'December, 30 2016 00:00:00',
          country: 'United States of America',
          relevance: 2,
          pestle: 'Organization',
          source: 'Global Money Trends',
          title: 'Some are confident that the sanctions will go after the new US administration takes over.',
          likelihood: 3
        },
        {
          end_year: 2017,
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Short-Term Energy Outlook',
          url: 'http://www.eia.gov/outlooks/steo/report/global_oil.cfm',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'January, 08 2017 07:23:11',
          published: 'December, 06 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'DOE EIA 2013 Energy Conference',
          title: 'Global oil inventory builds are forecast to average 0.7 million b/d in 2016 and 0.4 million b/d in 2017.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'unemployment',
          insight: 'Global unemployment to rise by 3.4 million in two years, report says',
          url: 'https://www.theguardian.com/business/2016/jan/19/global-unemployment-3-million-rise-next-two-years-international-labour-organization-report',
          region: 'Eastern Europe',
          start_year: '',
          impact: '',
          added: 'January, 08 2017 06:50:11',
          published: 'January, 19 2016 00:00:00',
          country: 'Brazil',
          relevance: 2,
          pestle: 'Economic',
          source: 'Guardian Sustainable Business',
          title: 'Oil producers such as Brazil, Nigeria and Russia could suffer social instability as unemployment rose.',
          likelihood: 2
        },
        {
          end_year: 2018,
          intensity: 20,
          sector: 'Financial services',
          topic: 'gas',
          insight: 'Rig Count - January 1, 2017',
          url: 'https://oklahomaminerals.com/rig-count-january-1-2017/',
          region: 'Northern America',
          start_year: 2017,
          impact: '',
          added: 'January, 08 2017 06:36:24',
          published: 'January, 01 2017 00:00:00',
          country: 'United States of America',
          relevance: 5,
          pestle: 'Economic',
          source: 'OklahomaMinerals.com',
          title: 'Analysts at U.S. investment bank Piper Jaffray recently forecast the total oil and natural gas rig count would average 723 in 2017 and 933 in 2018.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Energy',
          topic: 'gas',
          insight: 'Rig Count - January 1, 2017',
          url: 'https://oklahomaminerals.com/rig-count-january-1-2017/',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'January, 08 2017 06:36:23',
          published: 'January, 01 2017 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'OklahomaMinerals.com',
          title: "Oil and gas activity is expected to gradually pick up and that there's a sense that 2017 would be better than 2016.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Aerospace & defence',
          topic: 'market',
          insight: 'Biofuels Conference 2017',
          url: 'http://biofuels-bioenergy.conferenceseries.com/middleeast/',
          region: '',
          start_year: 2020,
          impact: '',
          added: 'January, 08 2017 06:33:17',
          published: 'April, 01 2017 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Political',
          source: '4th Annual Congress and Expo on Biofuels and Bioenergy April 27-28 2017 Dubai UAE',
          title: 'Hydrogen as a fuel could be penetrating the market in 2020.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Oil Fundamental Analysis - Forecast for January 2017',
          url: 'https://www.fxempire.com/forecasts/article/oil-fundamental-analysis-forecast-january-2017-381182',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'January, 08 2017 06:26:31',
          published: 'January, 01 2017 00:00:00',
          country: 'United States of America',
          relevance: 2,
          pestle: 'Industries',
          source: 'FX Empire',
          title: 'A stronger U.S. Dollar will make dollar-denominated crude oil more expensive for foreign buyers.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Aerospace & defence',
          topic: 'oil',
          insight: 'GOVARDHAN ECOVILLAGE INVITES YOU TO A ONE DAY NATIONAL WATER CONFERENCE TO DISCUSS SUSTAINABLE AND INTEGRATED WATER RESOURCES MANAGEMENT SYSTEMS',
          url: 'http://nexusconference.in/',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'January, 08 2017 06:03:11',
          published: '',
          country: '',
          relevance: 2,
          pestle: 'Political',
          source: 'Nexus Conference',
          title: 'Predictions are that the next world war will not be for oil.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: '',
          topic: 'trade',
          insight: 'MAURITANIA Food Security OutlookFEWS net,',
          url: 'http://www.fews.net/sites/default/files/documents/reports/MauritaniaOLJune2016EngFinal.pdf',
          region: 'Western Africa',
          start_year: '',
          impact: '',
          added: 'January, 08 2017 05:29:42',
          published: 'July, 31 2016 00:00:00',
          country: 'Mali',
          relevance: 2,
          pestle: 'Economic',
          source: 'Fews Net',
          title: 'There will be a smaller than average flow of coarse grain trade from Mali and Senegal throughout the outlook period.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: '',
          topic: '',
          insight: 'Oil Production Cuts to Begin in January 2017 - Saudi Minister',
          url: 'https://sputniknews.com/business/201611301048021828-oil-output-saudi-minister/',
          region: 'Western Asia',
          start_year: '',
          impact: '',
          added: 'January, 08 2017 05:29:35',
          published: 'November, 30 2016 00:00:00',
          country: 'Saudi Arabia',
          relevance: 2,
          pestle: '',
          source: 'Sputnik News',
          title: "Saudi Arabia's minister will be the next OPEC president.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Oil Production Cuts to Begin in January 2017 - Saudi Minister',
          url: 'https://sputniknews.com/business/201611301048021828-oil-output-saudi-minister/',
          region: 'South-Eastern Asia',
          start_year: '',
          impact: '',
          added: 'January, 08 2017 05:29:34',
          published: 'November, 30 2016 00:00:00',
          country: 'Indonesia',
          relevance: 2,
          pestle: 'Industries',
          source: 'Sputnik News',
          title: 'Indonesia will not participate in the oil production cuts deal.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 8,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Oil Production Cuts to Begin in January 2017 - Saudi Minister',
          url: 'https://sputniknews.com/business/201611301048021828-oil-output-saudi-minister/',
          region: 'Western Asia',
          start_year: '',
          impact: '',
          added: 'January, 08 2017 05:29:34',
          published: 'November, 30 2016 00:00:00',
          country: 'Iraq',
          relevance: 2,
          pestle: 'Industries',
          source: 'Sputnik News',
          title: 'Iraq will cut oil production by 200,000 barrels a day.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 8,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Oil Production Cuts to Begin in January 2017 - Saudi Minister',
          url: 'https://sputniknews.com/business/201611301048021828-oil-output-saudi-minister/',
          region: 'Southern Asia',
          start_year: '',
          impact: '',
          added: 'January, 08 2017 05:29:33',
          published: 'November, 30 2016 00:00:00',
          country: 'Iran',
          relevance: 2,
          pestle: 'Industries',
          source: 'Sputnik News',
          title: 'Iran will increase it oil production by 90,000 barrels per day to 3.79 million bpd.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 9,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Oil Production Cuts to Begin in January 2017 - Saudi Minister',
          url: 'https://sputniknews.com/business/201611301048021828-oil-output-saudi-minister/',
          region: 'Southern Asia',
          start_year: '',
          impact: '',
          added: 'January, 08 2017 05:29:33',
          published: 'November, 30 2016 00:00:00',
          country: 'Iran',
          relevance: 3,
          pestle: 'Industries',
          source: 'Sputnik News',
          title: 'Iran is the only OPEC member that will boost its daily oil output under a new OPEC oil production deal reached on Wednesday.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 8,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Oil Production Cuts to Begin in January 2017 - Saudi Minister',
          url: 'https://sputniknews.com/business/201611301048021828-oil-output-saudi-minister/',
          region: 'Western Asia',
          start_year: '',
          impact: '',
          added: 'January, 08 2017 05:29:32',
          published: 'November, 30 2016 00:00:00',
          country: 'Saudi Arabia',
          relevance: 2,
          pestle: 'Industries',
          source: 'Sputnik News',
          title: 'Saudi Arabia will cut oil production by 486,000 barrels a day.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 4,
          sector: '',
          topic: 'demand',
          insight: "All eyes on 2017. Yes, 2017, if you're in the metals world",
          url: 'http://blogs.platts.com/2016/01/06/all-eyes-on-2017-metals/',
          region: 'Eastern Asia',
          start_year: '',
          impact: '',
          added: 'January, 08 2017 04:59:51',
          published: '',
          country: 'China',
          relevance: 2,
          pestle: 'Economic',
          source: 'platts',
          title: 'A "significant proportion" of refined nickel drawn into China throughout 2015 could have been used to meet growing financing demand for nickel.',
          likelihood: 2
        },
        {
          end_year: 2019,
          intensity: 12,
          sector: 'Support services',
          topic: 'growth',
          insight: 'An Update to the Budget and Economic Outlook: 2016 to 2026',
          url: 'https://www.cbo.gov/publication/51908',
          region: '',
          start_year: '',
          impact: '',
          added: 'January, 08 2017 04:53:15',
          published: 'August, 23 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'CBO',
          title: 'Most of the growth in U.S. output during the coming years will be driven by consumers, businesses, and home builders.',
          likelihood: 4
        },
        {
          end_year: 2020,
          intensity: 12,
          sector: '',
          topic: 'economic growth',
          insight: 'An Update to the Budget and Economic Outlook: 2016 to 2026',
          url: 'https://www.cbo.gov/publication/51908',
          region: '',
          start_year: 2018,
          impact: '',
          added: 'January, 08 2017 04:53:15',
          published: 'August, 23 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'CBO',
          title: 'U.S. economic growth is expected to slow in 2018 and fall below but remain close to the growth of potential (maximum sustainable) GDP in 2019 and 2020.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 9,
          sector: 'Support services',
          topic: 'energy',
          insight: 'Month: January 2017',
          url: 'https://thechirographer.com/2017/01/',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'January, 08 2017 04:37:29',
          published: 'January, 01 2017 00:00:00',
          country: 'United States of America',
          relevance: 3,
          pestle: 'Industries',
          source: 'The Chirographer',
          title: "With the US becoming energy independent don't expect the Trump administration to be anywhere nearly as cozy with the Saudis as a Hillary Clinton administration would have been.",
          likelihood: 3
        },
        {
          end_year: 2040,
          intensity: 12,
          sector: 'Retail',
          topic: 'export',
          insight: 'No title could be extracted, please add manually',
          url: 'http://www.lwv-fairfax.org/files/2017_Jan_FAVoter_Final-Color.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'January, 08 2017 04:25:06',
          published: 'December, 09 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'THE LEAGUE OF WOMEN VOTERS® OF THE FAIRFAX AREA',
          title: 'Shale gas and tight oil plays make up half of US dry gas production. By 2018, the US will become a net exporter for the first time since the 1950s.',
          likelihood: 4
        },
        {
          end_year: 2040,
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'No title could be extracted, please add manually',
          url: 'http://www.lwv-fairfax.org/files/2017_Jan_FAVoter_Final-Color.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'January, 08 2017 04:25:06',
          published: 'December, 09 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'THE LEAGUE OF WOMEN VOTERS® OF THE FAIRFAX AREA',
          title: 'By 2040, shale gas and tight oil plays are expected to be 69% of production.',
          likelihood: 4
        },
        {
          end_year: 2018,
          intensity: 12,
          sector: '',
          topic: '',
          insight: 'No title could be extracted, please add manually',
          url: 'http://www.lwv-fairfax.org/files/2017_Jan_FAVoter_Final-Color.pdf',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'January, 08 2017 04:25:05',
          published: 'December, 09 2016 00:00:00',
          country: 'United States of America',
          relevance: 3,
          pestle: '',
          source: 'THE LEAGUE OF WOMEN VOTERS® OF THE FAIRFAX AREA',
          title: 'By 2018, the US will become a net exporter for the first time since the 1950s.',
          likelihood: 4
        },
        {
          end_year: 2020,
          intensity: 16,
          sector: '',
          topic: '',
          insight: 'Canadian regulator cuts 2040 oil output forecast by 400,000 bpd',
          url: 'https://ca.finance.yahoo.com/news/canadian-regulator-cuts-2040-oil-203804314.html',
          region: '',
          start_year: '',
          impact: '',
          added: 'January, 08 2017 03:58:56',
          published: 'October, 26 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: '',
          source: 'Yahoo Finance Canada',
          title: 'The price of Brent crude oil will rise from $45 a barrel in 2016 to $68 a barrel in 2020, and $90 a barrel by 2040.',
          likelihood: 4
        },
        {
          end_year: 2024,
          intensity: 12,
          sector: '',
          topic: 'industry',
          insight: 'Market Report Catalog',
          url: 'https://www.giiresearch.com/catalog/infrastructure.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'January, 08 2017 03:23:55',
          published: 'December, 14 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'Gii Research',
          title: 'Offshore application is projected to account for 28.9% of total industry share by 2024.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 9,
          sector: 'Financial services',
          topic: 'capital',
          insight: 'Market Report Catalog',
          url: 'https://www.giiresearch.com/catalog/infrastructure.pdf',
          region: 'South-Eastern Asia',
          start_year: '',
          impact: '',
          added: 'January, 08 2017 03:23:53',
          published: 'December, 14 2016 00:00:00',
          country: 'Indonesia',
          relevance: 3,
          pestle: 'Economic',
          source: 'Gii Research',
          title: 'Depleting reserves of crude oil in major OPEC countries including Saudi Arabia and Indonesia owing to rising capital costs in exploration & production (E & P) is expected to force oil companies to invest in alternate sources including tight oil.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Food & agriculture',
          topic: 'food',
          insight: 'South Sudan to increase oil output',
          url: 'http://www.southsudannewsagency.com/index.php/2017/01/03/south-sudan-increase-oil-output/',
          region: 'Eastern Africa',
          start_year: '',
          impact: '',
          added: 'January, 08 2017 02:40:08',
          published: 'January, 03 2017 00:00:00',
          country: 'South Sudan',
          relevance: 2,
          pestle: 'Industries',
          source: 'South Sudan News Agency',
          title: 'South Sudan offers investment opportunities in tourism, oil industry and in agriculture sectors for the UAE government to invest.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Financial services',
          topic: 'oil',
          insight: 'Investor Waves Goodbye to Palm Oil',
          url: 'http://climate-change-news.blogspot.co.uk/2017/01/investor-waves-goodbye-to-palm-oil.html',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'January, 08 2017 02:29:10',
          published: 'January, 04 2017 00:00:00',
          country: 'United States of America',
          relevance: 2,
          pestle: 'Economic',
          source: 'Climate Change News',
          title: 'Major US financial firm starts to divest itself of palm oil plantations in a move that it is hoped other investors will follow.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 12,
          sector: '',
          topic: 'worker',
          insight: 'Crude palm oil to trade up to RM3,200 in January, says CIMB Research',
          url: 'http://www.thestar.com.my/business/business-news/2017/01/04/crude-palm-oil-to-trade-up-to-rm3200-in-january-says-cimb-research/',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'January, 08 2017 02:29:01',
          published: 'January, 04 2017 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Organization',
          source: 'the star online',
          title: 'Malaysian employers will have to personally incur the levy for hiring foreign workers from 1 Jan 2017.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'khor reports - palm oil',
          url: 'http://khorreports-palmoil.blogspot.co.uk/2017_01_01_archive.html',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'January, 08 2017 02:28:46',
          published: 'January, 06 2017 00:00:00',
          country: 'Iraq',
          relevance: 4,
          pestle: 'Economic',
          source: 'khorreports-palmoil',
          title: 'A strong US dollar and a slowdown in demand has seen the price of oil slump ...... Iraq and Iran will lead the push to reduce production and raise the oil price closer to a benchmarked $100 a barrel.',
          likelihood: 4
        },
        {
          end_year: 2021,
          intensity: 24,
          sector: '',
          topic: '',
          insight: 'khor reports - palm oil',
          url: 'http://khorreports-palmoil.blogspot.co.uk/2017_01_01_archive.html',
          region: 'Northern America',
          start_year: 2017,
          impact: '',
          added: 'January, 08 2017 02:28:45',
          published: 'January, 06 2017 00:00:00',
          country: 'United States of America',
          relevance: 6,
          pestle: '',
          source: 'khorreports-palmoil',
          title: 'Brent crude fell below $80 a barrel for the first time in four years amid speculation OPEC will refrain from removing a surplus triggered by booming U.S. shale output ... Futures dropped as much as 2.2 percent.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 12,
          sector: '',
          topic: 'growth',
          insight: 'khor reports - palm oil',
          url: 'http://khorreports-palmoil.blogspot.co.uk/2017_01_01_archive.html',
          region: 'Eastern Asia',
          start_year: '',
          impact: '',
          added: 'January, 08 2017 02:28:43',
          published: 'January, 06 2017 00:00:00',
          country: 'China',
          relevance: 3,
          pestle: 'Economic',
          source: 'khorreports-palmoil',
          title: "Roubini Global Economics Forecasts China's 2016 Growth at 5.4%.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'khor reports - palm oil',
          url: 'http://khorreports-palmoil.blogspot.co.uk/2017_01_01_archive.html',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'January, 08 2017 02:28:39',
          published: 'January, 06 2017 00:00:00',
          country: 'United States of America',
          relevance: 4,
          pestle: 'Industries',
          source: 'khorreports-palmoil',
          title: 'Oil extended losses below $48 a barrel amid speculation that U.S. inventories will expand.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'khor reports - palm oil',
          url: 'http://khorreports-palmoil.blogspot.co.uk/2017_01_01_archive.html',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'January, 08 2017 02:28:35',
          published: 'January, 06 2017 00:00:00',
          country: 'United States of America',
          relevance: 2,
          pestle: 'Economic',
          source: 'khorreports-palmoil',
          title: "A wave of spending cuts by oil producers and a sharp decline in the number of rigs drilling for crude in the U.S. likely will slow the nation's oil-output growth.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: '',
          topic: '',
          insight: 'khor reports - palm oil',
          url: 'http://khorreports-palmoil.blogspot.co.uk/2017_01_01_archive.html',
          region: 'South America',
          start_year: '',
          impact: '',
          added: 'January, 08 2017 02:28:25',
          published: 'January, 06 2017 00:00:00',
          country: 'Venezuela',
          relevance: 2,
          pestle: '',
          source: 'khorreports-palmoil',
          title: 'Venezuela predicted prices may tumble to the mid-$ 20s a barrel unless OPEC tackles the global surplus.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Global pellet market outlook in 2017',
          url: 'http://www.canadianbiomassmagazine.ca/pellets/growing-demand-for-pellets-6074',
          region: '',
          start_year: '',
          impact: '',
          added: 'January, 08 2017 02:18:30',
          published: 'January, 05 2017 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'Canadian Biomass',
          title: 'Heating oil prices will be about at breakeven with wood pellets for the equivalent energy (assuming $245 per ton pellet price).',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Monthly Investment Update January 2017',
          url: 'https://www.icfp.co.uk/2017/01/monthly-investment-update-january-2017/',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'January, 08 2017 01:50:44',
          published: 'January, 02 2017 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'Informed Choice Chartered Financial Planners in Cranleigh',
          title: 'Oil prices are expected to stay volatile in 2017.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Monthly Investment Update January 2017',
          url: 'https://www.icfp.co.uk/2017/01/monthly-investment-update-january-2017/',
          region: '',
          start_year: '',
          impact: '',
          added: 'January, 08 2017 01:50:43',
          published: 'January, 02 2017 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'Informed Choice Chartered Financial Planners in Cranleigh',
          title: 'Analysts expect the oil price to be pushed higher towards $60 a barrel.',
          likelihood: 4
        },
        {
          end_year: 2019,
          intensity: 6,
          sector: 'Retail',
          topic: 'export',
          insight: "January 24, 2017 - The Times They Are A-Changin': Energy Policy in the Trump Administration",
          url: 'http://guarinicenter.org/energy-policy-trump-administration/',
          region: '',
          start_year: '',
          impact: '',
          added: 'January, 08 2017 01:50:10',
          published: 'November, 16 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Political',
          source: 'Guarini Center',
          title: 'US oil and gas policy may undergo substantial change in the next administration. Federal rules governing methane emissions, the leasing of government lands, exports, and much more could be revised in the coming years.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 4,
          sector: '',
          topic: 'tension',
          insight: 'The Bulletin Focus 2017',
          url: 'https://www.omfif.org/media/1666079/omfif-focus-january-2017.pdf',
          region: 'Europe',
          start_year: '',
          impact: '',
          added: 'January, 08 2017 01:17:54',
          published: 'January, 04 2017 00:00:00',
          country: 'United States of America',
          relevance: 2,
          pestle: 'Political',
          source: 'OMFIF',
          title: 'Sino-US tension remains the major economic risk for the "new" Europe.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Aerospace & defence',
          topic: 'terrorism',
          insight: 'Africa political forecast 2017',
          url: 'http://www.southworld.net/africa-political-forecast-2017/',
          region: 'Western Africa',
          start_year: '',
          impact: '',
          added: 'January, 08 2017 01:00:07',
          published: 'January, 01 2017 00:00:00',
          country: 'Burkina Faso',
          relevance: 2,
          pestle: 'Political',
          source: 'South World',
          title: 'In Mali and Burkina Faso, the intensification of the rivality between Al Qaida and the Islamic State could create new security challenges for both states to find an efficient response to terrorism in the region.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'No Market Rebalancing until Later in 2017: Kemp',
          url: 'http://direct.worldenergynews.com/news/market-rebalancing-until-later-2017-kemp-654693',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'January, 08 2017 00:50:56',
          published: 'December, 08 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'World Energy News',
          title: 'Traders are signalling they expect oil demand to exceed supply in the second half of 2017 and throughout 2018.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 8,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Venezuela opposition seeks new polls, military help, against Maduro | Reuters',
          url: 'http://slinkingtowardretirement.com/?p=260041',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'January, 07 2017 04:34:38',
          published: 'January, 06 2017 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'Slinking Toward Retirement',
          title: "Civil disobedience is the only way to dislodge Hugo Chavez's unpopular successor and moderates who fear that could spark bloodshed and backfire in the OPEC member nation with the world's largest oil reserves.",
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 9,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Reuters: Oil steady after Saudis, Abu Dhabi cut supplies',
          url: 'http://www.unian.info/economics/1712562-reuters-oil-steady-after-saudis-abu-dhabi-cut-supplies.html',
          region: 'Western Asia',
          start_year: '',
          impact: '',
          added: 'January, 07 2017 04:23:34',
          published: '',
          country: 'Saudi Arabia',
          relevance: 3,
          pestle: 'Economic',
          source: 'unian',
          title: 'Oil prices were steady on Friday as the start of supply cuts by Saudi Arabia and Abu Dhabi supported the market but doubts that all producers will implement output reductions agreed in a landmark deal last year kept markets from rising further.',
          likelihood: 3
        },
        {
          end_year: 2040,
          intensity: 16,
          sector: 'Energy',
          topic: 'energy',
          insight: 'U.S. on Track to Become Net Energy Exporter',
          url: 'https://www.scientificamerican.com/article/u-s-on-track-to-become-net-energy-exporter/',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'January, 07 2017 03:31:24',
          published: 'January, 06 2017 00:00:00',
          country: 'United States of America',
          relevance: 4,
          pestle: 'Industries',
          source: 'Scientific American',
          title: 'The U.S. is likely to become a major exporter of energy because it is expected to produce about 20 percent more energy than it does today through 2040 while using only about 5 percent more energy.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'energy',
          insight: 'U.S. on Track to Become Net Energy Exporter',
          url: 'https://www.scientificamerican.com/article/u-s-on-track-to-become-net-energy-exporter/',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'January, 07 2017 03:31:23',
          published: 'January, 06 2017 00:00:00',
          country: 'United States of America',
          relevance: 2,
          pestle: 'Industries',
          source: 'Scientific American',
          title: 'Electricity generation is expected to remain the largest single use of energy in the U.S.',
          likelihood: 3
        },
        {
          end_year: 2026,
          intensity: 8,
          sector: 'Energy',
          topic: 'gas',
          insight: "U.S. Could Become 'Energy Independent' by 2026, Report Finds",
          url: 'http://time.com/4624001/energy-independent-crude-oil/',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'January, 07 2017 02:39:35',
          published: 'January, 05 2017 00:00:00',
          country: 'United States of America',
          relevance: 4,
          pestle: 'Industries',
          source: 'Time',
          title: 'The U.S. could become a net energy exporter by 2026 as crude oil and natural gas production continues to increase in the country.',
          likelihood: 2
        },
        {
          end_year: 2030,
          intensity: 9,
          sector: 'Retail',
          topic: 'transport',
          insight: "Planes and ships hampering road transport's climate efforts",
          url: 'http://www.transportenvironment.org/news/planes-and-ships-hampering-road-transport’s-climate-efforts',
          region: '',
          start_year: '',
          impact: '',
          added: 'January, 07 2017 01:23:39',
          published: 'January, 05 2017 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'Transport Environment',
          title: 'Land transport is expected to consume 43 Mtoe less per year in 2030 than it did in 2010.',
          likelihood: 3
        },
        {
          end_year: 2030,
          intensity: 12,
          sector: 'Aerospace & defence',
          topic: 'oil',
          insight: "Planes and ships hampering road transport's climate efforts",
          url: 'http://www.transportenvironment.org/news/planes-and-ships-hampering-road-transport’s-climate-efforts',
          region: '',
          start_year: '',
          impact: '',
          added: 'January, 07 2017 01:23:39',
          published: 'January, 05 2017 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'Transport Environment',
          title: 'Growth in emissions from shipping and aviation will add 19 million tonnes of oil equivalent (Mtoe) in emissions between 2010 and 2030.',
          likelihood: 4
        },
        {
          end_year: 2022,
          intensity: 6,
          sector: 'Energy',
          topic: 'peak oil',
          insight: 'Rocky Mountain Institute Still Bullish on Renewable Future',
          url: 'http://www.triplepundit.com/2017/01/rocky-mountain-institute-still-bullish-renewable-future/',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'January, 06 2017 04:44:08',
          published: 'January, 04 2017 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'Triple Pundit',
          title: 'Peak oil demand could hit in the next five years.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Automotive',
          topic: 'vehicle',
          insight: "Ford Announces 13 'Electrified' Models, Inc. Hybrid Mustang, Hybrid F150 Pickup, 300-Mile Electric SUV",
          url: 'https://transportevolved.com/2017/01/03/ford-announces-13-electrified-models-inc-hybrid-mustang-hybrid-f150-pickup-300-mile-electric-suv/',
          region: '',
          start_year: '',
          impact: '',
          added: 'January, 06 2017 00:54:00',
          published: 'January, 03 2017 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'Transport Evolved',
          title: 'With similar-minded individuals appointed to control the EPA and DoE the fear that all support for electric vehicles will be withdrawn come post-inauguration is a very real one.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Tourism & hospitality',
          topic: 'tourist',
          insight: "Financial Trends: What's In and What's Out in 2017",
          url: 'http://www.foxbusiness.com/features/2017/01/04/financial-trends-whats-in-and-whats-out-in-2017.html?platform=hootsuite',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'January, 05 2017 02:57:16',
          published: 'January, 04 2017 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Lifestyles',
          source: 'Fox Business',
          title: 'In 2017, more travelers will move away from being traditional "tourists" and will be looking for something completely unique.',
          likelihood: 4
        },
        {
          end_year: 2020,
          intensity: 12,
          sector: 'Information Technology',
          topic: 'artificial intelligence',
          insight: 'Artificial Intelligence (A.I.) Market to Hit 53.65% CAGR to 2022 Dominated by APAC',
          url: 'http://satprnews.com/2017/01/04/artificial-intelligence-a-i-market-to-hit-53-65-cagr-to-2022-dominated-by-apac-2/',
          region: '',
          start_year: '',
          impact: '',
          added: 'January, 05 2017 02:27:27',
          published: 'January, 04 2017 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: '',
          title: 'The AI market in APAC is expected to grow at the highest CAGR between 2015 and 2020.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 8,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Record number of oil and gas firms go bust as renewable energy revolution begins to bite',
          url: 'http://www.independent.co.uk/environment/oil-gas-firms-industry-bust-renewable-energy-revolution-biofuel-solar-panel-wind-power-opec-saudi-a7507016.html',
          region: '',
          start_year: '',
          impact: '',
          added: 'January, 05 2017 02:01:53',
          published: 'January, 03 2017 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'The Independent',
          title: 'Growth in renewable energy could push the cost of oil down to as low as $10 in less than 10 years.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 8,
          sector: 'Aerospace & defence',
          topic: 'oil',
          insight: 'German biofuel consumption to increase in 2017 but challenges lie ahead',
          url: 'http://www.biofuelsdigest.com/bdigest/2017/01/04/german-biofuel-consumption-to-increase-in-2017-but-challenges-lie-ahead/',
          region: 'Western Europe',
          start_year: '',
          impact: '',
          added: 'January, 05 2017 01:00:29',
          published: 'January, 04 2017 00:00:00',
          country: 'Germany',
          relevance: 2,
          pestle: 'Political',
          source: 'Biofuels Digest',
          title: "In Germany, biofuels are set to benefit from the country's 'climate protection rate' that will raise to 4% in 2017 from 3.5% in 2016, meaning oil companies will have to reduce the greenhouse gas emissions of the fuels they sell by 4%.",
          likelihood: 4
        },
        {
          end_year: 2017,
          intensity: 16,
          sector: 'Energy',
          topic: 'climate',
          insight: 'German biofuel consumption to increase in 2017 but challenges lie ahead',
          url: 'http://www.biofuelsdigest.com/bdigest/2017/01/04/german-biofuel-consumption-to-increase-in-2017-but-challenges-lie-ahead/',
          region: 'Western Europe',
          start_year: '',
          impact: '',
          added: 'January, 05 2017 01:00:28',
          published: 'January, 04 2017 00:00:00',
          country: 'Germany',
          relevance: 4,
          pestle: 'Environmental',
          source: 'Biofuels Digest',
          title: "In Germany, biofuels are set to benefit from the country's 'climate protection rate' that will raise to 4% in 2017 from 3.5% in 2016.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'energy',
          insight: "IRENA's Year in Review 2016",
          url: 'https://irenanewsroom.org/2017/01/02/irenas-year-in-review-2016/',
          region: '',
          start_year: '',
          impact: '',
          added: 'January, 04 2017 03:36:59',
          published: 'January, 02 2017 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'IRENA newsroom',
          title: 'A renewable energy market analysis revealed that the GCC region could save 11 trillion litres of water withdrawal (a 16 per cent decrease).',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'power',
          insight: '2017 - A thunderous clash of politics, economies and policies',
          url: 'http://www.nationofchange.org/2017/01/02/2017-thunderous-clash-politics-economies-policies/?platform=hootsuite',
          region: 'Eastern Asia',
          start_year: '',
          impact: '',
          added: 'January, 04 2017 01:00:13',
          published: 'January, 02 2017 00:00:00',
          country: 'China',
          relevance: 2,
          pestle: 'Political',
          source: 'Nation of Change',
          title: 'U.S.-China relations could change from big-power co-existence with a careful combination of competition and cooperation.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 20,
          sector: 'Energy',
          topic: 'oil',
          insight: "Will Obama's offshore drilling ban be Trumped?",
          url: 'http://www.nationofchange.org/2017/01/03/will-obamas-offshore-drilling-ban-trumped/?platform=hootsuite',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'January, 04 2017 00:59:43',
          published: 'January, 03 2017 00:00:00',
          country: '',
          relevance: 5,
          pestle: 'Industries',
          source: 'Nation of Change',
          title: 'Crude oil prices will rise to only about $52 per barrel in 2017.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: '',
          topic: 'crisis',
          insight: '2017: A Saudi existential crisis',
          url: 'http://www.middleeasteye.net/columns/2017-saudi-existential-crisis-185025494',
          region: 'Southern Asia',
          start_year: 2017,
          impact: '',
          added: 'January, 04 2017 00:45:18',
          published: 'January, 03 2017 00:00:00',
          country: 'Iran',
          relevance: 4,
          pestle: 'Political',
          source: 'Middle East Eye',
          title: 'For Saudi Arabia, 2017 will be defined by an existential crisis resulting from its failure to secure hegemony across the Arab world and emerge victorious in its long rivalry with Iran.',
          likelihood: 4
        },
        {
          end_year: 2021,
          intensity: 12,
          sector: 'Aerospace & defence',
          topic: 'transport',
          insight: 'Executive Summary - Medium-Term Renewable Energy Market Report 2016',
          url: 'http://www.iea.org/Textbase/npsum/MTrenew2016sum.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'January, 02 2017 05:24:03',
          published: 'October, 18 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Political',
          source: 'IEA',
          title: 'The share of biofuels in transport fuel demand is expected to increase only marginally from 3% in 2015 to 4% by 2021.',
          likelihood: 4
        },
        {
          end_year: 2025,
          intensity: 20,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Free Energy, $10 A Barrel Oil By 2025 Says French Utility Company',
          url: 'http://gas2.org/2016/12/28/free-energy-10-barrel-oil-2025-french-utility-company/',
          region: '',
          start_year: '',
          impact: '',
          added: 'January, 02 2017 05:08:56',
          published: 'December, 28 2016 00:00:00',
          country: '',
          relevance: 5,
          pestle: 'Industries',
          source: 'Gas 2',
          title: 'Oil will drop to around $10 a barrel by 2025.',
          likelihood: 4
        },
        {
          end_year: 2021,
          intensity: 12,
          sector: 'Financial services',
          topic: 'oil',
          insight: 'As We Enter 2017, Keep The Big Picture In Mind',
          url: 'https://www.peakprosperity.com/blog/105291/we-enter-2017-keep-big-picture-mind',
          region: '',
          start_year: 2018,
          impact: '',
          added: 'January, 02 2017 03:51:35',
          published: 'December, 31 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'Peak Prosperity',
          title: 'The profound lack of investment in oil development will have a future impact on supplies so look for a big upside movement in oil prices somewhere between 2018 and 2021.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 12,
          sector: '',
          topic: '',
          insight: 'Oil prices should be a lot lower than where they are now',
          url: 'http://uk.businessinsider.com/why-oil-prices-are-too-high-2016-12?r=US&IR=T',
          region: 'Northern Africa',
          start_year: 2017,
          impact: '',
          added: 'January, 02 2017 03:11:15',
          published: 'January, 02 2017 00:00:00',
          country: 'Libya',
          relevance: 3,
          pestle: '',
          source: 'Business Insider',
          title: 'Libya and Nigeria will add oil output in 2017.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 8,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Global Transmission Oil Pump Market Driven by High Demand for Automatic Vehicles: Technavio',
          url: 'http://www.businesswire.com/news/home/20161230005204/en/Global-Transmission-Oil-Pump-Market-Driven-High/?feedref=JjAwJuNHiystnCoBq_hl-WepL6sRhX6ZA9uIKkLyMC2Ka1ah7uC6RdZY8DBvigxR7fxFuNFTHSunhvli30RlBNXya2izy9YOgHlBiZQk2LO4aHursdTgjq-KNSSWsKUa97ZTKjNldK1STeKrUjqbvg%3D%3D',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'January, 02 2017 01:53:11',
          published: 'December, 30 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'Business Wire',
          title: 'The global transmission oil pump market is expected to grow at a CAGR of more than 6% during the forecast period.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 8,
          sector: 'Financial services',
          topic: 'policy',
          insight: 'Arks, sharks and whales',
          url: 'http://riskmap.controlrisks.com/the-big-picture/arks-sharks-and-whales/',
          region: 'Northern America',
          start_year: 2017,
          impact: '',
          added: 'January, 02 2017 00:51:03',
          published: 'December, 05 2016 00:00:00',
          country: 'United States of America',
          relevance: 4,
          pestle: 'Political',
          source: 'RiskMap 2017',
          title: 'A more inflationary US fiscal policy comprised of corporate tax cuts and infrastructure spending could spur growth in 2017.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Retail',
          topic: 'export',
          insight: 'Russia sees oil products output down 2.5% in 2017',
          url: 'http://www.mrcplast.com/news-news_open-324195.html',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'December, 31 2016 01:49:26',
          published: '',
          country: '',
          relevance: 3,
          pestle: 'Political',
          source: 'MRC',
          title: 'Production of fuel oil could decline by more than 2 MMt due to an increase in export duty from Jan. 1 2017.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Aerospace & defence',
          topic: 'oil',
          insight: 'Russia sees oil products output down 2.5% in 2017',
          url: 'http://www.mrcplast.com/news-news_open-324195.html',
          region: 'Eastern Europe',
          start_year: 2017,
          impact: '',
          added: 'December, 31 2016 01:49:25',
          published: '',
          country: 'Russia',
          relevance: 4,
          pestle: 'Political',
          source: 'MRC',
          title: "Russia's output of oil products is expected to fall by about 2.5% in 2017 due to further work on a massive refinery modernization program aimed at boosting fuel quality.",
          likelihood: 4
        },
        {
          end_year: 2046,
          intensity: 9,
          sector: '',
          topic: 'ice',
          insight: "Murmansk's silver lining: Arctic city banks on ice melt for its renaissance",
          url: 'https://www.theguardian.com/environment/2016/dec/22/murmansks-silver-lining-arctic-city-banks-on-ice-melt-for-its-renaissance',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'December, 31 2016 00:54:00',
          published: 'December, 22 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Environmental',
          source: 'Guardian Sustainable Business',
          title: 'For the next decades, there will definitely be ice in the Arctic.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'gas',
          insight: 'China Unveils Plans to Allow More Foreign Financial Services Investments',
          url: 'http://www.insurancejournal.com/news/international/2016/12/30/436893.htm',
          region: 'Eastern Asia',
          start_year: '',
          impact: '',
          added: 'December, 31 2016 00:48:59',
          published: 'December, 30 2016 00:00:00',
          country: 'China',
          relevance: 2,
          pestle: 'Economic',
          source: 'Insurance Journal',
          title: 'China will lift restrictions on foreign investment in unconventional oil and gas production.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'gas',
          insight: 'What is fracking? WIRED Explains',
          url: 'http://www.wired.co.uk/article/what-is-fracking',
          region: 'Northern Europe',
          start_year: '',
          impact: '',
          added: 'December, 30 2016 05:14:11',
          published: 'December, 23 2016 00:00:00',
          country: 'United Kingdom',
          relevance: 2,
          pestle: 'Political',
          source: 'Wired UK',
          title: "Fracking of shale gas could contribute to the UK's future energy needs and ensure the UK has gas security.",
          likelihood: 2
        },
        {
          end_year: 2126,
          intensity: 9,
          sector: 'Energy',
          topic: 'gas',
          insight: 'Why China Is Dominating the Solar Industry',
          url: 'https://www.scientificamerican.com/article/why-china-is-dominating-the-solar-industry/?WT.mc_id=SA_TW_ENGYSUS_NEWS',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'December, 29 2016 03:43:23',
          published: 'December, 19 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Environmental',
          source: 'Scientific American',
          title: 'Expanding energy demands will exhaust coal, oil and natural gas supplies over the next 110 years.',
          likelihood: 3
        },
        {
          end_year: 2020,
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Fish Oil Products Market in the US 2016-2020',
          url: 'http://www.technavio.com/report/usa-food-fish-oil-products-market-us-2016-2020',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'December, 29 2016 00:51:36',
          published: 'October, 17 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'Technavio',
          title: 'An increasing proportion of fish oil will be derived from trimmings as a by-product of fish processing over the next four years.',
          likelihood: 4
        },
        {
          end_year: 2020,
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Fish Oil Products Market in the US 2016-2020',
          url: 'http://www.technavio.com/report/usa-food-fish-oil-products-market-us-2016-2020',
          region: 'Northern America',
          start_year: 2016,
          impact: '',
          added: 'December, 29 2016 00:51:35',
          published: 'October, 17 2016 00:00:00',
          country: 'United States of America',
          relevance: 4,
          pestle: 'Economic',
          source: 'Technavio',
          title: "Technavio's market research analyst predicts the fish oil products market in the US to grow at a CAGR of around 1% between 2016 and 2020.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 4,
          sector: '',
          topic: 'population',
          insight: 'ANALYSIS: Shadow of Islamic State hangs over Saudi Arabia',
          url: 'http://www.middleeasteye.net/news/islamic-state-and-gulf-144600412',
          region: 'Western Asia',
          start_year: '',
          impact: '',
          added: 'December, 28 2016 03:29:51',
          published: 'December, 25 2016 00:00:00',
          country: 'Kuwait',
          relevance: 2,
          pestle: 'Social',
          source: 'Middle East Eye',
          title: 'Kuwait faces a similar threat from IS as up to 30 per cent of its population are Shia Muslims.',
          likelihood: 2
        },
        {
          end_year: 2020,
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Oil field robots part of $34 billion GE-Baker Hughes vision',
          url: 'http://www.expressnews.com/business/eagle-ford-energy/article/Oil-field-robots-part-of-34-billion-GE-Baker-10814387.php?cmpid=twitter-premium',
          region: '',
          start_year: '',
          impact: '',
          added: 'December, 28 2016 01:32:59',
          published: 'December, 22 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Social',
          source: 'News',
          title: 'Robots could push more humans out of the oil field by 2020.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 9,
          sector: 'Energy',
          topic: 'oil',
          insight: 'OPEC Cuts & Climbing Oil Prices',
          url: 'https://media.ibisworld.com/2016/12/22/opec-cuts-climbing-oil-prices/',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'December, 28 2016 01:27:23',
          published: 'December, 22 2016 00:00:00',
          country: 'United States of America',
          relevance: 3,
          pestle: 'Industries',
          source: 'Media Center ',
          title: 'US oil production will likely rise to fill some of the gap left by OPEC and other oil-producing countries.',
          likelihood: 3
        },
        {
          end_year: 2017,
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'OPEC Cuts & Climbing Oil Prices',
          url: 'https://media.ibisworld.com/2016/12/22/opec-cuts-climbing-oil-prices/',
          region: 'World',
          start_year: 2016,
          impact: '',
          added: 'December, 28 2016 01:27:21',
          published: 'December, 22 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'Media Center ',
          title: 'The world price of crude oil will increase 21.5% in the next year alone.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 9,
          sector: 'Support services',
          topic: 'oil',
          insight: 'OPEC Cuts & Climbing Oil Prices',
          url: 'https://media.ibisworld.com/2016/12/22/opec-cuts-climbing-oil-prices/',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'December, 28 2016 01:27:20',
          published: 'December, 22 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Social',
          source: 'Media Center ',
          title: "OPEC's agreement will impact businesses and consumers across the globe as the world price of oil finally recovers after a two-year slump.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'gas',
          insight: 'Policy, digital and workforce innovation ahead in 2017, says EY US oil and gas outlook',
          url: 'http://www.ey.com/us/en/newsroom/news-releases/news-policy-digital-and-workforce-innovation-ahead-in-2017-says-ey-us-oil-and-gas-outlook',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'December, 27 2016 03:22:09',
          published: 'December, 15 2016 00:00:00',
          country: 'United States of America',
          relevance: 2,
          pestle: 'Industries',
          source: 'EY',
          title: "Paying attention to weak signals' will be essential for US oil and gas competitiveness and success.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 12,
          sector: '',
          topic: 'growth',
          insight: 'Policy, digital and workforce innovation ahead in 2017, says EY US oil and gas outlook',
          url: 'http://www.ey.com/us/en/newsroom/news-releases/news-policy-digital-and-workforce-innovation-ahead-in-2017-says-ey-us-oil-and-gas-outlook',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'December, 27 2016 03:22:08',
          published: 'December, 15 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'EY',
          title: 'Mergers and acquisitions will play an important role in achieving growth goals in 2017 for US oil and gas companies.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: '',
          topic: 'industry',
          insight: 'Policy, digital and workforce innovation ahead in 2017, says EY US oil and gas outlook',
          url: 'http://www.ey.com/us/en/newsroom/news-releases/news-policy-digital-and-workforce-innovation-ahead-in-2017-says-ey-us-oil-and-gas-outlook',
          region: 'World',
          start_year: 2017,
          impact: '',
          added: 'December, 27 2016 03:22:07',
          published: 'December, 15 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Social',
          source: 'EY',
          title: 'The influx of millennials in the global workforce will create challenges for the industry in 2017 and beyond.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Fossil Fuel Era over: End of Crude oil',
          url: 'http://tacticalinvestor.com/fossil-fuel-era-over-end-of-crude-oil/',
          region: '',
          start_year: '',
          impact: '',
          added: 'December, 27 2016 01:44:09',
          published: 'March, 22 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'Tactical Investor',
          title: 'Oil is not projected to trade past $60 for any prolonged period.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: '',
          topic: '',
          insight: '4 Reasons I Prefer 3M Over General Electric',
          url: 'http://seekingalpha.com/article/4031003-4-reasons-prefer-3m-general-electric?ifp=0',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'December, 27 2016 00:49:04',
          published: 'December, 16 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: '',
          source: 'Seeking Alpha',
          title: "GE's fundamentals could continue to struggle in 2017.",
          likelihood: 2
        },
        {
          end_year: 2019,
          intensity: 12,
          sector: 'Government',
          topic: 'oil',
          insight: 'Oil Exporters Learn to Live with Cheaper Oil',
          url: 'https://blog-imfdirect.imf.org/2016/06/08/oil-exporters-learn-to-live-with-cheaper-oil/?hootPostID=4ae8e55e091eac55bca0069b109607d1',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'December, 26 2016 05:21:37',
          published: 'June, 08 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Political',
          source: 'iMFdirect - The IMF Blog',
          title: 'In the coming years, oil revenues will no longer be sufficient for governments to act as the main employer of their fast-growing young populations.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 12,
          sector: '',
          topic: 'growth',
          insight: "''EVs, Solar Could Push Oil Down To $10 By 2025\"",
          url: 'http://oilprice.com/Energy/Oil-Prices/EVs-Solar-Could-Push-Oil-Down-To-10-By-2025.html',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'December, 26 2016 03:41:14',
          published: 'December, 20 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'oilprice.com',
          title: '2017 will see demand growth drop to just 1.3 mb/d.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: "''EVs, Solar Could Push Oil Down To $10 By 2025\"",
          url: 'http://oilprice.com/Energy/Oil-Prices/EVs-Solar-Could-Push-Oil-Down-To-10-By-2025.html',
          region: '',
          start_year: '',
          impact: '',
          added: 'December, 26 2016 03:41:12',
          published: 'December, 20 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'oilprice.com',
          title: 'Oil prices could fall to as low as $10 per barrel within a decade as a "tsunami" of threats could undo demand.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Government',
          topic: 'politics',
          insight: "The Era of American Global Leadership Is Over. Here's What Comes Next",
          url: 'http://www.eurasiagroup.net/live-post/the-era-of-american-global-leadership-is-over-heres-what-comes-next',
          region: 'Eastern Asia',
          start_year: '',
          impact: '',
          added: 'December, 26 2016 01:20:43',
          published: 'December, 19 2016 00:00:00',
          country: 'China',
          relevance: 2,
          pestle: 'Political',
          source: 'Eurasia Group',
          title: "China's leadership transition will make Beijing a more unpredictable player in regional and international politics.",
          likelihood: 1
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: "The Era of American Global Leadership Is Over. Here's What Comes Next",
          url: 'http://www.eurasiagroup.net/live-post/the-era-of-american-global-leadership-is-over-heres-what-comes-next',
          region: 'Eastern Europe',
          start_year: '',
          impact: '',
          added: 'December, 26 2016 01:20:41',
          published: 'December, 19 2016 00:00:00',
          country: 'Russia',
          relevance: 2,
          pestle: 'Economic',
          source: 'Eurasia Group',
          title: 'Russia, Saudi Arabia, Venezuela and others will continue to seek solutions to the existential threat posed to their economies by persistently low oil prices.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Financial services',
          topic: 'power',
          insight: "The Era of American Global Leadership Is Over. Here's What Comes Next",
          url: 'http://www.eurasiagroup.net/live-post/the-era-of-american-global-leadership-is-over-heres-what-comes-next',
          region: 'Eastern Europe',
          start_year: '',
          impact: '',
          added: 'December, 26 2016 01:20:38',
          published: 'December, 19 2016 00:00:00',
          country: 'Russia',
          relevance: 2,
          pestle: 'Political',
          source: 'Eurasia Group',
          title: "The long-term erosion of Russia's power and financial reserves will eventually give Putin good reasons to create international distractions.",
          likelihood: 3
        },
        {
          end_year: 2050,
          intensity: 6,
          sector: '',
          topic: '',
          insight: 'How to Make Hydropower More Environmentally Friendly',
          url: 'http://www.resilience.org/stories/2016-12-22/how-to-make-hydropower-more-environmentally-friendly/',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'December, 26 2016 01:01:54',
          published: 'December, 22 2016 00:00:00',
          country: 'United States of America',
          relevance: 3,
          pestle: '',
          source: 'Resilience',
          title: 'The DOE estimates U.S. hydropower could grow a surprising 50 percent by 2050.',
          likelihood: 2
        },
        {
          end_year: 2041,
          intensity: 40,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Tell Investors of Climate Risks, Energy Sector Is Urged',
          url: 'http://www.nytimes.com/2016/12/14/business/energy-environment/global-panel-urges-companies-to-disclose-climate-change-risks.html?ref=energy-environment&mtrref=www.nytimes.com&_r=2',
          region: '',
          start_year: 2016,
          impact: 4,
          added: 'December, 23 2016 03:47:50',
          published: 'December, 14 2016 00:00:00',
          country: '',
          relevance: 5,
          pestle: 'Economic',
          source: 'NY Times',
          title: 'Oil company revenue could fall by more than $22 trillion over the next 25 years.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Financial services',
          topic: 'gas',
          insight: 'Energy consultancy predicts stability for oil and gas sector in 2017',
          url: 'http://www.imeche.org/news/news-article/energy-consultancy-predicts-stability-for-oil-and-gas-in-2017',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'December, 23 2016 03:34:52',
          published: 'December, 19 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'Imeche',
          title: 'Overall 2017 will be a year of stability and opportunity for oil and gas companies in positions of financial strength.',
          likelihood: 4
        },
        {
          end_year: 2046,
          intensity: 6,
          sector: '',
          topic: '',
          insight: 'The Local Economic and Welfare Consequences of Hydraulic Fracturing',
          url: 'https://epic.uchicago.edu/sites/default/files/UCH-120116_FrackingResearch_final_0.pdf',
          region: 'Northern America',
          start_year: 2016,
          impact: '',
          added: 'December, 23 2016 01:48:14',
          published: 'December, 09 2016 00:00:00',
          country: 'United States of America',
          relevance: 3,
          pestle: '',
          source: 'University of Chicago',
          title: 'Substantial additional shale oil supplies could be produced throughout the United States and globally over the coming decades.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Support services',
          topic: 'business',
          insight: 'No Agenda Episode 888 - "Dutch Trump"',
          url: 'http://adam.curry.com/html/NoAgendaEpisode888Du-1482444877.html',
          region: 'Northern Africa',
          start_year: '',
          impact: '',
          added: 'December, 23 2016 01:18:55',
          published: 'December, 17 2016 00:00:00',
          country: 'Egypt',
          relevance: 2,
          pestle: 'Organization',
          source: 'Adam Curry',
          title: "Qatar's business moves could be an indication of indirectly inserting itself into an emerging Russian-US-Egypt nexus.",
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Environment',
          topic: 'oil',
          insight: 'President Obama Issues Permanent Arctic Drilling Ban Before Leaving Office',
          url: 'http://time.com/4608280/arctic-drilling-barack-obama-trump/?xid=tcoshare',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'December, 22 2016 04:48:03',
          published: 'December, 20 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Environmental',
          source: 'Time',
          title: 'Millions of people around the world will be grateful to President Obama for permanently protecting much of the Arctic and the Atlantic coasts from catastrophic oil exploration and development.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Trump Cabinet Selections Signal Potential Changes to Environmental Regulations',
          url: 'http://www.jdsupra.com/legalnews/trump-cabinet-selections-signal-65827/',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'December, 22 2016 04:34:06',
          published: 'December, 20 2016 00:00:00',
          country: 'United States of America',
          relevance: 2,
          pestle: 'Industries',
          source: 'JD Supra',
          title: 'Some suspect that the United States will further incentivize oil exploration and production.',
          likelihood: 3
        },
        {
          end_year: 2019,
          intensity: 12,
          sector: '',
          topic: 'work',
          insight: 'Business Impact Target: First Annual Report 2015-2016',
          url: 'https://www.gov.uk/government/uploads/system/uploads/attachment_data/file/530683/bis-16-182-bit-annual-report.pdf?platform=hootsuite',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'December, 22 2016 03:43:32',
          published: 'June, 22 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'UK Government',
          title: 'Decommissioning work is increasing as offshore oil and gas fields come to the end of their economic life and it is anticipated that the number of decommissioning programmes will continue to increase over the coming years.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'gas',
          insight: 'Barack Obama bans oil and gas drilling in most of Arctic and Atlantic oceans',
          url: 'https://www.theguardian.com/us-news/2016/dec/20/barack-obama-bans-oil-gas-drilling-arctic-atlantic?CMP=share_btn_tw',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'December, 22 2016 02:17:11',
          published: 'December, 20 2016 00:00:00',
          country: 'Canada',
          relevance: 2,
          pestle: 'Environmental',
          source: 'Guardian Sustainable Business',
          title: 'Canada will designate all Arctic Canadian waters as indefinitely off limits to future offshore Arctic oil and gas licensing.',
          likelihood: 3
        },
        {
          end_year: 2017,
          intensity: 12,
          sector: 'Aerospace & defence',
          topic: 'oil',
          insight: 'Brides, Bureaucrats and Bargaining: Commodities in 2017',
          url: 'https://www.bloomberg.com/gadfly/articles/2016-12-21/commodity-prices-2017-brides-bureaucrats-bargaining',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'December, 22 2016 02:05:25',
          published: 'December, 21 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Political',
          source: 'Bloomberg Business',
          title: 'Indicators from rig counts to payrolls to M&A indicate rising prices will fuel some sort of recovery in American oil production next year.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Oil Markets Daily - Libya Restarts Production In The West',
          url: 'http://seekingalpha.com/article/4032074-oil-markets-daily-libya-restarts-production-west',
          region: 'Northern Africa',
          start_year: '',
          impact: '',
          added: 'December, 22 2016 01:34:19',
          published: 'December, 21 2016 00:00:00',
          country: 'Libya',
          relevance: 2,
          pestle: 'Industries',
          source: 'Seeking Alpha',
          title: "The return of Libya's oil production will be met with the drop in Venezuela's oil production.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 8,
          sector: 'Manufacturing',
          topic: 'production',
          insight: 'Oil Markets Daily - Libya Restarts Production In The West',
          url: 'http://seekingalpha.com/article/4032074-oil-markets-daily-libya-restarts-production-west',
          region: '',
          start_year: '',
          impact: '',
          added: 'December, 22 2016 01:34:19',
          published: 'December, 21 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'Seeking Alpha',
          title: 'OPEC is expected to cut production by about ~1.2 million b/d.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Manufacturing',
          topic: 'production',
          insight: "Operations resuming at Libya's Sharara oil field after pipeline reopens: field official",
          url: 'http://www.reuters.com/article/us-libya-security-oil-idUSKBN14A1WD',
          region: '',
          start_year: '',
          impact: '',
          added: 'December, 22 2016 01:33:44',
          published: 'December, 21 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'Reuters',
          title: 'Libyan production increases could still be reversed or disrupted by political and armed disputes that continue to plague the North African country five years after the uprising that toppled long-time leader Muammar Gaddafi.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Financial services',
          topic: 'crisis',
          insight: 'Icahn Cheers Trump EPA Pick Amid Calls for Fuel-Rule Revamp',
          url: 'https://www.bloomberg.com/news/articles/2016-12-09/oil-friendly-epa-pick-has-icahn-seeing-trump-revamp-of-fuel-rule',
          region: '',
          start_year: '',
          impact: '',
          added: 'December, 21 2016 04:19:31',
          published: '',
          country: '',
          relevance: 2,
          pestle: 'Political',
          source: 'Bloomberg Business',
          title: 'Icahn has been demanding the EPA shift the compliance burden because the cost of RINs is crippling the refining business and could spur a 2008-style financial crisis as smaller refineries die off.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Energy',
          topic: 'energy',
          insight: 'Dividend Growth Likely to Slow in 2017',
          url: 'http://www.investopedia.com/news/dividend-growth-likely-slow-2017/',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'December, 21 2016 04:05:23',
          published: 'December, 19 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'Investopedia',
          title: 'Energy is expected to stabilize in 2017 with flattish payouts.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Government',
          topic: 'growth',
          insight: 'World Bank approves $1.5bn in aid for Iraq',
          url: 'http://www.middleeasteye.net/news/world-bank-approves-15bn-aid-iraq-516997589',
          region: 'Western Asia',
          start_year: '',
          impact: '',
          added: 'December, 21 2016 01:48:22',
          published: 'December, 20 2016 00:00:00',
          country: 'Iraq',
          relevance: 2,
          pestle: 'Political',
          source: 'Middle East Eye',
          title: 'Iraq is undertaking bold transformational reforms that will safeguard economic stability and lay the foundations for longer term private sector development and inclusive growth for all Iraqis.',
          likelihood: 3
        },
        {
          end_year: 2040,
          intensity: 12,
          sector: 'Energy',
          topic: 'coal',
          insight: 'Emerging nations have taken the lead on renewable energy, in 2 charts',
          url: 'http://www.vox.com/science-and-health/2016/12/19/13979768/emerging-nations-lead-renewable-energy-two-charts',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'December, 21 2016 01:36:48',
          published: 'December, 19 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Environmental',
          source: 'Vox',
          title: 'Global coal use will need to be close to zero by 2040.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: '',
          topic: 'gamification',
          insight: 'Will warmer ties between US and Russia leave China out in the cold?',
          url: 'http://www.scmp.com/news/china/diplomacy-defence/article/2054784/will-warmer-ties-between-us-and-russia-leave-china-out',
          region: 'Eastern Asia',
          start_year: '',
          impact: '',
          added: 'December, 20 2016 03:45:34',
          published: 'December, 15 2016 00:00:00',
          country: 'China',
          relevance: 3,
          pestle: 'Lifestyles',
          source: 'South China Morning Post',
          title: "Analysts cautioned that Trump's courtship of the Kremlin could be part of a bigger game to counterbalance the rise of China.",
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Aerospace & defence',
          topic: 'economy',
          insight: 'ExxonMobil Publishes Is 2017 Outlook for Energy: A View to 2040',
          url: 'http://www.imakenews.com/lubritec/e_article003436827.cfm?x=bqPbkP1,bsh5w4GW',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'December, 20 2016 03:43:29',
          published: '',
          country: '',
          relevance: 2,
          pestle: 'Political',
          source: 'OEM/Lube News',
          title: 'By 2040, average global fuel economy for new light-duty vehicles is expected to improve by about two-thirds.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'ExxonMobil Publishes Is 2017 Outlook for Energy: A View to 2040',
          url: 'http://www.imakenews.com/lubritec/e_article003436827.cfm?x=bqPbkP1,bsh5w4GW',
          region: 'World',
          start_year: 2040,
          impact: '',
          added: 'December, 20 2016 03:43:28',
          published: '',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'OEM/Lube News',
          title: "Oil will provide about one third of the world's energy in 2040.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'gas',
          insight: 'ExxonMobil Publishes Is 2017 Outlook for Energy: A View to 2040',
          url: 'http://www.imakenews.com/lubritec/e_article003436827.cfm?x=bqPbkP1,bsh5w4GW',
          region: 'World',
          start_year: 2040,
          impact: '',
          added: 'December, 20 2016 03:43:28',
          published: '',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'OEM/Lube News',
          title: 'In 2040, oil and natural gas are expected to make up nearly 60 percent of global supplies, while nuclear and renewables will be approaching 25 percent.',
          likelihood: 4
        },
        {
          end_year: 2019,
          intensity: 16,
          sector: 'Financial services',
          topic: 'finance',
          insight: 'Algeria and Libya Country Risk Report Q1 2017',
          url: 'http://www.prnewswire.com/news-releases/algeria-and-libya-country-risk-report-q1-2017-300380701.html',
          region: 'Northern Africa',
          start_year: 2016,
          impact: '',
          added: 'December, 20 2016 03:22:13',
          published: 'December, 18 2016 00:00:00',
          country: 'Libya',
          relevance: 4,
          pestle: 'Economic',
          source: 'PR Newswire',
          title: 'Libya will continue to record large fiscal deficits in coming years.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Manufacturing',
          topic: 'production',
          insight: 'Not So Prolific: U.S. Shale Faces A Reality Check',
          url: 'http://www.resilience.org/stories/2016-12-13/not-so-prolific-u-s-shale-faces-a-reality-check',
          region: '',
          start_year: '',
          impact: '',
          added: 'December, 19 2016 05:23:56',
          published: 'December, 13 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'Resilience',
          title: 'The rebound in shale production from higher prices might not be as impressive as organizations like the EIA expect.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: '2016 Tight Oil Reality Check',
          url: 'http://www.resilience.org/stories/2016-12-15/2016-tight-oil-reality-check',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'December, 19 2016 05:23:27',
          published: 'December, 15 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'Resilience',
          title: 'The EIA assumes that tight oil production will begin to grow strongly in 2017.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'energy',
          insight: 'Drowning the World in Oil',
          url: 'http://www.resilience.org/stories/2016-12-16/drowning-the-world-in-oil',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'December, 19 2016 05:23:21',
          published: 'December, 16 2016 00:00:00',
          country: 'United States of America',
          relevance: 2,
          pestle: 'Economic',
          source: 'Resilience',
          title: 'American energy dominance will be declared a strategic economic and foreign policy goal of the United States.',
          likelihood: 3
        },
        {
          end_year: 2019,
          intensity: 12,
          sector: '',
          topic: '',
          insight: 'Global Bulk Terminals Market Volume to Surpass 20 Billion Tonnes by 2026; APEJ to Remain at the Forefront of Global Demand',
          url: 'http://www.futuremarketinsights.com/press-release/bulk-terminals-market',
          region: 'Europe',
          start_year: 2016,
          impact: '',
          added: 'December, 19 2016 05:11:48',
          published: 'December, 14 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: '',
          source: 'Future Market Insights',
          title: 'Preferred usage of LNG is likely to have a favourable impact on the demand for liquid bulk terminals, serving vitally for oil and natural gas storage and trade activities. Several terminals in the Americas, APAC, and Europe are expected to start full-scale operations in the next few years.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'gas',
          insight: 'PETROTECH-2016: Focuses on Energy Access, Energy Efficiency, Energy Sustainability, and Energy Security',
          url: 'https://automation2.com/2016/12/13/petrotech-2016-focuses-on-energy-access-energy-efficiency-energy-sustainability-and-energy-security/',
          region: '',
          start_year: '',
          impact: '',
          added: 'December, 19 2016 04:58:18',
          published: 'December, 13 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'Manufacturing Operations Technology Viewpoints',
          title: 'The latest OPEC decision will see emergence of lesser known oil and gas producers and skew the market to bring down prices again.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'gas',
          insight: 'What are the key energy choices for the new administration?',
          url: 'https://www.csis.org/analysis/what-are-key-energy-choices-new-administration',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'December, 19 2016 01:35:01',
          published: 'December, 15 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Political',
          source: 'CSIS',
          title: 'Geopolitical turmoil in certain key energy-producing regions of the world will continue to keep oil and gas markets on edge.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Information Technology',
          topic: 'oil',
          insight: 'THE DAILY EDGE (9 December 2016)',
          url: 'http://www.edgeandodds.com/2016/12/09/the-daily-edge-9-december-2016/',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'December, 19 2016 01:24:44',
          published: 'December, 09 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Social',
          source: 'Edge and Odds',
          title: 'Bloomberg News calculations based on OPEC data show that across the whole of 2017 there will be little overall reduction in record oil inventories.',
          likelihood: 4
        },
        {
          end_year: 2017,
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'THE DAILY EDGE (14 December 2016)',
          url: 'http://www.edgeandodds.com/2016/12/14/the-daily-edge-14-december-2016/',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'December, 19 2016 01:24:18',
          published: 'December, 14 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'Edge and Odds',
          title: 'OPEC itself forecasts oil demand will grow by 1.15 million barrels a day next year.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: '',
          topic: 'interest rate',
          insight: 'THE DAILY EDGE (14 December 2016)',
          url: 'http://www.edgeandodds.com/2016/12/14/the-daily-edge-14-december-2016/',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'December, 19 2016 01:24:17',
          published: 'December, 14 2016 00:00:00',
          country: 'United States of America',
          relevance: 2,
          pestle: 'Economic',
          source: 'Edge and Odds',
          title: 'Analysts expect higher U.S. interest rates to hit emerging market demand.',
          likelihood: 3
        },
        {
          end_year: 2017,
          intensity: 6,
          sector: '',
          topic: 'demand',
          insight: 'THE DAILY EDGE (14 December 2016)',
          url: 'http://www.edgeandodds.com/2016/12/14/the-daily-edge-14-december-2016/',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'December, 19 2016 01:24:17',
          published: 'December, 14 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'Edge and Odds',
          title: "Even as oil has rallied following OPEC's agreement to cut supply, demand next year could increase at its slowest pace since 2014.",
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 8,
          sector: '',
          topic: 'risk',
          insight: 'Stock Pick - IBM shares and cognitive computing systems',
          url: 'http://maltawinds.com/2016/12/12/stock-pick-ibm-shares-cognitive-computing-systems/',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'December, 18 2016 07:09:02',
          published: 'December, 12 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Organization',
          source: 'maltawinds.com',
          title: 'Balance of risk is skewed entirely against the Canadian dollar in 2017 despite the mild euphoria of an OPEC pact.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 32,
          sector: 'Retail',
          topic: 'export',
          insight: 'Stock Pick - IBM shares and cognitive computing systems',
          url: 'http://maltawinds.com/2016/12/12/stock-pick-ibm-shares-cognitive-computing-systems/',
          region: 'Northern America',
          start_year: '',
          impact: 4,
          added: 'December, 18 2016 07:09:01',
          published: 'December, 12 2016 00:00:00',
          country: 'United States of America',
          relevance: 4,
          pestle: 'Political',
          source: 'maltawinds.com',
          title: "Trump's corporate tax repatriation plan ($2.5 trillion US offshore assets) and protectionist moves against NAFTA and Canadian lumber / auto part exports to the US could lead to a loss of confidence in the loonie in Planet Forex.",
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 8,
          sector: '',
          topic: 'economic growth',
          insight: 'Stock Pick - IBM shares and cognitive computing systems',
          url: 'http://maltawinds.com/2016/12/12/stock-pick-ibm-shares-cognitive-computing-systems/',
          region: 'Northern America',
          start_year: 2017,
          impact: '',
          added: 'December, 18 2016 07:08:59',
          published: 'December, 12 2016 00:00:00',
          country: 'Canada',
          relevance: 4,
          pestle: 'Economic',
          source: 'maltawinds.com',
          title: 'US economic growth could accelerate above 3% in 2017 while Canada will be lucky to manage 1% growth.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'energy',
          insight: 'Energy & Sustainability',
          url: 'https://www.iamericas.org/en/ioa-programs/energy1',
          region: 'South America',
          start_year: '',
          impact: '',
          added: 'December, 18 2016 07:05:54',
          published: 'December, 16 2016 00:00:00',
          country: 'Argentina',
          relevance: 2,
          pestle: 'Industries',
          source: 'iamericas',
          title: 'Argentina could become a regional or even global energy powerhouse.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'gas',
          insight: 'Country Analysis Brief: Mexico',
          url: 'http://www.cpzulia.org/ARCHIVOS/EIA_MEXICO_ANALYSIS_December_2016.pdf',
          region: 'Central America',
          start_year: '',
          impact: '',
          added: 'December, 18 2016 07:05:16',
          published: 'December, 09 2016 00:00:00',
          country: 'Mexico',
          relevance: 2,
          pestle: 'Environmental',
          source: 'cpzulia',
          title: "Mexico's shale gas resources could support increased natural gas reserves and production.",
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'WHY THE U.S. $ SOARING RALLY MAY JUST BE STARTING!',
          url: 'http://riskmanagement.farms.com/DailyChart/DailyLong/DailyPDF.pdf',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'December, 18 2016 07:03:55',
          published: 'December, 16 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'farms',
          title: 'A struggling CDN economy and slightly higher crude oil prices in 2017 will not be enough to offset a falling CDN$.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'THE DAILY EDGE (13 December 2016)',
          url: 'http://www.edgeandodds.com/2016/12/13/the-daily-edge-13-december-2016/',
          region: 'World',
          start_year: 2016,
          impact: '',
          added: 'December, 18 2016 07:01:06',
          published: 'December, 13 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'Edge and Odds',
          title: 'Global oil demand growth is better than expected and rose by 1.4 million barrels a day in 2016.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Fake News Alert: "Fracking Impacts Drinking Water"',
          url: 'http://legalinsurrection.com/2016/12/fake-news-alert-fracking-impacts-drinking-water/',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'December, 18 2016 06:53:12',
          published: 'December, 14 2016 00:00:00',
          country: 'United States of America',
          relevance: 3,
          pestle: 'Industries',
          source: 'Le·gal In·sur·rec·tion',
          title: 'The ingenuity of the U.S. shale-oil industry has diffused serious OPEC threats of production cuts.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Energy',
          topic: 'food',
          insight: 'Eating Responsibly A. Elizabeth Sloan | December 2016, Volume 70, No.12',
          url: 'http://www.ift.org/Food-Technology/Past-Issues/2016/December/Columns/consumer-trends-consumer-purchase-behavior-corporate-social-responsibility-sustainability.aspx',
          region: '',
          start_year: 2020,
          impact: '',
          added: 'December, 18 2016 06:07:50',
          published: 'December, 01 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Environmental',
          source: 'IFT',
          title: 'Food industry environmental sustainability targets for 2020 will continue to focus on energy use / renewable energy.',
          likelihood: 4
        },
        {
          end_year: 2025,
          intensity: 6,
          sector: 'Automotive',
          topic: 'vehicle',
          insight: 'The Growth in Lithium Mining Investment',
          url: 'https://internationalbanker.com/brokerage/growth-lithium-mining-investment/',
          region: '',
          start_year: '',
          impact: '',
          added: 'December, 18 2016 06:06:00',
          published: 'June, 27 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'International Banker',
          title: "Demand for lithium's use in electric vehicles could grow 11-fold to more than 300,000 tonnes by 2025.",
          likelihood: 2
        },
        {
          end_year: 2019,
          intensity: 12,
          sector: 'Construction',
          topic: 'export',
          insight: 'Monetary Policy Report - April 2016',
          url: 'http://www.bankofcanada.ca/wp-content/uploads/2016/04/mpr-2016-04-13.pdf',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'December, 18 2016 04:03:15',
          published: 'April, 12 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'bankofcanada',
          title: 'Growth in Canadian energy exports is expected to moderate in the coming years but to remain positive as oil sands projects currently under construction are completed.',
          likelihood: 4
        },
        {
          end_year: 2018,
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Monetary Policy Report - April 2016',
          url: 'http://www.bankofcanada.ca/wp-content/uploads/2016/04/mpr-2016-04-13.pdf',
          region: 'World',
          start_year: 2017,
          impact: '',
          added: 'December, 18 2016 04:03:08',
          published: 'April, 12 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'bankofcanada',
          title: 'Growth is expected to pick up in the rest of the world over 2017-18 as the Russian economy stabilizes and other oil-exporting economies adjust to lower oil prices.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Monetary Policy Report - January 2016',
          url: 'http://www.bankofcanada.ca/wp-content/uploads/2016/01/mpr-2016-01-20.pdf',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'December, 18 2016 04:02:27',
          published: 'January, 19 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'bankofcanada',
          title: 'The global oil market is now expected to remain in excess supply into 2017.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Monetary Policy Report - January 2016',
          url: 'http://www.bankofcanada.ca/wp-content/uploads/2016/01/mpr-2016-01-20.pdf',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'December, 18 2016 04:02:26',
          published: 'January, 19 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'bankofcanada',
          title: 'The global oil market is expected to gradually rebalance as growth in world demand continues and growth in supply slows.',
          likelihood: 3
        },
        {
          end_year: 2017,
          intensity: 16,
          sector: '',
          topic: 'growth',
          insight: 'Monetary Policy Report - January 2016',
          url: 'http://www.bankofcanada.ca/wp-content/uploads/2016/01/mpr-2016-01-20.pdf',
          region: 'Southern Asia',
          start_year: '',
          impact: '',
          added: 'December, 18 2016 04:02:25',
          published: 'January, 19 2016 00:00:00',
          country: 'India',
          relevance: 4,
          pestle: 'Economic',
          source: 'bankofcanada',
          title: 'GDP growth in India will likely remain in the 7 to 8 per cent range through 2017.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Financial services',
          topic: 'oil',
          insight: 'Monetary Policy Report - January 2016',
          url: 'http://www.bankofcanada.ca/wp-content/uploads/2016/01/mpr-2016-01-20.pdf',
          region: 'Eastern Asia',
          start_year: '',
          impact: '',
          added: 'December, 18 2016 04:02:22',
          published: 'January, 19 2016 00:00:00',
          country: 'Japan',
          relevance: 2,
          pestle: 'Economic',
          source: 'bankofcanada',
          title: 'Accommodative monetary policy, low oil prices and past exchange rate depreciations are expected to underpin continued expansions in the euro area and Japan.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Financial services',
          topic: 'oil',
          insight: 'Monetary Policy Report - January 2016',
          url: 'http://www.bankofcanada.ca/wp-content/uploads/2016/01/mpr-2016-01-20.pdf',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'December, 18 2016 04:02:21',
          published: 'January, 19 2016 00:00:00',
          country: 'United States of America',
          relevance: 2,
          pestle: 'Economic',
          source: 'bankofcanada',
          title: 'Lower commodity prices are expected to lead to even weaker U.S. investment in the oil and mining sectors during 2016.',
          likelihood: 3
        },
        {
          end_year: 2018,
          intensity: 16,
          sector: '',
          topic: 'economy',
          insight: 'Monetary Policy Report - January 2016',
          url: 'http://www.bankofcanada.ca/wp-content/uploads/2016/01/mpr-2016-01-20.pdf',
          region: 'World',
          start_year: 2016,
          impact: '',
          added: 'December, 18 2016 04:02:20',
          published: 'January, 19 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'bankofcanada',
          title: 'The global economy is expected to resume a strengthening trend over the next two years.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'December 2016',
          url: 'http://koeniginvestment.com/2016/december-2016',
          region: '',
          start_year: '',
          impact: '',
          added: 'December, 18 2016 03:24:55',
          published: 'December, 13 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'Koenig Investment Advisory',
          title: 'OPEC agreements to limit pumping are expected to hold and help drive up oil prices somewhat.',
          likelihood: 3
        },
        {
          end_year: 2017,
          intensity: 12,
          sector: '',
          topic: 'inflation',
          insight: 'European Economic Forecast - Winter 2016',
          url: 'http://ec.europa.eu/economy_finance/publications/eeip/pdf/ip020_en.pdf',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'December, 18 2016 03:22:11',
          published: 'January, 27 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'Europa',
          title: "Russia's inflation is expected to fall to average annual rates of 8.5% and 6.2% in 2016 and 2017.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Retail',
          topic: 'export',
          insight: 'European Economic Forecast - Winter 2016',
          url: 'http://ec.europa.eu/economy_finance/publications/eeip/pdf/ip020_en.pdf',
          region: 'Southern Asia',
          start_year: '',
          impact: '',
          added: 'December, 18 2016 03:21:55',
          published: 'January, 27 2016 00:00:00',
          country: 'Iran',
          relevance: 2,
          pestle: 'Political',
          source: 'Europa',
          title: 'The repeal of international sanctions on Iran is expected to provide some lift to Turkish export growth.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Government',
          topic: 'asylum',
          insight: 'European Economic Forecast - Winter 2016',
          url: 'http://ec.europa.eu/economy_finance/publications/eeip/pdf/ip020_en.pdf',
          region: 'Western Europe',
          start_year: 2016,
          impact: '',
          added: 'December, 18 2016 03:21:10',
          published: 'January, 27 2016 00:00:00',
          country: 'Austria',
          relevance: 4,
          pestle: 'Political',
          source: 'Europa',
          title: 'The increased inflow of asylum-seekers to Austria during 2015 is expected to continue in 2016.',
          likelihood: 4
        },
        {
          end_year: 2017,
          intensity: 16,
          sector: '',
          topic: 'economy',
          insight: 'European Economic Forecast - Winter 2016',
          url: 'http://ec.europa.eu/economy_finance/publications/eeip/pdf/ip020_en.pdf',
          region: 'Southern Europe',
          start_year: '',
          impact: '',
          added: 'December, 18 2016 03:20:33',
          published: 'January, 27 2016 00:00:00',
          country: 'Spain',
          relevance: 4,
          pestle: 'Economic',
          source: 'Europa',
          title: "Spain's economy is expected to have expanded by 3.2% in 2015 and is forecast to grow by 2.8% and 2.5% in 2016 and 2017.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Retail',
          topic: 'export',
          insight: 'European Economic Forecast - Winter 2016',
          url: 'http://ec.europa.eu/economy_finance/publications/eeip/pdf/ip020_en.pdf',
          region: 'Northern Europe',
          start_year: '',
          impact: '',
          added: 'December, 18 2016 03:20:25',
          published: 'January, 27 2016 00:00:00',
          country: 'Estonia',
          relevance: 2,
          pestle: 'Political',
          source: 'Europa',
          title: "Persistently low international oil prices could further impair Estonia's shale-oil industry and exports.",
          likelihood: 2
        },
        {
          end_year: 2017,
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'European Economic Forecast - Winter 2016',
          url: 'http://ec.europa.eu/economy_finance/publications/eeip/pdf/ip020_en.pdf',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'December, 18 2016 03:20:02',
          published: 'January, 27 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'Europa',
          title: 'Prices for Brent oil are projected to be on average 35.80 USD / bbl in 2016 and 42.50 USD / bbl in 2017.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Retail',
          topic: 'export',
          insight: 'European Economic Forecast - Winter 2016',
          url: 'http://ec.europa.eu/economy_finance/publications/eeip/pdf/ip020_en.pdf',
          region: 'Northern America',
          start_year: 2016,
          impact: '',
          added: 'December, 18 2016 03:19:44',
          published: 'January, 27 2016 00:00:00',
          country: 'United States of America',
          relevance: 4,
          pestle: 'Economic',
          source: 'Europa',
          title: "The renewed fall in oil prices early this year and the depreciation of the euro's exchange rate vis-à-vis the US dollar are expected to remain key determinants of both export and import prices in 2016.",
          likelihood: 4
        },
        {
          end_year: 2017,
          intensity: 20,
          sector: 'Energy',
          topic: 'oil',
          insight: 'December 14, 2016',
          url: 'https://www.jachincapital.com/december-14-2016/',
          region: 'World',
          start_year: 2016,
          impact: '',
          added: 'December, 18 2016 03:18:08',
          published: 'December, 14 2016 00:00:00',
          country: '',
          relevance: 5,
          pestle: 'Economic',
          source: 'Jachin Capital',
          title: "Global oil markets will swing into deficit during the first half of next year amid OPEC's recent agreement to curb supply.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: '',
          topic: '',
          insight: 'Global Chartbook: March 2016March 10, 2016',
          url: 'https://externalcontent.blob.core.windows.net/pdfs/global-chartbook-9thDec.pdf',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'December, 18 2016 03:16:55',
          published: 'December, 09 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: '',
          source: 'Wells Fargo',
          title: 'Prices for Brent are expected to stay within the$ 50-55 range in H 1:17 before climbing to around $60 by the end of 2017 as inventories are gradually worked down.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 20,
          sector: 'Food & agriculture',
          topic: 'oil',
          insight: 'Palm Voices: Plant A Thought',
          url: 'http://www.thestar.com.my/oilpalm/',
          region: 'South-Eastern Asia',
          start_year: 2017,
          impact: '',
          added: 'December, 18 2016 03:11:11',
          published: 'December, 16 2016 00:00:00',
          country: 'Indonesia',
          relevance: 5,
          pestle: 'Environmental',
          source: 'the star online',
          title: 'Palm oil output in world No.1 producer Indonesia is expected to grow by around 10% in 2017 as planters devote more land to the crop.',
          likelihood: 4
        },
        {
          end_year: 2020,
          intensity: 12,
          sector: 'Manufacturing',
          topic: 'production',
          insight: 'Palm Oil Free and Sustainable Palm Oil Products',
          url: 'http://www.ethicalconsumer.org/shoppingethically/palmoilfreelist.aspx',
          region: '',
          start_year: '',
          impact: '',
          added: 'December, 18 2016 03:08:58',
          published: '',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'ethicalconsumer',
          title: 'India and China each consume more palm oil than the EU, and production is projected to increase 50% by 2020.',
          likelihood: 4
        },
        {
          end_year: 2050,
          intensity: 9,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Palm Oil Free and Sustainable Palm Oil Products',
          url: 'http://www.ethicalconsumer.org/shoppingethically/palmoilfreelist.aspx',
          region: '',
          start_year: '',
          impact: '',
          added: 'December, 18 2016 03:08:58',
          published: '',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'ethicalconsumer',
          title: 'Demand for palm oil has undergone a phenomenal growth and is expected to more than double by 2030 and triple by 2050.',
          likelihood: 3
        },
        {
          end_year: 2017,
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Financial Market Analysis',
          url: 'http://www.citibank.com/ipb/europe/pdfs/Financial_Market_Analysis.pdf',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'December, 18 2016 02:48:04',
          published: 'December, 12 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'Citibank',
          title: 'Bond yields and oil prices are forecast to trend higher next year.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Retail',
          topic: 'export',
          insight: 'Wheat Outlook: December',
          url: 'http://usda.mannlib.cornell.edu/usda/current/WHS/WHS-12-13-2016.pdf',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'December, 18 2016 02:44:55',
          published: 'December, 13 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'Cornell University',
          title: "Russia's total grain exports of 38.6 million tons are projected for 2016.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'The Global Fossil Fuel Divestment and Clean Energy Investment Movement',
          url: 'https://www.arabellaadvisors.com/wp-content/uploads/2016/12/Global_Divestment_Report_2016.pdf?platform=hootsuite',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'December, 18 2016 02:35:28',
          published: 'December, 12 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'arabellaadvisors',
          title: 'A 2016 report from Fitch found that several oil majors have not taken necessary steps to diversify in response to the threat posed to the industry by innovation in battery technologies.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Energy',
          topic: 'coal',
          insight: 'The Global Fossil Fuel Divestment and Clean Energy Investment Movement',
          url: 'https://www.arabellaadvisors.com/wp-content/uploads/2016/12/Global_Divestment_Report_2016.pdf?platform=hootsuite',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'December, 18 2016 02:35:27',
          published: 'December, 12 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Environmental',
          source: 'arabellaadvisors',
          title: 'At least 105 North American oil and gas companies have filed for bankruptcy between January 2015 and October 2016, representing nearly $68 billion in cumulative secured and unsecured debt. Analysts anticipate more producer bankruptcy filings in 2017.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Environment',
          topic: 'policy',
          insight: 'The Global Fossil Fuel Divestment and Clean Energy Investment Movement',
          url: 'https://www.arabellaadvisors.com/wp-content/uploads/2016/12/Global_Divestment_Report_2016.pdf?platform=hootsuite',
          region: '',
          start_year: '',
          impact: '',
          added: 'December, 18 2016 02:35:22',
          published: 'December, 12 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Environmental',
          source: 'arabellaadvisors',
          title: 'ExxonMobil and Chevron shareholders have pressured the companies to disclose climate risk and to explain how resilient their portfolios and strategy would be if policy measures to restrict warming to 2°C.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 9,
          sector: 'Government',
          topic: 'resource',
          insight: 'Update and Assessment: December 14, 2016',
          url: 'http://www.criticalthreats.org/threat-update/december-14-2016',
          region: 'Northern Africa',
          start_year: '',
          impact: '',
          added: 'December, 18 2016 02:26:37',
          published: 'December, 14 2016 00:00:00',
          country: 'Libya',
          relevance: 3,
          pestle: 'Political',
          source: 'Critical Threats',
          title: "Civil conflict over control of Libya's hydrocarbon resources will allow ISIS to solidify new safe havens in Libya's interior.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 9,
          sector: '',
          topic: 'market',
          insight: "It's 'Omni-Channel' or Bust for Retailers, Restaurants in 2017",
          url: 'http://blogs.barrons.com/incomeinvesting/2016/12/12/its-omni-channel-or-bust-for-retailers-restaurants-in-2017/',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'December, 18 2016 01:40:58',
          published: '',
          country: 'United States of America',
          relevance: 3,
          pestle: 'Economic',
          source: 'Fitch',
          title: "McDonald's will continue to lose market share in the U.S. due to heightened competition due to the rise of specialty burger competitors and increasing breakfast competition.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: '',
          topic: 'growth',
          insight: 'High Pressure Seal Market Revenue, Opportunity, Forecast and Value Chain 2016-2026',
          url: 'http://prsync.com/future-market-insights/high-pressure-seal-market-revenue-opportunity-forecast-and-value-chain---1300752/',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'December, 18 2016 01:25:29',
          published: 'December, 13 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'prsync',
          title: 'The global high pressure seal market is projected to witness significant growth rate over the forecast period.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Support services',
          topic: 'climate',
          insight: 'Images of 2016 in physics',
          url: 'http://physicsworld.com/cws/article/news/2016/dec/16/images-of-2016-in-physics',
          region: '',
          start_year: '',
          impact: '',
          added: 'December, 17 2016 03:21:31',
          published: 'December, 16 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Social',
          source: 'Physics World',
          title: 'A senior Trump campaign advisor has indicated that NASA will no longer take on climate projects under a Trump administration.',
          likelihood: 3
        },
        {
          end_year: 2017,
          intensity: 12,
          sector: 'Energy',
          topic: 'biofuel',
          insight: "US Boosts Refiners' 2017 Biofuel Quotas to Record Levels",
          url: 'http://www.renewableenergyworld.com/articles/2016/11/us-boosts-refiners-2017-biofuel-quotas-to-record-levels.html',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'December, 17 2016 02:41:43',
          published: 'November, 29 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'Renewable Energy World',
          title: 'Refiners will be forced to blend 4.28 billion gallons of advanced biofuels next year.',
          likelihood: 4
        },
        {
          end_year: 2030,
          intensity: 8,
          sector: 'Energy',
          topic: 'gas',
          insight: "Europe development banks plan £5.5bn backing for gas project 'with mafia links'",
          url: 'https://www.theguardian.com/global-development/2016/dec/16/europe-development-banks-plan-5bn-backing-for-gas-project-with-mafia-links-bankwatch-report',
          region: 'Europe',
          start_year: '',
          impact: '',
          added: 'December, 17 2016 02:21:38',
          published: 'December, 16 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'Guardian Sustainable Business',
          title: "Improved energy efficiency measures could reduce Europe's gas imports by 174m tonnes of oil equivalent annually by 2030.",
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: "Where is South Africa's economy heading?",
          url: 'http://www.bbc.co.uk/news/business-38342363',
          region: 'Western Africa',
          start_year: '',
          impact: '',
          added: 'December, 17 2016 01:37:02',
          published: 'December, 16 2016 00:00:00',
          country: 'Nigeria',
          relevance: 2,
          pestle: 'Industries',
          source: 'BBC News Technology',
          title: 'Nigeria is wallowing in a recession and even with a rise in the oil price there is little hope things will improve in the near future.',
          likelihood: 3
        },
        {
          end_year: 2020,
          intensity: 12,
          sector: 'Manufacturing',
          topic: 'plastic',
          insight: 'Ikea nears three-fold increase in sustainable product sales',
          url: 'http://www.edie.net/news/7/Ikea-nears-three-fold-increase-for-sustainable-product-sales/',
          region: '',
          start_year: '',
          impact: '',
          added: 'December, 17 2016 01:15:45',
          published: 'December, 12 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Environmental',
          source: 'edie.net',
          title: 'By 2020, Ikea hopes that 100% of the material in its plastic products will be renewable or recyclable.',
          likelihood: 4
        },
        {
          end_year: 2017,
          intensity: 12,
          sector: '',
          topic: '',
          insight: 'Representatives of 12 Russian companies to monitor oil production reduction',
          url: 'http://rbth.com/news/2016/12/16/representatives-of-12-russian-companies-to-monitor-oil-production-reduction_659808',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'December, 17 2016 01:08:32',
          published: 'December, 16 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: '',
          source: 'Russia Beyond The Headlines',
          title: '11 countries will join the announced cut by OPEC members of 1.164 million barrels per day in the first half of next year.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Representatives of 12 Russian companies to monitor oil production reduction',
          url: 'http://rbth.com/news/2016/12/16/representatives-of-12-russian-companies-to-monitor-oil-production-reduction_659808',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'December, 17 2016 01:08:31',
          published: 'December, 16 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'Russia Beyond The Headlines',
          title: 'Representatives of 12 oil companies will form a working group to monitor implementation of agreements on oil production reduction in the first half of 2017.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'electricity',
          insight: "Europe's radioactive embrace",
          url: 'http://www.politico.eu/article/europes-radioactive-embrace-hungary-russia-paks-ii-project-nuclear-reactors/',
          region: 'Eastern Europe',
          start_year: '',
          impact: '',
          added: 'December, 16 2016 05:08:42',
          published: 'December, 14 2016 00:00:00',
          country: 'Hungary',
          relevance: 2,
          pestle: 'Political',
          source: 'Politico',
          title: 'Electricity rates in Hungary will have to be far higher than current levels for the government to earn back the cost of the new reactors in a reasonable amount of time.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 8,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Sawdust Reinvented As Super Sponge To Soak Up Oil Spills',
          url: 'http://www.techtimes.com/articles/188760/20161215/sawdust-reinvented-as-super-sponge-to-soak-up-oil-spills.htm',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'December, 16 2016 04:17:06',
          published: 'December, 15 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Environmental',
          source: 'Tech Times',
          title: "The Arctic is estimated to contain 13 percent of the world's undiscovered oil and more oil developers are expected to enter the region as ice retreats in the Arctic Sea.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 8,
          sector: 'Financial services',
          topic: 'bank',
          insight: 'Norway Combats Surging Housing Market Risks as Easing Seen Done',
          url: 'https://www.bloomberg.com/news/articles/2016-12-15/norway-keeps-rates-unchanged-amid-rapid-house-price-gains',
          region: '',
          start_year: '',
          impact: '',
          added: 'December, 16 2016 01:37:46',
          published: '',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'Bloomberg Business',
          title: "The Federal Reserve's rate increase on Wednesday will ease pressure on the Norwegian bank after the krone slid as much as 1.8 percent against the dollar.",
          likelihood: 4
        },
        {
          end_year: 2035,
          intensity: 16,
          sector: 'Energy',
          topic: 'electricity',
          insight: 'Fuelling the future: hydrocarbons and renewables',
          url: 'https://www.woodmac.com/analysis/fuelling-the-future-hydrocarbons-and-renewables',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'December, 15 2016 03:38:21',
          published: 'December, 09 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'Wood McKenzie',
          title: 'By 2035 wind and solar will represent 11% of world electricity demand.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Energy',
          topic: 'gas',
          insight: 'Electricity supply and 3D printing',
          url: 'http://www.3dprintingprogress.com/articles/10362/electricity-supply-and-3d-printing',
          region: '',
          start_year: 2030,
          impact: '',
          added: 'December, 14 2016 05:00:09',
          published: 'December, 12 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: '3D Printing Progress',
          title: 'Cost parity of wind with gas can be expected not long after 2030 heralding the beginning of the end of gas as an interim solution.',
          likelihood: 4
        },
        {
          end_year: 2035,
          intensity: 8,
          sector: 'Energy',
          topic: 'gasoline',
          insight: 'Electricity supply and 3D printing',
          url: 'http://www.3dprintingprogress.com/articles/10362/electricity-supply-and-3d-printing',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'December, 14 2016 05:00:08',
          published: 'December, 12 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: '3D Printing Progress',
          title: 'Electric vehicles could erode as much as 10% of global gasoline demand by 2035.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Manufacturing',
          topic: 'production',
          insight: 'Oil and gas outlook still gloomy next year',
          url: 'http://www.thejakartapost.com/news/2016/12/14/oil-and-gas-outlook-still-gloomy-next-year.html',
          region: '',
          start_year: '',
          impact: '',
          added: 'December, 14 2016 04:07:00',
          published: 'December, 14 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'The Jakarta Post',
          title: 'Lower production will still lead to an annual crude price average of US$53 to $58 per barrel on benchmark Brent Crude.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 24,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Global Economy to Expand at Rate of 2.8 Percent in 2017',
          url: 'http://news.ihsmarkit.com/press-release/financial-markets/global-economy-expand-rate-28-percent-2017?&hootPostID=6c112084a55c0fb782435e9e2c9edac4',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'December, 14 2016 03:09:52',
          published: 'December, 13 2016 00:00:00',
          country: '',
          relevance: 6,
          pestle: 'Industries',
          source: 'ihsmarkit',
          title: 'IHS Markit has increased the average oil prices forecast for 2017 by a few dollars to $55 (dated Brent) due to the recent OPEC agreement to cut output.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 8,
          sector: '',
          topic: 'demand',
          insight: '3 Oil Experts: Shorts Cover As Saudis & Non-OPEC Cuts Bloom',
          url: 'http://blogs.barrons.com/emergingmarketsdaily/2016/12/12/3-oil-experts-shorts-cover-as-saudis-non-opec-cuts-bloom/',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'December, 13 2016 05:14:29',
          published: '',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'Fitch',
          title: 'A 1.8 million barrel per day cut in global supply will result in global demand exceeding global supply; thus, oil inventories will fall returning historical levels as early as the summer of 2017.',
          likelihood: 4
        },
        {
          end_year: 2020,
          intensity: 8,
          sector: 'Energy',
          topic: 'oil',
          insight: "Turning Australia's Old Tyres Into 220 Million Litres Of Oil",
          url: 'http://www.gizmodo.com.au/2016/12/turning-australias-old-tyres-into-220-million-litres-of-oil/',
          region: 'Oceania',
          start_year: '',
          impact: '',
          added: 'December, 13 2016 04:24:43',
          published: 'December, 01 2016 00:00:00',
          country: 'Australia',
          relevance: 4,
          pestle: 'Industries',
          source: 'Gizmodo Australia',
          title: 'Australia could generate 220 million litres of oil by 2020.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Manufacturing',
          topic: 'production',
          insight: 'Keeping to quotas the key for rebalancing of oil market',
          url: 'http://www.nationmultimedia.com/news/business/EconomyAndTourism/30301814',
          region: 'Eastern Europe',
          start_year: '',
          impact: '',
          added: 'December, 13 2016 02:58:23',
          published: 'December, 09 2016 00:00:00',
          country: 'Russia',
          relevance: 2,
          pestle: 'Industries',
          source: 'The Nation',
          title: 'Russia has agreed to cut its crude-oil production from the current level of around 11.2mmbd from January 1.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 9,
          sector: 'Energy',
          topic: 'gas',
          insight: 'Newsletter Tuesday',
          url: 'http://newsletters.creamermedia.co.za/p/m/s/twitter/wAnWRmFE9Q2PuSWk/cXfl1xvTKaZfIL7B/',
          region: 'Europe',
          start_year: '',
          impact: '',
          added: 'December, 12 2016 04:19:28',
          published: 'December, 06 2016 00:00:00',
          country: 'Morocco',
          relevance: 3,
          pestle: 'Industries',
          source: 'creamermedia',
          title: 'Nigeria and Morocco have signed a joint venture to construct a gas pipeline that will connect the two nations as well as some other African countries to Europe.',
          likelihood: 3
        },
        {
          end_year: 2018,
          intensity: 14,
          sector: 'Energy',
          topic: 'oil',
          insight: 'OPEC Skeptics Flee as Output Cut Rockets Oil Past $50 a Barrel',
          url: 'https://www.bloomberg.com/news/articles/2016-12-12/opec-skeptics-flee-as-output-cut-rockets-oil-past-50-a-barrel?cmpid=socialflow-twitter-business',
          region: 'Northern America',
          start_year: 2016,
          impact: '',
          added: 'December, 12 2016 03:57:39',
          published: 'December, 11 2016 00:00:00',
          country: 'United States of America',
          relevance: 7,
          pestle: 'Industries',
          source: 'Bloomberg Business',
          title: 'U.S. oil companies are using the post-OPEC rally to hedge their oil price risk for next year and 2018 above $50 a barrel.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 12,
          sector: '',
          topic: 'economy',
          insight: 'Agriculture: a common factor in western growth',
          url: 'http://www.farms.com/ag-industry-news/agriculture-a-common-factor-in-western-growth-561.aspx',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'December, 10 2016 03:28:24',
          published: 'December, 08 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'Farms.com',
          title: "Rebuilding Fort MacMurray after 2016's forest fires will also positively affect the province's economy.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 12,
          sector: '',
          topic: 'growth',
          insight: 'Agriculture: a common factor in western growth',
          url: 'http://www.farms.com/ag-industry-news/agriculture-a-common-factor-in-western-growth-561.aspx',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'December, 10 2016 03:28:24',
          published: 'December, 08 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'Farms.com',
          title: 'Alberta is finally out of recession and can expect to see real (economic) growth of 2.2 per cent in 2017.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Outages brighten European refineries year-end profit prospects',
          url: 'http://www.mrcplast.com/news-news_open-323641.html',
          region: 'World',
          start_year: 2016,
          impact: '',
          added: 'December, 10 2016 03:26:41',
          published: '',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'MRC',
          title: 'Global oil demand in 2016 is expected to rise by 1.2 MMbpd.',
          likelihood: 4
        },
        {
          end_year: 2020,
          intensity: 20,
          sector: '',
          topic: 'growth',
          insight: 'Prices of European PP fell for CIS countries in December',
          url: 'http://www.mrcplast.com/news-news_open-323712.html',
          region: 'World',
          start_year: 2016,
          impact: '',
          added: 'December, 10 2016 03:26:30',
          published: '',
          country: '',
          relevance: 5,
          pestle: 'Economic',
          source: 'MRC',
          title: 'McKinsey report forecasts global refining capacity growth to exceed demand until 2020.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Oil-field services sector gears up for a recovery ... but is not there yet',
          url: 'http://www.mckinsey.com/industries/oil-and-gas/our-insights/oil-field-services-sector-gears-up-for-a-recovery-but-is-not-there-yet',
          region: '',
          start_year: 2018,
          impact: '',
          added: 'December, 10 2016 01:23:41',
          published: 'December, 01 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'McKinsey & Company',
          title: 'Oil majors such as BP and ENI indicate they will maintain low capex levels until at least 2018.',
          likelihood: 4
        },
        {
          end_year: 2030,
          intensity: 16,
          sector: 'Aerospace & defence',
          topic: 'oil',
          insight: "Shipping and aviation set to reverse half of Europe's transport carbon savings",
          url: 'http://www.edie.net/news/6/Shipping-and-aviation-set-to-reverse-half-of-Europe-carbon-savings/',
          region: 'Europe',
          start_year: '',
          impact: '',
          added: 'December, 10 2016 01:09:44',
          published: 'December, 07 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Political',
          source: 'edie.net',
          title: 'Land transport in Europe will consume 42mtoe (million tonnes of oil equivalent) less fuel in 2030 than it did in 2010.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Palm oil boom: companies must clean up their act in Africa',
          url: 'https://www.theguardian.com/sustainable-business/2016/dec/07/palm-oil-africa-deforestation-climate-change-land-rights-private-sector-liberia-cameroon',
          region: 'Africa',
          start_year: '',
          impact: '',
          added: 'December, 10 2016 00:48:03',
          published: 'December, 07 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'The Guardian',
          title: 'Smallholder farmers in Africa will need support from the private sector if they are to see the benefits of palm oil expansion into the continent.',
          likelihood: 3
        },
        {
          end_year: 2021,
          intensity: 6,
          sector: '',
          topic: '',
          insight: 'Palm oil boom: companies must clean up their act in Africa',
          url: 'https://www.theguardian.com/sustainable-business/2016/dec/07/palm-oil-africa-deforestation-climate-change-land-rights-private-sector-liberia-cameroon',
          region: 'Africa',
          start_year: 2016,
          impact: '',
          added: 'December, 10 2016 00:48:02',
          published: 'December, 07 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: '',
          source: 'The Guardian',
          title: 'As much as 22m hectares (54m acres) of land in west and central Africa could be converted to palm plantations over the next five years.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Energy Policy and a Trump Administration',
          url: 'http://www.rff.org/research/publications/energy-policy-and-trump-administration',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'December, 09 2016 01:03:40',
          published: 'November, 30 2016 00:00:00',
          country: 'United States of America',
          relevance: 2,
          pestle: 'Political',
          source: 'Resources for the Future',
          title: 'Global oil prices are expected to remain low-an ongoing challenge for US state and local governments that rely on taxes or other revenues from energy resources to fund their budgets.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'gas',
          insight: 'Wireline Services Market Grow at CAGR Of 10.1% 2016 and Forecast to 2022',
          url: 'http://satprnews.com/2016/12/08/wireline-services-market-grow-at-cagr-of-10-1-2016-and-forecast-to-2022/',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'December, 08 2016 04:32:38',
          published: 'December, 08 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'satprnews',
          title: 'North America has the largest market for wireline services and is expected to continue its growth during the forecast period due to rapidly increasing oil and gas production levels and logging services.',
          likelihood: 3
        },
        {
          end_year: 2026,
          intensity: 9,
          sector: 'Manufacturing',
          topic: 'car',
          insight: 'Can you imagine a circular city?',
          url: 'https://www.greenbiz.com/article/can-you-imagine-circular-city',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'December, 08 2016 00:34:23',
          published: 'December, 03 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Social',
          source: 'GreenBiz',
          title: 'In the coming decade, each new autonomous vehicle is projected to replace 10 cars.',
          likelihood: 3
        },
        {
          end_year: 2021,
          intensity: 20,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Cramer Remix: The stocks surprisingly at risk under Trump',
          url: 'http://www.cnbc.com/2016/12/06/cramer-remix-the-stocks-surprisingly-at-risk-under-trump.html?__source=twitter',
          region: '',
          start_year: '',
          impact: '',
          added: 'December, 07 2016 05:37:23',
          published: 'December, 06 2016 00:00:00',
          country: '',
          relevance: 5,
          pestle: 'Industries',
          source: 'CNBC ',
          title: 'The price of oil will be $56 a barrel by 2021.',
          likelihood: 4
        },
        {
          end_year: 2035,
          intensity: 10,
          sector: 'Automotive',
          topic: 'vehicle',
          insight: 'Electric cars could take an OPEC-sized bite from oil demand',
          url: 'http://www.smh.com.au/business/energy/electric-cars-could-take-an-opecsized-bite-from-oil-demand-20161204-gt3juc.html',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'December, 07 2016 05:16:21',
          published: 'December, 04 2016 00:00:00',
          country: '',
          relevance: 5,
          pestle: 'Economic',
          source: 'Sydney Morning Herald',
          title: 'A boom in electric vehicles made by the likes of Tesla Motors could erode as much as 10 per cent of global petrol demand by 2035.',
          likelihood: 2
        },
        {
          end_year: 2040,
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'OPEC sees robust oil demand growth even if prices rise',
          url: 'http://in.reuters.com/article/us-india-energy-opec-idINKBN13U10L',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'December, 06 2016 03:37:05',
          published: 'December, 05 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'Reuters',
          title: 'World oil demand will rise by 17 million bpd to around 110 million bpd by 2040.',
          likelihood: 4
        },
        {
          end_year: 2040,
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'OPEC sees robust oil demand growth even if prices rise',
          url: 'http://in.reuters.com/article/us-india-energy-opec-idINKBN13U10L',
          region: '',
          start_year: '',
          impact: '',
          added: 'December, 06 2016 03:37:04',
          published: 'December, 05 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'Reuters',
          title: 'In India alone oil demand is projected to rise to more than 10 million barrels per day (bpd) by 2040.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Our commitment is strong & our motto is to replace Red Tape with Red Carpet: PM',
          url: 'http://www.narendramodi.in/pm-modi-inaugurates-petrotech-2016-exhibition-in-new-delhi-533413',
          region: 'Europe',
          start_year: 2040,
          impact: '',
          added: 'December, 06 2016 01:02:05',
          published: 'December, 05 2016 00:00:00',
          country: 'India',
          relevance: 4,
          pestle: 'Industries',
          source: 'www.narendramodi.in',
          title: 'India is expected to consume more oil in 2040 than the whole of Europe.',
          likelihood: 3
        },
        {
          end_year: 2017,
          intensity: 8,
          sector: '',
          topic: '',
          insight: 'OPEC deal sends oil spiking 14% in 3 days',
          url: 'http://money.cnn.com/2016/12/02/investing/oil-prices-spike-opec-meeting/index.html',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'December, 05 2016 03:30:06',
          published: 'December, 02 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: '',
          source: 'CNNMoney',
          title: 'Crude could range between $50 to $60 a barrel in the first half of next year.',
          likelihood: 2
        },
        {
          end_year: 2018,
          intensity: 16,
          sector: 'Financial services',
          topic: 'economic growth',
          insight: 'A temporary reprieve for OPEC',
          url: 'http://country.eiu.com/article.aspx?articleid=1884873972&Country=Russia&topic=Economy',
          region: 'Southern Asia',
          start_year: 2017,
          impact: '',
          added: 'December, 05 2016 01:26:55',
          published: 'December, 02 2016 00:00:00',
          country: 'India',
          relevance: 4,
          pestle: 'Economic',
          source: 'EIU',
          title: "Buoyant economic growth and investment will continue to drive growth in India's oil consumption in 2017-18.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 4,
          sector: '',
          topic: 'market',
          insight: 'A temporary reprieve for OPEC',
          url: 'http://country.eiu.com/article.aspx?articleid=1884873972&Country=Russia&topic=Economy',
          region: '',
          start_year: '',
          impact: '',
          added: 'December, 05 2016 01:26:54',
          published: 'December, 02 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'EIU',
          title: 'A risk of surrendering market share to shale producers could materialise in the event that OPEC members respect their quotas.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 72,
          sector: 'Financial services',
          topic: 'export',
          insight: 'Sanction removal unveils Iran currency hopes',
          url: 'http://www.euromoney.com/Article/3524755/Sanction-removal-unveils-Iran-currency-hopes.html',
          region: 'Southern Asia',
          start_year: 2016,
          impact: 3,
          added: 'December, 04 2016 03:00:18',
          published: 'January, 28 2016 00:00:00',
          country: 'Iran',
          relevance: 6,
          pestle: 'Economic',
          source: 'Euromoney',
          title: 'Renaissance Capital forecasts a total $54 billion of export receipts and capital inflows to Iran in 2016.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'gas',
          insight: 'The outlook for LNG in 2016',
          url: 'http://www.gasstrategies.com/sites/default/files/download/outlook_for_2016_-_gas_strategies.pdf',
          region: 'Eastern Asia',
          start_year: 2016,
          impact: '',
          added: 'December, 04 2016 02:32:07',
          published: 'January, 14 2016 00:00:00',
          country: 'Australia',
          relevance: 4,
          pestle: 'Political',
          source: 'gasstrategies',
          title: "The volume of LNG contracted by China's three government owned oil and gas companies will increase by 8 mtpa to 31 mtpa in 2016 as new trains in Australia come on stream.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 20,
          sector: 'Aerospace & defence',
          topic: 'oil',
          insight: 'Fuel Price Cut Likely in December 2016',
          url: 'https://www.cars.co.za/motoring_news/fuel-price-cut-likely-in-december-2016/42875/',
          region: 'Northern America',
          start_year: 2016,
          impact: '',
          added: 'December, 04 2016 02:32:04',
          published: 'November, 22 2016 00:00:00',
          country: 'South Africa',
          relevance: 5,
          pestle: 'Political',
          source: 'Cars.co.za',
          title: 'Motorists in South Africa can expect some relief at the fuel pumps come December 2016 as a result of lower international oil prices and a stronger Rand/US Dollar exchange rate during the month of November.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Financial services',
          topic: 'money',
          insight: 'World Outlook 2016',
          url: 'http://docs.dpaq.de/10076-db_worldoutlook_2016.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'December, 04 2016 02:29:33',
          published: 'December, 08 2015 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'dpaq',
          title: 'The ECB will probably not turn on the monetary spigot again either.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'World Outlook 2016',
          url: 'http://docs.dpaq.de/10076-db_worldoutlook_2016.pdf',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'December, 04 2016 02:29:32',
          published: 'December, 08 2015 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'dpaq',
          title: 'Oil prices pose a significant threat in 2017.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Financial services',
          topic: 'oil',
          insight: 'World Outlook 2016',
          url: 'http://docs.dpaq.de/10076-db_worldoutlook_2016.pdf',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'December, 04 2016 02:29:28',
          published: 'December, 08 2015 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'dpaq',
          title: '2017 will likely be more difficult for private consumption as oil prices are expected to rise 10% in dollar terms and the fiscal rules are expected to bite again.',
          likelihood: 4
        },
        {
          end_year: 2020,
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'EFFICIENCY FIRST: A NEW PARADIGM FOR THE EUROPEAN ENERGY SYSTEM',
          url: 'https://europeanclimate.org/wp-content/uploads/2016/06/ECF_Report_v9-screen-spreads.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'December, 04 2016 02:23:58',
          published: 'June, 17 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'europeanclimate',
          title: 'Article 7 could deliver at least 119 million tonnes of oil equivalent of energy savings by 2020.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'gas',
          insight: 'Prospect Magazine December 2015-February 2016',
          url: 'http://www.dmp.wa.gov.au/Documents/About-Us-Careers/Prospect-December15_February2016.pdf',
          region: 'Oceania',
          start_year: '',
          impact: '',
          added: 'December, 04 2016 01:43:02',
          published: 'December, 10 2015 00:00:00',
          country: 'Australia',
          relevance: 2,
          pestle: 'Industries',
          source: 'Australian Government',
          title: 'With increased exploration activity for onshore oil and gas in Western Australia the land access agreement will assist negotiations between petroleum companies and farmers.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Market panorama. 01 December 2016',
          url: 'https://www.teletrade.eu/analytics/panorama/date-01-12-2016',
          region: '',
          start_year: '',
          impact: '',
          added: 'December, 04 2016 01:41:07',
          published: 'December, 01 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'TeleTrade',
          title: 'OPEC countries will reduce oil output by 1.2 mln barrels daily to 32.5 mln barrels starting from January.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Government',
          topic: 'growth',
          insight: 'Liebreich: 10 predictions for 2016: Sunny with a hint of Götterdämmerung',
          url: 'https://about.bnef.com/blog/liebreich-10-predictions-for-2016-sunny-with-a-hint-of-gotterdammerung/',
          region: 'Eastern Asia',
          start_year: '',
          impact: '',
          added: 'December, 04 2016 01:30:06',
          published: 'January, 18 2016 00:00:00',
          country: 'China',
          relevance: 2,
          pestle: 'Political',
          source: 'Bloomberg New Energy Finance',
          title: "China will lead global EV growth as the government's push to leapfrog the conventional automotive sector gains speed.",
          likelihood: 3
        },
        {
          end_year: 2017,
          intensity: 24,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Short-Term Energy Outlook',
          url: 'http://www.eia.gov/outlooks/steo/report/prices.cfm',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'December, 04 2016 01:03:18',
          published: 'November, 08 2016 00:00:00',
          country: '',
          relevance: 6,
          pestle: 'Industries',
          source: 'DOE EIA 2013 Energy Conference',
          title: 'EIA expects Brent crude oil prices will average close to $48/ barrel (b) in the fourth quarter of 2016 and in the first quarter of 2017.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 48,
          sector: 'Manufacturing',
          topic: 'production',
          insight: 'Vilsack comments on Farm Income Forecast for 2016',
          url: 'http://www.farms.com/ag-industry-news/vilsack-comments-on-farm-income-forecast-for-2016-196.aspx',
          region: 'Northern America',
          start_year: '',
          impact: 3,
          added: 'December, 03 2016 03:04:34',
          published: 'December, 02 2016 00:00:00',
          country: 'United States of America',
          relevance: 4,
          pestle: 'Industries',
          source: 'Farms.com',
          title: 'The annual value of U.S. agricultural production is forecast at $403.7 billion.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Retail',
          topic: 'export',
          insight: 'Saudi Aramco to supply more oil to Asia in January sources say',
          url: 'http://www.mrcplast.com/news-news_open-323340.html',
          region: 'Western Asia',
          start_year: '',
          impact: '',
          added: 'December, 03 2016 03:02:17',
          published: '',
          country: 'Saudi Arabia',
          relevance: 2,
          pestle: 'Economic',
          source: 'MRC',
          title: 'Saudi Arabia is signaling that it will not budge on market share even as it works with members of the Organization of Petroleum Exporting Countries to finalize plans for a production cut at their Nov. 30 meeting.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 8,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Oil prices OPEC reaches a deal to cut production',
          url: 'http://www.economist.com/news/finance-and-economics/21711088-oil-prices-surge-saudi-arabia-and-iran-sign-deal-opecs-meeting?fsrc=rss',
          region: '',
          start_year: '',
          impact: '',
          added: 'December, 03 2016 02:12:59',
          published: 'December, 03 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'The Economist',
          title: 'The OPEC agreement could push oil above $60 a barrel within weeks.',
          likelihood: 2
        },
        {
          end_year: 2020,
          intensity: 12,
          sector: '',
          topic: '',
          insight: 'Tests on oil recycled from tyres finds a cleaner diesel blend',
          url: 'http://phys.org/news/2016-11-oil-recycled-tyres-cleaner-diesel.html',
          region: 'Oceania',
          start_year: 2016,
          impact: '',
          added: 'December, 03 2016 00:50:03',
          published: 'November, 29 2016 00:00:00',
          country: 'Australia',
          relevance: 3,
          pestle: '',
          source: 'Phys Org',
          title: 'Australia will generate 55 million disused tyres a year by 2020.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Information Technology',
          topic: 'technology',
          insight: 'North American energy integration poised for rapid transformation',
          url: 'http://phys.org/news/2016-12-north-american-energy-poised-rapid.html',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'December, 03 2016 00:49:18',
          published: 'December, 02 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'Phys Org',
          title: "Technological and geological fundamentals will continue to drive the profile of North America's cross-border markets.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Support services',
          topic: 'gas',
          insight: 'Survey uncovers a vast amount of jobs have been lost in oil and gas sector',
          url: 'http://www.djsresearch.co.uk/OilAndGasMarketResearchInsightsAndFindings/article/Survey-uncovers-a-vast-amount-of-jobs-have-been-lost-in-oil-and-gas-sector-03425',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'December, 03 2016 00:47:28',
          published: 'December, 01 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'djsresearch',
          title: 'More than two thirds (67 per cent) of oil and gas businesses have cut jobs in 2016 and more cuts have been predicted for the next 12 months.',
          likelihood: 4
        },
        {
          end_year: 2018,
          intensity: 6,
          sector: 'Retail',
          topic: 'export',
          insight: 'Saudi Arabia: Growth to moderate as the kingdom embarks on fiscal consolidation',
          url: 'http://www.kuwait.nbk.com/InvestmentAndBrokerage/ResearchandReports/$Document/MonthlyBriefs/en-gb/MainCopy/$UserFiles/NBKKSAMacro20160403E.pdf',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'December, 02 2016 13:22:39',
          published: 'April, 03 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Political',
          source: 'nbk',
          title: 'Over the next two years, more Saudi oil could be freed up for export (as crude or as higher-value petroleum products) if natural gas is substituted for crude in domestic power generation.',
          likelihood: 2
        },
        {
          end_year: 2016,
          intensity: 12,
          sector: 'Financial services',
          topic: 'oil',
          insight: 'Saudi Arabia: Growth to moderate as the kingdom embarks on fiscal consolidation',
          url: 'http://www.kuwait.nbk.com/InvestmentAndBrokerage/ResearchandReports/$Document/MonthlyBriefs/en-gb/MainCopy/$UserFiles/NBKKSAMacro20160403E.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'December, 02 2016 13:22:39',
          published: 'April, 03 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'nbk',
          title: "Saudi Arabia's growth is forecast to slow from 3.4% in 2015 to 1.6% in 2016 amid lower oil prices and renewed fiscal restraint.",
          likelihood: 4
        },
        {
          end_year: 2021,
          intensity: 16,
          sector: '',
          topic: '',
          insight: 'Short-term positives mask structural economic deficiencies',
          url: 'http://country.eiu.com/article.aspx?articleid=1334864117&Country=Pakistan&topic=Economy',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'December, 02 2016 03:24:09',
          published: 'November, 30 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: '',
          source: 'EIU',
          title: 'Price of Brent crude will average just US$60.5/b a year in 2017-21.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'consumption',
          insight: "Trudeau's Six Unanswered Questions on Kinder Morgan Expansion",
          url: 'http://www.resilience.org/stories/2016-11-30/trudeau-s-six-unanswered-questions-on-kinder-morgan-expansion',
          region: 'Eastern Asia',
          start_year: '',
          impact: '',
          added: 'December, 02 2016 02:31:44',
          published: 'November, 30 2016 00:00:00',
          country: 'Japan',
          relevance: 2,
          pestle: 'Industries',
          source: 'Resilience',
          title: 'Petroleum consumption in California, Japan and South Korea will decline.',
          likelihood: 3
        },
        {
          end_year: 2020,
          intensity: 16,
          sector: 'Construction',
          topic: 'energy',
          insight: 'UN: Paris Agreement still not good enough to avoid serious climate change',
          url: 'http://www.edie.net/news/9/UN-Global-climate-action-must-scale-up-to-prevent-avoidable-human-tragedy/',
          region: '',
          start_year: '',
          impact: '',
          added: 'December, 01 2016 15:34:33',
          published: 'November, 03 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'edie.net',
          title: 'All new buildings in OECD countries member countries will need to be zero-energy by 2020 to make the building sector compatible with the 1.5C warming target of COP21.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Oil price surges as Opec agrees first cut in output since 2008',
          url: 'https://www.theguardian.com/business/2016/nov/30/oil-price-opec-cut-in-output-saudi-arabia-deal-market',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'December, 01 2016 12:58:37',
          published: 'November, 30 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'Guardian',
          title: 'Global oil production will still be at a historically high level.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Environment',
          topic: 'aquaculture',
          insight: 'Cargill developing new canola with long-chain omega-3-rich Canola to increase availability of nutritious fish',
          url: 'http://www.cargill.com/news/releases/2016/NA31990270.jsp',
          region: '',
          start_year: '',
          impact: '',
          added: 'December, 01 2016 03:32:37',
          published: 'November, 28 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Environmental',
          source: 'cargill',
          title: 'A new groundbreaking type of canola in development by Cargill could give aquaculture farmers a more sustainable way to raise fish with EPA/DHA omega-3 fatty acids.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Can water go extinct?',
          url: 'https://worldlyir.wordpress.com/2016/11/30/can-water-go-extinct/',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'December, 01 2016 00:50:48',
          published: 'November, 30 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'Worldly',
          title: 'Prime Minister Justin Trudeau approved two more major pipeline projects in British Columbia that will vastly expand the amount of oil transported from the Alberta Tar Sands to global markets.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 9,
          sector: 'Retail',
          topic: 'export',
          insight: 'Canada approves controversial Kinder Morgan oil pipeline',
          url: 'https://www.theguardian.com/world/2016/nov/29/canada-approves-kinder-morgan-oil-pipeline-justin-trudeau?CMP=twt_gu',
          region: 'Asia',
          start_year: '',
          impact: '',
          added: 'November, 30 2016 02:59:41',
          published: 'November, 30 2016 00:00:00',
          country: 'United States of America',
          relevance: 3,
          pestle: 'Economic',
          source: 'Guardian',
          title: 'Allowing Kinder Morgan to build a second pipeline next to its existing Trans Mountain line in Canada will help ensure oil exports reach Asia and reduce reliance on the US market.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: "Saudis believe Trump will unleash America's economy",
          url: 'http://money.cnn.com/2016/11/28/investing/saudi-trump-oil-opec-meeting/index.html',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'November, 30 2016 00:34:59',
          published: 'November, 28 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'CNNMoney',
          title: 'There will be more thirst for oil in 2017 and oil prices will stabilize without OPEC intervention.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Get ready for $40 oil if OPEC deal collapses',
          url: 'http://money.cnn.com/2016/11/28/investing/opec-meeting-oil-prices-saudi-iran/index.html',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 30 2016 00:34:48',
          published: 'November, 28 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'CNNMoney',
          title: 'If a large cut is announced, oil prices could soar to $55 a barrel or higher.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'technology',
          insight: 'Washington carbon capture project says it has permanently sequestered CO2',
          url: 'http://www.utilitydive.com/news/washington-carbon-capture-project-says-it-has-permanently-sequestered-co2/430935/',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 29 2016 02:16:47',
          published: 'November, 22 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Technological',
          source: 'Utility Dive',
          title: 'Carbon capture is considered an expensive technology and the possibility of making it more secure and affordable could be a boon to coal-fired plants.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 12,
          sector: '',
          topic: '',
          insight: 'Gamechangers',
          url: 'https://www.gamechangers.newscientist.com/wp-content/uploads/2016/02/NSGamechangers.pdf',
          region: 'Northern America',
          start_year: 2020,
          impact: '',
          added: 'November, 28 2016 01:20:58',
          published: 'February, 25 2016 00:00:00',
          country: 'United States of America',
          relevance: 3,
          pestle: '',
          source: 'newscientist',
          title: 'If oil prices stay below $50 a barrel, US producers will pump out 2.5 million fewer barrels per day in 2020.',
          likelihood: 4
        },
        {
          end_year: 2020,
          intensity: 12,
          sector: 'Energy',
          topic: 'biofuel',
          insight: 'Gamechangers',
          url: 'https://www.gamechangers.newscientist.com/wp-content/uploads/2016/02/NSGamechangers.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 28 2016 01:20:56',
          published: 'February, 25 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Political',
          source: 'newscientist',
          title: 'Biofuels will stall at about 4 percent of motor fuels through 2020.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Palm oil/Vegoils: Market factors to watch Monday Nov 7',
          url: 'http://www.thestar.com.my/business/business-news/2016/11/07/palm-oil-market-factors-to-watch-nov-7/',
          region: 'Southern Asia',
          start_year: '',
          impact: '',
          added: 'November, 27 2016 07:01:47',
          published: 'November, 07 2016 00:00:00',
          country: 'Iran',
          relevance: 2,
          pestle: 'Industries',
          source: 'the star online',
          title: 'Saudis could raise oil output again as sparring with Iran returns.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 9,
          sector: 'Retail',
          topic: 'export',
          insight: 'Intelligence Report Series',
          url: 'http://www.westpandi.com/globalassets/loss-prevention/mast-reports/mast-intelligence-report---23-november-2016.pdf',
          region: 'Northern Africa',
          start_year: '',
          impact: '',
          added: 'November, 27 2016 06:59:18',
          published: 'November, 23 2016 00:00:00',
          country: 'Libya',
          relevance: 3,
          pestle: 'Economic',
          source: 'westpandi',
          title: "OPEC has raised concerns that Libya's exports will force global oil prices down.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 12,
          sector: '',
          topic: '',
          insight: '18th November 2016 Current Affairs Analysis - IASToppers',
          url: 'http://www.iastoppers.com/18th-november-2016-current-affairs-analysis-iastoppers/',
          region: 'Southern Asia',
          start_year: 2016,
          impact: '',
          added: 'November, 27 2016 06:29:20',
          published: 'November, 18 2016 00:00:00',
          country: 'India',
          relevance: 3,
          pestle: '',
          source: 'IASTOPPERS',
          title: 'India imported 2 million barrels of Iran and is going to import another 4 million barrels in November 2016.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Energy',
          topic: 'oil',
          insight: "Fitch Revises Nigerian Banks' Issuer Default Ratings Downwards",
          url: 'http://www.thisdaylive.com/index.php/2016/11/21/fitch-revises-nigerian-banks-issuer-default-ratings-downwards/',
          region: 'Western Africa',
          start_year: '',
          impact: '',
          added: 'November, 27 2016 05:45:16',
          published: 'November, 21 2016 00:00:00',
          country: 'Niger',
          relevance: 3,
          pestle: 'Industries',
          source: 'THISDAY LIVE',
          title: 'Sustained low oil prices and continuing production disruptions in the Niger Delta could cause industry NPL ratios to rise more dramatically.',
          likelihood: 1
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'gas',
          insight: "NEO - Netanyahu Scuttles Trump's Russian Rapprochement",
          url: 'http://www.veteranstoday.com/2016/11/20/neo-netanyahu-scuttles-trumps-russian-rapprochement/',
          region: 'Western Asia',
          start_year: '',
          impact: '',
          added: 'November, 27 2016 05:22:27',
          published: 'November, 20 2016 00:00:00',
          country: 'Iraq',
          relevance: 2,
          pestle: 'Industries',
          source: 'veteranstoday',
          title: 'Turkey is actively threatening the territorial integrity of both Iraq and Syria and Turkish moves into both nations is directly aimed at securing oil and gas reserves.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'The Spanish Economy',
          url: 'http://www.thespanisheconomy.com/',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'November, 27 2016 04:02:47',
          published: 'November, 24 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'thespanisheconomy',
          title: "Spain's inflation is expected to pick up in 2017 as oil prices increase and core inflation recovers.",
          likelihood: 4
        },
        {
          end_year: 2035,
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Updated energy and emissions projections 2015',
          url: 'https://www.gov.uk/government/uploads/system/uploads/attachment_data/file/501292/eepReport2015_160205.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 27 2016 03:34:04',
          published: 'February, 18 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'UK Government',
          title: 'UK primary energy demand is projected to fall to 183 Mtoe (million tonnes of oil equivalent) in 2025 from 207 Mtoe in 2015 before rising back to 3% below current levels in 2035.',
          likelihood: 4
        },
        {
          end_year: 2055,
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Citing Climate Crisis, Trump Presidency, San Francisco Supervisors Ban Fossil Fuel Extraction on City-owned Lands',
          url: 'http://www.biologicaldiversity.org/news/press_releases/2016/fossil-fuels-11-16-2016.html',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 27 2016 02:56:58',
          published: '',
          country: '',
          relevance: 3,
          pestle: 'Environmental',
          source: 'biologicaldiversity',
          title: 'Current U.S. federal oil leases will last through 2055 and halting new fossil fuel leases on federal land and waters would prevent the release of up to 450 billion tons of carbon pollution.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 9,
          sector: 'Manufacturing',
          topic: 'production',
          insight: 'Menu',
          url: 'http://portfolioticker.com/2016/11/25/',
          region: 'Eastern Europe',
          start_year: '',
          impact: '',
          added: 'November, 27 2016 02:38:10',
          published: 'November, 25 2016 00:00:00',
          country: 'Iraq',
          relevance: 3,
          pestle: 'Industries',
          source: 'portfolioticker',
          title: "OPEC's focus has shifted to negotiations with Iran and non-member Russia for production curbs after Iraq's prime minister signaled it will agree to cut output.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Iran News Round Up - November 21, 2016',
          url: 'http://www.criticalthreats.org/iran-news-round-november-21-2016',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 27 2016 02:29:03',
          published: 'November, 21 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'Critical Threats',
          title: 'OPEC will likely reach an agreement over oil output.',
          likelihood: 3
        },
        {
          end_year: 2030,
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Indian Oil plans USD5.5 B expansion of refinery co-owned by Iran',
          url: 'http://www.mrcplast.com/news-news_open-323268.html',
          region: 'Southern Asia',
          start_year: '',
          impact: '',
          added: 'November, 26 2016 03:49:42',
          published: 'April, 01 2020 00:00:00',
          country: 'India',
          relevance: 4,
          pestle: 'Industries',
          source: 'MRC',
          title: 'India will require up to 329 MMt of oil products annually by 2030.',
          likelihood: 3
        },
        {
          end_year: 2041,
          intensity: 96,
          sector: 'Energy',
          topic: 'oil',
          insight: 'The future of oil',
          url: 'http://www.economist.com/news/special-report/21710628-worlds-use-oil-approaching-tipping-point-writes-henry-tricks-dont-expect?fsrc=rss',
          region: 'World',
          start_year: 2016,
          impact: 4,
          added: 'November, 26 2016 03:15:53',
          published: 'November, 26 2016 00:00:00',
          country: '',
          relevance: 6,
          pestle: 'Industries',
          source: 'The Economist',
          title: 'The world will still need to invest in oil to the tune of almost $1trn a year for the next 25 years.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'energy',
          insight: 'The future of oil',
          url: 'http://www.economist.com/news/special-report/21710628-worlds-use-oil-approaching-tipping-point-writes-henry-tricks-dont-expect?fsrc=rss',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 26 2016 03:15:53',
          published: 'November, 26 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'The Economist',
          title: 'Mark Carney has given warning that the energy transition could put severe strains on financial stability.',
          likelihood: 2
        },
        {
          end_year: 2017,
          intensity: 16,
          sector: 'Energy',
          topic: 'energy',
          insight: 'Big Corn beats Big Oil as U.S. hikes 2017 biofuel targets',
          url: 'http://www.reuters.com/article/us-usa-biofuels-idUSKBN13I1MB',
          region: 'Northern America',
          start_year: 2016,
          impact: '',
          added: 'November, 25 2016 04:15:55',
          published: 'November, 23 2016 00:00:00',
          country: 'United States of America',
          relevance: 4,
          pestle: 'Political',
          source: 'Reuters',
          title: 'The U.S. government will require energy companies to use a record amount of biofuel next year.',
          likelihood: 4
        },
        {
          end_year: 2030,
          intensity: 6,
          sector: 'Manufacturing',
          topic: 'city',
          insight: 'Electric Cars Are About to Dent Global Gasoline Consumption',
          url: 'https://www.technologyreview.com/s/602956/electric-cars-are-about-to-dent-global-gasoline-consumption/',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 24 2016 03:51:48',
          published: 'November, 22 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Social',
          source: 'MIT Technology Review',
          title: 'As many as two-thirds of all cars on the road in some wealthy cities could be electric by 2030.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Electric Cars Are About to Dent Global Gasoline Consumption',
          url: 'https://www.technologyreview.com/s/602956/electric-cars-are-about-to-dent-global-gasoline-consumption/',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 24 2016 03:51:48',
          published: 'November, 22 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'MIT Technology Review',
          title: 'The IEA reckons other types of refined oil, such as jet fuel and diesel, will continue to grow.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Oil: Why Goldman Is Now "Tactically Bullish"',
          url: 'http://blogs.barrons.com/asiastocks/2016/11/21/oil-why-goldman-is-now-tactically-bullish/?mod=bol-social-tw',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'November, 23 2016 04:32:45',
          published: '',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'Fitch',
          title: 'The global oil market will shift into a supply deficit in the second-half of next year.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Manufacturing',
          topic: 'production',
          insight: "Warning sounded on this year's olive oil harvest",
          url: 'http://www.foodqualitynews.com/Industry-news/Experts-provides-olive-oil-harvest-insights?platform=hootsuite',
          region: 'Southern Europe',
          start_year: '',
          impact: '',
          added: 'November, 23 2016 02:38:20',
          published: 'November, 22 2016 00:00:00',
          country: 'Spain',
          relevance: 2,
          pestle: 'Industries',
          source: 'FoodQualityNews.com',
          title: 'Spain is going to have increased production compared to last year, resulting in a surplus of extra oil.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 8,
          sector: 'Manufacturing',
          topic: 'production',
          insight: "Warning sounded on this year's olive oil harvest",
          url: 'http://www.foodqualitynews.com/Industry-news/Experts-provides-olive-oil-harvest-insights?platform=hootsuite',
          region: 'Southern Europe',
          start_year: '',
          impact: '',
          added: 'November, 23 2016 02:38:19',
          published: 'November, 22 2016 00:00:00',
          country: 'Greece',
          relevance: 2,
          pestle: 'Industries',
          source: 'FoodQualityNews.com',
          title: 'Greece will be the third highest in estimated production volume (behind Italy and Spain) and will have a 50,000 metric ton oilve oil surplus.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'oil',
          insight: "What Trump's 'energy independent' US would mean for the rest of the world",
          url: 'http://theconversation.com/what-trumps-energy-independent-us-would-mean-for-the-rest-of-the-world-69182?#link_time=1479828652',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'November, 23 2016 02:27:44',
          published: 'November, 22 2016 00:00:00',
          country: 'United States of America',
          relevance: 2,
          pestle: 'Industries',
          source: 'The Conversation',
          title: 'The US could further increase imports of Canadian crude oil.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Financial services',
          topic: 'interest rate',
          insight: 'World Bank Document',
          url: 'http://documents.worldbank.org/curated/en/409591474983005625/pdf/108525-REVISED-PUBLIC.pdf',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'November, 22 2016 08:05:57',
          published: 'October, 04 2016 00:00:00',
          country: 'United States of America',
          relevance: 2,
          pestle: 'Economic',
          source: 'World Bank Group',
          title: 'The recent hike in interest rates in the US could lead to a tightening of financial markets and increase the costs of financing.',
          likelihood: 2
        },
        {
          end_year: 2016,
          intensity: 12,
          sector: 'Energy',
          topic: 'growth',
          insight: 'World Bank Document',
          url: 'http://documents.worldbank.org/curated/en/409591474983005625/pdf/108525-REVISED-PUBLIC.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 22 2016 08:05:55',
          published: 'October, 04 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'World Bank Group',
          title: 'Hydrocarbon GDP growth is expected to slow down to 2 percent in 2016 from an estimated 4.6 percent in 2015.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Financial services',
          topic: 'oil',
          insight: 'World Bank Document',
          url: 'http://documents.worldbank.org/curated/en/409591474983005625/pdf/108525-REVISED-PUBLIC.pdf',
          region: 'Western Asia',
          start_year: '',
          impact: '',
          added: 'November, 22 2016 08:05:52',
          published: 'October, 04 2016 00:00:00',
          country: 'Saudi Arabia',
          relevance: 2,
          pestle: 'Economic',
          source: 'World Bank Group',
          title: 'Low oil prices continue to threaten growth and fiscal sustainability in the Kingdom of Saudi Arabia.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'gas',
          insight: 'World Bank Document',
          url: 'http://documents.worldbank.org/curated/en/409591474983005625/pdf/108525-REVISED-PUBLIC.pdf',
          region: 'Western Asia',
          start_year: '',
          impact: '',
          added: 'November, 22 2016 08:05:50',
          published: 'October, 04 2016 00:00:00',
          country: 'Qatar',
          relevance: 2,
          pestle: 'Economic',
          source: 'World Bank Group',
          title: "Over the medium term, growing competition and the emergence of a global spot market in gas prices could pose a challenge to Qatar's dominance in global LNG markets.",
          likelihood: 2
        },
        {
          end_year: 2018,
          intensity: 16,
          sector: 'Food & agriculture',
          topic: 'food',
          insight: 'World Bank Document',
          url: 'http://documents.worldbank.org/curated/en/409591474983005625/pdf/108525-REVISED-PUBLIC.pdf',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'November, 22 2016 08:05:45',
          published: 'October, 04 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Political',
          source: 'World Bank Group',
          title: 'Cost push pressures from rising global food prices and subsidy reform are expected to increase inflation to 2.8 percent by 2018.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Financial services',
          topic: 'gdp',
          insight: 'World Bank Document',
          url: 'http://documents.worldbank.org/curated/en/409591474983005625/pdf/108525-REVISED-PUBLIC.pdf',
          region: '',
          start_year: 2018,
          impact: '',
          added: 'November, 22 2016 08:05:44',
          published: 'October, 04 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'World Bank Group',
          title: 'Continued fiscal austerity measures and revenue mobilization will allow the budget deficit to further narrow to 10 percent of GDP in 2018.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Construction',
          topic: 'investment',
          insight: 'World Bank Document',
          url: 'http://documents.worldbank.org/curated/en/409591474983005625/pdf/108525-REVISED-PUBLIC.pdf',
          region: 'Western Asia',
          start_year: '',
          impact: '',
          added: 'November, 22 2016 08:05:44',
          published: 'October, 04 2016 00:00:00',
          country: 'Oman',
          relevance: 2,
          pestle: 'Economic',
          source: 'World Bank Group',
          title: 'Oman is expected to focus its infrastructure investment in tourism and logistics.',
          likelihood: 3
        },
        {
          end_year: 2016,
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'World Bank Document',
          url: 'http://documents.worldbank.org/curated/en/409591474983005625/pdf/108525-REVISED-PUBLIC.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 22 2016 08:05:41',
          published: 'October, 04 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'World Bank Group',
          title: 'Lower oil sector investment in 2016 in Oman is expected to slow hydrocarbon GDP growth to 1.1 percent from 4 percent in 2015.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'World Bank Document',
          url: 'http://documents.worldbank.org/curated/en/409591474983005625/pdf/108525-REVISED-PUBLIC.pdf',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'November, 22 2016 08:05:33',
          published: 'October, 04 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'World Bank Group',
          title: 'Non-oil sector growth in Iraq is projected to recover to 0.2 percent in 2017.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 9,
          sector: 'Financial services',
          topic: 'money',
          insight: 'World Bank Document',
          url: 'http://documents.worldbank.org/curated/en/409591474983005625/pdf/108525-REVISED-PUBLIC.pdf',
          region: 'Western Asia',
          start_year: '',
          impact: '',
          added: 'November, 22 2016 08:05:33',
          published: 'October, 04 2016 00:00:00',
          country: 'Iraq',
          relevance: 3,
          pestle: 'Economic',
          source: 'World Bank Group',
          title: 'Fiscal and current account deficits are expected to be financed by an increase in indirect monetary financing by the Central Bank of Iraq.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 12,
          sector: '',
          topic: 'growth',
          insight: 'World Bank Document',
          url: 'http://documents.worldbank.org/curated/en/409591474983005625/pdf/108525-REVISED-PUBLIC.pdf',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'November, 22 2016 08:05:32',
          published: 'October, 04 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'World Bank Group',
          title: 'Overall real GDP growth in Iraq is expected to reach 4.8 percent in 2016.',
          likelihood: 4
        },
        {
          end_year: 2018,
          intensity: 16,
          sector: '',
          topic: 'economy',
          insight: 'World Bank Document',
          url: 'http://documents.worldbank.org/curated/en/409591474983005625/pdf/108525-REVISED-PUBLIC.pdf',
          region: 'Southern Asia',
          start_year: 2016,
          impact: '',
          added: 'November, 22 2016 08:05:30',
          published: 'October, 04 2016 00:00:00',
          country: 'Iran',
          relevance: 4,
          pestle: 'Economic',
          source: 'World Bank Group',
          title: "Iran's economy is expected to grow at an annual average rate of 4.6 percent in 2016-18.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: '',
          topic: 'growth',
          insight: 'World Bank Document',
          url: 'http://documents.worldbank.org/curated/en/409591474983005625/pdf/108525-REVISED-PUBLIC.pdf',
          region: 'Southern Asia',
          start_year: 2016,
          impact: '',
          added: 'November, 22 2016 08:05:20',
          published: 'October, 04 2016 00:00:00',
          country: 'Iran',
          relevance: 4,
          pestle: 'Economic',
          source: 'World Bank Group',
          title: 'Growth in Iran will accelerate to 4.3 percent in 2016.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'World Bank Document',
          url: 'http://documents.worldbank.org/curated/en/409591474983005625/pdf/108525-REVISED-PUBLIC.pdf',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'November, 22 2016 08:05:16',
          published: 'October, 04 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'World Bank Group',
          title: 'Growth in oil exporters in MENA is expected to remain subdued at 2.3 percent in 2016 due to a sharp drop in growth in the GCC countries.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: '',
          topic: 'growth',
          insight: 'World Bank Document',
          url: 'http://documents.worldbank.org/curated/en/409591474983005625/pdf/108525-REVISED-PUBLIC.pdf',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'November, 22 2016 08:05:15',
          published: 'October, 04 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'World Bank Group',
          title: "Real GDP growth in MENA for 2016 is projected to fall to its lowest level since 2013, 2.3 percent, lower than last year's growth by half a percentage point and about one percentage point lower than predicted in April 2016.",
          likelihood: 4
        },
        {
          end_year: 2017,
          intensity: 72,
          sector: '',
          topic: 'revenue',
          insight: 'World Bank Document',
          url: 'http://documents.worldbank.org/curated/en/409591474983005625/pdf/108525-REVISED-PUBLIC.pdf',
          region: '',
          start_year: 2016,
          impact: 3,
          added: 'November, 22 2016 08:05:14',
          published: 'October, 04 2016 00:00:00',
          country: '',
          relevance: 6,
          pestle: 'Economic',
          source: 'World Bank Group',
          title: 'OPEC revenue is expected to fall to $341 billion in 2016 before rising to $427 billion in 2017.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: '',
          topic: 'growth',
          insight: 'World Bank Document',
          url: 'http://documents.worldbank.org/curated/en/409591474983005625/pdf/108525-REVISED-PUBLIC.pdf',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'November, 22 2016 08:05:11',
          published: 'October, 04 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'World Bank Group',
          title: 'The global outlook remains weak with growth expected to stay below the average of 2000-07 for the seventh year in a row.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 20,
          sector: '',
          topic: 'growth',
          insight: 'World Bank Document',
          url: 'http://documents.worldbank.org/curated/en/409591474983005625/pdf/108525-REVISED-PUBLIC.pdf',
          region: 'Western Asia',
          start_year: 2016,
          impact: '',
          added: 'November, 22 2016 08:05:11',
          published: 'October, 04 2016 00:00:00',
          country: 'Saudi Arabia',
          relevance: 5,
          pestle: 'Economic',
          source: 'World Bank Group',
          title: "Among Middle East oil exporters, growth in the GCC countries is expected to fall sharply with Saudi Arabia's declining to one percent in 2016 from above 3 percent last year.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: '',
          topic: 'growth',
          insight: 'World Bank Document',
          url: 'http://documents.worldbank.org/curated/en/409591474983005625/pdf/108525-REVISED-PUBLIC.pdf',
          region: 'Central Africa',
          start_year: 2016,
          impact: '',
          added: 'November, 22 2016 08:05:10',
          published: 'October, 04 2016 00:00:00',
          country: 'Angola',
          relevance: 4,
          pestle: 'Economic',
          source: 'World Bank Group',
          title: "Nigeria's and Angola's growth will fall below 1 percent in 2016 from almost 3 percent a year ago.",
          likelihood: 4
        },
        {
          end_year: 2017,
          intensity: 6,
          sector: '',
          topic: 'growth',
          insight: 'Recession worsens as economy shrinks by 2.24 percent in Q3',
          url: 'https://www.thecable.ng/breaking-recession-worsens-economy-shrinks-2-24-percent-q3',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'November, 22 2016 03:01:20',
          published: 'November, 21 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'TheCable',
          title: "Nigeria's growth could reach 2.5 percent next year.",
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'emission',
          insight: 'Low growth in global carbon emissions continues for third successive year',
          url: 'http://futureearth.org/news/low-growth-global-carbon-emissions-continues-third-successive-year',
          region: 'Northern America',
          start_year: 2016,
          impact: '',
          added: 'November, 22 2016 01:55:29',
          published: '',
          country: 'United States of America',
          relevance: 4,
          pestle: 'Environmental',
          source: 'Future Earth',
          title: 'U.S. emissions are projected to decrease by 1.7 percent in 2016.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'coal',
          insight: 'Analysis: What global emissions in 2016 mean for climate change goals',
          url: 'https://www.carbonbrief.org/what-global-co2-emissions-2016-mean-climate-change',
          region: 'Eastern Asia',
          start_year: 2016,
          impact: '',
          added: 'November, 22 2016 01:54:49',
          published: 'November, 15 2016 00:00:00',
          country: 'China',
          relevance: 4,
          pestle: 'Environmental',
          source: 'Carbon Brief',
          title: 'The drop in emissions forecast for China in 2016 is largely down to a reduction in coal emissions of 1.8%.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Environment',
          topic: 'oil',
          insight: 'Wetland',
          url: 'https://en.wikipedia.org/wiki/Wetland',
          region: 'Africa',
          start_year: '',
          impact: '',
          added: 'November, 20 2016 07:23:03',
          published: '',
          country: '',
          relevance: 2,
          pestle: 'Environmental',
          source: 'Wikipedia',
          title: 'Industrial-scale production of palm oil threatens the biodiversity of wetland ecosystems in parts of southeast Asia, Africa, and other developing countries.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Food & agriculture',
          topic: 'climate change',
          insight: 'Methane Issue Brief',
          url: 'http://nwf.org/~/media/PDFs/Global-Warming/Reports/Methane-Issue-Brief_NWF_Nov2016.ashx',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'November, 20 2016 07:16:56',
          published: 'October, 24 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Environmental',
          source: 'NWF',
          title: 'One in every six species on Earth could become extinct if climate change were to continue apace.',
          likelihood: 2
        },
        {
          end_year: 2025,
          intensity: 12,
          sector: 'Construction',
          topic: 'infrastructure',
          insight: 'India PVC Market Study, 2011 - 2025',
          url: 'https://www.giiresearch.com/report/tsci388963-india-pvc-market-study.html',
          region: 'Southern Asia',
          start_year: '',
          impact: '',
          added: 'November, 20 2016 04:20:10',
          published: 'November, 15 2016 00:00:00',
          country: 'India',
          relevance: 4,
          pestle: 'Economic',
          source: 'Gii Research',
          title: 'Coupled with development of proper infrastructure in the country are the major factors that are expected to drive India PVC market through 2025.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Manufacturing',
          topic: 'production',
          insight: 'Oilseeds',
          url: 'http://apps.fas.usda.gov/psdonline/circulars/oilseeds.pdf',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'November, 20 2016 03:25:47',
          published: 'November, 09 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'USDA',
          title: 'Global olive oil supplies in 2016/17 are forecast to tighten as production prospects for major producers in the Mediterranean basin are revised lower. Total global production is forecast at 2.8 million tons, down 8 percent from the previous campaign.',
          likelihood: 4
        },
        {
          end_year: 2041,
          intensity: 9,
          sector: 'Energy',
          topic: 'coal',
          insight: 'World Energy Outlook 2016',
          url: 'https://www.energyglobal.com/pipelines/equipment-and-safety/16112016/world-energy-outlook-2016/',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'November, 20 2016 03:23:11',
          published: 'November, 16 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Environmental',
          source: 'energyglobal',
          title: 'Coal consumption will grow very little in the next 25 years.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Financial services',
          topic: 'oil',
          insight: 'World Energy Outlook 2016',
          url: 'http://www.iea.org/newsroom/news/2016/november/world-energy-outlook-2016.html',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'November, 20 2016 03:21:48',
          published: 'November, 16 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'IEA.org',
          title: 'Another year of lower upstream oil investment in 2017 would create a significant risk of a shortfall in new conventional supply within a few years.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: '',
          topic: '',
          insight: 'UK Economic Outlook',
          url: 'http://www.pwc.co.uk/economic-services/ukeo/ukeo-nov16-full-report.pdf',
          region: 'Northern Europe',
          start_year: 2017,
          impact: '',
          added: 'November, 20 2016 02:06:11',
          published: 'November, 09 2016 00:00:00',
          country: 'United Kingdom',
          relevance: 3,
          pestle: '',
          source: 'PwC',
          title: 'UK inflation could remain at only around 1% on average in 2017.',
          likelihood: 2
        },
        {
          end_year: 2017,
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Molybdenum',
          url: 'https://www.metalprices.com/metal/molybdenum/lme-molybdenum-cash-official',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 20 2016 01:48:49',
          published: 'November, 17 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'metalprices',
          title: 'Oil prices could fall next year if the supply surplus persists.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Information Technology',
          topic: 'gas',
          insight: "This Astronomer's Idea Just Opened A Universe Of New Opportunities For GE's Digital Growth",
          url: 'http://www.gereports.com/astronomers-idea-just-opened-universe-new-opportunities-ges-digital-growth/',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 19 2016 03:13:39',
          published: 'November, 18 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Technological',
          source: 'GE Reports',
          title: 'Inspectors at an oil and gas pipeline company can now take reams of data from acoustic pressure measurements and filter out unnecessary noise to focus on data that might signal the risk of a dangerous leak.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Energy',
          topic: 'energy',
          insight: 'Financing the Climate-Change Transition',
          url: 'https://www.project-syndicate.org/commentary/finance-climate-change-clean-energy-by-hans-j--schellnhuber-et-al-2016-11',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 19 2016 02:41:37',
          published: 'November, 14 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Political',
          source: 'Project Syndicate',
          title: 'Investments in fossil-fuel energy sources will continue to lose value over time.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Government',
          topic: 'government',
          insight: 'An Economic Ultimatum for the Arab World',
          url: 'https://www.project-syndicate.org/commentary/rentierism-middle-east-arab-world-by-marwan-muasher-2016-11',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 19 2016 02:40:58',
          published: 'November, 16 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Political',
          source: 'Project Syndicate',
          title: 'Arab governments will need to privatize many state-controlled companies.',
          likelihood: 3
        },
        {
          end_year: 2030,
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Oil taking on green sheen',
          url: 'http://phys.org/news/2016-11-oil-green-sheen.html',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 19 2016 01:38:54',
          published: 'November, 13 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'Phys Org',
          title: 'Oil demand could begin declining by 2030.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 16,
          sector: '',
          topic: 'economic',
          insight: '80 Gensler Leaders Spotlight Their Favorite Projects',
          url: 'http://www.interiordesign.net/articles/11124-the-people-who-make-the-place/',
          region: '',
          start_year: 2020,
          impact: '',
          added: 'November, 18 2016 05:47:29',
          published: 'December, 03 2015 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'Interior Design',
          title: 'The Dubai World Expo 2020 will be an additional economic driver for the region.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Energy',
          topic: 'energy',
          insight: 'World Energy Outlook 2016 - Executive Summary - English version',
          url: 'http://www.iea.org/publications/freepublications/publication/WorldEnergyOutlook2016ExecutiveSummaryEnglish.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 18 2016 04:24:05',
          published: 'October, 27 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Environmental',
          source: 'IEA',
          title: 'Over the period to 2040, the amount of energy used in the water sector is projected to more than double.',
          likelihood: 3
        },
        {
          end_year: 2016,
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'World Energy Outlook 2016 - Executive Summary - English version',
          url: 'http://www.iea.org/publications/freepublications/publication/WorldEnergyOutlook2016ExecutiveSummaryEnglish.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 18 2016 04:24:04',
          published: 'October, 27 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'IEA',
          title: 'A near-term risk to oil markets could arise from the opposite direction if the cuts in upstream spending in 2015-2016 are prolonged for another year.',
          likelihood: 2
        },
        {
          end_year: 2020,
          intensity: 12,
          sector: 'Information Technology',
          topic: 'gas',
          insight: '10 predictions for the oil and gas industry',
          url: 'https://idc-community.com/energy/oilgas/10_predictions_for_the_oil__gas_industry',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 18 2016 02:35:43',
          published: 'November, 17 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Social',
          source: 'idc-community',
          title: 'By 2020, 80% of large Oil & Gas companies will run their business with help from a cognitive/AI agent capable of learning, reasoning, and solving complex problems.',
          likelihood: 4
        },
        {
          end_year: 2020,
          intensity: 12,
          sector: 'Security',
          topic: 'security',
          insight: '10 predictions for the oil and gas industry',
          url: 'https://idc-community.com/energy/oilgas/10_predictions_for_the_oil__gas_industry',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 18 2016 02:35:42',
          published: 'November, 17 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Political',
          source: 'idc-community',
          title: 'By 2020, 50% of companies will monitor and inspect oilfield assets and pipelines for purposes of security and safety and to rapidly react to problematic, and even dangerous, conditions.',
          likelihood: 4
        },
        {
          end_year: 2019,
          intensity: 12,
          sector: 'Information Technology',
          topic: 'gas',
          insight: '10 predictions for the oil and gas industry',
          url: 'https://idc-community.com/energy/oilgas/10_predictions_for_the_oil__gas_industry',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 18 2016 02:35:42',
          published: 'November, 17 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Technological',
          source: 'idc-community',
          title: 'By 2019, 40% of all Oil & Gas companies will have basic platforms for managing data and generating analytics and cognitive/artificial intelligence solutions for performance-related insights.',
          likelihood: 4
        },
        {
          end_year: 2019,
          intensity: 16,
          sector: 'Information Technology',
          topic: 'gas',
          insight: '10 predictions for the oil and gas industry',
          url: 'https://idc-community.com/energy/oilgas/10_predictions_for_the_oil__gas_industry',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'November, 18 2016 02:35:41',
          published: 'November, 17 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Technological',
          source: 'idc-community',
          title: 'By 2019, Oil & Gas companies that executed digital transformation plans in 2016 will have reduced costs and increased efficiencies (10-50%) by evolving IT to 3rd Platform technologies.',
          likelihood: 4
        },
        {
          end_year: 2018,
          intensity: 12,
          sector: 'Information Technology',
          topic: 'gas',
          insight: '10 predictions for the oil and gas industry',
          url: 'https://idc-community.com/energy/oilgas/10_predictions_for_the_oil__gas_industry',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 18 2016 02:35:40',
          published: 'November, 17 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Technological',
          source: 'idc-community',
          title: 'By 2018, more than 50% of Oil & Gas companies will acknowledge cybersecurity as the top IT initiative because of the vast numbers of new sensors, devices, and software presenting multiple, new entry points.',
          likelihood: 4
        },
        {
          end_year: 2018,
          intensity: 12,
          sector: 'Information Technology',
          topic: 'software',
          insight: '10 predictions for the oil and gas industry',
          url: 'https://idc-community.com/energy/oilgas/10_predictions_for_the_oil__gas_industry',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 18 2016 02:35:39',
          published: 'November, 17 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Technological',
          source: 'idc-community',
          title: 'By 2018, 50%+ of companies will update software that will reduce costs and help build a stable IT environment, automating workflows, filling functionality gaps, and aligning processes.',
          likelihood: 4
        },
        {
          end_year: 2018,
          intensity: 12,
          sector: 'Energy',
          topic: 'gas',
          insight: '10 predictions for the oil and gas industry',
          url: 'https://idc-community.com/energy/oilgas/10_predictions_for_the_oil__gas_industry',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 18 2016 02:35:39',
          published: 'November, 17 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'idc-community',
          title: 'By 2018, 50% of Oil & Gas companies will be using proven assembly-line and just-in-time manufacturing methodologies and approaches to well development and production.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Sovereign Risk Downgrades Outnumber Upgrades Despite Being over Low Oil Trough, IHS Markit Says',
          url: 'http://news.ihsmarkit.com/press-release/financial-markets/sovereign-risk-downgrades-outnumber-upgrades-despite-being-over-low-?&hootPostID=7088ede0e1811f9f7bdefca9123e2c3e',
          region: 'Western Asia',
          start_year: '',
          impact: '',
          added: 'November, 18 2016 00:40:09',
          published: 'November, 11 2016 00:00:00',
          country: 'Saudi Arabia',
          relevance: 2,
          pestle: 'Economic',
          source: 'ihsmarkit',
          title: 'Saudi Arabia could see some tumultuous economic policy changes provoked by the lower oil price era and the emerging challenge from renewable energies.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'emission',
          insight: 'Low growth in global carbon emissions continues for third successive year',
          url: 'https://www.sciencedaily.com/releases/2016/11/161114082243.htm',
          region: 'Northern America',
          start_year: 2016,
          impact: '',
          added: 'November, 16 2016 04:47:01',
          published: 'November, 14 2016 00:00:00',
          country: 'United States of America',
          relevance: 4,
          pestle: 'Environmental',
          source: 'Science Daily',
          title: 'USA emissions are projected to decrease by 1.7 per cent in 2016.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 8,
          sector: 'Energy',
          topic: 'oil',
          insight: 'U.S. energy companies lead indexes higher as oil price soars',
          url: 'http://mainichi.jp/english/articles/20161116/p2g/00m/0bu/005000c',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 16 2016 01:06:56',
          published: 'November, 16 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'The Mainichi',
          title: 'Oil rose almost 6 percent as investors once again grew hopeful that the OPEC cartel will agree to cut fuel production in a few weeks.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'U.S. Macroeconomic Outlook Alternative Scenarios',
          url: 'https://www.economy.com/home/products/samples/Moodys-Analytics-US-Alternative-Scenarios.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 13 2016 06:22:41',
          published: 'February, 16 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'economy',
          title: "Moody's Analytics does not expect oil prices to top $100 per barrel for another decade.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'IHS Identifies Top Five Trends in 2016 That Will Shape the Global Maritime Industry for the Coming Decade',
          url: 'http://news.ihsmarkit.com/press-release/maritime-trade/ihs-identifies-top-five-trends-2016-will-shape-global-maritime-industry',
          region: 'World',
          start_year: 2016,
          impact: '',
          added: 'November, 13 2016 05:39:58',
          published: 'November, 18 2015 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'ihsmarkit',
          title: 'The lifting of some Iranian sanctions is expected to add about half a million barrels of oil a day to the global supply by the end of 2016.',
          likelihood: 4
        },
        {
          end_year: 2040,
          intensity: 20,
          sector: 'Energy',
          topic: 'oil',
          insight: 'IHS Identifies Top Five Trends in 2016 That Will Shape the Global Maritime Industry for the Coming Decade',
          url: 'http://news.ihsmarkit.com/press-release/maritime-trade/ihs-identifies-top-five-trends-2016-will-shape-global-maritime-industry',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'November, 13 2016 05:39:54',
          published: 'November, 18 2015 00:00:00',
          country: '',
          relevance: 5,
          pestle: 'Economic',
          source: 'ihsmarkit',
          title: 'IHS expects overall global oil demand growth will average just 0.6 percent per year through 2040.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'emission',
          insight: 'Fracking Week in Parliament - week ending 11 November 2016',
          url: 'https://drillordrop.com/2016/11/12/fracking-week-in-parliament-week-ending-11-november-2016/',
          region: '',
          start_year: 2035,
          impact: '',
          added: 'November, 13 2016 04:41:14',
          published: 'November, 12 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Environmental',
          source: 'Drill or drop?',
          title: "Scotland's CO2 equivalent emissions in 2035 could be between 1.1 and 2.6 megatonnes per year.",
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: '',
          topic: 'trade',
          insight: "Most Canadians Worry Trump Will Hurt Their Country's Relationship With The U.S.",
          url: 'http://www.huffingtonpost.com/entry/canada-us-relations-trump-election_us_5825f233e4b0c4b63b0c4c26?ir=WorldPost',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'November, 12 2016 02:11:09',
          published: 'November, 11 2016 00:00:00',
          country: 'Canada',
          relevance: 2,
          pestle: 'Economic',
          source: 'Huffington Post',
          title: "Canada's trade relations with the U.S. will take a hit.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'emission',
          insight: "Hundreds of thousands of lives to be saved thanks to IMO's cleaner ship fuel decision",
          url: 'http://www.transportenvironment.org/news/hundreds-thousands-lives-be-saved-thanks-imo’s-cleaner-ship-fuel-decision',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 12 2016 01:51:29',
          published: 'November, 10 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Environmental',
          source: 'Transport Environment',
          title: "Shipping's SO2 emissions will be reduced by 85% compared with today's levels.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 2,
          sector: '',
          topic: 'risk',
          insight: 'Outlook bleak for the oil industry',
          url: 'http://www.transportenvironment.org/news/outlook-bleak-oil-industry',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 12 2016 01:51:24',
          published: 'November, 10 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Economic',
          source: 'Transport Environment',
          title: 'Companies such as ExxonMobil are at risk from declining demand and plentiful low-cost supply.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Financial services',
          topic: 'oil',
          insight: 'Outlook bleak for the oil industry',
          url: 'http://www.transportenvironment.org/news/outlook-bleak-oil-industry',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 12 2016 01:51:23',
          published: 'November, 10 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Economic',
          source: 'Transport Environment',
          title: 'A surge in EV sales would threaten oil investments.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Construction',
          topic: 'growth',
          insight: 'Outlook bleak for the oil industry',
          url: 'http://www.transportenvironment.org/news/outlook-bleak-oil-industry',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 12 2016 01:51:22',
          published: 'November, 10 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Economic',
          source: 'Transport Environment',
          title: 'The growth in electric vehicles will be held up by several aspects of EV infrastructure.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Financial services',
          topic: 'investment',
          insight: 'Legal Considerations Guiding the Iraq-Kurdistan Dispute',
          url: 'https://www.lawfareblog.com/legal-considerations-guiding-iraq-kurdistan-dispute',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'November, 12 2016 01:09:55',
          published: 'November, 07 2016 00:00:00',
          country: 'United States of America',
          relevance: 2,
          pestle: 'Political',
          source: 'Lawfare',
          title: 'A series of massive investments in the region by the U.S. military even control over Kirkuk will not be enough to lift Kurdistan from its dire straits.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Government',
          topic: 'robot',
          insight: 'Futureseek Daily Link Review; 6 November 2016',
          url: 'https://futureseek.wordpress.com/2016/11/06/futureseek-daily-link-review-6-november-2016/',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 12 2016 01:02:27',
          published: 'November, 06 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Political',
          source: 'Futureseek Link Digest',
          title: 'Elon Musk predicts robots will take so many jobs from people governments will be forced to pay everyone a basic wage.',
          likelihood: 3
        },
        {
          end_year: 2017,
          intensity: 16,
          sector: 'Energy',
          topic: 'economic growth',
          insight: 'THE DAILY EDGE (10 November 2016): Watch the tax rates!',
          url: 'http://www.edgeandodds.com/2016/11/10/the-daily-edge-10-november-2016-watch-the-tax-rates/',
          region: 'Eastern Asia',
          start_year: 2016,
          impact: '',
          added: 'November, 11 2016 06:04:46',
          published: 'November, 10 2016 00:00:00',
          country: 'China',
          relevance: 4,
          pestle: 'Economic',
          source: 'Edge and Odds',
          title: 'Slower global economic growth and more modest demand in previous consumption hot spots such as India and China mean overall demand for oil will likely not pick up next year.',
          likelihood: 4
        },
        {
          end_year: 2017,
          intensity: 8,
          sector: '',
          topic: 'growth',
          insight: 'THE DAILY EDGE (10 November 2016): Watch the tax rates!',
          url: 'http://www.edgeandodds.com/2016/11/10/the-daily-edge-10-november-2016-watch-the-tax-rates/',
          region: 'World',
          start_year: 2016,
          impact: '',
          added: 'November, 11 2016 06:04:45',
          published: 'November, 10 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'Edge and Odds',
          title: '2017 could be another year of relentless global oil supply growth similar to that seen in 2016.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 8,
          sector: 'Construction',
          topic: 'building',
          insight: 'THE DAILY EDGE (10 November 2016): Watch the tax rates!',
          url: 'http://www.edgeandodds.com/2016/11/10/the-daily-edge-10-november-2016-watch-the-tax-rates/',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'November, 11 2016 06:04:44',
          published: 'November, 10 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'Edge and Odds',
          title: '2017 could see oil inventories building again if there is no cut from OPEC.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Energy',
          topic: 'gas',
          insight: 'What Does a Trump Presidency Mean for Environmental Managers? By: Jessica Lyons Hardcastle',
          url: 'http://www.environmentalleader.com/2016/11/09/what-does-a-trump-presidency-mean-for-environmental-managers/',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 11 2016 04:11:02',
          published: '',
          country: '',
          relevance: 1,
          pestle: 'Industries',
          source: 'Environmental Leader',
          title: "Trump's pledge to promote more oil and gas exploration could help keep down prices.",
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 72,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Saudi Arabia owes billions to private firms after collapse in oil revenues',
          url: 'https://www.theguardian.com/world/2016/nov/11/saudi-arabia-owes-billions-to-private-firms-after-collapse-in-oil-revenues?CMP=twt_gu',
          region: 'Western Asia',
          start_year: 2016,
          impact: 3,
          added: 'November, 11 2016 03:46:35',
          published: 'November, 11 2016 00:00:00',
          country: 'Saudi Arabia',
          relevance: 6,
          pestle: 'Industries',
          source: 'Guardian',
          title: "Saudi Arabia, the world's biggest oil exporter, is projecting a budget deficit of $87bn in 2016.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Energy',
          topic: 'coal',
          insight: "Obama's Environmental Legacy Just Went Up in Smoke",
          url: 'http://www.bloomberg.com/news/articles/2016-11-10/obama-s-environmental-legacy-just-went-up-in-smoke?cmpid=socialflow-twitter-businessweek',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 11 2016 03:01:31',
          published: 'November, 10 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Environmental',
          source: 'Bloomberg Business',
          title: "Obama's temporary moratorium on coal production on federal land will likely be overturned by Trump.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 8,
          sector: 'Retail',
          topic: 'export',
          insight: "Palm Oil Tipped to Oust Iron Ore as Liberia's Leading Export",
          url: 'http://www.bloomberg.com/news/articles/2016-11-08/palm-oil-tipped-to-replace-iron-ore-as-liberia-s-leading-export',
          region: 'Western Africa',
          start_year: '',
          impact: '',
          added: 'November, 11 2016 02:33:16',
          published: 'November, 08 2016 00:00:00',
          country: 'Liberia',
          relevance: 2,
          pestle: 'Economic',
          source: 'Bloomberg Business',
          title: "Palm oil is forecast to replace iron ore as Liberia's leading export and employ more than 100,000 people in an economy that was ravaged by a commodity price slump and the worst-ever Ebola outbreak.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Environment',
          topic: 'economy',
          insight: 'Setback for renewable energy, says S&P',
          url: 'http://www.business-standard.com/article/international/setback-for-renewable-energy-says-s-p-116111000004_1.html',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 10 2016 03:37:39',
          published: 'November, 10 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Economic',
          source: 'Business Standard',
          title: 'Trump would likely quash efforts to institute new greenhouse gas performance standards for petroleum refineries and could push to weaken future fuel economy standards for light-duty vehicles.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 3,
          sector: '',
          topic: 'growth',
          insight: 'Autumn 2016 Economic Forecast: Modest growth in challenging times',
          url: 'http://europa.eu/rapid/press-release_IP-16-3611_en.htm',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 10 2016 03:22:05',
          published: 'November, 09 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Economic',
          source: 'ESPAS',
          title: 'Core inflation in the euro area is expected to rise gradually amid higher wage growth and a further narrowing of the output gap.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 48,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Saudi oil shipments to Egypt halted indefinitely, Egyptian officials say',
          url: 'http://uk.mobile.reuters.com/article/worldNews/idUSKBN1320RQ?il=0',
          region: 'Northern Africa',
          start_year: '',
          impact: 3,
          added: 'November, 09 2016 05:28:28',
          published: 'November, 07 2016 00:00:00',
          country: 'Egypt',
          relevance: 4,
          pestle: 'Industries',
          source: 'Reuters',
          title: 'Saudi Arabia has informed Egypt that shipments of oil products expected under a $23 billion aid deal have been halted indefinitely.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: "Egypt to Enter Int'l Oil Market, Seek Better Prices to Replace Saudi Deliveries",
          url: 'https://sputniknews.com/business/201611081047172882-egypt-oil-market/',
          region: 'Northern Africa',
          start_year: '',
          impact: '',
          added: 'November, 09 2016 05:28:19',
          published: 'November, 08 2016 00:00:00',
          country: 'Egypt',
          relevance: 2,
          pestle: 'Political',
          source: 'Sputnik News',
          title: 'Egypt will enter the international oil market and seek better prices to supplant suspended deliveries from Saudi Arabia.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 2,
          sector: '',
          topic: 'demand',
          insight: 'Energy 2050: Insights from the ground up',
          url: 'http://www.mckinsey.com/industries/oil-and-gas/our-insights/energy-2050-insights-from-the-ground-up',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 09 2016 04:39:16',
          published: 'November, 01 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Economic',
          source: 'McKinsey & Company',
          title: 'Peak oil demand could come as soon as 2030.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 9,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Russian oil major Lukoil says ready to freeze output',
          url: 'http://rbth.com/news/2016/11/08/russian-oil-major-lukoil-says-ready-to-freeze-output_646031',
          region: 'Eastern Europe',
          start_year: '',
          impact: '',
          added: 'November, 09 2016 01:41:34',
          published: 'November, 08 2016 00:00:00',
          country: 'Russia',
          relevance: 3,
          pestle: 'Industries',
          source: 'Russia Beyond The Headlines',
          title: "Russia's largest private oil company Lukoil will freeze output, if the Organization of the Petroleum Exporting Countries (OPEC) makes such a decision at its Nov. 30 meeting in Vienna and Russia joins it.",
          likelihood: 3
        },
        {
          end_year: 2026,
          intensity: 72,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Big Oil to Invest $1 Billion in Carbon-Capture Technology',
          url: 'http://www.bloomberg.com/news/articles/2016-11-04/big-oil-to-invest-1-billion-in-carbon-capture-technology?platform=hootsuite',
          region: 'World',
          start_year: 2016,
          impact: 3,
          added: 'November, 08 2016 03:24:15',
          published: 'November, 04 2016 00:00:00',
          country: '',
          relevance: 6,
          pestle: 'Technological',
          source: 'Bloomberg Business',
          title: "Some of the world's biggest oil companies will invest $1 billion over the next 10 years to develop technologies to capture and store emissions of greenhouse gases and improve energy efficiency.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Aerospace & defence',
          topic: 'oil',
          insight: 'U.S. Election Guide to Markets: What to Watch With One Day to Go',
          url: 'http://www.bloomberg.com/politics/articles/2016-11-07/u-s-election-guide-to-markets-what-to-watch-with-one-day-to-go?cmpid=socialflow-twitter-business',
          region: 'Southern Asia',
          start_year: '',
          impact: '',
          added: 'November, 07 2016 06:26:25',
          published: 'November, 07 2016 00:00:00',
          country: 'Iran',
          relevance: 3,
          pestle: 'Political',
          source: 'Bloomberg Business',
          title: "Oil prices could get a lift from the return of a risk premium if Trump continues with the bellicose language that's been heard on the campaign trail about Iran and scraps President Barack Obama's nuclear deal with the country.",
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 3,
          sector: '',
          topic: '',
          insight: 'U.S. Election Guide to Markets: What to Watch With One Day to Go',
          url: 'http://www.bloomberg.com/politics/articles/2016-11-07/u-s-election-guide-to-markets-what-to-watch-with-one-day-to-go?cmpid=socialflow-twitter-business',
          region: 'Eastern Asia',
          start_year: '',
          impact: '',
          added: 'November, 07 2016 06:26:24',
          published: 'November, 07 2016 00:00:00',
          country: 'China',
          relevance: 1,
          pestle: '',
          source: 'Bloomberg Business',
          title: 'In Asia, China will bear the brunt of risks if Trump wins.',
          likelihood: 3
        },
        {
          end_year: 2019,
          intensity: 16,
          sector: 'Transport',
          topic: 'infrastructure',
          insight: 'State firms told to triple investment to help stoke growth',
          url: 'http://www.thejakartapost.com/news/2016/11/07/state-firms-told-to-triple-investment-to-help-stoke-growth-.html',
          region: 'South-Eastern Asia',
          start_year: '',
          impact: '',
          added: 'November, 07 2016 04:55:43',
          published: 'November, 07 2016 00:00:00',
          country: 'Indonesia',
          relevance: 4,
          pestle: 'Environmental',
          source: 'The Jakarta Post',
          title: 'Indonesia will need Rp 5.5 quadrillion for its infrastructure projects from 2014 to 2019.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Energy',
          topic: 'oil',
          insight: 'THE DAILY EDGE (4 November 2016)',
          url: 'http://www.edgeandodds.com/2016/11/04/the-daily-edge-4-november-2016/',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 07 2016 03:19:22',
          published: 'November, 04 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Industries',
          source: 'Edge and Odds',
          title: 'Riyadh is threatening to raise oil output steeply to bring prices down if Tehran refuses to limit its supply.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Retail',
          topic: 'export',
          insight: 'Denmark',
          url: 'http://www.eulerhermes.com/economic-research/blog/EconomicPublications/denmark-country-report-sep16.pdf',
          region: 'Northern Europe',
          start_year: '',
          impact: '',
          added: 'November, 07 2016 01:14:39',
          published: 'September, 28 2016 00:00:00',
          country: 'Denmark',
          relevance: 2,
          pestle: 'Economic',
          source: 'Euler Hermes',
          title: 'GBP depreciation could translate into lower export growth for Denmark.',
          likelihood: 2
        },
        {
          end_year: 2016,
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Weekly 04th November 2016',
          url: 'http://research-center.amundi.com/page/Article/2016/10/Weekly-04th-November-2016',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 06 2016 05:40:42',
          published: 'November, 04 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'amundi',
          title: 'The effects of some of the drivers of 2015 and 2016 (cheaper oil, weaker euro) are going to dissipate.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: '',
          topic: 'economy',
          insight: 'Global Forecast 2016',
          url: 'https://csis-prod.s3.amazonaws.com/s3fs-public/legacy_files/files/publication/151116_Cohen_GlobalForecast2016_Web.pdf',
          region: 'Western Africa',
          start_year: '',
          impact: '',
          added: 'November, 06 2016 04:37:15',
          published: 'November, 16 2015 00:00:00',
          country: 'Nigeria',
          relevance: 2,
          pestle: 'Economic',
          source: 'CSIS',
          title: "Nigeria's economy will likely be resilient.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Government',
          topic: 'growth',
          insight: 'Global Forecast 2016',
          url: 'https://csis-prod.s3.amazonaws.com/s3fs-public/legacy_files/files/publication/151116_Cohen_GlobalForecast2016_Web.pdf',
          region: 'World',
          start_year: 2016,
          impact: '',
          added: 'November, 06 2016 04:37:13',
          published: 'November, 16 2015 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Political',
          source: 'CSIS',
          title: 'With the collapse of global oil and mineral prices, 2016 will offer an important reality check for many African governments and some hard lessons on the limits of growth without vision, diversification, and broad-based development.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 12,
          sector: '',
          topic: 'growth',
          insight: 'Microsoft Word - REP Nov2016_vf',
          url: 'http://www.ebrd.com/documents/comms-and-bis/regional-economic-forecasts.pdf',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'November, 06 2016 04:36:17',
          published: 'November, 03 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'ebrd',
          title: 'In 2017, growth can be expected to recover slightly to 7.1 per cent in Turkmenistan.',
          likelihood: 4
        },
        {
          end_year: 2017,
          intensity: 16,
          sector: '',
          topic: 'growth',
          insight: 'Microsoft Word - REP Nov2016_vf',
          url: 'http://www.ebrd.com/documents/comms-and-bis/regional-economic-forecasts.pdf',
          region: 'Central Asia',
          start_year: 2016,
          impact: '',
          added: 'November, 06 2016 04:35:56',
          published: 'November, 03 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'ebrd',
          title: 'Growth in Central Asia is expected to decelerate further in 2016 before recovering in 2017.',
          likelihood: 4
        },
        {
          end_year: 2017,
          intensity: 16,
          sector: '',
          topic: 'economy',
          insight: 'Microsoft Word - REP Nov2016_vf',
          url: 'http://www.ebrd.com/documents/comms-and-bis/regional-economic-forecasts.pdf',
          region: 'Eastern Europe',
          start_year: 2016,
          impact: '',
          added: 'November, 06 2016 04:35:55',
          published: 'November, 03 2016 00:00:00',
          country: 'Russia',
          relevance: 4,
          pestle: 'Economic',
          source: 'ebrd',
          title: "Russia's economy is expected to return to modest growth in late 2016 and 2017 after another year of recession in 2016.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: '',
          topic: 'growth',
          insight: 'Microsoft Word - REP Nov2016_vf',
          url: 'http://www.ebrd.com/documents/comms-and-bis/regional-economic-forecasts.pdf',
          region: 'Eastern Europe',
          start_year: 2016,
          impact: '',
          added: 'November, 06 2016 04:35:54',
          published: 'November, 03 2016 00:00:00',
          country: 'Russia',
          relevance: 4,
          pestle: 'Economic',
          source: 'ebrd',
          title: 'Growth in EEC region as a whole is expected to remain negative in 2016 reflecting headwinds from the recession in Russia.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 12,
          sector: '',
          topic: 'growth',
          insight: 'Staying power European cities hotel forecast for 2016 and 2017',
          url: 'http://www.pwc.com/gx/en/hospitality-leisure/pdf/european-cities-hotel-forecast-2016-2017.pdf',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'November, 06 2016 03:27:45',
          published: 'March, 15 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'PwC',
          title: 'Czech GDP growth is expected to slow down in 2016 to a forecasted 2.7%.',
          likelihood: 4
        },
        {
          end_year: 2017,
          intensity: 12,
          sector: 'Energy',
          topic: 'economic growth',
          insight: 'Staying power European cities hotel forecast for 2016 and 2017',
          url: 'http://www.pwc.com/gx/en/hospitality-leisure/pdf/european-cities-hotel-forecast-2016-2017.pdf',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'November, 06 2016 03:27:43',
          published: 'March, 15 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Political',
          source: 'PwC',
          title: 'Economic growth in France is forecast to rise gradually to 1.3% in 2016 and 1.6% in 2017 underpinned by external factors such lower oil prices, a weaker euro and continued expansion in monetary policy in the Eurozone and by domestic factors such as improvement in corporate profit margins.',
          likelihood: 4
        },
        {
          end_year: 2017,
          intensity: 12,
          sector: 'Energy',
          topic: 'energy',
          insight: 'Staying power European cities hotel forecast for 2016 and 2017',
          url: 'http://www.pwc.com/gx/en/hospitality-leisure/pdf/european-cities-hotel-forecast-2016-2017.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 06 2016 03:27:28',
          published: 'March, 15 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'PwC',
          title: 'The German economy grew by 1.4% in 2015, and is expected to grow by 1.8% in 2016 and 1.6% in 2017 driven by low oil prices, low interest rates and low inflation that will continue to drive private consumption and outweigh the decline in external demand caused by the slowdown in emerging economies.',
          likelihood: 4
        },
        {
          end_year: 2017,
          intensity: 12,
          sector: '',
          topic: 'unemployment',
          insight: 'Staying power European cities hotel forecast for 2016 and 2017',
          url: 'http://www.pwc.com/gx/en/hospitality-leisure/pdf/european-cities-hotel-forecast-2016-2017.pdf',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'November, 06 2016 03:27:28',
          published: 'March, 15 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'PwC',
          title: "Germany's unemployment fell even further to 4.8% and is expected to remain at historic lows in 2016 and 2017.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Staying power European cities hotel forecast for 2016 and 2017',
          url: 'http://www.pwc.com/gx/en/hospitality-leisure/pdf/european-cities-hotel-forecast-2016-2017.pdf',
          region: 'World',
          start_year: 2016,
          impact: '',
          added: 'November, 06 2016 03:27:05',
          published: 'March, 15 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'PwC',
          title: 'The global outlook remains mixed and the changing balance of global growth, low oil prices and geopolitical risks will determine the global economic outlook for 2016.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Energy',
          topic: 'gas',
          insight: "LNG 'panacea' approach under question",
          url: 'http://www.drydockmagazine.com/2016/11/02/lng-panacea-approach-under-question/',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 06 2016 03:04:01',
          published: 'November, 02 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Environmental',
          source: 'Drydock Magazine',
          title: 'Liquefied natural gas is not a panacea to reducing greenhouse gas emissions and its increasing use as a marine fuel could be worse for the environment than burning heavy fuel oil.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: '25 July 2016: James Fry - Palm oil import demand to be high in Q4-FY17, Malaysia-Indonesia concerned about anti-PO campaign, China SOE mergers to better compete with foreign-owned processor-traders, BMD RM2,268/$560',
          url: 'http://khorreports-palmoil.blogspot.co.uk/2016_11_01_archive.html',
          region: 'South-Eastern Asia',
          start_year: 2016,
          impact: '',
          added: 'November, 06 2016 01:16:39',
          published: 'November, 03 2016 00:00:00',
          country: 'Indonesia',
          relevance: 6,
          pestle: 'Industries',
          source: 'khorreports-palmoil',
          title: 'Crude palm oil prices could rise to $650-$675 per tonne by mid-2016 as top producer Indonesia uses more palm-based biodiesel.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Transport',
          topic: 'transportation',
          insight: 'Crude Palm Oil Weekly Report - November 5, 2016',
          url: 'http://www.theborneopost.com/2016/11/06/crude-palm-oil-weekly-report-november-5-2016/',
          region: 'South-Eastern Asia',
          start_year: '',
          impact: '',
          added: 'November, 06 2016 01:16:29',
          published: 'November, 05 2016 00:00:00',
          country: 'Malaysia',
          relevance: 2,
          pestle: 'Industries',
          source: 'BorneoPost Online',
          title: 'Malaysia will implement higher biodiesel mandates for transportation and industrial sector from December 1.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'energy',
          insight: 'Can Lebanon Escape the Resource Curse?',
          url: 'https://www.project-syndicate.org/commentary/lebanon-economy-oil-curse-by-nasser-saidi-2016-11',
          region: 'Western Asia',
          start_year: '',
          impact: '',
          added: 'November, 05 2016 03:32:49',
          published: 'November, 03 2016 00:00:00',
          country: 'Lebanon',
          relevance: 2,
          pestle: 'Political',
          source: 'Project Syndicate',
          title: "In the absence of good governance Lebanon's energy windfall will likely lead to more corruption.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 4,
          sector: '',
          topic: 'wealth',
          insight: 'Can Lebanon Escape the Resource Curse?',
          url: 'https://www.project-syndicate.org/commentary/lebanon-economy-oil-curse-by-nasser-saidi-2016-11',
          region: 'Western Asia',
          start_year: '',
          impact: '',
          added: 'November, 05 2016 03:32:47',
          published: 'November, 03 2016 00:00:00',
          country: 'Lebanon',
          relevance: 2,
          pestle: 'Economic',
          source: 'Project Syndicate',
          title: "Lebanon's potential hydrocarbon wealth could indeed transform the country.",
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: '',
          topic: 'market',
          insight: 'Reuters: Oil prices steady after five days of declines, but sentiment bearish',
          url: 'http://www.unian.info/economics/1606526-reuters-oil-prices-steady-after-five-days-of-declines-but-sentiment-bearish.html',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 05 2016 03:23:27',
          published: '',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'unian',
          title: "The persistent market dynamic of softer demand and stronger supply will become a more dominant driver of prices as the impact of OPEC's verbal interventions begins to fade and expectations for coordinated cuts are readjusted.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: "Ukraine's oil giant Ukrnafta forecasts 15% drop in output in 2017",
          url: 'http://www.unian.info/economics/1607081-ukraines-oil-giant-ukrnafta-forecasts-15-drop-in-output-in-2017.html',
          region: 'Eastern Europe',
          start_year: 2017,
          impact: '',
          added: 'November, 05 2016 03:22:52',
          published: '',
          country: 'Ukraine',
          relevance: 4,
          pestle: 'Political',
          source: 'unian',
          title: "Ukraine's largest oil producer, Ukrnafta, forecasts a decline in crude oil production by 15% in 2017 in connection with high royalties and the unsolved problem of the company's tax debts.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 20,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Traders Timeout: Crude Oil Is Back in The Doldrums',
          url: 'http://www.financemagnates.com/institutional-forex/bloggers/traders-timeout-crude-oil-back-doldrums/',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'November, 05 2016 01:37:12',
          published: 'November, 04 2016 00:00:00',
          country: '',
          relevance: 5,
          pestle: 'Industries',
          source: 'Finance Magnates',
          title: 'Oil prices will remain below $60 a barrel in 2017.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Friday Thinking 4 Nov. 2016',
          url: 'http://johnverdon-friday-thinking.blogspot.co.uk/2016/11/friday-thinking-4-nov-2016.html',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 04 2016 05:52:17',
          published: 'November, 03 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'friday-thinking',
          title: 'Fitch Predict Oil "Death Spiral" As Early As 2023.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 48,
          sector: 'Support services',
          topic: 'gas',
          insight: 'GE, Baker Hughes Create $32 Billion Oil Services Giant By: Jessica Lyons Hardcastle',
          url: 'http://www.environmentalleader.com/2016/10/31/ge-baker-hughes-create-32-billion-oil-services-giant/',
          region: '',
          start_year: '',
          impact: 3,
          added: 'November, 04 2016 05:42:56',
          published: '',
          country: '',
          relevance: 4,
          pestle: 'Environmental',
          source: 'Environmental Leader',
          title: 'General Electric will combine its oil and gas business with Baker Hughes to create a $32 billion oil services company and is "exploring options" for selling its water business.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: '',
          topic: 'economy',
          insight: 'Will Electric Cars Turn the World Upside Down?',
          url: 'http://europe.newsweek.com/will-electric-cars-turn-world-upside-down-515351?rm=eu',
          region: 'Western Asia',
          start_year: '',
          impact: '',
          added: 'November, 04 2016 01:59:46',
          published: 'November, 01 2016 00:00:00',
          country: 'Saudi Arabia',
          relevance: 2,
          pestle: 'Economic',
          source: 'Newsweek',
          title: 'Saudi Arabia and the Gulf states will face increasing pressure from populations long accustomed to the lavish wealth of the petro-state economy.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'gas',
          insight: 'China and Russia: Gaming the West',
          url: 'http://www.ecfr.eu/publications/summary/china_and_russia_gaming_the_west7166',
          region: 'Eastern Europe',
          start_year: '',
          impact: '',
          added: 'November, 04 2016 00:51:17',
          published: 'November, 02 2016 00:00:00',
          country: 'Russia',
          relevance: 3,
          pestle: 'Industries',
          source: 'ECFR',
          title: "Russia's gas supplies could create the conditions for a new petrochemical industry in the region.",
          likelihood: 2
        },
        {
          end_year: 2017,
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: "Saudi Aramco's chief expects oil prices to pick up in 2017",
          url: 'http://www.businessinsider.com/saudi-aramco-chief-executive-sees-oil-prices-rising-first-half-2017-2016-11?IR=T',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'November, 04 2016 00:50:31',
          published: 'November, 03 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'Business Insider',
          title: "Crude oil prices will rise in the first half of next year as the commodity's fundamentals return to balance.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 3,
          sector: '',
          topic: '',
          insight: 'The War in Ukraine: Lessons for Europe',
          url: 'http://appc.lv/wp-content/uploads/2015/05/War_in_Ukraine.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 03 2016 21:44:03',
          published: 'April, 30 2015 00:00:00',
          country: '',
          relevance: 1,
          pestle: '',
          source: 'University of Latvia',
          title: 'The Ukraine Central Bank reserve will become exhausted soon.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 8,
          sector: 'Energy',
          topic: 'oil',
          insight: 'New pollution limits for shipping by 2020',
          url: 'http://www.futuretimeline.net/blog/2016/11/1.htm',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'November, 02 2016 05:04:48',
          published: 'November, 01 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'Future Timeline',
          title: 'Under the new global cap, ships will have to use fuel oil on board with a sulphur content of no more than 0.50% m/m.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Manufacturing',
          topic: 'clothing',
          insight: 'Brexit vote will lead to cut in disposable incomes in 2017, says thinktank',
          url: 'https://www.theguardian.com/business/2016/nov/02/brexit-vote-disposable-incomes-gdp-niesr?CMP=twt_gu',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 02 2016 02:11:10',
          published: 'November, 02 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Political',
          source: 'Guardian',
          title: 'Prices of everyday items including clothing, wine, bread and fruit are expected to come under increasing pressure as Brexit nears.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Financial services',
          topic: 'bank',
          insight: 'Capital Markets & Thematic Research',
          url: 'https://www.allianzglobalinvestors.de/MDBWS/doc/FridayMail+CW43.pdf?8590c9b8742d2e3e62d2e45e7f62487f04715c60&WT.mc_id=00f594a0b208aed4b6014e743a2198ce&WT.sn_type=TWITTER&hoot.message=Why%2520short%2520duration%2520investing%2520may%2520be%2520a%2520smart%2520long-term%2520move%2520%255BLINK%255D%2520This%2520and%2520more%2520in%2520the%2520latest%2520%2523FridayMail&hoot.send_date=2016-10-27%252014%253A10%253A00&hoot.username=AllianzGI_view&hoot.send_dayofweek=Thursday&hoot.send_hour=14',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 02 2016 01:58:38',
          published: 'October, 27 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Economic',
          source: 'allianzglobalinvestors',
          title: 'The Bank of England will announce the bank rate on Nov 3 (Thu), and given the lingering uncertainty with regard to Brexit, investors are expecting the central bank to maintain the current rate of 0.25%.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Manufacturing',
          topic: 'production',
          insight: 'Is a New Oil Boom Underway? (GE, BHI)',
          url: 'http://www.investopedia.com/news/new-oil-boom-underway-ge-bhi/',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 02 2016 01:24:26',
          published: 'November, 01 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'Investopedia',
          title: 'There is no certainty that the recent decision by OPEC to cut production (and thus bolster prices) will hold fast.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: '',
          topic: 'security',
          insight: 'Libyan officials squabble, residents protest as cash crisis hits home',
          url: 'http://uk.mobile.reuters.com/article/worldNews/idUSKBN12U0EY?il=0',
          region: 'Northern Africa',
          start_year: '',
          impact: '',
          added: 'November, 02 2016 00:58:45',
          published: 'October, 30 2016 00:00:00',
          country: 'Libya',
          relevance: 2,
          pestle: 'Political',
          source: 'Reuters',
          title: "Libya's liquidity crisis will not be resolved without improved security and trust in the banking system.",
          likelihood: 3
        },
        {
          end_year: 2020,
          intensity: 12,
          sector: 'Support services',
          topic: 'energy',
          insight: 'Pay attention: Industrie 4.0 and ICS cyber security',
          url: 'http://m.controleng.com/index.php?cHash=dfb6832f4f6683df19333fcecb34f5d9&id=9113&tx_ttnews%5Btt_news%5D=139127',
          region: '',
          start_year: '',
          impact: '',
          added: 'November, 01 2016 05:28:09',
          published: '',
          country: '',
          relevance: 3,
          pestle: 'Technological',
          source: 'controleng',
          title: 'Energy companies will be installing 1 billion smart meters on homes, businesses, and factories by 2020.',
          likelihood: 4
        },
        {
          end_year: 2020,
          intensity: 16,
          sector: 'Energy',
          topic: 'gas',
          insight: 'Pay attention: Industrie 4.0 and ICS cyber security',
          url: 'http://m.controleng.com/index.php?cHash=dfb6832f4f6683df19333fcecb34f5d9&id=9113&tx_ttnews%5Btt_news%5D=139127',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'November, 01 2016 05:28:08',
          published: '',
          country: '',
          relevance: 4,
          pestle: 'Technological',
          source: 'controleng',
          title: 'An estimated 5.4 million IoT devices will be used on oil and gas extraction sites around the world by 2020.',
          likelihood: 4
        },
        {
          end_year: 2017,
          intensity: 16,
          sector: '',
          topic: 'growth',
          insight: 'Africa Must Face Reality of Low Commodity Prices, IMF Warns',
          url: 'http://www.bloomberg.com/news/articles/2016-10-25/africa-needs-to-face-reality-of-low-commodity-prices-imf-warns',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'November, 01 2016 00:48:05',
          published: 'October, 25 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'Bloomberg Business',
          title: 'The IMF forecasts growth in Africa will pick up next year to slightly less than 3 percent.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Let Crude Crash: US Oil Producers Are Hedging At Levels Not Seen Since 2007',
          url: 'http://www.zerohedge.com/news/2016-10-27/let-crude-crash-us-oil-producers-are-hedging-levels-not-seen-2007',
          region: '',
          start_year: '',
          impact: '',
          added: 'October, 31 2016 03:42:31',
          published: 'October, 27 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'Zero Hedge',
          title: 'The truly high cost oil exporters within OPEC will suffer sovereign defaults and social unrest.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Monsanto Was Put On Trial For Ecocide At The Hague',
          url: 'http://www.nationofchange.org/2016/10/30/monsanto-put-trial-ecocide-hague/?platform=hootsuite',
          region: '',
          start_year: '',
          impact: '',
          added: 'October, 31 2016 03:35:27',
          published: 'October, 30 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Environmental',
          source: 'Nation of Change',
          title: 'GMO soya and chemical-intensive palm oil plantations are the primary driving forces of the tropical deforestation that threatens to smother the literal lungs of the planet.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'gas',
          insight: 'Textile Coatings Market Worth 6.81 Billion USD by 2021',
          url: 'http://www.prnewswire.com/news-releases/textile-coatings-market-worth-681-billion-usd-by-2021-599032071.html',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'October, 31 2016 00:59:55',
          published: 'October, 28 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'PR Newswire',
          title: 'North America is expected to witness growth in oil & gas and manufacturing industry due to the recent discoveries of shale gas and shale oil in the region and strong manufacturing base in.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Jordan',
          url: 'https://en.wikipedia.org/wiki/Jordan',
          region: 'Western Asia',
          start_year: '',
          impact: '',
          added: 'October, 30 2016 03:22:22',
          published: '',
          country: 'Jordan',
          relevance: 2,
          pestle: 'Industries',
          source: 'Wikipedia',
          title: 'Jordan has the 5th largest oil-shale reserves in the world that could be commercially exploited in the central and northern regions west of the country.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 4,
          sector: '',
          topic: '',
          insight: 'Inputsmonitor',
          url: 'http://www.inputsmonitor.com/assets/26/6/october_2016.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'October, 30 2016 02:15:25',
          published: 'October, 14 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: '',
          source: 'inputsmonitor',
          title: 'Crude futures could swell to $60 per barrel by the end of the year.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Retail',
          topic: 'oil',
          insight: '2016 World Energy: Unprecedented Changes',
          url: 'http://planetsave.com/2016/10/20/renewables-energy-unprecedented-changes/',
          region: 'Asia',
          start_year: '',
          impact: '',
          added: 'October, 30 2016 01:41:53',
          published: 'October, 20 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'Planetsave ',
          title: "Asia's population and consumer growth will support oil demand.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Agritrends',
          url: 'http://www.agriworldsa.com/article-archive/agri-trade/Agri%20Trends%2025%20October%202016%20final.pdf',
          region: 'Southern Africa',
          start_year: '',
          impact: '',
          added: 'October, 30 2016 01:35:36',
          published: 'October, 25 2016 00:00:00',
          country: 'South Africa',
          relevance: 2,
          pestle: 'Industries',
          source: 'agriworldsa',
          title: 'South Africa is a net importing country of vegetable oil and prices are expected to remain high.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Retail',
          topic: 'oil',
          insight: 'Agritrends',
          url: 'http://www.agriworldsa.com/article-archive/agri-trade/Agri%20Trends%2025%20October%202016%20final.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'October, 30 2016 01:35:33',
          published: 'October, 25 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Social',
          source: 'agriworldsa',
          title: 'The coincidence of ample supplies of corn, feed wheat, oil meals and sunflower meal will lead to increased competition amongst suppliers and prices will be determined by consumers rather than producers.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: '',
          topic: 'shortage',
          insight: 'Microsoft Word - October 20, 2016; GMT Newsletter',
          url: 'http://globalmoneytrends.com/wp-content/uploads/2016/10/October-21-2016-GMT-Newsletter-focus-on-Russia-Crude-oil.pdf',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'October, 30 2016 01:35:04',
          published: 'October, 24 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'globalmoneytrends',
          title: 'North America has effectively become a swing producer that will be able to respond rapidly to any global supply shortage.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Financial services',
          topic: 'bank',
          insight: 'Microsoft Word - October 20, 2016; GMT Newsletter',
          url: 'http://globalmoneytrends.com/wp-content/uploads/2016/10/October-21-2016-GMT-Newsletter-focus-on-Russia-Crude-oil.pdf',
          region: 'Eastern Europe',
          start_year: '',
          impact: '',
          added: 'October, 30 2016 01:34:59',
          published: 'October, 24 2016 00:00:00',
          country: 'Russia',
          relevance: 2,
          pestle: 'Economic',
          source: 'globalmoneytrends',
          title: "The Bank of Russia will not intervene in the currency market unless the ruble's swings threaten the stability of the nation's banking industry.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 2,
          sector: '',
          topic: 'economy',
          insight: 'Microsoft Word - October 20, 2016; GMT Newsletter',
          url: 'http://globalmoneytrends.com/wp-content/uploads/2016/10/October-21-2016-GMT-Newsletter-focus-on-Russia-Crude-oil.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'October, 30 2016 01:34:58',
          published: 'October, 24 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Political',
          source: 'globalmoneytrends',
          title: 'International rating agencies do not see the risk of a new collapse of the Russian economy.',
          likelihood: 2
        },
        {
          end_year: 2016,
          intensity: 16,
          sector: 'Financial services',
          topic: 'bank',
          insight: 'Microsoft Word - October 20, 2016; GMT Newsletter',
          url: 'http://globalmoneytrends.com/wp-content/uploads/2016/10/October-21-2016-GMT-Newsletter-focus-on-Russia-Crude-oil.pdf',
          region: 'Eastern Europe',
          start_year: '',
          impact: '',
          added: 'October, 30 2016 01:34:56',
          published: 'October, 24 2016 00:00:00',
          country: 'Russia',
          relevance: 4,
          pestle: 'Economic',
          source: 'globalmoneytrends',
          title: "Russia's central bank predicted its economy would shrink -4.5% in 2015 and -1.1% in 2016.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 24,
          sector: 'Retail',
          topic: 'export',
          insight: 'Microsoft Word - October 20, 2016; GMT Newsletter',
          url: 'http://globalmoneytrends.com/wp-content/uploads/2016/10/October-21-2016-GMT-Newsletter-focus-on-Russia-Crude-oil.pdf',
          region: 'Eastern Europe',
          start_year: '',
          impact: 3,
          added: 'October, 30 2016 01:34:53',
          published: 'October, 24 2016 00:00:00',
          country: 'Russia',
          relevance: 4,
          pestle: 'Economic',
          source: 'globalmoneytrends',
          title: 'Russia could lose $40 billion annually in exports due to sanctions, and between $90 and $100 billion on account of sharply lower oil prices.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 8,
          sector: '',
          topic: '',
          insight: 'Microsoft Word - October 20, 2016; GMT Newsletter',
          url: 'http://globalmoneytrends.com/wp-content/uploads/2016/10/October-21-2016-GMT-Newsletter-focus-on-Russia-Crude-oil.pdf',
          region: 'Western Asia',
          start_year: 2016,
          impact: '',
          added: 'October, 30 2016 01:34:52',
          published: 'October, 24 2016 00:00:00',
          country: 'Syria',
          relevance: 4,
          pestle: '',
          source: 'globalmoneytrends',
          title: '2016, EU threatens more sanctions over Syria.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 16,
          sector: '',
          topic: '',
          insight: 'Microsoft Word - October 20, 2016; GMT Newsletter',
          url: 'http://globalmoneytrends.com/wp-content/uploads/2016/10/October-21-2016-GMT-Newsletter-focus-on-Russia-Crude-oil.pdf',
          region: 'Eastern Europe',
          start_year: 2016,
          impact: '',
          added: 'October, 30 2016 01:34:51',
          published: 'October, 24 2016 00:00:00',
          country: 'Russia',
          relevance: 4,
          pestle: '',
          source: 'globalmoneytrends',
          title: "2016, Russia will join OPEC's efforts to cut global crude output.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'export',
          insight: "Burning Land, Burning the Climate: The biofuel industry's capture of EU bioenergy policy",
          url: 'https://www.oxfam.org/sites/www.oxfam.org/files/bp-burning-land-climate-eu-bioenergy-261016-en_0.pdf',
          region: 'South America',
          start_year: '',
          impact: '',
          added: 'October, 30 2016 01:18:09',
          published: 'October, 24 2016 00:00:00',
          country: 'Colombia',
          relevance: 2,
          pestle: 'Economic',
          source: 'Oxfam',
          title: 'Peru now ranks 21st on the list of producing countries and large areas are under threat as global demand for palm oil continues to grow.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: "Burning Land, Burning the Climate: The biofuel industry's capture of EU bioenergy policy",
          url: 'https://www.oxfam.org/sites/www.oxfam.org/files/bp-burning-land-climate-eu-bioenergy-261016-en_0.pdf',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'October, 30 2016 01:18:08',
          published: 'October, 24 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'Oxfam',
          title: 'The EU is expected to import 6.6 million tonnes of palm oil in 2016.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'gas',
          insight: 'Competing for Top Talent: Build the Talent Platform',
          url: 'http://www.gartner.com/resources/308700/308714/competing_for_top_talent_ent_308714.pdf',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'October, 30 2016 01:15:56',
          published: 'June, 09 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'Gartner',
          title: 'Oil and gas will remain a vital part of the global energy mix for many decades.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Manufacturing',
          topic: 'production',
          insight: 'CANADA: OUTLOOK FOR PRINCIPAL FIELD CROPS',
          url: 'http://www.clientadvisoryservices.com/Downloads/Canada%20Principal%20Field%20Crops_October2016Steve1.pdf',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'October, 30 2016 01:14:37',
          published: 'October, 21 2016 00:00:00',
          country: 'United States of America',
          relevance: 3,
          pestle: 'Industries',
          source: 'clientadvisoryservices',
          title: 'US sunflower seed production is forecast by USDA to decrease by 16% to 1.1 Mt.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'export',
          insight: 'CANADA: OUTLOOK FOR PRINCIPAL FIELD CROPS',
          url: 'http://www.clientadvisoryservices.com/Downloads/Canada%20Principal%20Field%20Crops_October2016Steve1.pdf',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'October, 30 2016 01:14:20',
          published: 'October, 21 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'clientadvisoryservices',
          title: 'Canadian flaxseed exports are forecast to remain relatively stable at 0.6 Mt as buying is constrained by competition from burdensome world oilseed and vegetable oil supplies.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Manufacturing',
          topic: 'production',
          insight: 'CANADA: OUTLOOK FOR PRINCIPAL FIELD CROPS',
          url: 'http://www.clientadvisoryservices.com/Downloads/Canada%20Principal%20Field%20Crops_October2016Steve1.pdf',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'October, 30 2016 01:14:19',
          published: 'October, 21 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'clientadvisoryservices',
          title: 'At the world level, production of rapeseed-canola is expected to decline by about 2.0 Mt from last year.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Energy',
          topic: 'oil',
          insight: 'U.S. Economy Grew 2.9% in 3rd Quarter, Picking Up the Pace',
          url: 'http://www.nytimes.com/2016/10/29/business/economy/3rd-quarter-gdp.html?partner=rss&emc=rss&_r=0',
          region: '',
          start_year: '',
          impact: '',
          added: 'October, 29 2016 03:36:19',
          published: 'October, 28 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Economic',
          source: 'NY Times',
          title: 'The recent rebound in oil prices could spur more economic activity among drillers and other energy producers in the months ahead.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 3,
          sector: '',
          topic: '',
          insight: "Saudi Arabia's Vision 2030: We Want It... We Need It",
          url: 'http://seekingalpha.com/article/4016337-saudi-arabias-vision-2030-want-need',
          region: 'Western Asia',
          start_year: '',
          impact: '',
          added: 'October, 29 2016 01:30:58',
          published: 'October, 28 2016 00:00:00',
          country: 'Saudi Arabia',
          relevance: 1,
          pestle: '',
          source: 'Seeking Alpha',
          title: "Within 3-4 years, Saudi Arabia's foreign reserves will likely be much lower and the country would find itself in a debtor position.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 8,
          sector: 'Energy',
          topic: 'gas',
          insight: 'Renewable Energy: India to Replace Coal with Cheaper Solar Power by 2022',
          url: 'http://www.natureworldnews.com/articles/30601/20161024/renewable-thinking-india-replace-coal-cheaper-solar-power-2022.htm',
          region: 'Southern Asia',
          start_year: '',
          impact: '',
          added: 'October, 28 2016 06:13:21',
          published: 'October, 24 2016 00:00:00',
          country: 'India',
          relevance: 2,
          pestle: 'Industries',
          source: 'News',
          title: "By the year 2035, India's gas import will increase by a staggering 573 percent, oil import by 169 percent and coal import by 85 percent.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Food & agriculture',
          topic: 'investment',
          insight: 'The carbon bubble: why investors can no longer ignore climate risks',
          url: 'https://www.theguardian.com/sustainable-business/2016/oct/27/investment-advice-retirement-portfolio-tips-climate-change-financial-risk?CMP=twt_gu',
          region: '',
          start_year: '',
          impact: '',
          added: 'October, 28 2016 03:36:24',
          published: 'October, 27 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'Guardian',
          title: 'A growing number of investors see global warming not only as a looming environmental problem but also an investment risk.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'energy',
          insight: 'Exxon, Auditor Must Comply With New York Climate Fraud Subpoena, Court Says',
          url: 'http://www.huffingtonpost.com/entry/exxon-pwc-subpoena-new-york-climate-fraud-probe_us_581124f0e4b0390e69ce182b',
          region: '',
          start_year: '',
          impact: '',
          added: 'October, 28 2016 02:53:52',
          published: 'October, 27 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'Huffington Post',
          title: "Exxon's finances show signs of significant deterioration and the company could be on the brink of irreversible decline.",
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 48,
          sector: 'Energy',
          topic: '',
          insight: 'Peak Oil Review: A Midweek Update - 27th Oct 2016',
          url: 'http://www.resilience.org/stories/2016-10-27/peak-oil-review-a-midweek-update-27th-oct-2016',
          region: 'South America',
          start_year: '',
          impact: 3,
          added: 'October, 28 2016 01:53:21',
          published: 'October, 27 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: '',
          source: 'Resilience',
          title: 'Delaying payments on $2.8 billion is nothing compared to the $65 billion outstanding and Venezuela will default anyway as oil output continues to drop and there is no sign of change in the government or policy.',
          likelihood: 4
        },
        {
          end_year: 2019,
          intensity: 12,
          sector: '',
          topic: '',
          insight: 'Sub-Saharan Africa: Policy Adjustment Way Out of Growth Slump',
          url: 'http://www.imf.org/en/News/Articles/2016/10/24/NA102416-Sub-Saharan-Africa-Policy-Adjustment-Way-Out-of-Growth-Slump?hootPostID=fa80d7ba765da34f2e2134bc910174ca',
          region: 'Eastern Africa',
          start_year: 2016,
          impact: '',
          added: 'October, 28 2016 01:47:43',
          published: 'October, 25 2016 00:00:00',
          country: 'Ethiopia',
          relevance: 3,
          pestle: '',
          source: 'IMF',
          title: "Countries such as Côte d'Ivoire, Ethiopia, Senegal, and Tanzania are expected to continue to grow at more than 6 percent for the next couple of years.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'A "New Normal" for the Oil Market',
          url: 'https://blog-imfdirect.imf.org/2016/10/27/a-new-normal-for-the-oil-market/?hootPostID=b32c6c68bddcc1e9b91ad6f63fdeccf4',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'October, 28 2016 01:47:21',
          published: 'October, 27 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'iMFdirect - The IMF Blog',
          title: 'Many experts expect oil markets to balance in 2017.',
          likelihood: 4
        },
        {
          end_year: 2035,
          intensity: 16,
          sector: 'Energy',
          topic: 'gas',
          insight: "India's solar power set to outshine coal",
          url: 'http://www.eco-business.com/news/indias-solar-power-set-to-outshine-coal/',
          region: 'Southern Asia',
          start_year: '',
          impact: '',
          added: 'October, 28 2016 00:49:49',
          published: 'October, 24 2016 00:00:00',
          country: 'India',
          relevance: 4,
          pestle: 'Industries',
          source: 'Eco-Business.com',
          title: 'By 2035 gas imports to India will rise by 573 per cent.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 20,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Oil rises above US$50 as US inventory drop balances OPEC doubts',
          url: 'http://www.channelnewsasia.com/news/singapore/oil-rises-above-us-50-as-us-inventory-drop-balances-opec-doubts/3239120.html',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'October, 27 2016 10:20:00',
          published: 'October, 27 2016 00:00:00',
          country: 'United States of America',
          relevance: 5,
          pestle: 'Economic',
          source: 'Channel News Asia',
          title: 'Oil edged above US$50 a barrel on Thursday as a further drop in U.S. crude inventories countered investor doubts that OPEC will be able to implement a production cut.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'gas',
          insight: "Politics, Population, and Hydrocarbons: Preparing for Mosul's Aftermath",
          url: 'http://warontherocks.com/2016/10/politics-population-and-hydrocarbons-preparing-for-mosuls-aftermath/',
          region: 'Eastern Europe',
          start_year: '',
          impact: '',
          added: 'October, 27 2016 09:23:51',
          published: 'October, 25 2016 00:00:00',
          country: 'Russia',
          relevance: 2,
          pestle: 'Political',
          source: 'War on the Rocks',
          title: "Moscow views any gas source or transit route that challenges Russia's monopoly over European demand as a national security risk.",
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Energy',
          topic: 'energy',
          insight: 'European Biomass Association releases 2016 bioenergy outlook',
          url: 'http://biomassmagazine.com/articles/13837/european-biomass-association-releases-2016-bioenergy-outlook',
          region: '',
          start_year: '',
          impact: '',
          added: 'October, 25 2016 01:19:37',
          published: 'October, 24 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Industries',
          source: 'biomassmagazine',
          title: 'Biomass will play a growing role as a backup, dispatchable energy source.',
          likelihood: 3
        },
        {
          end_year: 2017,
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: "The World's Biggest Oil Kingdom Reverses Course",
          url: 'http://www.bloomberg.com/news/articles/2016-10-20/the-world-s-biggest-oil-kingdom-reverses-course?&cmpid=socialflow-twitter-businessweek',
          region: 'Western Asia',
          start_year: 2016,
          impact: '',
          added: 'October, 24 2016 05:42:28',
          published: 'October, 20 2016 00:00:00',
          country: 'Saudi Arabia',
          relevance: 4,
          pestle: 'Economic',
          source: 'Bloomberg Business',
          title: "Next year will be a test of strength for Saudi Arabia, the world's largest oil exporter, as it tries to regain control of the market and lift prices.",
          likelihood: 4
        },
        {
          end_year: 2026,
          intensity: 9,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Bloomberg, Fitch predict oil "death spiral" as early as 2023',
          url: 'http://gas2.org/2016/10/21/bllomberg-fitch-oil-death-spiral-2023/',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'October, 24 2016 05:29:38',
          published: 'October, 21 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'Gas 2',
          title: 'The next collapse of oil prices will occur within 10 years.',
          likelihood: 3
        },
        {
          end_year: 2028,
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: "Electric car revolution may drive oil 'investor death spiral'",
          url: 'https://thinkprogress.org/oil-investor-death-spiral-35773e131250?gi=362a21dfd6d6',
          region: '',
          start_year: '',
          impact: '',
          added: 'October, 24 2016 03:57:35',
          published: 'October, 21 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'Think Progress',
          title: "Bloomberg New Energy Finance has already told investors to expect the 'big crash' in oil by 2028.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 10,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Oil Halts Rally Above $50 as Iraq Signals Break From OPEC Cuts',
          url: 'http://www.bloomberg.com/news/articles/2016-10-23/oil-holds-above-50-as-iraq-signals-break-from-opec-output-plan?&cmpid=socialflow-twitter-business',
          region: 'Western Asia',
          start_year: '',
          impact: '',
          added: 'October, 24 2016 02:39:01',
          published: 'October, 23 2016 00:00:00',
          country: 'Iraq',
          relevance: 5,
          pestle: 'Economic',
          source: 'Bloomberg Business',
          title: "Oil halted its advance near $50 a barrel as Iraq threatened to derail OPEC's plan to stabilize crude markets by saying it should be exempt from planned output cuts.",
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Financial services',
          topic: 'capital',
          insight: 'GMT Newsletter - October 13, 2016',
          url: 'http://globalmoneytrends.com/wp-content/uploads/2016/10/GMT-Newsletter-October-13-2016.pdf',
          region: 'Eastern Asia',
          start_year: '',
          impact: '',
          added: 'October, 23 2016 06:07:07',
          published: 'October, 14 2016 00:00:00',
          country: 'China',
          relevance: 2,
          pestle: 'Economic',
          source: 'globalmoneytrends',
          title: "A relentless rise in borrowing by China's largest companies could eventually require a capital injection of nearly $2-trillion to clean up the country's banking sector.",
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 20,
          sector: 'Energy',
          topic: '',
          insight: '22 October 2016',
          url: 'http://www.no2nuclearpower.org.uk/news/22-october-2016/',
          region: 'Southern Asia',
          start_year: 2016,
          impact: '',
          added: 'October, 23 2016 05:51:53',
          published: 'October, 22 2016 00:00:00',
          country: '',
          relevance: 5,
          pestle: '',
          source: 'No 2 Nuclear Power',
          title: 'India will depend increasingly on imports for its energy.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'gas',
          insight: 'OGA Overview 2016',
          url: 'https://www.ogauthority.co.uk/media/2825/oga-overview-october-2016.pdf',
          region: 'Northern Europe',
          start_year: '',
          impact: '',
          added: 'October, 23 2016 04:55:41',
          published: 'October, 14 2016 00:00:00',
          country: 'United Kingdom',
          relevance: 2,
          pestle: 'Industries',
          source: 'ogauthority',
          title: 'The sustained decline in global oil and gas prices has brought into sharp focus the significant risks facing the mature UK offshore oil and gas industry.',
          likelihood: 2
        },
        {
          end_year: 2017,
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'PowerPoint Presentation',
          url: 'http://www.ibef.org/download/Oil-Gas-October-2016-D.PDF',
          region: 'Southern Asia',
          start_year: '',
          impact: '',
          added: 'October, 23 2016 03:51:45',
          published: 'October, 19 2016 00:00:00',
          country: 'India',
          relevance: 4,
          pestle: 'Industries',
          source: 'IBEF',
          title: 'By 2017, the oil refining capacity of India is expected to rise and reach more than 310 million tonnes.',
          likelihood: 4
        },
        {
          end_year: 2017,
          intensity: 12,
          sector: 'Energy',
          topic: 'energy',
          insight: 'Prices seen rising for oil and other commodities in 2017',
          url: 'http://blogs.worldbank.org/developmenttalk/prices-seen-rising-oil-and-other-commodities-2017',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'October, 22 2016 02:34:08',
          published: 'October, 20 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'Prospects for Development',
          title: 'Energy prices are forecast to jump 24 percent in the coming year.',
          likelihood: 4
        },
        {
          end_year: 2017,
          intensity: 20,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Prices seen rising for oil and other commodities in 2017',
          url: 'http://blogs.worldbank.org/developmenttalk/prices-seen-rising-oil-and-other-commodities-2017',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'October, 22 2016 02:34:07',
          published: 'October, 20 2016 00:00:00',
          country: '',
          relevance: 5,
          pestle: 'Economic',
          source: 'Prospects for Development',
          title: 'Oil prices are forecast to rise to $55 per barrel next year from $43 per barrel in 2016 as markets readjust after an era of abundant supply that outpaced demand.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Quantifying uncertainties in global growth forecasts',
          url: 'http://blogs.worldbank.org/opendata/quantifying-uncertainties-global-growth-forecasts',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'October, 22 2016 02:05:03',
          published: 'October, 19 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'Prospects for Development',
          title: 'Greater volatility in oil price futures could be associated with rising uncertainty around global growth forecasts.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'gas',
          insight: 'Water Treatment Chemicals Market projected to reach USD 24.94 billion by 2020',
          url: 'http://www.prnewswire.com/news-releases/water-treatment-chemicals-market-projected-to-reach-usd-2494-billion-by-2020-300348222.html',
          region: 'Africa',
          start_year: '',
          impact: '',
          added: 'October, 21 2016 06:20:34',
          published: 'October, 19 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'PR Newswire',
          title: 'Oil & gas reserves in Africa will further drive the market for water treatment chemicals in the oil & gas industry.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 32,
          sector: '',
          topic: 'debt',
          insight: 'Peak Oil Review: A Midweek Update - 20th Oct 2016',
          url: 'http://www.resilience.org/stories/2016-10-20/peak-oil-review-a-midweek-update-20th-oct-2016',
          region: 'World',
          start_year: '',
          impact: 4,
          added: 'October, 21 2016 06:17:15',
          published: 'October, 20 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'Resilience',
          title: 'As much as $3.4 trillion or one quarter of global corporate debt could be at risk if there is a widespread shift to electric-powered vehicles.',
          likelihood: 2
        },
        {
          end_year: 2046,
          intensity: 3,
          sector: 'Energy',
          topic: 'technology',
          insight: 'Peak Oil Review: A Midweek Update - 20th Oct 2016',
          url: 'http://www.resilience.org/stories/2016-10-20/peak-oil-review-a-midweek-update-20th-oct-2016',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'October, 21 2016 06:17:14',
          published: 'October, 20 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'Resilience',
          title: 'Disruptive battery technologies could set off a death spiral in the credit markets as the demand for gasoline and diesel melts way in the next few decades.',
          likelihood: 1
        },
        {
          end_year: 2017,
          intensity: 12,
          sector: 'Energy',
          topic: 'energy',
          insight: 'World Bank raises 2017 price outlook for oil and metals',
          url: 'http://www.engineeringnews.co.za/article/world-bank-raises-2017-price-outlook-for-oil-and-metals-2016-10-20',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'October, 21 2016 04:36:40',
          published: 'October, 20 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'Engineering News',
          title: 'Energy prices are projected to jump almost 25% overall next year.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Financial services',
          topic: 'gas',
          insight: 'Will We Have $60 Oil Next Year?',
          url: 'http://www.bloomberg.com/news/articles/2016-10-20/will-we-have-60-oil-next-year?&cmpid=socialflow-twitter-businessweek',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'October, 21 2016 04:13:54',
          published: 'October, 20 2016 00:00:00',
          country: 'United States of America',
          relevance: 2,
          pestle: 'Economic',
          source: 'Bloomberg Business',
          title: 'The lack of capital investment in the last year or two in the U.S. and globally in oil and gas could be a problem five years from now.',
          likelihood: 2
        },
        {
          end_year: 2021,
          intensity: 20,
          sector: '',
          topic: '',
          insight: 'Middle East, North Africa Region Urged to Stay on Course with Reforms',
          url: 'http://www.imf.org/en/News/Articles/2016/10/18/NA101916-MENAP-REO?hootPostID=e02470fade8f90c527b0b2682a7880b0',
          region: '',
          start_year: '',
          impact: '',
          added: 'October, 21 2016 02:54:29',
          published: 'October, 19 2016 00:00:00',
          country: '',
          relevance: 5,
          pestle: '',
          source: 'IMF',
          title: 'The IMF projects oil prices to barely reach $60 a barrel by 2021.',
          likelihood: 4
        },
        {
          end_year: 2019,
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Middle East, North Africa Region Urged to Stay on Course with Reforms',
          url: 'http://www.imf.org/en/News/Articles/2016/10/18/NA101916-MENAP-REO?hootPostID=e02470fade8f90c527b0b2682a7880b0',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'October, 21 2016 02:54:29',
          published: 'October, 19 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'IMF',
          title: "Oil prices-the key driver of growth for MENA's oil exporters-are projected to remain low over the coming years.",
          likelihood: 4
        },
        {
          end_year: 2018,
          intensity: 8,
          sector: 'Energy',
          topic: 'oil',
          insight: "Exxon's CEO doesn't think there's going to be an oil supply crunch",
          url: 'http://uk.businessinsider.com/exxon-ceo-rex-tillerson-says-there-wont-be-an-oil-supply-crunch-2016-10?r=US&IR=T',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'October, 21 2016 02:43:49',
          published: 'October, 21 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Political',
          source: 'Business Insider',
          title: 'Washington based think-tank SAFE expects that global oil supply could fall up to 4 million barrels per day by 2018 as a result of recent capex cuts.',
          likelihood: 2
        },
        {
          end_year: 2019,
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: "Exxon's CEO doesn't think there's going to be an oil supply crunch",
          url: 'http://uk.businessinsider.com/exxon-ceo-rex-tillerson-says-there-wont-be-an-oil-supply-crunch-2016-10?r=US&IR=T',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'October, 21 2016 02:43:49',
          published: 'October, 21 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'Business Insider',
          title: 'New sources of oil will prevent a supply crunch in the next few years.',
          likelihood: 4
        },
        {
          end_year: 2019,
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Oil prices could hit $90 sooner than you think',
          url: 'http://uk.businessinsider.com/oil-prices-could-hit-90-2016-10?r=US&IR=T',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'October, 21 2016 02:43:12',
          published: 'October, 21 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'Business Insider',
          title: 'Several hundred billion dollars must be invested over the next few years to bring oil out of the ground from a far more concentrated set of opportunities.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Oil Prices Dip After Strong Rally, But Sentiment Remains Confident',
          url: 'http://profit.ndtv.com/news/commodities/article-oil-prices-dip-after-strong-rally-but-sentiment-remains-confident-1476569',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'October, 20 2016 04:33:48',
          published: 'October, 20 2016 00:00:00',
          country: 'United States of America',
          relevance: 4,
          pestle: 'Social',
          source: 'NDTV',
          title: 'U.S. oil is expected to break a resistance zone of $51.67-$52.11 per barrel.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: "AfDB President Akinwumi A. Adesina's Opening Remarks at \"Jobs for Youth in Africa\" West African Ministerial Conference - 18 October, 2016 - Abidjan, Côte d'Ivoire",
          url: 'http://www.afdb.org/en/news-and-events/article/afdb-president-akinwumi-a-adesinas-opening-remarks-at-jobs-for-youth-in-africa-west-african-ministerial-conference-18-october-2016-abidjan-cote-divoire-16231/',
          region: 'Africa',
          start_year: '',
          impact: '',
          added: 'October, 20 2016 01:51:20',
          published: 'October, 18 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Environmental',
          source: 'African Development Bank',
          title: "Agriculture will become Africa's new oil.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: '',
          topic: 'agriculture',
          insight: "AfDB President Akinwumi A. Adesina's Opening Remarks at \"Jobs for Youth in Africa\" West African Ministerial Conference - 18 October, 2016 - Abidjan, Côte d'Ivoire",
          url: 'http://www.afdb.org/en/news-and-events/article/afdb-president-akinwumi-a-adesinas-opening-remarks-at-jobs-for-youth-in-africa-west-african-ministerial-conference-18-october-2016-abidjan-cote-divoire-16231/',
          region: 'Africa',
          start_year: '',
          impact: '',
          added: 'October, 20 2016 01:51:19',
          published: 'October, 18 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Environmental',
          source: 'African Development Bank',
          title: 'The future millionaires of Africa will come from agriculture.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 4,
          sector: '',
          topic: 'debt',
          insight: "Venezuela's oil giant warns of default next week",
          url: 'http://money.cnn.com/2016/10/18/news/economy/venezuela-pdvsa-default/index.html',
          region: '',
          start_year: '',
          impact: '',
          added: 'October, 19 2016 06:03:39',
          published: 'October, 18 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'CNNMoney',
          title: "Despite sitting on the world's largest oil reserves, Venezuela is running out of food, medicine and cash as its citizens go hungry. Things could get much worse if PDVSA defaults on its debt.",
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Government',
          topic: 'oil',
          insight: "Venezuela's oil giant warns of default next week",
          url: 'http://money.cnn.com/2016/10/18/news/economy/venezuela-pdvsa-default/index.html',
          region: 'South America',
          start_year: '',
          impact: '',
          added: 'October, 19 2016 06:03:38',
          published: 'October, 18 2016 00:00:00',
          country: 'Venezuela',
          relevance: 2,
          pestle: 'Political',
          source: 'CNNMoney',
          title: "Venezuela's government-run oil giant is warning that it could default on its bonds as early as next week.",
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Energy',
          topic: 'oil',
          insight: 'THE DAILY EDGE (18 October 2016): Cars, Oil.',
          url: 'http://www.edgeandodds.com/2016/10/18/the-daily-edge-18-october-2016-cars-oil/',
          region: '',
          start_year: '',
          impact: '',
          added: 'October, 19 2016 03:44:59',
          published: 'October, 18 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Technological',
          source: 'Edge and Odds',
          title: 'Widespread adoption of battery-powered vehicles is a serious threat to the oil industry.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Energy',
          topic: 'gas',
          insight: 'BHP says sees signs of recovery across commodities markets',
          url: 'http://www.cnbc.com/2016/10/18/bhp-says-sees-signs-of-recovery-across-commodities-markets.html?_source=twitter',
          region: '',
          start_year: '',
          impact: '',
          added: 'October, 19 2016 03:22:28',
          published: 'October, 18 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Economic',
          source: 'CNBC ',
          title: 'Both oil and gas markets will improve over the next 12 to 18 months.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: '',
          topic: 'policy',
          insight: "What OPEC's Oil U-Turn Missed: Peak Demand Keeps Getting Closer",
          url: 'http://www.bloomberg.com/news/articles/2016-10-16/what-opec-s-oil-u-turn-missed-peak-demand-keeps-getting-closer-iud8k6o5?&cmpid%3D=socialflow-twitter-business',
          region: '',
          start_year: 2030,
          impact: '',
          added: 'October, 19 2016 01:39:57',
          published: 'October, 16 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Organization',
          source: 'Bloomberg Business',
          title: 'More aggressive adoption of low-carbon policies could bring a lower 2030 peak of 94 million barrels a day.',
          likelihood: 2
        },
        {
          end_year: 2036,
          intensity: 12,
          sector: 'Manufacturing',
          topic: 'car',
          insight: "What OPEC's Oil U-Turn Missed: Peak Demand Keeps Getting Closer",
          url: 'http://www.bloomberg.com/news/articles/2016-10-16/what-opec-s-oil-u-turn-missed-peak-demand-keeps-getting-closer-iud8k6o5?&cmpid%3D=socialflow-twitter-business',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'October, 19 2016 01:39:57',
          published: 'October, 16 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Social',
          source: 'Bloomberg Business',
          title: 'The anticipated increase in demand of about 20 million barrels a day over the next two decades will probably be big enough to overwhelm the impact of the electric car.',
          likelihood: 4
        },
        {
          end_year: 2030,
          intensity: 9,
          sector: '',
          topic: 'vehicle',
          insight: "What OPEC's Oil U-Turn Missed: Peak Demand Keeps Getting Closer",
          url: 'http://www.bloomberg.com/news/articles/2016-10-16/what-opec-s-oil-u-turn-missed-peak-demand-keeps-getting-closer-iud8k6o5?&cmpid%3D=socialflow-twitter-business',
          region: '',
          start_year: '',
          impact: '',
          added: 'October, 19 2016 01:39:56',
          published: 'October, 16 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'Bloomberg Business',
          title: 'By 2030 carbon-powered vehicles will be the exception rather than the norm.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 1,
          sector: 'Manufacturing',
          topic: 'oil',
          insight: "What OPEC's Oil U-Turn Missed: Peak Demand Keeps Getting Closer",
          url: 'http://www.bloomberg.com/news/articles/2016-10-16/what-opec-s-oil-u-turn-missed-peak-demand-keeps-getting-closer-iud8k6o5?&cmpid%3D=socialflow-twitter-business',
          region: '',
          start_year: '',
          impact: '',
          added: 'October, 19 2016 01:39:55',
          published: 'October, 16 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Economic',
          source: 'Bloomberg Business',
          title: 'Disruption could spread to the oil industry as electric vehicles become more economic than gasoline or diesel cars.',
          likelihood: 1
        },
        {
          end_year: '',
          intensity: 9,
          sector: '',
          topic: 'consumption',
          insight: "What OPEC's Oil U-Turn Missed: Peak Demand Keeps Getting Closer",
          url: 'http://www.bloomberg.com/news/articles/2016-10-16/what-opec-s-oil-u-turn-missed-peak-demand-keeps-getting-closer-iud8k6o5?&cmpid%3D=socialflow-twitter-business',
          region: '',
          start_year: 2030,
          impact: '',
          added: 'October, 19 2016 01:39:55',
          published: 'October, 16 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Lifestyles',
          source: 'Bloomberg Business',
          title: 'Petroleum consumption will peak in 2030 and decline thereafter.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Shadow War in the Sahara',
          url: 'http://www.aljazeera.com/programmes/specialseries/2016/10/shadow-war-sahara-161009025023817.html',
          region: 'Africa',
          start_year: '',
          impact: '',
          added: 'October, 17 2016 06:27:24',
          published: 'October, 15 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'Aljazeera.com',
          title: 'The last major reserves of oil in Africa will become increasingly important.',
          likelihood: 3
        },
        {
          end_year: 2036,
          intensity: 9,
          sector: 'Energy',
          topic: 'gas',
          insight: 'Shadow War in the Sahara',
          url: 'http://www.aljazeera.com/programmes/specialseries/2016/10/shadow-war-sahara-161009025023817.html',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'October, 17 2016 06:27:23',
          published: 'October, 15 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'Aljazeera.com',
          title: 'Nearly $2tn of investments in African oil and gas are expected in the next two decades.',
          likelihood: 3
        },
        {
          end_year: 2021,
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'World Energy Resources',
          url: 'https://www.worldenergy.org/wp-content/uploads/2016/10/WECJ4713_Resources_ShortReport_.pdf',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'October, 16 2016 02:57:47',
          published: 'October, 12 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'worldenergy',
          title: 'Oil substitution is not yet imminent and is not expected to reach more than 5% for the next five years.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 12,
          sector: '',
          topic: '',
          insight: 'BOARD COMMUNICATIONS',
          url: 'http://d2qrgk75cp62ej.cloudfront.net/sites/main/files/file-attachments/board_communication_-_october_14_2016.pdf',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'October, 16 2016 01:52:54',
          published: 'October, 14 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: '',
          source: 'cloudfront',
          title: 'The Federal Reserve is expected to raise the discount rate to about 1.5% by the end of 2017.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Manufacturing',
          topic: 'production',
          insight: "Saudi Arabia, Russia role 'critical in rebalancing oil markets'",
          url: 'http://www.zawya.com/story/Saudi_Arabia_Russia_role_critical_in_rebalancing_oil_markets-ZAWYA20161007054122/',
          region: '',
          start_year: '',
          impact: '',
          added: 'October, 16 2016 01:44:11',
          published: 'October, 07 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'Zawya',
          title: "OPEC's decision to embrace production cuts will help move crude prices toward a target of $50 to $60 per barrel.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'energy',
          insight: 'The future is now: How to win the resource revolution',
          url: 'http://www.mckinsey.com/business-functions/sustainability-and-resource-productivity/our-insights/the-future-is-now-how-to-win-the-resource-revolution?cid=sustainability-eml-alt-mip-mck-oth-1610',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'October, 13 2016 08:53:59',
          published: 'October, 01 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'McKinsey & Company',
          title: 'Greater energy efficiency and the substitution of some existing resources, such as coal and oil, by alternatives, including wind and solar, could improve the energy productivity of the global economy by almost 75 percent.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'energy',
          insight: 'The future is now: How to win the resource revolution',
          url: 'http://www.mckinsey.com/business-functions/sustainability-and-resource-productivity/our-insights/the-future-is-now-how-to-win-the-resource-revolution?cid=sustainability-eml-alt-mip-mck-oth-1610',
          region: '',
          start_year: '',
          impact: '',
          added: 'October, 13 2016 08:53:59',
          published: 'October, 01 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Industries',
          source: 'McKinsey & Company',
          title: 'Cement-grinding plants can cut energy consumption by 5 percent or more with customized controls that predict peak demand.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Manufacturing',
          topic: 'car',
          insight: 'The future is now: How to win the resource revolution',
          url: 'http://www.mckinsey.com/business-functions/sustainability-and-resource-productivity/our-insights/the-future-is-now-how-to-win-the-resource-revolution?cid=sustainability-eml-alt-mip-mck-oth-1610',
          region: '',
          start_year: '',
          impact: '',
          added: 'October, 13 2016 08:53:56',
          published: 'October, 01 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Social',
          source: 'McKinsey & Company',
          title: 'By 2030, electric vehicles could represent about 30 percent of all new cars sold globally.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'FISH AND SEAFOOD',
          url: 'http://www.fao.org/3/a-BO102e.pdf?platform=hootsuite',
          region: 'Northern Europe',
          start_year: 2025,
          impact: '',
          added: 'October, 13 2016 01:11:35',
          published: 'June, 29 2016 00:00:00',
          country: 'Norway',
          relevance: 4,
          pestle: 'Industries',
          source: 'FAO',
          title: 'Norway will account for 31% of world fish oil imports in 2025.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Energy',
          topic: 'oil',
          insight: 'FISH AND SEAFOOD',
          url: 'http://www.fao.org/3/a-BO102e.pdf?platform=hootsuite',
          region: '',
          start_year: '',
          impact: '',
          added: 'October, 13 2016 01:11:22',
          published: 'June, 29 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Environmental',
          source: 'FAO',
          title: 'Fish oil is still expected to be used in the aquaculture industry.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Manufacturing',
          topic: 'production',
          insight: 'FISH AND SEAFOOD',
          url: 'http://www.fao.org/3/a-BO102e.pdf?platform=hootsuite',
          region: '',
          start_year: 2025,
          impact: '',
          added: 'October, 13 2016 01:11:14',
          published: 'June, 29 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'FAO',
          title: 'In 2025, fishmeal obtained from by-products is expected to account for 38% of total fishmeal production by 2025.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Manufacturing',
          topic: 'production',
          insight: 'FISH AND SEAFOOD',
          url: 'http://www.fao.org/3/a-BO102e.pdf?platform=hootsuite',
          region: '',
          start_year: 2025,
          impact: '',
          added: 'October, 13 2016 01:11:07',
          published: 'June, 29 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Environmental',
          source: 'FAO',
          title: 'Overall, freshwater species, such as carp will account for most of the increase in aquaculture production and represent around 60% of total aquaculture production in 2025.',
          likelihood: 4
        },
        {
          end_year: 2025,
          intensity: 12,
          sector: 'Manufacturing',
          topic: 'production',
          insight: 'FISH AND SEAFOOD',
          url: 'http://www.fao.org/3/a-BO102e.pdf?platform=hootsuite',
          region: '',
          start_year: 2021,
          impact: '',
          added: 'October, 13 2016 01:11:06',
          published: 'June, 29 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Environmental',
          source: 'FAO',
          title: 'Aquaculture will overtake capture fisheries in 2021 and reach 52% of total fish production in 2025.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 3,
          sector: '',
          topic: 'consumption',
          insight: 'FISH AND SEAFOOD',
          url: 'http://www.fao.org/3/a-BO102e.pdf?platform=hootsuite',
          region: '',
          start_year: '',
          impact: '',
          added: 'October, 13 2016 01:11:01',
          published: 'June, 29 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Lifestyles',
          source: 'FAO',
          title: 'The average price of traded fish products for human consumption is expected to decline during the outlook period.',
          likelihood: 3
        },
        {
          end_year: 2025,
          intensity: 16,
          sector: 'Manufacturing',
          topic: 'production',
          insight: 'FISH AND SEAFOOD',
          url: 'http://www.fao.org/3/a-BO102e.pdf?platform=hootsuite',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'October, 13 2016 01:10:54',
          published: 'June, 29 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'FAO',
          title: 'World production of fishmeal is expected to increase by 15% in 2025 relative to the average 2013-15 level.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 8,
          sector: 'Manufacturing',
          topic: 'production',
          insight: 'FISH AND SEAFOOD',
          url: 'http://www.fao.org/3/a-BO102e.pdf?platform=hootsuite',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'October, 13 2016 01:10:51',
          published: 'June, 29 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'FAO',
          title: 'World fish production is projected to grow at 1.5% p.a.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'oil',
          insight: 'World Energy Scenarios 2016',
          url: 'https://www.worldenergy.org/wp-content/uploads/2016/10/World-Energy-Scenarios-2016_Full-report.pdf',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'October, 12 2016 03:53:14',
          published: 'October, 06 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'worldenergy',
          title: 'Demand peaks for coal and oil have the potential to take the world from stranded assets predominantly in the private sector to state-owned stranded resources and could cause significant stress to the current global economic equilibrium with unforeseen consequences on geopolitical agendas.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 3,
          sector: '',
          topic: '',
          insight: 'Worldsteel expects some growth in steel demand for 2016, 2017',
          url: 'http://www.engineeringnews.co.za/article/worldsteel-expects-some-growth-in-steel-demand-for-2016-2017-2016-10-11',
          region: '',
          start_year: '',
          impact: '',
          added: 'October, 12 2016 03:35:38',
          published: 'October, 11 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: '',
          source: 'Engineering News',
          title: "he EU's steel demand recovery is expected to stay on track, backed by resilient consumption and a mild recovery in construction despite heightened uncertainties following the UK referendum on exiting the EU.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 48,
          sector: '',
          topic: 'tax',
          insight: 'Lauded Security Boss in Rio Quits as Crime, Violence Surge',
          url: 'http://www.voanews.com/a/lauded-security-boss-rio-quits-crime-violence-surge/3546538.html',
          region: 'South America',
          start_year: '',
          impact: 3,
          added: 'October, 12 2016 02:42:09',
          published: 'October, 11 2016 00:00:00',
          country: 'Brazil',
          relevance: 4,
          pestle: 'Political',
          source: 'VOA',
          title: "Falling tax revenue amid Brazil's worst recession since the Great Depression will cause a 2016 state deficit of as much as 20 billion reais ($6.23 billion).",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Construction',
          topic: 'city',
          insight: '2017 Global Travel Price Outlook Identifies Key Risks for Global Market',
          url: 'http://www.htrends.com/trends-detail-sid-90195.html',
          region: '',
          start_year: '',
          impact: '',
          added: 'October, 12 2016 01:17:57',
          published: 'July, 14 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Economic',
          source: 'Hospitality Trends',
          title: 'East Coast cities including New York City and Toronto will face low growth or even a reduction because of an over-supply of hotel rooms.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 4,
          sector: '',
          topic: '',
          insight: '2017 Global Travel Price Outlook Identifies Key Risks for Global Market',
          url: 'http://www.htrends.com/trends-detail-sid-90195.html',
          region: 'South America',
          start_year: '',
          impact: '',
          added: 'October, 12 2016 01:17:55',
          published: 'July, 14 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: '',
          source: 'Hospitality Trends',
          title: 'It is anticipated that Eastern Europe hotel prices will fall 2.4 percent, Western Europe prices will increase 1.8 percent, and Middle East and Africa rates will fall slightly, by 0.5 percent. Prices in Latin America and the Caribbean are projected to decrease by 0.9 percent.',
          likelihood: 4
        },
        {
          end_year: 2060,
          intensity: 6,
          sector: 'Energy',
          topic: 'power',
          insight: 'Global demand for energy will peak in 2030, says World Energy Council',
          url: 'https://www.theguardian.com/business/2016/oct/10/global-demand-for-energy-will-peak-in-2030-says-world-energy-council?CMP=Share_iOSApp_Other',
          region: '',
          start_year: '',
          impact: '',
          added: 'October, 12 2016 00:50:11',
          published: 'October, 10 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Political',
          source: 'Guardian',
          title: 'Solar and wind accounted for 4% of power generation in 2014 but could supply up to 39% by 2060.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Energy',
          topic: 'oil',
          insight: 'White Biotechnology Market Is Expected To Grow At A CAGR Of 10.2% From 2016 To 2024: Grand View Research, Inc',
          url: 'http://www.saltlakecityheadlines.com/story/101007/white-biotechnology-market-is-expected-to-grow-at-a-cagr-of-102-from-2016-to-2024-grand-view-research-inc.html',
          region: '',
          start_year: '',
          impact: '',
          added: 'October, 11 2016 03:39:20',
          published: '',
          country: '',
          relevance: 1,
          pestle: 'Economic',
          source: 'saltlakecityheadlines',
          title: 'Volatility of crude oil prices is expected to encourage various manufacturers in the market to increase biofuel production over the next eight years which in turn will propel technology demand.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Financial services',
          topic: 'oil',
          insight: 'Basic Materials, Energy Sectors Looking to Rally In Upcoming Earnings',
          url: 'https://tickertape.tdameritrade.com/trading/2016/10/basic-materials-energy-sector-earnings-24829',
          region: 'Northern America',
          start_year: 2017,
          impact: '',
          added: 'October, 11 2016 03:15:24',
          published: 'October, 06 2016 00:00:00',
          country: 'United States of America',
          relevance: 4,
          pestle: 'Economic',
          source: 'The Ticker Tape',
          title: 'Declining U.S. oil production is expected to bring down global oversupply and reduced investment in new production should lead to greater output declines in the future and help markets rebalance in 2017.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Basic Materials, Energy Sectors Looking to Rally In Upcoming Earnings',
          url: 'https://tickertape.tdameritrade.com/trading/2016/10/basic-materials-energy-sector-earnings-24829',
          region: 'World',
          start_year: 2016,
          impact: '',
          added: 'October, 11 2016 03:15:23',
          published: 'October, 06 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'The Ticker Tape',
          title: 'Global oil demand will rise by 1.3 million barrels per day (MMb/d) in 2016 to 96.1 MMb/d.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Environment',
          topic: 'carbon',
          insight: 'Why carbon capture is just as important as renewable energy Add to ...',
          url: 'http://www.theglobeandmail.com/report-on-business/rob-commentary/why-carbon-capture-is-just-as-important-as-renewable-energy/article32311433/?cmpid=applenews',
          region: '',
          start_year: '',
          impact: '',
          added: 'October, 11 2016 02:55:53',
          published: 'October, 09 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Environmental',
          source: 'The Globe and Mail',
          title: 'CCS facilities could help fund themselves by using the carbon dioxide they capture to make new products.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 2,
          sector: '',
          topic: '',
          insight: 'Rice Seen Extending Biggest Loss in Three Years on India Monsoon',
          url: 'http://www.agweb.com/article/rice-seen-extending-biggest-loss-in-three-years-on-india-monsoon-blmg/',
          region: 'Asia',
          start_year: '',
          impact: '',
          added: 'October, 11 2016 00:43:11',
          published: 'October, 10 2016 00:00:00',
          country: 'Nigeria',
          relevance: 1,
          pestle: '',
          source: 'AgWeb - The Home Page of Agriculture',
          title: 'Only unexpected demand from Asia or the reopening of rice imports into Nigeria could have some stabilizing impact on rice prices.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Energy',
          topic: 'oil',
          insight: "Putin just upped Russia's status in global oil markets",
          url: 'http://uk.businessinsider.com/putin-just-upped-its-status-global-oil-markets-2016-10?r=US&IR=T',
          region: '',
          start_year: '',
          impact: '',
          added: 'October, 10 2016 00:34:04',
          published: 'October, 10 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Economic',
          source: 'Business Insider',
          title: 'Oil markets are future oriented and will undoubtedly anticipate rising prices.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'gas',
          insight: 'Fracking Press Clips: October 6, 2016',
          url: 'http://www.cafrackfacts.org/uncategorized/fracking-press-clips-october-6-2016/',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'October, 09 2016 03:11:11',
          published: 'October, 06 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Environmental',
          source: 'CAFrackFacts',
          title: 'Global methane emissions from the oil and gas industries could be as much as 60 percent higher than previously reported.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 8,
          sector: 'Information Technology',
          topic: 'export',
          insight: "Asia ex-Japan's growth to decelerate further in 2016",
          url: 'http://www.thestar.com.my/business/business-news/2016/01/23/asia-exjapans-growth-to-decelerate-further-in-2016/',
          region: 'Eastern Asia',
          start_year: '',
          impact: '',
          added: 'October, 09 2016 02:54:49',
          published: 'January, 23 2016 00:00:00',
          country: 'China',
          relevance: 2,
          pestle: 'Economic',
          source: 'the star online',
          title: 'Electronics exports (33% share) will be constrained by weak global demand which has reduced intermediate supply chain flows through China.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 8,
          sector: 'Retail',
          topic: 'export',
          insight: "Asia ex-Japan's growth to decelerate further in 2016",
          url: 'http://www.thestar.com.my/business/business-news/2016/01/23/asia-exjapans-growth-to-decelerate-further-in-2016/',
          region: 'South-Eastern Asia',
          start_year: '',
          impact: '',
          added: 'October, 09 2016 02:54:49',
          published: 'January, 23 2016 00:00:00',
          country: 'Malaysia',
          relevance: 2,
          pestle: 'Political',
          source: 'the star online',
          title: "The impact of a decline in oil will affect Malaysia as it contributes to 28% of Government's revenue and as a commodity export constitutes about 21% of GDP.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: "Algeria's Economic Outlook- October 2016",
          url: 'http://www.worldbank.org/en/country/algeria/publication/economic-outlook-fall-2016',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'October, 09 2016 02:54:20',
          published: 'October, 01 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'World Bank',
          title: "Algeria's fiscal deficit is expected to remain large at about 13.2% of GDP in 2016 (albeit gradually, narrowing to 8.0% in 2018) as low oil prices weigh on fiscal receipts.",
          likelihood: 4
        },
        {
          end_year: 2020,
          intensity: 12,
          sector: 'Transport',
          topic: 'oil',
          insight: "Libya's Economic Outlook- October 2016",
          url: 'http://www.worldbank.org/en/country/libya/publication/economic-outlook-fall-2016',
          region: '',
          start_year: '',
          impact: '',
          added: 'October, 09 2016 02:05:17',
          published: 'October, 01 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Environmental',
          source: 'World Bank',
          title: 'Oil production will progressively increase without reaching full capacity before 2020 due to the time necessary to restore the heavily damaged oil infrastructure.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: '',
          topic: 'economy',
          insight: '2016 PRODUCTION FORECASTS FOR THE GLOBAL ELECTRONICS AND INFORMATION TECHNOLOGY INDUSTRIES',
          url: 'http://www.jeita.or.jp/japanese/topics/2015/1216/Epfget.pdf',
          region: 'Northern America',
          start_year: 2016,
          impact: '',
          added: 'October, 09 2016 00:47:40',
          published: 'December, 16 2015 00:00:00',
          country: 'United States of America',
          relevance: 4,
          pestle: 'Economic',
          source: 'jeita',
          title: 'In 2016, the world economy is expected to see sustainable growth in the U.S. and European economies, taking advantage of low oil prices, and rising consumption and infrastructure development in India and Southeast Asia, among other regions, despite some concerns.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Financial services',
          topic: 'policy',
          insight: 'Forecast for the Japanese Economy in Fiscal 2016 and 2017',
          url: 'http://www.murc.jp/english/think_tank/forecast_jp/fc1602.pdf',
          region: 'Eastern Asia',
          start_year: '',
          impact: '',
          added: 'October, 09 2016 00:46:49',
          published: 'February, 01 2016 00:00:00',
          country: 'Japan',
          relevance: 2,
          pestle: 'Economic',
          source: 'murc',
          title: 'There will be limits on how much the yen will weaken because of differences in direction of monetary policies in Japan and the United States and it will be difficult for the yen to stabilize at over ¥120 to the dollar.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Environment',
          topic: 'economic growth',
          insight: 'Canada Is Introducing A Nationwide Carbon Tax. Could The U.S. Be Next?',
          url: 'https://www.fastcoexist.com/3064338/canada-is-introducing-a-nationwide-carbon-tax-could-the-us-be-next',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'October, 07 2016 05:50:01',
          published: 'October, 06 2016 00:00:00',
          country: 'United States of America',
          relevance: 2,
          pestle: 'Economic',
          source: 'Fast Co-Exist',
          title: 'The U.S. could reduce pollution and not seriously harm economic growth.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 16,
          sector: '',
          topic: '',
          insight: 'THE DAILY EDGE (3 October 2016)',
          url: 'http://www.edgeandodds.com/2016/10/03/the-daily-edge-3-october-2016/',
          region: 'Northern America',
          start_year: 2017,
          impact: '',
          added: 'October, 07 2016 05:44:39',
          published: 'October, 03 2016 00:00:00',
          country: 'United States of America',
          relevance: 4,
          pestle: '',
          source: 'Edge and Odds',
          title: 'Fitch Ratings is reducing its 2016 US high yield bond default rate forecast to 5% from 6% and expects the overall 2017 rate to finish at 3%.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: '',
          topic: '',
          insight: "There's a 'wall of supply' against the oil rally",
          url: 'http://uk.businessinsider.com/theres-a-wall-of-supply-against-the-oil-rally-2016-10?r=US&IR=T',
          region: '',
          start_year: '',
          impact: '',
          added: 'October, 07 2016 03:37:58',
          published: 'October, 07 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: '',
          source: 'Business Insider',
          title: 'The OPEC output deal could add US$10 to crude prices.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 12,
          sector: '',
          topic: '',
          insight: 'Remittances to Developing Countries Expected to Grow at Weak Pace in 2016 and Beyond',
          url: 'http://www.worldbank.org/en/news/press-release/2016/10/06/remittances-to-developing-countries-expected-to-grow-at-weak-pace-in-2016-and-beyond',
          region: 'Africa',
          start_year: 2016,
          impact: '',
          added: 'October, 07 2016 02:57:49',
          published: 'October, 06 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: '',
          source: 'World Bank',
          title: 'Remittances flows to Sub-Saharan Africa are expected to decline by 0.5 percent in 2016.',
          likelihood: 4
        },
        {
          end_year: 2020,
          intensity: 20,
          sector: '',
          topic: 'industry',
          insight: 'A Mixed Barrel: Oil, the Commodity We Love to Hate',
          url: 'http://blog.cushwake.com/americas/mixed-barrel-oil-commodity-love-hate.html?&hootPostID=e29e5ea2c0de9125e038096a6c5d80c7',
          region: '',
          start_year: '',
          impact: '',
          added: 'October, 07 2016 02:55:02',
          published: 'October, 04 2016 00:00:00',
          country: '',
          relevance: 5,
          pestle: 'Industries',
          source: 'Cushman & Wakefield Blog',
          title: 'Industry expectations forecast Brent Crude below-$70 per barrel through 2020.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Retail',
          topic: 'export',
          insight: 'Peak Oil Review: A Midweek Update - 6th Oct 2016',
          url: 'http://www.resilience.org/stories/2016-10-06/peak-oil-review-a-midweek-update-6th-oct-2016',
          region: '',
          start_year: '',
          impact: '',
          added: 'October, 07 2016 02:49:52',
          published: 'October, 06 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'Resilience',
          title: 'The increase in Libyan and Nigerian exports alone could be enough to offset the possible OPEC cut.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 8,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Peak Oil Review: A Midweek Update - 6th Oct 2016',
          url: 'http://www.resilience.org/stories/2016-10-06/peak-oil-review-a-midweek-update-6th-oct-2016',
          region: 'Northern Africa',
          start_year: '',
          impact: '',
          added: 'October, 07 2016 02:49:52',
          published: 'October, 06 2016 00:00:00',
          country: 'Libya',
          relevance: 2,
          pestle: 'Industries',
          source: 'Resilience',
          title: "Libya's oil production has now reached about 500,000 b/d and is expected to climb to 600,000 by the end of the month.",
          likelihood: 4
        },
        {
          end_year: 2020,
          intensity: 12,
          sector: '',
          topic: 'emission',
          insight: '195 nations approve historic climate accord',
          url: 'https://www.sciencenews.org/article/195-nations-approve-historic-climate-accord',
          region: '',
          start_year: '',
          impact: '',
          added: 'October, 07 2016 01:13:23',
          published: 'March, 06 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Environmental',
          source: 'Science News',
          title: 'By 2020, countries will release their long-term plans to cut emissions.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Environment',
          topic: 'gas',
          insight: "World's largest carbon-capture power station will soon open-on schedule and within budget",
          url: 'http://qz.com/801637/worlds-largest-carbon-capture-power-station/',
          region: '',
          start_year: '',
          impact: '',
          added: 'October, 06 2016 00:51:13',
          published: '',
          country: '',
          relevance: 1,
          pestle: 'Environmental',
          source: 'Quartz',
          title: 'The 240-megawatt facility outside Houston, Texas is expected to capture 90% of the carbon dioxide from its exhaust gas, and pump it 80 miles away before injecting it into depleted oil wells out of the atmosphere.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 2,
          sector: '',
          topic: '',
          insight: '"Anyone who Does not Understand What is Going on is not in the Right Place."',
          url: 'http://www.resilience.org/stories/2016-10-04/anyone-who-does-not-understand-what-is-going-on-is-not-in-the-right-place',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'October, 05 2016 01:36:55',
          published: '',
          country: '',
          relevance: 1,
          pestle: '',
          source: 'Resilience',
          title: 'Risks of [oil] supply restraint will resurface long before risks of global demand peaking.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 8,
          sector: 'Energy',
          topic: 'gas',
          insight: 'Total is counting on natural gas to satisfy increasing energy demand',
          url: 'http://us.total.com/en-us/making-energy-better/worldwide-projects/total-counting-natural-gas-satisfy-increasing-energy-demand',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'October, 04 2016 03:02:04',
          published: 'October, 04 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'Total',
          title: 'By 2030, annual growth of the world natural gas market will be about 2% and that LNG will be about 4%, while the growth of the world oil market will be barely above 0.5%.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Translating Arabic Speaking Countries: Oman',
          url: 'http://blog.globalizationpartners.com/translating-arabic-speaking-countries-oman.aspx',
          region: 'Western Asia',
          start_year: 2020,
          impact: '',
          added: 'October, 04 2016 01:21:52',
          published: 'August, 16 2016 00:00:00',
          country: 'Oman',
          relevance: 4,
          pestle: 'Economic',
          source: 'globalizationpartners',
          title: 'Oman will build an oil independent economy through implementing diversification programs as part of Oman Vision 2020.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 8,
          sector: '',
          topic: '',
          insight: "S&P Global Platts' RigData: U.S. Rig Count to Grow by Nearly 30% in 2017",
          url: 'http://www.prnewswire.com/news-releases/sp-global-platts-rigdata-us-rig-count-to-grow-by-nearly-30-in-2017-300337543.html',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'October, 03 2016 04:04:15',
          published: 'September, 30 2016 00:00:00',
          country: 'United States of America',
          relevance: 2,
          pestle: '',
          source: 'PR Newswire',
          title: 'Platts RigData projects the U.S. rig count will grow by an average of 131 rigs or 29% year over year during 2017.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 8,
          sector: '',
          topic: '',
          insight: 'Is the oil world big enough for two swing producers?',
          url: 'https://www.washingtonpost.com/business/economy/is-the-oil-world-big-enough-for-two-swing-producers/2016/09/29/ce4e96f0-85f7-11e6-a3ef-f35afb41797f_story.html',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'October, 03 2016 01:32:46',
          published: '',
          country: 'United States of America',
          relevance: 4,
          pestle: '',
          source: 'Washington Post',
          title: 'Prices could stay within a $40-to-$55-a-barrel band because of adjustments made by the OPEC cartel and U.S. shale producers to effectively prop up prices at the low end and contain them at the high end.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'India just ratified the Paris climate deal - bringing it extremely close to taking effect',
          url: 'https://www.washingtonpost.com/news/energy-environment/wp/2016/10/02/india-ratifies-global-climate-agreement-on-gandhis-birthday/?postshare=6881475420539745&tid=ss_tw',
          region: 'Southern Asia',
          start_year: '',
          impact: '',
          added: 'October, 03 2016 01:32:41',
          published: '',
          country: 'India',
          relevance: 2,
          pestle: 'Economic',
          source: 'Washington Post',
          title: 'India will be the number one country for oil demand growth worldwide.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'gas',
          insight: "2016: California's 'Staggering' Leak Could Spew Methane for Months",
          url: 'https://insideclimatenews.org/news/21122015/2016-california-massive-methane-leak-socal-natural-gas-fracking-climate-change-health',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'October, 02 2016 05:57:56',
          published: 'January, 04 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Environmental',
          source: 'Inside Climate News',
          title: 'In 2016, the U.S. Environmental Protection Agency will issue long-awaited rules to control methane emissions from the oil and gas industry.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Energy',
          topic: 'gas',
          insight: 'January 2016: Commodity Markets Outlook',
          url: 'http://pubdocs.worldbank.org/en/991211453766993714/CMO-Jan-2016-Full-Report.pdf',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'October, 02 2016 05:24:46',
          published: 'January, 25 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'World Bank',
          title: 'Natural gas prices are projected to fall in 2016.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 9,
          sector: 'Manufacturing',
          topic: 'production',
          insight: 'January 2016: Commodity Markets Outlook',
          url: 'http://pubdocs.worldbank.org/en/991211453766993714/CMO-Jan-2016-Full-Report.pdf',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'October, 02 2016 05:24:43',
          published: 'January, 25 2016 00:00:00',
          country: 'United States of America',
          relevance: 3,
          pestle: 'Industries',
          source: 'World Bank',
          title: 'Non-OPEC production outside the U.S. is expected to fall by 0.1 mb/d.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: '',
          topic: 'growth',
          insight: 'January 2016: Commodity Markets Outlook',
          url: 'http://pubdocs.worldbank.org/en/991211453766993714/CMO-Jan-2016-Full-Report.pdf',
          region: 'Asia',
          start_year: '',
          impact: '',
          added: 'October, 02 2016 05:24:41',
          published: 'January, 25 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'World Bank',
          title: 'OECD oil consumption is expected to be flat with a modest gain in North America nearly offsetting declines elsewhere. Non-OECD oil consumption is projected to rise by 1.2 mb/d (2.4 percent). Consumption growth is expected to be considerably slower in Asia.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 9,
          sector: 'Energy',
          topic: 'oil',
          insight: 'January 2016: Commodity Markets Outlook',
          url: 'http://pubdocs.worldbank.org/en/991211453766993714/CMO-Jan-2016-Full-Report.pdf',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'October, 02 2016 05:24:41',
          published: 'January, 25 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'World Bank',
          title: 'OECD oil consumption is expected to be flat with a modest gain in North America nearly offsetting declines elsewhere.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'January 2016: Commodity Markets Outlook',
          url: 'http://pubdocs.worldbank.org/en/991211453766993714/CMO-Jan-2016-Full-Report.pdf',
          region: 'World',
          start_year: 2016,
          impact: '',
          added: 'October, 02 2016 05:24:40',
          published: 'January, 25 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'World Bank',
          title: 'For 2016, world oil consumption growth is expected to slow to 1.3 percent (1.2 mb/d) to an average global consumption of 95.7 mb/d.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'export',
          insight: 'January 2016: Commodity Markets Outlook',
          url: 'http://pubdocs.worldbank.org/en/991211453766993714/CMO-Jan-2016-Full-Report.pdf',
          region: 'Southern Asia',
          start_year: '',
          impact: '',
          added: 'October, 02 2016 05:24:37',
          published: 'January, 25 2016 00:00:00',
          country: 'Iran',
          relevance: 2,
          pestle: 'Economic',
          source: 'World Bank',
          title: 'Exports from the Islamic Republic of Iran are expected to rise sharply as sanctions that had hampered oil sector investment and exports have been lifted.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: '',
          topic: 'growth',
          insight: 'Strong growth in global acrylic acid market driven by demand from adhesives and sealants industry',
          url: 'http://www.polymerspaintcolourjournal.com/news/view/strong-growth-in-global-acrylic-acid-market-driven-by-demand-from-adhesives',
          region: 'Europe',
          start_year: '',
          impact: '',
          added: 'October, 02 2016 04:32:28',
          published: '',
          country: '',
          relevance: 2,
          pestle: 'Political',
          source: 'polymerspaintcolourjournal',
          title: 'Stringent regulations imposed in North America and Europe will also adversely affect the growth of the acrylic acid market.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 8,
          sector: 'Energy',
          topic: 'oil',
          insight: 'CFS Annual Report - 2016',
          url: 'http://www.njc-cnm.gc.ca/doc.php?did=635&lang=en',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'October, 02 2016 03:28:31',
          published: '',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'njc-cnm',
          title: 'Overall, global crude oil supply is expected to grow by about 2.4%.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 8,
          sector: '',
          topic: 'economy',
          insight: 'CFS Annual Report - 2016',
          url: 'http://www.njc-cnm.gc.ca/doc.php?did=635&lang=en',
          region: 'South America',
          start_year: '',
          impact: '',
          added: 'October, 02 2016 03:28:31',
          published: '',
          country: 'Brazil',
          relevance: 2,
          pestle: 'Economic',
          source: 'njc-cnm',
          title: "Brazil's economy is projected to contract by 3% this year and Venezuela's by 10%.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'gas',
          insight: 'A Perspective on Infrastructure and Energy Security In the Transition',
          url: 'https://europeanclimate.org/wp-content/uploads/2016/03/EUC_Report-WEB.pdf',
          region: '',
          start_year: 2018,
          impact: '',
          added: 'October, 02 2016 03:27:29',
          published: 'February, 29 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'europeanclimate',
          title: 'Norwegian gas production could peak in 2018.',
          likelihood: 2
        },
        {
          end_year: 2026,
          intensity: 16,
          sector: '',
          topic: 'trade',
          insight: 'USDA Agricultural Projections to 2025',
          url: 'http://ers.usda.gov/media/2017463/oce-2016-1.pdf',
          region: 'World',
          start_year: 2016,
          impact: '',
          added: 'October, 02 2016 03:04:35',
          published: 'February, 12 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'USDA',
          title: 'During the next decade, global soybean trade is projected to increase by 22 percent.',
          likelihood: 4
        },
        {
          end_year: 2026,
          intensity: 9,
          sector: '',
          topic: '',
          insight: 'USDA Agricultural Projections to 2025',
          url: 'http://ers.usda.gov/media/2017463/oce-2016-1.pdf',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'October, 02 2016 03:04:22',
          published: 'February, 12 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: '',
          source: 'USDA',
          title: 'Increasing global demand for agricultural commodities, especially by developing countries, leads to higher production and exports by major exporting countries throughout the projection period. The European Union (EU) are expected to remain important exporters during the coming decade.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'USDA Agricultural Projections to 2025',
          url: 'http://ers.usda.gov/media/2017463/oce-2016-1.pdf',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'October, 02 2016 03:04:20',
          published: 'February, 12 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'USDA',
          title: 'U.S. farm production expenses are projected to increase after 2017 as crude oil prices and interest rates rise.',
          likelihood: 4
        },
        {
          end_year: 2026,
          intensity: 16,
          sector: '',
          topic: 'economic growth',
          insight: 'USDA Agricultural Projections to 2025',
          url: 'http://ers.usda.gov/media/2017463/oce-2016-1.pdf',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'October, 02 2016 03:04:10',
          published: 'February, 12 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'USDA',
          title: 'Economic growth in the European Union is projected at about 1.8 percent per year over the next decade.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Retail',
          topic: 'export',
          insight: 'USDA Agricultural Projections to 2025',
          url: 'http://ers.usda.gov/media/2017463/oce-2016-1.pdf',
          region: 'Eastern Asia',
          start_year: '',
          impact: '',
          added: 'October, 02 2016 03:04:08',
          published: 'February, 12 2016 00:00:00',
          country: 'China',
          relevance: 2,
          pestle: 'Economic',
          source: 'USDA',
          title: 'Weak global demand from relatively slow growth in developed countries and economic transition in China will be a drag on growth in export-oriented economies while lower oil prices will moderate these challenges.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: '',
          topic: 'brexit',
          insight: 'Survival: Global Politics and Strategy October-November 2016',
          url: 'https://www.iiss.org/en/publications/survival/sections/2016-5e13/survival--global-politics-and-strategy-october-november-2016-ff0a',
          region: 'Southern Asia',
          start_year: '',
          impact: '',
          added: 'October, 02 2016 01:48:05',
          published: 'July, 22 2016 00:00:00',
          country: 'Iran',
          relevance: 3,
          pestle: 'Political',
          source: 'IISS',
          title: 'Seyed Hossein Mousavian argues that Brexit creates an opportunity for a new EU-Iran relationship.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: "EIA's October Estimates for US Shale Oil Production",
          url: 'http://marketrealist.com/2016/09/eias-october-estimates-for-us-shale-oil-production/',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'October, 02 2016 01:08:06',
          published: 'September, 14 2016 00:00:00',
          country: 'United States of America',
          relevance: 2,
          pestle: 'Political',
          source: 'marketrealist',
          title: 'The expected fall in crude oil production in key US shales will negatively affect the performance of oilfield services companies like McDermott International (MDR).',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 12,
          sector: '',
          topic: 'growth',
          insight: '5 Expert Predictions for the Global Economy in 2016',
          url: 'http://www.theatlantic.com/international/archive/2016/01/global-economy-2016/422475/',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'October, 02 2016 00:34:39',
          published: 'September, 30 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'The Atlantic',
          title: 'Euro-zone growth is expected to reach 1.5 percent with inflation of around 1 percent in 2016.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: '',
          topic: 'economy',
          insight: '5 Expert Predictions for the Global Economy in 2016',
          url: 'http://www.theatlantic.com/international/archive/2016/01/global-economy-2016/422475/',
          region: 'South America',
          start_year: 2016,
          impact: '',
          added: 'October, 02 2016 00:34:33',
          published: 'September, 30 2016 00:00:00',
          country: 'Brazil',
          relevance: 4,
          pestle: 'Economic',
          source: 'The Atlantic',
          title: 'Emerging economies like Brazil, South Africa, Thailand, and Turkey will be the real sources of concern in 2016.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Energy',
          topic: 'oil',
          insight: "Malaysia's unique freshwater mussels in danger",
          url: 'http://www.innovations-report.com/html/reports/environment-sciences/malaysia-s-unique-freshwater-mussels-in-danger.html',
          region: '',
          start_year: '',
          impact: '',
          added: 'October, 01 2016 02:49:21',
          published: 'September, 27 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Environmental',
          source: 'Innovations Report',
          title: 'Most native species are severely threatened by ongoing nutrient pollution and acidification of freshwater habitats caused by atmospheric pollution, deforestation, oil-palm plantations and a lack of functioning wastewater treatment particularly in rural areas.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'gas',
          insight: "African elephants, forensic science and China's gene bank",
          url: 'http://www.nature.com/news/african-elephants-forensic-science-and-china-s-gene-bank-1.20689',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'October, 01 2016 02:31:47',
          published: 'September, 28 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Environmental',
          source: 'Nature',
          title: 'Carbon emissions will cause global warming to surpass 2 °C if the world produces all of the oil, gas and coal in reserves that are already being exploited or developed.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Manufacturing',
          topic: 'growth',
          insight: 'Oil prices rise, but for how long?',
          url: 'http://rbth.com/business/2016/09/30/oil-prices-rise-but-for-how-long_634785',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'October, 01 2016 01:25:59',
          published: 'September, 30 2016 00:00:00',
          country: 'United States of America',
          relevance: 4,
          pestle: 'Economic',
          source: 'Russia Beyond The Headlines',
          title: 'Any price growth higher than $50 per barrel will lead to an increase of drilling in the US and the renewal of shale production growth.',
          likelihood: 4
        },
        {
          end_year: 2017,
          intensity: 20,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Oil and Gas Report',
          url: 'http://www.cushmanwakefield.com/en/research-and-insight/2016/oil-and-gas-report/',
          region: '',
          start_year: '',
          impact: '',
          added: 'September, 30 2016 05:21:36',
          published: 'September, 22 2016 00:00:00',
          country: '',
          relevance: 5,
          pestle: 'Industries',
          source: 'Cushman & Wakefield',
          title: 'Oil is expected to remain below $60 per barrel through 2017.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: '',
          topic: 'economy',
          insight: 'Russia: Putin consolidates power following Duma elections',
          url: 'https://maplecroft.com/portfolio/new-analysis/2016/09/29/putin-consolidates-power-following-duma-elections/',
          region: 'Eastern Europe',
          start_year: '',
          impact: '',
          added: 'September, 30 2016 05:07:29',
          published: '',
          country: 'Russia',
          relevance: 2,
          pestle: 'Economic',
          source: 'Maplecroft',
          title: "Russia's economy will remain in poor shape for the foreseeable future and fiscal austerity will be unavoidable.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Retail',
          topic: 'oil',
          insight: 'Jojoba Oil Market Analysis By Application And Segment Forecasts To 2024',
          url: 'http://www.prnewswire.com/news-releases/jojoba-oil-market-analysis-by-application-and-segment-forecasts-to-2024-300337016.html',
          region: '',
          start_year: '',
          impact: '',
          added: 'September, 30 2016 05:03:50',
          published: 'September, 29 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Economic',
          source: 'PR Newswire',
          title: 'The rising demand for organic personal care products along with formulation development for specific consumer group is expected to create new market avenues for cultivators and producers of jojoba oil.',
          likelihood: 3
        },
        {
          end_year: 2024,
          intensity: 48,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Jojoba Oil Market Analysis By Application And Segment Forecasts To 2024',
          url: 'http://www.prnewswire.com/news-releases/jojoba-oil-market-analysis-by-application-and-segment-forecasts-to-2024-300337016.html',
          region: 'World',
          start_year: '',
          impact: 2,
          added: 'September, 30 2016 05:03:49',
          published: 'September, 29 2016 00:00:00',
          country: '',
          relevance: 6,
          pestle: 'Economic',
          source: 'PR Newswire',
          title: 'The global jojoba oil market is expected to reach USD 254.2 million by 2024.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Goldman Brushes Aside OPEC Deal, Continues To See WTI Oil At $43',
          url: 'http://blogs.barrons.com/asiastocks/2016/09/29/goldman-brushes-aside-opec-deal-continues-to-see-wti-oil-at-43/?mod=bol-social-tw',
          region: '',
          start_year: '',
          impact: '',
          added: 'September, 30 2016 04:13:06',
          published: '',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'Fitch',
          title: 'If the production cut to 32.5-33 million barrels a day is "strictly implemented in 1H17", the OPEC deal could add $7-10 a barrel to the oil price.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 8,
          sector: 'Energy',
          topic: 'oil',
          insight: 'OPEC agrees to cut production; oil prices surge',
          url: 'http://money.cnn.com/2016/09/28/investing/oil-surges-after-opec-informal-meeting/index.html',
          region: 'Western Asia',
          start_year: '',
          impact: '',
          added: 'September, 29 2016 03:02:27',
          published: 'September, 28 2016 00:00:00',
          country: 'Saudi Arabia',
          relevance: 2,
          pestle: 'Industries',
          source: 'CNNMoney',
          title: 'Saudi Arabia, the largest oil producer, is expected to give up 350,000 barrels a day.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 8,
          sector: 'Energy',
          topic: 'oil',
          insight: 'OPEC agrees to cut production; oil prices surge',
          url: 'http://money.cnn.com/2016/09/28/investing/oil-surges-after-opec-informal-meeting/index.html',
          region: '',
          start_year: '',
          impact: '',
          added: 'September, 29 2016 03:02:26',
          published: 'September, 28 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'CNNMoney',
          title: 'OPEC oil production is expected to be reduced to a range of 32.5 to 33 million barrels of oil per day from 33.4 million.',
          likelihood: 4
        },
        {
          end_year: 2020,
          intensity: 72,
          sector: '',
          topic: 'market',
          insight: 'The Trick to Predictive Analytics: How to Bridge the Quant/Business Culture Gap',
          url: 'http://www.predictiveanalyticsworld.com/patimes/trick-predictive-analytics-bridge-quantbusiness-culture-gap/8177/',
          region: 'World',
          start_year: '',
          impact: 3,
          added: 'September, 29 2016 01:36:03',
          published: 'September, 28 2016 00:00:00',
          country: '',
          relevance: 6,
          pestle: 'Economic',
          source: 'Predictive Analytics Times',
          title: 'The global predictive analytics market could reach as high as $9 billion by 2020.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Information Technology',
          topic: 'gas',
          insight: 'The oil and gas organization of the future',
          url: 'http://www.mckinsey.com/industries/oil-and-gas/our-insights/the-oil-and-gas-organization-of-the-future?cid=other-eml-alt-mip-mck-oth-1609',
          region: '',
          start_year: '',
          impact: '',
          added: 'September, 28 2016 20:13:28',
          published: 'September, 01 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Technological',
          source: 'McKinsey Quarterly',
          title: 'Oil and gas companies could employ more PhD-level data scientists than geologists.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'oil',
          insight: 'This analyst says OPEC must cut production if it wants to rebalance the crude market next year',
          url: 'http://uk.businessinsider.com/opec-must-cut-production-if-it-wants-to-rebalance-the-crude-market-2016-9?r=US&IR=T',
          region: '',
          start_year: '',
          impact: '',
          added: 'September, 28 2016 06:34:47',
          published: 'September, 28 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Social',
          source: 'Business Insider',
          title: 'A deal to limit oil production could be a reality when OPEC next meet on November 30.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'THE DAILY EDGE (27 September 2016)',
          url: 'http://www.edgeandodds.com/2016/09/27/the-daily-edge-27-september-2016/',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'September, 28 2016 02:12:03',
          published: 'September, 27 2016 00:00:00',
          country: 'United States of America',
          relevance: 3,
          pestle: 'Industries',
          source: 'Edge and Odds',
          title: 'Goldman Sachs forecasts the U.S. will be pumping an additional 600,000 to 700,000 barrels of oil a day by the end of next year-making up for every drop lost in the bust.',
          likelihood: 4
        },
        {
          end_year: 2020,
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Sodexo Awarded Maximum Score on World Wildlife Fund Palm Oil Buyers Scorecard',
          url: 'http://www.sodexo.com/home/media/press-releases/newsListArea/press-releases/palm-oil-buyers-scorecard@/palm-oil-buyers-scorecard.html',
          region: '',
          start_year: '',
          impact: '',
          added: 'September, 28 2016 01:16:50',
          published: 'September, 21 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'Countries.com Global Content',
          title: 'Palm oil is now the most widely used vegetable oil on the planet, accounting for 65 percent of all vegetable oil traded internationally and the use of palm oil is expected to double by 2020.',
          likelihood: 4
        },
        {
          end_year: 2034,
          intensity: 12,
          sector: '',
          topic: 'workforce',
          insight: 'Pride in Lions',
          url: 'http://www.mckinsey.com/about-us/new-at-mckinsey-blog/pride-in-lions?cid=other-soc-twi-mbl-mck-oth-1609&kui=SqiPmUZiGa6P60weKYMLwg',
          region: 'Africa',
          start_year: '',
          impact: '',
          added: 'September, 28 2016 00:51:38',
          published: 'September, 23 2016 00:00:00',
          country: 'China',
          relevance: 4,
          pestle: 'Organization',
          source: 'McKinsey Quarterly',
          title: 'By 2034, Africa is expected to have a larger workforce than either China or India.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: "The Electric Car Might Spell The Death Of Oil. Here's Why",
          url: 'http://themarketmogul.com/the-electric-car-might-spell-the-death-of-oil-heres-why/',
          region: '',
          start_year: 2040,
          impact: '',
          added: 'September, 27 2016 03:09:37',
          published: 'September, 26 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'The Market Mogul',
          title: 'Oil will continue to be used long after 2040 as it is still the most efficient fuel for planes by far.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 8,
          sector: 'Energy',
          topic: 'oil',
          insight: "Saudi Arabia slashes ministers' pay, cuts public sector bonuses",
          url: 'http://uk.reuters.com/article/uk-saudi-economy-idUKKCN11W26N',
          region: 'Western Asia',
          start_year: '',
          impact: '',
          added: 'September, 27 2016 03:03:02',
          published: 'September, 26 2016 00:00:00',
          country: 'Saudi Arabia',
          relevance: 2,
          pestle: 'Economic',
          source: 'Reuters',
          title: "Saudi Arabia will cut ministers' salaries by 20 percent and scale back financial perks for public sector employees in one of the most drastic measures yet by the energy-rich kingdom to save money at a time of low oil prices.",
          likelihood: 4
        },
        {
          end_year: 2016,
          intensity: 12,
          sector: '',
          topic: 'growth',
          insight: 'Refugees’ Right to Work and Access to Labor Markets – An Assessment',
          url: 'http://www.knomad.org/docs/forced_migration/KNOMAD%20Study%20-%20Part%20II-%20Refugees%27%20Rights%20to%20Work%20-%20An%20Assessment.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'September, 26 2016 04:50:00',
          published: 'September, 15 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'knomad',
          title: 'Ecuadorean GDP growth will expand modestly in 2016 (0.7%) following a contraction in 2015.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'gas',
          insight: 'The G20 accounts for 92% of global spending on research',
          url: 'http://www.unesco.org/new/en/media-services/single-view/news/the_g20_accounts_for_92_of_global_spending_on_research/#.V-D8ME3ynIU',
          region: 'Eastern Asia',
          start_year: '',
          impact: '',
          added: 'September, 26 2016 03:31:48',
          published: '',
          country: 'China',
          relevance: 2,
          pestle: 'Industries',
          source: 'UNESCO ',
          title: 'Currently, China receives nearly 60% of its oil and over 30% of its natural gas from foreign sources. For domestic production to make up 85% of total energy consumption by 2020, China will need to increase its production of natural gas, shale gas and coalbed methane.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Energy',
          topic: 'oil',
          insight: 'A legendary investor thinks electric cars will raise the price of oil',
          url: 'http://uk.businessinsider.com/dwight-anderson-ospraie-management-on-oil-price-2016-9?r=US&IR=T',
          region: '',
          start_year: '',
          impact: '',
          added: 'September, 26 2016 02:41:05',
          published: 'September, 25 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Industries',
          source: 'Business Insider',
          title: 'In the short-term, electric vehicles could actually lead to a spike in the oil price.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'energy',
          insight: "Here's where Hillary Clinton and Donald Trump stand on energy issues",
          url: 'http://uk.businessinsider.com/trump-and-clinton-on-the-issues-energy-policy-2016-9?r=US&IR=T',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'September, 26 2016 02:40:56',
          published: 'September, 25 2016 00:00:00',
          country: 'United States of America',
          relevance: 2,
          pestle: 'Political',
          source: 'Business Insider',
          title: "Solving America's energy problems will be a major election issue and a top priority for the next president.",
          likelihood: 3
        },
        {
          end_year: 2019,
          intensity: 16,
          sector: '',
          topic: 'change',
          insight: "Russia is the 'sleeping giant' of global beef trade",
          url: 'http://www.globalmeatnews.com/Industry-Markets/Russia-is-the-sleeping-giant-of-global-beef-trade',
          region: 'Eastern Europe',
          start_year: 2016,
          impact: '',
          added: 'September, 26 2016 01:45:36',
          published: 'September, 23 2016 00:00:00',
          country: 'Russia',
          relevance: 4,
          pestle: 'Organization',
          source: 'GlobalMeatNews.com',
          title: 'Beef imports into Russia are not expected to change in the coming years.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 2,
          sector: '',
          topic: 'automaker',
          insight: 'Emerging trends and improved lubricants can propel your business forward',
          url: 'https://www.motor.com/newsletters/20120808/WebFiles/ID1_ChangeAgents.html',
          region: '',
          start_year: '',
          impact: '',
          added: 'September, 25 2016 06:00:12',
          published: '',
          country: '',
          relevance: 1,
          pestle: 'Industries',
          source: 'Motor Magazine',
          title: 'There is a shared concern among some automakers and lubricant manufacturers that the possible proliferation of lubricant products could overwhelm and further confuse the aftermarket.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Facing Energy and Geostrategic Global Changes',
          url: 'http://www.mena-forum.com/facing-energy-and-geostrategic-global-changes/',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'September, 25 2016 04:39:34',
          published: 'September, 19 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'MENA-Forum',
          title: 'Oil supply will continue to exceed demand at least during the first half of the year 2017.',
          likelihood: 4
        },
        {
          end_year: 2017,
          intensity: '',
          sector: 'Energy',
          topic: 'oil',
          insight: "IEA Bioenergy Countries' Report - 23.09.2016",
          url: 'http://www.ieabioenergy.com/wp-content/uploads/2016/09/IEA-Bioenergy-Countries-Report-23.09.2016.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'September, 25 2016 03:10:31',
          published: 'September, 22 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'IEA',
          title: 'Back-up oil boilers in Denmark are going to be banned in all new constructions by 2017.',
          likelihood: ''
        },
        {
          end_year: 2020,
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: "UK Companies 'Leading The Way' In The Sustainability Of Palm Oil",
          url: 'http://blueandgreentomorrow.com/2016/09/21/uk-companies-leading-way-sustainability-palm-oil/',
          region: '',
          start_year: '',
          impact: '',
          added: 'September, 25 2016 01:59:42',
          published: 'September, 21 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'Blue and Green Tomorrow',
          title: 'With demand for palm oil expected to double by 2020 there will be increasing pressure on tropical forests and biodiversity.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: '',
          topic: '',
          insight: 'Low oil prices reduce pain at the pump',
          url: 'http://phys.org/news/2016-09-oil-prices-pain.html',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'September, 24 2016 03:29:31',
          published: 'September, 22 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: '',
          source: 'Phys Org',
          title: 'Prices will remain at or near $50 a barrel for the rest of 2016.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: '',
          sector: 'Energy',
          topic: 'oil',
          insight: 'Oil State Venezuela is buying US oil and its oil workers are starving',
          url: 'http://www.nextbigfuture.com/2016/09/oil-state-venezuela-is-buying-us-oil.html',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'September, 24 2016 02:38:33',
          published: 'September, 21 2016 00:00:00',
          country: '',
          relevance: 6,
          pestle: 'Industries',
          source: 'nextbigfuture',
          title: 'Oil prices will increase to $80 a barrel in 2017.',
          likelihood: ''
        },
        {
          end_year: 2020,
          intensity: 8,
          sector: 'Energy',
          topic: 'oil',
          insight: "Ghana could be Africa's number four oil producer by 2020 - report",
          url: 'http://www.engineeringnews.co.za/article/ghana-could-be-africas-number-four-oil-producer-by-2020-report-2016-09-22',
          region: 'Africa',
          start_year: '',
          impact: '',
          added: 'September, 23 2016 03:25:27',
          published: 'September, 22 2016 00:00:00',
          country: 'Ghana',
          relevance: 4,
          pestle: 'Industries',
          source: 'Engineering News',
          title: 'Ghana could become the fourth biggest oil producer in sub-Saharan Africa by 2020 once two new offshore fields come on stream.',
          likelihood: 2
        },
        {
          end_year: 2021,
          intensity: 72,
          sector: '',
          topic: 'market',
          insight: 'Global Industrial Valves Market By Type, By Application, By Region, Competition Forecast and Opportunities, 2011 - 2021',
          url: 'http://www.prnewswire.com/news-releases/global-industrial-valves-market-by-type-by-application-by-region-competition-forecast-and-opportunities-2011--2021-300332227.html',
          region: 'World',
          start_year: '',
          impact: 3,
          added: 'September, 23 2016 02:51:18',
          published: 'September, 21 2016 00:00:00',
          country: '',
          relevance: 6,
          pestle: 'Economic',
          source: 'PR Newswire',
          title: 'The global industrial valves market is projected to cross $78 billion by 2021.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 18,
          sector: 'Energy',
          topic: 'oil',
          insight: "We're Nearing Peak Car Ownership",
          url: 'https://www.fastcoexist.com/3063940/were-nearing-peak-car-ownership',
          region: '',
          start_year: '',
          impact: 3,
          added: 'September, 23 2016 01:09:22',
          published: 'September, 22 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'Fast Co-Exist',
          title: 'Early-to-market automated mobility service providers could capture over $100 billion in revenue at the expense of incumbents like oil companies and traditional carmakers.',
          likelihood: 2
        },
        {
          end_year: 2025,
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Five technologies for the next ten years',
          url: 'http://www.mckinsey.com/industries/oil-and-gas/our-insights/five-technologies-for-the-next-ten-years',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'September, 22 2016 03:09:12',
          published: 'September, 01 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'McKinsey Quarterly',
          title: 'The number of robotic systems working in oil fields around the world will be nearly a million by 2025.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 3,
          sector: '',
          topic: '',
          insight: 'Daily Bulletin (English Version) VAF - 22 September 2016',
          url: 'http://www.valburyresearch.com/resources/files/vaf/Daily_Bulletin_(English_Version)_VAF_-_22_September_2016.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'September, 22 2016 00:38:12',
          published: 'September, 22 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: '',
          source: 'valburyresearch',
          title: 'The IMF expects that Chinese authorities will improve the reporting of its reserves composition, achieving full coverage within two to three years.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Construction',
          topic: 'population',
          insight: "These 6 sectors of Africa's economy are poised for growth",
          url: 'https://hbr.org/2016/09/these-6-sectors-of-africas-economy-are-poised-for-growth',
          region: 'Africa',
          start_year: '',
          impact: '',
          added: 'September, 21 2016 04:21:39',
          published: 'September, 20 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Social',
          source: 'HBR',
          title: 'In an aging world, Africa has the advantage of a young and growing population and will soon have the fastest urbanization rate in the world.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Manufacturing',
          topic: 'car',
          insight: "Which Country is the World's 'Most Innovative'? Where Does Your Country Rank (1 to 140) in the 'Innovation Game?'",
          url: 'https://genesisnanotech.wordpress.com/2016/09/19/which-country-is-the-worlds-most-innovative-where-does-your-country-rank-1-to-140-in-the-innovation-game/',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'September, 21 2016 01:37:19',
          published: 'September, 19 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Social',
          source: 'Nanotechnology Innovation',
          title: 'Scientists create innovative hydrogen fuel "nano-reactor" that could make hydrogen cars much cheaper.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Oil Majors Must Count on M&A to Replenish Reserves, WoodMac Says',
          url: 'http://www.bloomberg.com/news/articles/2016-09-20/oil-majors-must-count-on-m-a-to-replenish-reserves-woodmac-says?&cmpid%3D=socialflow-twitter-business',
          region: '',
          start_year: '',
          impact: '',
          added: 'September, 20 2016 17:24:08',
          published: 'September, 20 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Industries',
          source: 'Bloomberg Business',
          title: 'Major oil producers will rely on acquisitions for about half their reserve replacement in the future after cutting exploration budgets to weather the crude-price collapse.',
          likelihood: 3
        },
        {
          end_year: 2035,
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: "The US And China: Saudi Arabia's Big Picture Oil Strategy",
          url: 'http://www.oilvoice.com/n/The-US-And-China-Saudi-Arabias-Big-Picture-Oil-Strategy/fe06a1a034ef.aspx',
          region: 'Eastern Asia',
          start_year: '',
          impact: '',
          added: 'September, 20 2016 03:43:20',
          published: 'September, 16 2016 00:00:00',
          country: 'China',
          relevance: 4,
          pestle: 'Industries',
          source: 'oilvoice',
          title: "China is particularly important for Saudi Arabia because China's oil demand is expected to grow from 6m/bbl today to 13m bbl/day by 2035.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Food & agriculture',
          topic: 'energy',
          insight: "80 Gigawatts of Change, Egypt's Future Electricity Pathways",
          url: 'http://ecesr.org/wp-content/uploads/2016/03/80-Gigawatts-of-Change-En-Pages.pdf',
          region: 'Northern Africa',
          start_year: '',
          impact: '',
          added: 'September, 19 2016 06:06:52',
          published: 'March, 19 2016 00:00:00',
          country: 'Egypt',
          relevance: 2,
          pestle: 'Environmental',
          source: 'ecesr',
          title: "Increasing desertification, changing weather patterns and more intense and frequent extreme weather events (such as heat waves, snow, dust storms, floods and droughts) will all be factors affecting Egypt's energy sector.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Food & agriculture',
          topic: 'gas',
          insight: 'Anti-Pipeline Movement Gathers Steam',
          url: 'http://www.resilience.org/stories/2016-09-16/anti-pipeline-movement-gathers-steam',
          region: '',
          start_year: '',
          impact: '',
          added: 'September, 19 2016 04:58:36',
          published: '',
          country: '',
          relevance: 1,
          pestle: 'Environmental',
          source: 'Resilience',
          title: 'Methane from gas extraction and transportation poses a greater short-term climate change risk than burning carbon fuels like coal and oil.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 2,
          sector: '',
          topic: '',
          insight: 'Russian central bank cuts interest rate further-down to 10 percent',
          url: 'http://www.cnbc.com/2016/09/16/russian-central-bank-cuts-interest-rate-further---down-to-10-percent.html?_source=twitter',
          region: 'Eastern Europe',
          start_year: '',
          impact: '',
          added: 'September, 19 2016 04:12:31',
          published: 'September, 16 2016 00:00:00',
          country: 'Russia',
          relevance: 1,
          pestle: '',
          source: 'CNBC ',
          title: 'External risks to Russia have abated to a significant extent.',
          likelihood: 2
        },
        {
          end_year: 2020,
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'World Kaolin',
          url: 'http://www.freedoniagroup.com/industry-study/3462/world-kaolin.htm',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'September, 19 2016 04:00:08',
          published: '',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'Freedonia',
          title: 'A fall in global oil prices beginning in 2015 cast petroleum industries into a state of uncertainty and fast gains for ceramic proppants are not expected to be repeated through 2020.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Manufacturing',
          topic: 'production',
          insight: 'Researchers decode metabolic pathway of soil bacterium that thrives on lignin',
          url: 'http://phys.org/news/2016-09-decode-metabolic-pathway-soil-bacterium.html',
          region: '',
          start_year: '',
          impact: '',
          added: 'September, 19 2016 03:01:46',
          published: 'September, 16 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Industries',
          source: 'Phys Org',
          title: 'Using biomass for chemical production could yield at least 10 times more value, compared to burning it to make electricity.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Oil Investors Flee as OPEC Freeze Hopes Face Supply Glut Reality',
          url: 'http://www.bloomberg.com/news/articles/2016-09-18/oil-investors-flee-as-opec-freeze-hopes-face-supply-glut-reality?&cmpid%3D=socialflow-twitter-business',
          region: 'World',
          start_year: 2017,
          impact: '',
          added: 'September, 19 2016 01:19:35',
          published: 'September, 18 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'Bloomberg Business',
          title: 'World oil stockpiles will continue to accumulate into late 2017.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: '',
          sector: 'Automotive',
          topic: 'gasoline',
          insight: 'Quality of Life Indicators in Context - US Employment September 2016',
          url: 'http://www.ethicalmarkets.com/2016/09/02/quality-of-life-indicators-in-context-us-employment-september-2016/',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'September, 18 2016 02:02:13',
          published: 'September, 01 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'ethicalmarkets',
          title: 'U.S. gasoline prices are not expected to recover much in 2016, as they reflect demand worldwide and are still subject to speculation.',
          likelihood: ''
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Fossil fuels investment takes nosedive',
          url: 'http://climatenewsnetwork.net/fossil-fuels-investment-nosedive/',
          region: 'Eastern Europe',
          start_year: '',
          impact: '',
          added: 'September, 18 2016 02:01:08',
          published: 'September, 17 2016 00:00:00',
          country: 'Russia',
          relevance: 2,
          pestle: 'Industries',
          source: 'Climate News Network',
          title: 'Countries in the Middle East and Russia will continue to expand their oil production.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Retail',
          topic: 'export',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20September%202016.pdf',
          region: 'Northern America',
          start_year: 2016,
          impact: '',
          added: 'September, 18 2016 00:49:54',
          published: 'September, 12 2016 00:00:00',
          country: 'United States of America',
          relevance: 4,
          pestle: 'Economic',
          source: 'OPEC',
          title: '2016 will be the first full year in which US crudes are available for export.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 12,
          sector: '',
          topic: '',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20September%202016.pdf',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'September, 18 2016 00:49:53',
          published: 'September, 12 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: '',
          source: 'OPEC',
          title: 'In 2017, the demand for OPEC crude is projected at 32.5 mb/d.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: '',
          topic: 'growth',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20September%202016.pdf',
          region: 'Central Asia',
          start_year: 2017,
          impact: '',
          added: 'September, 18 2016 00:49:52',
          published: 'September, 12 2016 00:00:00',
          country: 'Kazakhstan',
          relevance: 4,
          pestle: 'Economic',
          source: 'OPEC',
          title: 'Kazakhstan is forecast to see the second highest oil growth in 2017 at 0.21 mb/d.',
          likelihood: 4
        },
        {
          end_year: 2017,
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20September%202016.pdf',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'September, 18 2016 00:49:51',
          published: 'September, 12 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'OPEC',
          title: 'Growth in oil production in GoM in 2017 will be mostly on the back of ramp-ups of projects implemented in 2016.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20September%202016.pdf',
          region: 'Northern America',
          start_year: 2017,
          impact: '',
          added: 'September, 18 2016 00:49:50',
          published: 'September, 12 2016 00:00:00',
          country: 'United States of America',
          relevance: 4,
          pestle: 'Industries',
          source: 'OPEC',
          title: 'US onshore crude oil is forecast to decline by 0.58 mb/d to average 6.7 mb/d in 2017.',
          likelihood: 4
        },
        {
          end_year: 2017,
          intensity: '',
          sector: '',
          topic: '',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20September%202016.pdf',
          region: 'Asia',
          start_year: 2016,
          impact: '',
          added: 'September, 18 2016 00:49:49',
          published: 'September, 12 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: '',
          source: 'OPEC',
          title: 'OECD Asia Pacific will keep oil output steady next year.',
          likelihood: ''
        },
        {
          end_year: '',
          intensity: '',
          sector: 'Energy',
          topic: 'oil',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20September%202016.pdf',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'September, 18 2016 00:49:48',
          published: 'September, 12 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'OPEC',
          title: 'Other regions total FSU oil supply is expected to grow by 0.12 mb/d in 2016 at an average of 13.81 mb/d.',
          likelihood: ''
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20September%202016.pdf',
          region: 'Africa',
          start_year: 2016,
          impact: '',
          added: 'September, 18 2016 00:49:48',
          published: 'September, 12 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'OPEC',
          title: "Africa Africa's oil supply is projected to average 2.12 mb/d in 2016.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 12,
          sector: '',
          topic: '',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20September%202016.pdf',
          region: 'South America',
          start_year: 2016,
          impact: '',
          added: 'September, 18 2016 00:49:47',
          published: 'September, 12 2016 00:00:00',
          country: 'Brazil',
          relevance: 3,
          pestle: '',
          source: 'OPEC',
          title: "Brazil's liquid supply is expected to average 3.13 mb/d in 2016.",
          likelihood: 4
        },
        {
          end_year: 2016,
          intensity: '',
          sector: '',
          topic: 'growth',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20September%202016.pdf',
          region: 'South America',
          start_year: '',
          impact: '',
          added: 'September, 18 2016 00:49:47',
          published: 'September, 12 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'OPEC',
          title: 'Latin America oil supply is now expected to decline in 2016 due to heavy declines in Colombia and lower growth in Brazil compared to remarkable growth in 2015 and 2014.',
          likelihood: ''
        },
        {
          end_year: 2017,
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20September%202016.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'September, 18 2016 00:49:46',
          published: 'September, 12 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'OPEC',
          title: '2015-2017 Non-OPEC oil supply is now forecast to contract by 0.61 mb/d in 2016 to average 56.32 mb/d.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20September%202016.pdf',
          region: 'Eastern Asia',
          start_year: 2016,
          impact: '',
          added: 'September, 18 2016 00:49:46',
          published: 'September, 12 2016 00:00:00',
          country: 'China',
          relevance: 4,
          pestle: 'Industries',
          source: 'OPEC',
          title: "For 2016, China's oil demand is projected to rise by around 0.28 mb/d.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: '',
          sector: 'Energy',
          topic: 'gas',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20September%202016.pdf',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'September, 18 2016 00:49:45',
          published: 'September, 12 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'OPEC',
          title: 'Substitution towards natural gas and geopolitical concerns are expected to weigh on product demand growth in 2017 in Saudi Arabia.',
          likelihood: ''
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20September%202016.pdf',
          region: 'Western Asia',
          start_year: '',
          impact: '',
          added: 'September, 18 2016 00:49:45',
          published: 'September, 12 2016 00:00:00',
          country: 'Saudi Arabia',
          relevance: 2,
          pestle: 'Economic',
          source: 'OPEC',
          title: 'Saudi Arabia is expected to be the oil demand growth driver in the region with transportation fuels and petrochemical feedstocks projected to be contributing to product growth.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20September%202016.pdf',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'September, 18 2016 00:49:45',
          published: 'September, 12 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'OPEC',
          title: 'Latin American oil demand is expected to decrease by 0.06 mb/d in 2016.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 20,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20September%202016.pdf',
          region: 'Asia',
          start_year: 2016,
          impact: '',
          added: 'September, 18 2016 00:49:44',
          published: 'September, 12 2016 00:00:00',
          country: '',
          relevance: 5,
          pestle: 'Economic',
          source: 'OPEC',
          title: 'OECD Asia Pacific oil consumption growth is projected to fall by 0.06 mb/d in 2016.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20September%202016.pdf',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'September, 18 2016 00:49:44',
          published: 'September, 12 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'OPEC',
          title: 'Japanese direct oil usage is most likely expected to decline further in the remaining part of 2016.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: '',
          sector: 'Energy',
          topic: 'oil',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20September%202016.pdf',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'September, 18 2016 00:49:44',
          published: 'September, 12 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'OPEC',
          title: 'OECD Europe oil demand is projected to grow by 0.10 mb/d in 2016 for the second consecutive year and oil demand in 2017 will slightly decline compared with 2016.',
          likelihood: ''
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20September%202016.pdf',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'September, 18 2016 00:49:43',
          published: 'September, 12 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'OPEC',
          title: 'In 2016, OECD Americas oil demand is projected to grow by 0.26 mb/d compared with the previous year.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: '',
          sector: 'Energy',
          topic: 'oil',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20September%202016.pdf',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'September, 18 2016 00:49:42',
          published: 'September, 12 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'OPEC',
          title: 'The US is projected to remain the main contributor to anticipated OECD oil demand growth during 2017.',
          likelihood: ''
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20September%202016.pdf',
          region: 'Northern America',
          start_year: 2016,
          impact: '',
          added: 'September, 18 2016 00:49:42',
          published: 'September, 12 2016 00:00:00',
          country: 'United States of America',
          relevance: 4,
          pestle: 'Industries',
          source: 'OPEC',
          title: 'US oil demand is projected to remain strong throughout the remainder of 2016.',
          likelihood: 4
        },
        {
          end_year: 2017,
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20September%202016.pdf',
          region: 'Northern America',
          start_year: 2016,
          impact: '',
          added: 'September, 18 2016 00:49:41',
          published: 'September, 12 2016 00:00:00',
          country: 'United States of America',
          relevance: 4,
          pestle: 'Economic',
          source: 'OPEC',
          title: 'Healthy gasoline demand is projected to remain the main driver behind US oil demand growth for the remainder of 2016 and 2017.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: '',
          sector: 'Government',
          topic: 'economic growth',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20September%202016.pdf',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'September, 18 2016 00:49:40',
          published: 'September, 12 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Political',
          source: 'OPEC',
          title: 'Government debt in India has seen strong nominal growth versus the debt ratio and manageability of external debt will support economic growth in 2017.',
          likelihood: ''
        },
        {
          end_year: '',
          intensity: 12,
          sector: '',
          topic: '',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20September%202016.pdf',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'September, 18 2016 00:49:28',
          published: 'September, 12 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: '',
          source: 'OPEC',
          title: 'OPEC NGLs are expected to average 6.43 mb/d in 2017.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 20,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20September%202016.pdf',
          region: 'World',
          start_year: 2016,
          impact: '',
          added: 'September, 18 2016 00:49:28',
          published: 'September, 12 2016 00:00:00',
          country: '',
          relevance: 5,
          pestle: 'Industries',
          source: 'OPEC',
          title: 'World Oil Supply Non-OPEC oil supply in 2016 is now expected to contract by 0.61 mb/d.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: '',
          sector: 'Energy',
          topic: 'oil',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20September%202016.pdf',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'September, 18 2016 00:49:28',
          published: 'September, 12 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'OPEC',
          title: 'World oil demand growth in 2016 is now anticipated to increase by 1.23 mb/d after a marginal upward revision.',
          likelihood: ''
        },
        {
          end_year: 2026,
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: "The Middle East's New Oil Paradigm",
          url: 'http://knowledge.insead.edu/blog/insead-blog/the-middle-easts-new-oil-paradigm-4928',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'September, 17 2016 03:09:29',
          published: 'September, 16 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Political',
          source: 'INSEAD Knowledge',
          title: 'The prospect of sustained lower oil prices over the next decade offers the oil-dependent economies of the Gulf Cooperation Council (GCC) an unprecedented opportunity to implement economic diversification strategies and reform policies that will underpin more sustainable and resilient economies.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Energy',
          topic: 'gas',
          insight: 'The role of wearable tech in the oil and gas industry',
          url: 'http://www.i-cio.com/strategy/digitalization/item/the-role-of-wearable-tech-in-the-oil-and-gas-industry?_escaped_fragment_=',
          region: '',
          start_year: '',
          impact: '',
          added: 'September, 17 2016 02:35:48',
          published: 'September, 01 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Industries',
          source: 'CIO',
          title: 'IoT and wearables will continue to play a big role in the future of oil and gas.',
          likelihood: 3
        },
        {
          end_year: 2030,
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'HPLC aims at 60 MM ton refining capacity by 2030',
          url: 'http://www.mrcplast.com/news-news_open-321184.html',
          region: 'Southern Asia',
          start_year: '',
          impact: '',
          added: 'September, 17 2016 02:24:03',
          published: '',
          country: 'India',
          relevance: 4,
          pestle: 'Industries',
          source: 'MRC',
          title: 'India will require up to 329 MMtpy of oil products by 2030.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 32,
          sector: 'Energy',
          topic: 'gas',
          insight: 'ExxonMobil Needs to Serve Its Shareholders on Climate Risk',
          url: 'http://www.institutionalinvestor.com/blogarticle/3584811/blog/exxonmobil-needs-to-serve-its-shareholders-on-climate-risk.html',
          region: '',
          start_year: '',
          impact: 4,
          added: 'September, 17 2016 02:01:59',
          published: 'September, 11 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'Institutional Investor',
          title: 'Barclays identified more than $22 trillion in revenue that could be at risk for the oil and gas sector alone.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Energy',
          topic: 'oil',
          insight: 'The oil field services and equipment market escapes its free fall',
          url: 'http://www.mckinsey.com/industries/oil-and-gas/our-insights/the-oil-field-services-and-equipment-market-escapes-its-free-fall',
          region: '',
          start_year: '',
          impact: '',
          added: 'September, 17 2016 00:50:00',
          published: 'August, 01 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Industries',
          source: 'McKinsey Quarterly',
          title: 'Record-high inventories remain a threat to the recent stability of oil prices.',
          likelihood: 2
        },
        {
          end_year: 2017,
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Peak Oil Review: A Midweek Update - 15th Sept 2016',
          url: 'http://www.resilience.org/stories/2016-09-15/peak-oil-review-a-midweek-update-15th-sept-2016',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'September, 16 2016 04:29:24',
          published: 'September, 15 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'Resilience',
          title: 'OPEC now expects that more oil will be pumped by non-member countries next year.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Manufacturing',
          topic: 'growth',
          insight: 'Peak Oil Review: A Midweek Update - 15th Sept 2016',
          url: 'http://www.resilience.org/stories/2016-09-15/peak-oil-review-a-midweek-update-15th-sept-2016',
          region: 'World',
          start_year: 2017,
          impact: '',
          added: 'September, 16 2016 04:29:23',
          published: 'September, 15 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'Resilience',
          title: 'The global surplus will continue into the first half of 2017 due to slower than expected growth in worldwide demand and increasing crude production.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 8,
          sector: 'Energy',
          topic: 'oil',
          insight: 'International Opportunities for UK Aftermarket Companies',
          url: 'http://www.smmt.co.uk/wp-content/uploads/sites/2/FS_SMMT_INTERNATIONAL-OPPORTUNITIES-FOR-AFTERMARKET-COMPANIES.pdf?SRC=IN',
          region: '',
          start_year: '',
          impact: '',
          added: 'September, 16 2016 01:14:56',
          published: 'September, 13 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'Society of Motor Manufacturers and Traders (SMMT)',
          title: 'The GCC automotive aftermarket will enjoy double-digit growth of about 12% annually once oil prices rebound.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Manufacturing',
          topic: 'car',
          insight: 'Electric cars could be charged at Shell service stations from 2017',
          url: 'https://www.theguardian.com/environment/2016/sep/13/electric-cars-could-be-charged-at-shell-service-stations-from-2017',
          region: 'Northern Europe',
          start_year: '',
          impact: '',
          added: 'September, 14 2016 05:57:15',
          published: 'September, 13 2016 00:00:00',
          country: 'United Kingdom',
          relevance: 2,
          pestle: 'Social',
          source: 'Guardian',
          title: "Electric car charging points could appear alongside petrol pumps at Shell's UK service stations as soon as next year.",
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: "Oil glut forecasted into 2017 as demand in Asia is 'wobbly'",
          url: 'https://www.washingtonpost.com/business/economy/oil-glut-forcasted-into-2017-as-demand-in-asia-is-wobbly/2016/09/13/c309aaf2-79a7-11e6-bd86-b7bbd53d2b5d_story.html?postshare=7471473777196292&tid=ss_tw',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'September, 14 2016 02:40:51',
          published: '',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'Washington Post',
          title: 'World oil demand is rising at a slower pace than expected.',
          likelihood: 3
        },
        {
          end_year: 2051,
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'More plastic than fish by 2050: worldwide plastic use increased 20x in 50 yrs, 8 million tons dumped into oceans every minute',
          url: 'http://www.worldculturepictorial.com/blog/content/ocean-of-plastic-more-than-fish-by-2050-world-wide-use-increased-20-fold-in-50-years-8-million-tons-dumped-every-minute',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'September, 13 2016 04:18:48',
          published: 'September, 06 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Environmental',
          source: 'worldculturepictorial',
          title: 'New plastics will consume 20% of all oil production within 35 years, up from an estimated 5% today.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Energy',
          topic: 'power',
          insight: 'UK must move now on carbon capture to save consumers billions, says report',
          url: 'https://www.theguardian.com/environment/2016/sep/12/uk-must-move-now-on-carbon-capture-to-save-consumers-billions-says-report?CMP=share_btn_tw',
          region: '',
          start_year: '',
          impact: '',
          added: 'September, 13 2016 03:08:52',
          published: 'September, 12 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Political',
          source: 'Guardian',
          title: 'Carbon capture and storage (CCS) could deliver clean electricity at a lower cost than an expanded Hinkley Point nuclear power station and almost all renewables.',
          likelihood: 2
        },
        {
          end_year: 2050,
          intensity: 40,
          sector: 'Energy',
          topic: 'oil',
          insight: 'GFEI State of the World Report 2016',
          url: 'http://www.globalfueleconomy.org/media/203446/gfei-state-of-the-world-report-2016.pdf',
          region: '',
          start_year: 2016,
          impact: 4,
          added: 'September, 13 2016 01:45:44',
          published: 'January, 06 2016 00:00:00',
          country: '',
          relevance: 5,
          pestle: 'Industries',
          source: 'globalfueleconomy',
          title: 'Between now and 2050 up to $8 trillion could be saved due to less oil consumption.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Retail',
          topic: 'export',
          insight: 'Between Hope and Fear A New Iran?',
          url: 'https://www.csis.gc.ca/pblctns/wrldwtch/2016/2016-09-12/NEW_IRAN_POST_WORKSHOP_REPORT_for_WEB_E.pdf',
          region: 'Southern Asia',
          start_year: '',
          impact: '',
          added: 'September, 12 2016 19:55:01',
          published: 'August, 22 2016 00:00:00',
          country: 'Iran',
          relevance: 2,
          pestle: 'Economic',
          source: 'CSIS',
          title: "Local actors remain wary of signing agreements that will limit Iran's ability to benefit from oil exports and parliament has to sign off on individual deals.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Manufacturing',
          topic: 'production',
          insight: 'Between Hope and Fear A New Iran?',
          url: 'https://www.csis.gc.ca/pblctns/wrldwtch/2016/2016-09-12/NEW_IRAN_POST_WORKSHOP_REPORT_for_WEB_E.pdf',
          region: 'Southern Asia',
          start_year: '',
          impact: '',
          added: 'September, 12 2016 19:54:57',
          published: 'August, 22 2016 00:00:00',
          country: 'Iran',
          relevance: 2,
          pestle: 'Industries',
          source: 'CSIS',
          title: 'Tehran has pointedly refused and insists that Iran will increase production (which contributes to lower prices) instead.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 4,
          sector: '',
          topic: 'worker',
          insight: 'Robots are after our jobs: what can we do?',
          url: 'http://www.livemint.com/Specials/L3KWdmbMBa1UqUZpPuZjvM/Robots-are-gunning-for-our-jobs-what-can-we-do.html',
          region: '',
          start_year: '',
          impact: '',
          added: 'September, 12 2016 06:12:31',
          published: 'September, 06 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Organization',
          source: 'LiveMint',
          title: 'Gartner believes that by 2018, more than 3 million workers globally will be supervised by a "robo boss" who will increasingly make decisions that previously could only have been made by a human manager.',
          likelihood: 4
        },
        {
          end_year: 2040,
          intensity: 16,
          sector: '',
          topic: 'population',
          insight: 'G20 China',
          url: 'http://www.g7g20.com/eBooks/G20_China_web.pdf',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'September, 12 2016 06:12:02',
          published: 'August, 25 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Social',
          source: 'g7g20',
          title: 'The global population is expected to reach nine billion by 2040.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 2,
          sector: '',
          topic: '',
          insight: "Trump's illegal, impossible, and 'beyond goofy' idea of seizing Iraq's oil",
          url: 'https://www.washingtonpost.com/news/energy-environment/wp/2016/09/09/trump-thinks-the-u-s-should-take-the-oil-in-iraq-heres-why-that-is-not-so-easy/?postshare=5401473446408280&tid=ss_tw',
          region: 'Western Asia',
          start_year: '',
          impact: '',
          added: 'September, 12 2016 03:41:06',
          published: 'October, 14 2015 00:00:00',
          country: 'Iraq',
          relevance: 1,
          pestle: '',
          source: 'Washington Post',
          title: 'Iraq could produce twice as much oil as it does currently, by 2035.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 4,
          sector: '',
          topic: '',
          insight: 'Four Scenarios for Oil Producers as They Seek to Boost Prices',
          url: 'http://www.bloomberg.com/news/articles/2016-09-08/four-scenarios-for-oil-producers-as-they-seek-to-boost-prices?&cmpid%3D=socialflow-twitter-business',
          region: 'Eastern Europe',
          start_year: '',
          impact: '',
          added: 'September, 12 2016 03:16:42',
          published: 'September, 08 2016 00:00:00',
          country: 'Russia',
          relevance: 2,
          pestle: '',
          source: 'Bloomberg Business',
          title: 'A meeting in Algiers at the end of September between OPEC and Russia has raised expectations that a deal could be struck to boost prices.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Areas of instability which could affect the passage or port call of your vessel',
          url: 'http://www.westpandi.com/globalassets/loss-prevention/mast-reports/mast-intelligence-report---07-september-2016.pdf',
          region: 'Western Asia',
          start_year: '',
          impact: '',
          added: 'September, 11 2016 06:18:54',
          published: 'September, 06 2016 00:00:00',
          country: 'Saudi Arabia',
          relevance: 3,
          pestle: 'Political',
          source: 'Mast',
          title: "A recent rocket attack by Yemeni rebels on the Saudi Aramco facilities in the South of Saudi Arabia has highlighted the risk to the country's oil sector.",
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Energy',
          topic: 'gas',
          insight: 'Canadian oil sands output to grow 42 per cent by 2025: report Add to ...',
          url: 'http://www.theglobeandmail.com/report-on-business/industry-news/energy-and-resources/canadian-oil-sands-output-to-grow-42-per-cent-by-2025-report/article30628897/',
          region: '',
          start_year: '',
          impact: '',
          added: 'September, 11 2016 03:32:57',
          published: 'June, 27 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Economic',
          source: 'The Globe and Mail',
          title: 'Future shale gas growth will have to come from so-called "brownfield" expansions where costs have come down as a result of lower construction activity, improved operating efficiencies and cheaper natural gas.',
          likelihood: 3
        },
        {
          end_year: 2025,
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Canadian oil sands output to grow 42 per cent by 2025: report Add to ...',
          url: 'http://www.theglobeandmail.com/report-on-business/industry-news/energy-and-resources/canadian-oil-sands-output-to-grow-42-per-cent-by-2025-report/article30628897/',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'September, 11 2016 03:32:57',
          published: 'June, 27 2016 00:00:00',
          country: 'Canada',
          relevance: 4,
          pestle: 'Industries',
          source: 'The Globe and Mail',
          title: "Canada's oil sands production will grow by 42 per cent to 3.4 million barrels per day by 2025.",
          likelihood: 4
        },
        {
          end_year: 2034,
          intensity: '',
          sector: '',
          topic: '',
          insight: 'khor reports - palm oil: September 2016',
          url: 'http://khorreports-palmoil.blogspot.co.uk/2016_09_01_archive.html',
          region: 'Eastern Asia',
          start_year: '',
          impact: '',
          added: 'September, 11 2016 03:31:26',
          published: 'September, 05 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: '',
          source: 'khorreports-palmoil',
          title: "China's oil consumption will exceed that of the United States by 2034.",
          likelihood: ''
        },
        {
          end_year: '',
          intensity: 2,
          sector: '',
          topic: '',
          insight: 'SAFE at first for autonomous car "best practices"',
          url: 'http://readwrite.com/2016/09/10/safe-autonomous-car-testing-tl4/',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'September, 11 2016 03:25:26',
          published: 'September, 10 2016 00:00:00',
          country: 'United States of America',
          relevance: 1,
          pestle: '',
          source: 'ReadWrite',
          title: 'The U.S. could be one of the first countries to adopt fully autonomous (Level 5) driving.',
          likelihood: 2
        },
        {
          end_year: 2017,
          intensity: 20,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Short-Term Energy Outlook',
          url: 'https://www.eia.gov/forecasts/steo/report/prices.cfm',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'September, 11 2016 02:55:46',
          published: 'September, 07 2016 00:00:00',
          country: '',
          relevance: 5,
          pestle: 'Industries',
          source: 'DOE EIA 2013 Energy Conference',
          title: 'Average West Texas Intermediate (WTI) crude oil prices are forecast to be $1/b lower than Brent prices in 2016 and 2017.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: '',
          topic: '',
          insight: 'Short-Term Energy Outlook',
          url: 'https://www.eia.gov/forecasts/steo/report/prices.cfm',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'September, 11 2016 02:55:46',
          published: 'September, 07 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: '',
          source: 'DOE EIA 2013 Energy Conference',
          title: 'Brent prices are forecast to average $52/b in 2017.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 8,
          sector: '',
          topic: '',
          insight: 'Short-Term Energy Outlook',
          url: 'https://www.eia.gov/forecasts/steo/report/prices.cfm',
          region: '',
          start_year: '',
          impact: '',
          added: 'September, 11 2016 02:55:46',
          published: 'September, 07 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: '',
          source: 'DOE EIA 2013 Energy Conference',
          title: 'Continuing builds and high inventory levels will likely contribute to Brent prices maintaining the recent $40/b to $50/b trading range during the next two quarters.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Government',
          topic: 'power',
          insight: 'North America',
          url: 'http://www.lngjournal.com/index.php/north-america',
          region: 'Southern Asia',
          start_year: '',
          impact: '',
          added: 'September, 11 2016 02:41:54',
          published: '',
          country: 'Pakistan',
          relevance: 2,
          pestle: 'Political',
          source: 'LNG',
          title: 'A second LNG import terminal will soon be built in Pakistan to realise government plans to replace some oil-fired power plants with three proposed LNG-to-power units.',
          likelihood: 3
        },
        {
          end_year: 2018,
          intensity: '',
          sector: 'Energy',
          topic: 'energy',
          insight: 'ECB staff macroeconomic projections for the euro area, September 2016',
          url: 'http://www.ecb.europa.eu/pub/pdf/other/ecbstaffprojections201609.en.pdf',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'September, 11 2016 02:33:28',
          published: 'September, 08 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'European Central Bank',
          title: 'The contribution of HICP energy inflation to headline inflation in the EU is expected to swing from -0.6 percentage point in 2016 to around +0.1 to 0.2 percentage point in 2017 and 2018.',
          likelihood: ''
        },
        {
          end_year: 2018,
          intensity: '',
          sector: '',
          topic: 'gdp',
          insight: 'ECB staff macroeconomic projections for the euro area, September 2016',
          url: 'http://www.ecb.europa.eu/pub/pdf/other/ecbstaffprojections201609.en.pdf',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'September, 11 2016 02:33:23',
          published: 'September, 08 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'European Central Bank',
          title: 'Real GDP in the EU is expected to grow by 1.7% in 2016 and by 1.6% in 2017 and 2018.',
          likelihood: ''
        },
        {
          end_year: '',
          intensity: '',
          sector: 'Energy',
          topic: 'power',
          insight: 'Plaza and Lovre Accords and 1987 Crash',
          url: 'http://globalmoneytrends.com/wp-content/uploads/2016/09/Sept-2-2016-Plaza-and-Lovre-Accords-and-1987-Crash-1.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'September, 11 2016 02:06:51',
          published: 'September, 07 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Political',
          source: 'Global Money Trends',
          title: 'Sharp increases in oil prices pose the biggest threat to growth because consumers suffer a sudden hit to purchasing power.',
          likelihood: ''
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'energy',
          insight: 'The Fightback Begins: European Cyber Experts to Meet in Central London',
          url: 'https://industrialcontrolsecurityeurope.com/',
          region: 'Europe',
          start_year: '',
          impact: '',
          added: 'September, 11 2016 01:15:10',
          published: 'July, 27 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'Industrial Control Security',
          title: 'Cyber-attacks continue to pose a huge threat to the energy industry across Europe.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Aerospace & defence',
          topic: 'nuclear',
          insight: "Today's Headlines and Commentary",
          url: 'https://www.lawfareblog.com/todays-headlines-and-commentary-1142',
          region: 'Eastern Asia',
          start_year: '',
          impact: '',
          added: 'September, 10 2016 00:55:08',
          published: 'September, 09 2016 00:00:00',
          country: 'Japan',
          relevance: 2,
          pestle: 'Political',
          source: 'Lawfare',
          title: "North Korea's move could trigger a regional escalation if South Korea responds by launching its own nuclear program or Japan enhances its offensive capabilities.",
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Aerospace & defence',
          topic: 'nuclear',
          insight: "Today's Headlines and Commentary",
          url: 'https://www.lawfareblog.com/todays-headlines-and-commentary-1142',
          region: 'Eastern Asia',
          start_year: '',
          impact: '',
          added: 'September, 10 2016 00:55:08',
          published: 'September, 09 2016 00:00:00',
          country: 'Japan',
          relevance: 2,
          pestle: 'Political',
          source: 'Lawfare',
          title: 'North Korea is now capable of putting a nuclear warhead on a short or medium-range missile that could hit Japan or South Korea.',
          likelihood: 2
        },
        {
          end_year: 2020,
          intensity: 12,
          sector: '',
          topic: '',
          insight: 'Tailwinds for Clean Energy and the Paris Agreement, Deepening Doldrums for the Incumbency',
          url: 'http://www.resilience.org/stories/2016-09-07/tailwinds-for-clean-energy-and-the-paris-agreement-deepening-doldrums-for-the-incumbency',
          region: 'Northern Europe',
          start_year: '',
          impact: '',
          added: 'September, 09 2016 11:12:07',
          published: 'September, 07 2016 00:00:00',
          country: 'United Kingdom',
          relevance: 3,
          pestle: '',
          source: 'Resilience',
          title: 'Charging points will outnumber petrol stations in the UK by 2020.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: '',
          topic: 'debt',
          insight: 'Gabon: How will the post-election crisis affect the economy?',
          url: 'https://www.maplecroft.com/portfolio/new-analysis/2016/09/07/how-will-post-election-crisis-affect-economy/',
          region: 'Central Africa',
          start_year: '',
          impact: '',
          added: 'September, 09 2016 10:34:54',
          published: '',
          country: 'Gabon',
          relevance: 2,
          pestle: 'Economic',
          source: 'Verisk Maplecroft',
          title: 'Gabon will struggle to sell more debt in the future.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Support services',
          topic: 'business',
          insight: 'Gabon: How will the post-election crisis affect the economy?',
          url: 'https://www.maplecroft.com/portfolio/new-analysis/2016/09/07/how-will-post-election-crisis-affect-economy/',
          region: '',
          start_year: '',
          impact: '',
          added: 'September, 09 2016 10:34:54',
          published: '',
          country: '',
          relevance: 1,
          pestle: 'Political',
          source: 'Verisk Maplecroft',
          title: 'Political uncertainty in Gabon will make external lenders more hesitant to finance the ambitious government spending programmes designed to create a more enticing business environment for foreign companies.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 8,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Fed speakers and oil are the big deals Friday',
          url: 'http://www.cnbc.com/2016/09/08/fed-speakers-and-oil-are-the-big-deals-friday.html?_source=twitter',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'September, 09 2016 09:52:47',
          published: 'September, 08 2016 00:00:00',
          country: 'United States of America',
          relevance: 4,
          pestle: 'Industries',
          source: 'CNBC ',
          title: 'They have pointed to $50 oil as a level that could bring more U.S. production back on line if prices hold.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'EU hits energy reduction target six years early',
          url: 'https://www.theguardian.com/environment/2016/sep/06/eu-energy-reduction-target-six-years-early-greenhouse-gas-emissions?CMP=twt_a-environment_b-gdneco',
          region: '',
          start_year: 2020,
          impact: '',
          added: 'September, 07 2016 05:56:03',
          published: 'September, 06 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'Guardian',
          title: "The EU's 28 member countries consumed 72m tonnes of oil equivalent less than had been projected for 2020.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 9,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Oil jumps as Saudi Arabia and Russia agree to work together',
          url: 'http://money.cnn.com/2016/09/05/investing/saudi-arabia-russia-oil-market/index.html?sr=twmoney090516saudi-arabia-russia-oil-market1115AMVODtopLink&linkId=28400616',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'September, 07 2016 01:42:05',
          published: 'September, 05 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'CNNMoney',
          title: "Closer collaboration between the world's top two exporters of crude oil may stoke hopes that OPEC and other big producers will agree to freeze production.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Brent crude futures ease as hope for output freeze fades',
          url: 'http://uk.mobile.reuters.com/article/businessNews/idUKKCN11C02N',
          region: 'Southern Asia',
          start_year: '',
          impact: '',
          added: 'September, 07 2016 00:45:59',
          published: 'September, 06 2016 00:00:00',
          country: 'Iran',
          relevance: 2,
          pestle: 'Industries',
          source: 'Reuters',
          title: 'Saudi Arabia said on Tuesday it would go along with a freeze in oil output if other producers agreed but cautioned that Iran could foil any attempt to limit output.',
          likelihood: 2
        },
        {
          end_year: 2017,
          intensity: 16,
          sector: 'Energy',
          topic: 'gas',
          insight: 'Oil block auctions under Hydrocarbon Exploration Licensing Policy by early next year',
          url: 'http://energy.economictimes.indiatimes.com/news/oil-and-gas/oil-block-auctions-under-hydrocarbon-exploration-licensing-policy-by-early-next-year/54023500',
          region: 'Southern Asia',
          start_year: 2016,
          impact: '',
          added: 'September, 06 2016 03:04:19',
          published: 'September, 06 2016 00:00:00',
          country: 'India',
          relevance: 4,
          pestle: 'Political',
          source: 'ETEnergyworld.com',
          title: 'India will likely begin auctioning its major oil and gas blocks early next year under its fresh Hydrocarbon Exploration Licensing Policy (HELP) that heralds a major shift from the previous policy by bringing in revenuesharing between companies and the government.',
          likelihood: 4
        },
        {
          end_year: 2030,
          intensity: 12,
          sector: 'Information Technology',
          topic: '3D',
          insight: 'Monsanto: THE #4IR Agtech Investment... just not right now',
          url: 'http://briandcolwell.com/2016/08/monsanto-the-4ir-agtech-investment-just-not-right-now/.html',
          region: '',
          start_year: '',
          impact: '',
          added: 'September, 06 2016 00:51:57',
          published: 'August, 03 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'briandcolwell',
          title: '63% of consumer industries strategy officers agree that by 2030 at-home manufacturing will be mainstream in both developed and developing markets as consumers 3D/4D print a wide variety of products at home.',
          likelihood: 4
        },
        {
          end_year: 2025,
          intensity: 12,
          sector: 'Energy',
          topic: 'gas',
          insight: 'Monsanto: THE #4IR Agtech Investment... just not right now',
          url: 'http://briandcolwell.com/2016/08/monsanto-the-4ir-agtech-investment-just-not-right-now/.html',
          region: '',
          start_year: '',
          impact: '',
          added: 'September, 06 2016 00:51:56',
          published: 'August, 03 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'briandcolwell',
          title: '75% of chemistry and advanced materials strategy officers agree that by 2025 the primary feedstock for chemical production will shift from oil & gas to biobased and recycled materials.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Energy',
          topic: 'gas',
          insight: 'Corrosion Monitoring Market Worth 297.8 Million USD by 2021',
          url: 'http://www.prnewswire.com/news-releases/corrosion-monitoring-market-worth-2978-million-usd-by-2021-592166691.html',
          region: '',
          start_year: '',
          impact: '',
          added: 'September, 05 2016 02:24:33',
          published: 'September, 02 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Economic',
          source: 'PR Newswire',
          title: 'The oil & gas industry accounts for almost four-fifths of the corrosion monitoring market and the trend is projected to remain more or less constant during the forecast period.',
          likelihood: 3
        },
        {
          end_year: 2050,
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Palm oil versus paradise in Papua',
          url: 'http://www.dw.com/en/palm-oil-versus-paradise-in-papua/a-19518922',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'September, 04 2016 05:37:00',
          published: '',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'DW.COM',
          title: 'Global production of palm oil has doubled over the last decade and is expected to double again by 2050.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Energy',
          topic: 'oil',
          insight: 'INAPALM ASIA 2016 - The 4th Indonesia International Palm Oil Machinery, Processing & Technology Exhibition 2016',
          url: 'http://www.globaleventslist.elsevier.com/events/2016/08/inapalm-asia-2016-the-4th-indonesia-international-palm-oil-machinery-processing-technology-exhibition-2016/',
          region: '',
          start_year: '',
          impact: '',
          added: 'September, 04 2016 05:36:58',
          published: 'September, 01 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Industries',
          source: 'Elsevier',
          title: 'The implementation of B20 will increase the demand and price of crude palm oil (CPO) highly.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Malaysia aims to "harmonise" palm oil export duty plan with Indonesia - minister',
          url: 'http://www.thestar.com.my/business/business-news/2016/09/01/malaysia-aims-to-harmonise-palm-oil-export-duty-plan-with-indonesia---minister/',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'September, 04 2016 05:36:45',
          published: 'September, 01 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'the star online',
          title: 'Analysts expect Malaysian palm oil output to slip to 19 million tonnes in 2016.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: '',
          sector: 'Manufacturing',
          topic: 'production',
          insight: 'U.S. Industrial Outlook: Manufacturing to Decelerate in 2016',
          url: 'https://www.mapi.net/blog/2016/03/us-industrial-outlook-manufacturing-decelerate-2016',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'September, 04 2016 04:50:12',
          published: 'March, 16 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'MAPI',
          title: 'U.S. manufacturing will not reach its pre-recession production level until the third quarter of 2017.',
          likelihood: ''
        },
        {
          end_year: '',
          intensity: '',
          sector: 'Energy',
          topic: 'oil',
          insight: 'Pollution Prevention Week on September, 2016: Hair loss preventionrejuvenation?',
          url: 'http://daysofyear.com/pollution-prevention-week/',
          region: '',
          start_year: '',
          impact: '',
          added: 'September, 04 2016 02:57:50',
          published: '',
          country: '',
          relevance: 1,
          pestle: 'Industries',
          source: 'Days Of Year',
          title: 'FDA has found that from face creams to soaps and other items of personal care, cosmetics companies are taking the general public for a ride. Oil could be coming from eels or shark.',
          likelihood: ''
        },
        {
          end_year: 2017,
          intensity: 16,
          sector: 'Manufacturing',
          topic: 'production',
          insight: 'CANADA: OUTLOOK FOR PRINCIPAL FIELD CROPS',
          url: 'http://www.clientadvisoryservices.com/Downloads/Canada%20Principal%20Field%20Crops%20August2016.pdf',
          region: 'Northern America',
          start_year: 2016,
          impact: '',
          added: 'September, 04 2016 02:28:02',
          published: 'September, 01 2016 00:00:00',
          country: 'United States of America',
          relevance: 4,
          pestle: 'Industries',
          source: 'clientadvisoryservices',
          title: '2016-17 US sunflower seed production is forecast by AAFC to fall by 20% to 1.1 Mt.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Change is in the Air',
          url: 'http://www.virgin-atlantic.com/content/dam/VAA/Documents/sustainabilitypdf/Virgin_Atlantic_Full_Sustainability_Report_2016.pdf',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'September, 04 2016 02:07:02',
          published: 'July, 14 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'Virgin Atlantic',
          title: 'Soy, palm oil and beef supplies represent a high deforestation risk in some parts of the world.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Retail',
          topic: 'export',
          insight: 'EU Agricultural Outlook Prospects for EU agricultural markets and income 2015-2025',
          url: 'http://ec.europa.eu/agriculture/markets-and-prices/medium-term-outlook/2015/fullrep_en.pdf',
          region: 'Africa',
          start_year: '',
          impact: '',
          added: 'September, 04 2016 01:20:39',
          published: 'January, 22 2016 00:00:00',
          country: 'China',
          relevance: 2,
          pestle: 'Economic',
          source: 'Europa',
          title: 'Exports are projected to be driven mainly by increasing demand in Asia (including China, where the SMP proportion of powder imports is increasing) and Africa.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: '',
          sector: 'Energy',
          topic: 'economic growth',
          insight: 'EU Agricultural Outlook Prospects for EU agricultural markets and income 2015-2025',
          url: 'http://ec.europa.eu/agriculture/markets-and-prices/medium-term-outlook/2015/fullrep_en.pdf',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'September, 04 2016 01:20:31',
          published: 'January, 22 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'Europa',
          title: 'Oilseed prices will decline further in line with general crop price projections, sluggish world economic growth and low crude oil prices.',
          likelihood: ''
        },
        {
          end_year: '',
          intensity: 8,
          sector: 'Energy',
          topic: 'oil',
          insight: 'EU Agricultural Outlook Prospects for EU agricultural markets and income 2015-2025',
          url: 'http://ec.europa.eu/agriculture/markets-and-prices/medium-term-outlook/2015/fullrep_en.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'September, 04 2016 01:20:23',
          published: 'January, 22 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'Europa',
          title: 'Biodiesel production accounts for over 40 % of vegetable oil demand in the EU and any change is expected to have a considerable impact on vegetable oil prices.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 8,
          sector: 'Energy',
          topic: 'gas',
          insight: 'Fracking Press Clips: September 1, 2016',
          url: 'http://www.cafrackfacts.org/uncategorized/fracking-press-clips-september-1-2016/',
          region: '',
          start_year: '',
          impact: '',
          added: 'September, 04 2016 01:18:05',
          published: 'September, 01 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Environmental',
          source: 'CAFrackFacts',
          title: 'Ozone pollution caused by oil and gas drilling will lead to 30,000 childhood asthma attacks just in Philadelphia.',
          likelihood: 4
        },
        {
          end_year: 2016,
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'ECONOMIC AND FISCAL OUTLOOK',
          url: 'http://www.budget.gov.ie/Budgets/2016/Documents/Economic%20and%20Fiscal%20Outlook%202016.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'September, 04 2016 01:09:50',
          published: 'October, 29 2015 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'Government of Ireland',
          title: 'For next year, oil price declines will be less of a drag.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: '',
          sector: 'Energy',
          topic: 'oil',
          insight: 'Iran News Round Up - September 1, 2016',
          url: 'http://www.criticalthreats.org/iran-news-round-september-01-2016',
          region: 'Southern Asia',
          start_year: '',
          impact: '',
          added: 'September, 04 2016 01:04:03',
          published: 'September, 01 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'Critical Threats',
          title: 'Two new nuclear reactors will save Iran approximately 22 million barrels of oil per year.',
          likelihood: ''
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'gas',
          insight: 'Water risk or water opportunity?',
          url: 'https://maplecroft.com/portfolio/new-analysis/2016/09/01/water-risk-or-water-opportunity/',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'September, 03 2016 02:40:16',
          published: '',
          country: 'United States of America',
          relevance: 3,
          pestle: 'Environmental',
          source: 'Maplecroft',
          title: 'The volume of oil and gas production from areas identified by Verisk Maplecroft as being at high and extreme risk of water stress in the US is set to double.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 60,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Reuters: Japan may invest $10 billion in Russian oil firm Rosneft',
          url: 'http://www.unian.info/economics/1499514-reuters-japan-may-invest-10-billion-in-russian-oil-firm-rosneft.html',
          region: 'Eastern Asia',
          start_year: '',
          impact: 3,
          added: 'September, 03 2016 01:55:09',
          published: '',
          country: 'Japan',
          relevance: 5,
          pestle: 'Economic',
          source: 'Reuters',
          title: 'Japan will propose a broad cooperation in the energy sector with Russia that could include a nearly $10 billion investment in Russian state-owned oil giant Rosneft.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: '',
          sector: 'Construction',
          topic: 'oil',
          insight: 'Reuters: Oil heads for biggest weekly loss since mid-January',
          url: 'http://www.unian.info/economics/1499689-reuters-oil-heads-for-biggest-weekly-loss-since-mid-january.html',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'September, 03 2016 01:55:01',
          published: '',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'Reuters',
          title: 'The end of the U.S. driving season and the prospect of building inventories create downward risk for the oil price and may see further pressure on energy stocks.',
          likelihood: ''
        },
        {
          end_year: 2027,
          intensity: 12,
          sector: '',
          topic: '',
          insight: 'America sets the bar high on lorry emissions',
          url: 'http://www.transportenvironment.org/news/america-sets-bar-high-lorry-emissions',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'September, 03 2016 01:05:55',
          published: 'August, 30 2016 00:00:00',
          country: 'United States of America',
          relevance: 3,
          pestle: '',
          source: 'Transport Environment',
          title: 'US lorries will produce 10% less CO2 and consume 10% less fuel by 2027 than they do now.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'The Middle East: An end to oil dependency',
          url: 'http://www.nature.com/nature/journal/v537/n7618_supp/full/537S6a.html',
          region: 'Western Asia',
          start_year: '',
          impact: '',
          added: 'September, 03 2016 00:58:08',
          published: 'August, 31 2016 00:00:00',
          country: 'United Arab Emirates',
          relevance: 2,
          pestle: 'Economic',
          source: 'Nature',
          title: 'The UAE and other Gulf countries do not expect to replace oil revenues with the commercialization of science.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'oil',
          insight: "'Blue whirl' fires could help oil spill clean-up",
          url: 'https://www.theengineer.co.uk/blue-whirl-fires-could-help-oil-spill-clean-up/',
          region: '',
          start_year: '',
          impact: '',
          added: 'September, 03 2016 00:45:22',
          published: 'August, 09 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'The Engineer',
          title: "Researchers from the University of Maryland have discovered a new type of fire tornado called a 'blue whirl' and could be used to aid oil spill clean-up.",
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 16,
          sector: '',
          topic: 'population',
          insight: 'Peak Oil Review: A Midweek Update - 1 Sept 2016',
          url: 'http://www.resilience.org/stories/2016-09-01/peak-oil-review-a-midweek-update-1-sept-2016',
          region: 'World',
          start_year: 2050,
          impact: '',
          added: 'September, 02 2016 04:42:28',
          published: 'September, 01 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Social',
          source: 'Resilience',
          title: 'World population will reach 9.9 billion in 2050.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Government',
          topic: 'oil',
          insight: 'The Lack of Economic Diversification in the Middle East',
          url: 'http://www.isa-world.com/news/?tx_ttnews[backPid]=1&tx_ttnews[tt_news]=239&cHash=22cd713f95255577b3fb174bb555d037',
          region: '',
          start_year: '',
          impact: '',
          added: 'September, 01 2016 05:07:33',
          published: 'August, 31 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Political',
          source: 'ISA',
          title: 'In the Middle East internal investment will suffer as a result of the fall in oil prices as governments will continue to impose new austerity measures on the region as long as oil prices remain low.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Energy',
          topic: 'oil',
          insight: 'The Lack of Economic Diversification in the Middle East',
          url: 'http://www.isa-world.com/news/?tx_ttnews[backPid]=1&tx_ttnews[tt_news]=239&cHash=22cd713f95255577b3fb174bb555d037',
          region: '',
          start_year: '',
          impact: '',
          added: 'September, 01 2016 05:07:33',
          published: 'August, 31 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Industries',
          source: 'ISA',
          title: 'Demand for oil has proven to have been weaker than most Middle Eastern countries expected.',
          likelihood: 3
        },
        {
          end_year: 2030,
          intensity: 8,
          sector: 'Energy',
          topic: 'oil',
          insight: 'The Benefits of Global Energy Leadership',
          url: 'http://www.energytomorrow.org/blog/2016/08/30/the-benefits-of-global-energy-leadership',
          region: 'Northern America',
          start_year: 2025,
          impact: '',
          added: 'September, 01 2016 00:46:31',
          published: 'August, 30 2016 00:00:00',
          country: 'United States of America',
          relevance: 4,
          pestle: 'Economic',
          source: 'Energy Tomorrow',
          title: "America's oil and natural industry could support as many as 1 million additional American jobs in 2025 and as many as 2.3 million jobs in 2030.",
          likelihood: 2
        },
        {
          end_year: 2022,
          intensity: '',
          sector: '',
          topic: 'vehicle',
          insight: 'Top Companies Investing in a Clean Energy Future',
          url: 'http://www.justmeans.com/blogs/top-companies-investing-in-a-clean-energy-future',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 31 2016 02:38:51',
          published: 'August, 29 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'Justmeans',
          title: 'By 2022, electric vehicles will cost the same as their internal combustion counterparts.',
          likelihood: ''
        },
        {
          end_year: '',
          intensity: '',
          sector: '',
          topic: 'growth',
          insight: 'Saudi diversification affirms UAE as regional trading hub',
          url: 'http://www.khaleejtimes.com/20160822/1798/no-title',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'August, 31 2016 01:32:48',
          published: 'August, 22 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'Khaleej Times',
          title: 'Large fiscal and current account deficits in Saudi Arabia will be recorded (perhaps -15 per cent and -8.5 per cent of GDP in 2016, respectively) and GDP growth is likely to be halved to around +1.5per cent in 2016.',
          likelihood: ''
        },
        {
          end_year: '',
          intensity: '',
          sector: 'Energy',
          topic: 'oil',
          insight: "Why Has Buffett's Berkshire Upped its Stake in Phillips 66? (PSX,BRK.A)",
          url: 'http://www.investopedia.com/news/why-has-buffetts-berkshire-upped-its-stake-phillips-66-psxbrka/',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 31 2016 01:08:42',
          published: 'August, 30 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Industries',
          source: 'Investopedia',
          title: 'Analysts have predicted a steady increase in the price of oil in the near future.',
          likelihood: ''
        },
        {
          end_year: '',
          intensity: '',
          sector: '',
          topic: 'growth',
          insight: 'Workers All Over America Are Getting a Raise',
          url: 'http://www.bloomberg.com/news/articles/2016-08-30/workers-all-over-america-are-getting-a-raise?&cmpid%3D=socialflow-twitter-business',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'August, 31 2016 00:58:13',
          published: 'August, 30 2016 00:00:00',
          country: 'United States of America',
          relevance: 2,
          pestle: 'Economic',
          source: 'Bloomberg Business',
          title: 'Signs of higher wage growth and a tighter labor market more generally will no doubt be seized upon by Fed hawks as attesting to the prospect of a tick up in underlying U.S. inflation in the coming months.',
          likelihood: ''
        },
        {
          end_year: '',
          intensity: 9,
          sector: 'Support services',
          topic: 'energy',
          insight: 'Electric Power Industry Transformation',
          url: 'http://www.iptechex.com/ketf20/uploads/TF%202013%2038%20Electric%20Power%20Industry%20Transformation.pdf',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'August, 30 2016 08:37:31',
          published: 'January, 10 2014 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'Innovaro',
          title: 'Energy storage among 12 technologies McKinsey believes will transform life, business, and the global economy.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Energy',
          topic: 'gas',
          insight: 'Electric Power Industry Transformation',
          url: 'http://www.iptechex.com/ketf20/uploads/TF%202013%2038%20Electric%20Power%20Industry%20Transformation.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 30 2016 08:37:29',
          published: 'January, 10 2014 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Technological',
          source: 'Innovaro',
          title: 'Technological advances and new sources such as shale gas will dramatically reduce dependence on oil- and gas-rich countries.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Support services',
          topic: 'power',
          insight: 'Electric Power Industry Transformation',
          url: 'http://www.iptechex.com/ketf20/uploads/TF%202013%2038%20Electric%20Power%20Industry%20Transformation.pdf',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'August, 30 2016 08:37:24',
          published: 'January, 10 2014 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Political',
          source: 'Innovaro',
          title: 'Nearly all (94%) of global power executives surveyed by PwC expect complete transformation or important changes to the power utility business model.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Water',
          topic: 'water',
          insight: 'Windpower Technology',
          url: 'http://www.iptechex.com/ketf20/uploads/FiF%20TF%202013%2042%20Windpower%20Technology%20FINAL.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 30 2016 08:33:18',
          published: 'September, 29 2014 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Environmental',
          source: 'FutureinFocus',
          title: 'Can operate in deeper water-resulting in significant cost reductions.23 Incremental improvements in everything from the reliability of turbines to rapid access for service personnel could result in significant cost savings.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Energy',
          topic: 'energy',
          insight: 'The Future of Storage Batteries',
          url: 'http://www.iptechex.com/ketf20/uploads/FiF%20TF%202014%2006%20Future%20of%20Storage%20Batteries%20FINAL.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 29 2016 17:37:34',
          published: 'November, 04 2014 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Industries',
          source: 'FutureinFocus',
          title: 'The use of quinones could cut the cost of energy storage materials by two-thirds or more.',
          likelihood: 2
        },
        {
          end_year: 2018,
          intensity: 9,
          sector: '',
          topic: 'gdp',
          insight: 'The Global Economic Shift',
          url: 'http://www.iptechex.com/ketf20/uploads/FIF-GL-2015-2%20The%20Global%20Economic%20Shift-FINAL.pdf',
          region: 'Western Africa',
          start_year: '',
          impact: '',
          added: 'August, 29 2016 16:53:31',
          published: 'February, 09 2015 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'FutureinFocus',
          title: 'By mid-century, Nigeria will have the 13th largest GDP (PPP) in the world.27.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Retail',
          topic: 'data',
          insight: 'Efficiency – a “Technology Values” Update',
          url: 'http://www.iptechex.com/ketf20/uploads/FiF-TF-2015-13-Efficiency-FINAL.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 29 2016 16:03:58',
          published: 'July, 27 2015 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Social',
          source: 'FutureinFocus',
          title: 'Consumers need and eagerly want innovations-such as new data visualization techniques-that will deliver more useful information in less time.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Energy',
          topic: 'energy',
          insight: 'Wave and Tidal Energy',
          url: 'http://www.iptechex.com/ketf20/uploads/FiF-TF-2016-05-Wave%20and%20Tidal%20Energy-FINAL.pdf',
          region: 'Northern Europe',
          start_year: '',
          impact: '',
          added: 'August, 29 2016 13:30:01',
          published: 'May, 01 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Political',
          source: 'FutureinFocus',
          title: 'A shortfall of private and government investment could hamper the development of wave and tidal technologies.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Energy',
          topic: 'fossil fuel',
          insight: 'Wave and Tidal Energy',
          url: 'http://www.iptechex.com/ketf20/uploads/FiF-TF-2016-05-Wave%20and%20Tidal%20Energy-FINAL.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 29 2016 13:30:00',
          published: 'May, 01 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Environmental',
          source: 'FutureinFocus',
          title: 'Drilling for fossil fuels will need to take place in increasingly expensive and difficult-to-access locations.',
          likelihood: 3
        },
        {
          end_year: 2035,
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Ocean Thermal Energy Conversion',
          url: 'http://www.iptechex.com/ketf20/uploads/FiF-TF-2016-06-OTEC-FINAL.pdf',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'August, 29 2016 13:28:55',
          published: 'May, 10 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'FutureinFocus',
          title: 'By 2035, global production of liquid oil will fall to a projected 26 million barrels per day unless significant advances are made in locating new oil fields.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: '',
          topic: 'market',
          insight: 'Science, technology & design',
          url: 'http://www.nowandnext.com/?action=sector/view&issueId=39&sectorId=3',
          region: '',
          start_year: 2019,
          impact: '',
          added: 'August, 29 2016 12:49:25',
          published: '',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: "What's Next",
          title: 'Market research company BCC Research valued the nanotech market at $US26 billion in 2014 and predicts it will reach about $US64 billion in 2019.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: '',
          sector: '',
          topic: '',
          insight: "Stanford scientists find 'water windfall' beneath California's Central Valley",
          url: 'http://news.stanford.edu/2016/06/27/stanford-scientists-find-water-windfall-beneath-californias-central-valley/',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 27 2016 11:05:10',
          published: 'June, 27 2016 00:00:00',
          country: '',
          relevance: '',
          pestle: '',
          source: 'Stanford News',
          title: "New research indicates that California's Central Valley harbors three times more groundwater than previously estimated, but challenges to using it include pumping costs, ground subsidence and possible contamination from fracking and other oil and gas activities.",
          likelihood: ''
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'IEA cuts oil demand forecast for 2017',
          url: 'http://www.middle-east-online.com/english/?id=78181',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'August, 25 2016 01:44:57',
          published: '',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'Middle East Online',
          title: 'Oil oversupply will disappear in the latter part of 2016.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: '',
          sector: '',
          topic: 'growth',
          insight: 'IEA cuts oil demand forecast for 2017',
          url: 'http://www.middle-east-online.com/english/?id=78181',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'August, 25 2016 01:44:56',
          published: '',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'Middle East Online',
          title: 'Global oil demand growth is now expected to slow to 1.2 million barrels per day in 2017 from 1.4 mb/d this year "due to a dimmer macroeconomic outlook".',
          likelihood: ''
        },
        {
          end_year: '',
          intensity: 4,
          sector: '',
          topic: '',
          insight: 'Middle East Stock Markets Crash As Iran Enters Oil War',
          url: 'http://www.neonnettle.com/sphere/476-middle-east-stock-markets-crash-as-iran-enters-oil-war',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'August, 25 2016 00:35:10',
          published: 'January, 01 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: '',
          source: 'Neon Nettle',
          title: "Estimates are suggesting Tehran will add a further 500,000 barrels a day (b/pd) to the world's bloated stockpiles within weeks.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Exclusive: Amazon Partners with Shell to Create Delivery Network',
          url: 'https://global.handelsblatt.com/breaking/exclusive-amazon-partners-with-shell-to-create-delivery-network',
          region: 'Western Europe',
          start_year: '',
          impact: '',
          added: 'August, 24 2016 02:58:26',
          published: 'August, 21 2016 00:00:00',
          country: 'Germany',
          relevance: 3,
          pestle: 'Economic',
          source: 'Handelsblatt Global Edition',
          title: "The world's largest online retailer Amazon is partnering with the multinational oil company Shell to create a network of package delivery stations in Germany that could one day challenge market leader DHL.",
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Will Natural Gas Perform Like Oil? (UNG, XLE)',
          url: 'http://www.investopedia.com/articles/investing/082216/will-natural-gas-perform-oil-ung-xle.asp',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 24 2016 01:14:32',
          published: 'August, 21 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'Investopedia',
          title: 'Oil prices are being driven higher by speculation that OPEC will reach some kind of output freeze agreement on the side lines of an energy conference in September.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Oil Faces Dark Clouds as China Chases Blue Skies for G-20 Summit',
          url: 'http://www.bloomberg.com/news/articles/2016-08-22/oil-faces-dark-clouds-as-china-chases-blue-skies-for-g-20-summit',
          region: 'Eastern Asia',
          start_year: '',
          impact: '',
          added: 'August, 23 2016 02:15:03',
          published: 'August, 22 2016 00:00:00',
          country: 'China',
          relevance: 2,
          pestle: 'Industries',
          source: 'Bloomberg Business',
          title: "Some analysts remain optimistic that China's overall oil use could rise in the third quarter.",
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Support services',
          topic: 'business',
          insight: 'Pikachu power: Can it transform the energy industry?',
          url: 'http://www.eenews.net/stories/1060041882',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 23 2016 00:37:07',
          published: 'August, 22 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Technological',
          source: 'EE News',
          title: 'The growing use of augmented reality in businesses generally could have a tangible side benefit in reducing transportation emissions, by eliminating the need to dispatch repair workers.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 8,
          sector: 'Retail',
          topic: 'export',
          insight: 'Oil Drops as Iraq Seeks Export Boost Amid Global Inventory Glut',
          url: 'http://www.bloomberg.com/news/articles/2016-08-21/oil-declined-after-iraq-agrees-to-boost-exports-amid-global-glut?&cmpid%3D=socialflow-twitter-business',
          region: 'Western Asia',
          start_year: '',
          impact: '',
          added: 'August, 22 2016 01:34:55',
          published: 'August, 21 2016 00:00:00',
          country: 'Iraq',
          relevance: 2,
          pestle: 'Economic',
          source: 'Bloomberg Business',
          title: 'Iraq will increase exports by about 150,000 barrels a day as shipments resume from the Baba Gorgor, Jambour and Khabbaz fields.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 8,
          sector: 'Retail',
          topic: 'export',
          insight: 'Oil Drops as Iraq Seeks Export Boost Amid Global Inventory Glut',
          url: 'http://www.bloomberg.com/news/articles/2016-08-21/oil-declined-after-iraq-agrees-to-boost-exports-amid-global-glut?&cmpid%3D=socialflow-twitter-business',
          region: 'Western Asia',
          start_year: '',
          impact: '',
          added: 'August, 22 2016 01:34:54',
          published: 'August, 21 2016 00:00:00',
          country: 'Iraq',
          relevance: 2,
          pestle: 'Economic',
          source: 'Bloomberg Business',
          title: 'Iraq will boost crude shipments by about 5 percent in the next few days after an agreement to resume exports from three oil fields in Kirkuk.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'policy',
          insight: 'Next Generation Batteries Market Global Segmentation,Application,Technology & Market Analysis Research Report 2027',
          url: 'http://beforeitsnews.com/business/2016/08/next-generation-batteries-market-global-segmentationapplicationtechnology-market-analysis-research-report-2027-2933827.html',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'August, 21 2016 04:15:07',
          published: 'August, 19 2016 00:00:00',
          country: 'United States of America',
          relevance: 2,
          pestle: 'Political',
          source: "Before It's News | Alternative News | UFO | Beyond Science | True News| Prophecy News | People Powered News",
          title: 'North America is expected to dominate the Global Next Generation Batteries Market with the largest market share due to growing electric vehicle market and government policies which are encouraging batteries market in U.S. region.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Wetland Breaking News',
          url: 'http://www.aswm.org/news/wetland-breaking-news/9509-wetland-breaking-news-august-2016',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'August, 21 2016 01:33:04',
          published: '',
          country: '',
          relevance: 2,
          pestle: 'Political',
          source: 'aswm',
          title: "A proposal to build the United States' largest oil-by-rail terminal in Vancouver, Washington, could transform the Columbia River into a major conduit for fossil fuel.",
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 9,
          sector: '',
          topic: 'election',
          insight: "Why the CIA, Saudi Arabia, and Qatar are Furious about Erdogan's Russian Rapprochement",
          url: 'http://johngaltfla.com/wordpress/2016/08/14/why-the-cia-saudi-arabia-and-qatar-are-furious-about-erdogans-russian-rapprochement/',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'August, 21 2016 01:16:39',
          published: 'August, 15 2016 00:00:00',
          country: 'Jordan',
          relevance: 3,
          pestle: 'Political',
          source: 'Shenandoah',
          title: 'The United States will not be allowed to supply "rebels" in Syria which indirectly aid and abet ISIS leaving a much longer supply route after the U.S. election via Jordan.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Energy',
          topic: 'oil',
          insight: '3 Steps To Creating Efficiency, In Good Times And Bad',
          url: 'http://www.digitalistmag.com/future-of-work/2016/08/19/3-steps-to-creating-efficiency-04393054',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 20 2016 02:20:22',
          published: 'August, 19 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Industries',
          source: 'Digitalist Magazine',
          title: 'Even at $60 per barrel, two-thirds of future oil reserves could be uneconomical.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Energy',
          topic: 'export',
          insight: 'Persian Gulf public amenable to energy subsidy reforms',
          url: 'http://phys.org/news/2016-08-persian-gulf-amenable-energy-subsidy.html',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 20 2016 01:44:46',
          published: 'August, 16 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Economic',
          source: 'Phys Org',
          title: 'Although the Persian Gulf population has long been accustomed to some of the lowest energy prices in the world, subsidized energy prices have exacerbated domestic consumption and threaten to undermine oil and gas exports.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 10,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Venezuela chaos: The biggest threat to cheap oil',
          url: 'http://money.cnn.com/2016/08/17/news/economy/venezuela-oil-prices/index.html',
          region: 'South America',
          start_year: 2017,
          impact: '',
          added: 'August, 19 2016 05:58:35',
          published: 'August, 17 2016 00:00:00',
          country: 'Venezuela',
          relevance: 5,
          pestle: 'Economic',
          source: 'CNNMoney',
          title: "A new report by Columbia University's Center on Global Energy Policy calls Venezuela a growing supply risk for oil markets in 2017.",
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Venezuela chaos: The biggest threat to cheap oil',
          url: 'http://money.cnn.com/2016/08/17/news/economy/venezuela-oil-prices/index.html',
          region: 'South America',
          start_year: '',
          impact: '',
          added: 'August, 19 2016 05:58:35',
          published: 'August, 17 2016 00:00:00',
          country: 'Venezuela',
          relevance: 2,
          pestle: 'Industries',
          source: 'CNNMoney',
          title: "Venezuela's oil output could plunge even lower.",
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Venezuela chaos: The biggest threat to cheap oil',
          url: 'http://money.cnn.com/2016/08/17/news/economy/venezuela-oil-prices/index.html',
          region: 'South America',
          start_year: '',
          impact: '',
          added: 'August, 19 2016 05:58:34',
          published: 'August, 17 2016 00:00:00',
          country: 'Venezuela',
          relevance: 2,
          pestle: 'Economic',
          source: 'CNNMoney',
          title: "Venezuela's deepening chaos could soon create tremors in the global oil markets.",
          likelihood: 2
        },
        {
          end_year: '',
          intensity: '',
          sector: 'Energy',
          topic: 'oil',
          insight: 'The one report for markets Friday',
          url: 'http://www.cnbc.com/2016/08/18/the-one-report-for-markets-friday.html?_source=twitter',
          region: 'Northern Africa',
          start_year: '',
          impact: '',
          added: 'August, 19 2016 05:51:43',
          published: 'August, 18 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'CNBC ',
          title: 'Iraq and Iran, are getting close to the limit of what they can produce. Libya is expected to bring some oil back on line, while Nigeria still has many barrels shut in.',
          likelihood: ''
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Brent crude oil prices dip on prospect of record Saudi output',
          url: 'http://www.cnbc.com/2016/08/17/brent-crude-oil-prices-dip-on-prospect-of-record-saudi-output.html',
          region: 'Western Asia',
          start_year: '',
          impact: '',
          added: 'August, 18 2016 03:29:43',
          published: 'August, 17 2016 00:00:00',
          country: 'Saudi Arabia',
          relevance: 2,
          pestle: 'Industries',
          source: 'CNBC ',
          title: 'Saudi Arabia is sending signals that it could boost its crude oil supplies in August.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Electric cars could be cheaper to run than gas cars by 2022',
          url: 'http://www.fastcoexist.com/3062751/world-changing-ideas/electric-cars-could-be-cheaper-to-run-than-gas-cars-by-2022',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 17 2016 03:30:16',
          published: 'August, 16 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'Fast Co-Exist',
          title: 'The people at Bloomberg predict a recovery and rise of oil prices.',
          likelihood: 3
        },
        {
          end_year: 2030,
          intensity: 12,
          sector: 'Environment',
          topic: 'greenhouse gas',
          insight: 'EPA and DOT Finalize Greenhouse Gas and Fuel Efficiency Standards for Heavy-Duty Trucks',
          url: 'https://www.epa.gov/newsreleases/epa-and-dot-finalize-greenhouse-gas-and-fuel-efficiency-standards-heavy-duty-trucks-0',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'August, 17 2016 03:22:07',
          published: '',
          country: '',
          relevance: 4,
          pestle: 'Environmental',
          source: 'EPA',
          title: 'In the U.S. GHG emissions from heavy-duty vehicles are growing rapidly and are expected to surpass emissions from passenger vehicles by 2030.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 9,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Oil prices are on fire -- up 10% in just 3 days',
          url: 'http://money.cnn.com/2016/08/15/investing/oil-prices-jump-opec-freeze/index.html',
          region: 'Eastern Europe',
          start_year: '',
          impact: '',
          added: 'August, 17 2016 01:15:02',
          published: 'August, 15 2016 00:00:00',
          country: 'Russia',
          relevance: 3,
          pestle: 'Industries',
          source: 'CNNMoney',
          title: 'Crude is being carried higher by vague hopes that OPEC, Russia and other major oil producers will agree to "freeze" production.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: '',
          sector: 'Energy',
          topic: 'gas',
          insight: "Afghanistan's oil market is having a tough time",
          url: 'http://uk.businessinsider.com/afghanistans-oil-market-is-having-a-tough-time-2016-8?r=US&IR=T',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 17 2016 00:58:22',
          published: 'August, 17 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Economic',
          source: 'Business Insider',
          title: 'The lack of meaningful energy investment in Afghanistan will keep the country from returning its oil and natural gas output to the levels it enjoyed during the late 1960s.',
          likelihood: ''
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Healthcare',
          topic: 'information',
          insight: 'Graphene Nanoribbons in Solutions Possess Properties for Use with Biological Systems',
          url: 'http://www.azonano.com/news.aspx?newsID=34958',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 17 2016 00:41:44',
          published: 'August, 16 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Technological',
          source: 'Azonano',
          title: 'The biocompatibility of nanoribbons was noticed by the researchers to possess the potential use for sensors that could travel through the body and provide information on what they discover.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 3,
          sector: '',
          topic: 'wealth',
          insight: 'How leading institutions are changing the rules on portfolio construction',
          url: 'http://www.mckinsey.com/industries/private-equity-and-principal-investors/our-insights/how-leading-institutions-are-changing-the-rules-on-portfolio-construction?cid=other-eml-alt-mip-mck-oth-1608',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 16 2016 16:35:49',
          published: 'August, 01 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Economic',
          source: 'McKinsey & Company',
          title: 'Sovereign-wealth funds will need to adjust their allocations based on the funding needs of their states, which in large part will be driven by oil prices.',
          likelihood: 3
        },
        {
          end_year: 2040,
          intensity: 9,
          sector: 'Energy',
          topic: 'gas',
          insight: 'Shale gas production drives world natural gas production growth',
          url: 'http://www.eia.gov/todayinenergy/detail.cfm?id=27512',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 16 2016 05:07:20',
          published: 'August, 15 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'DOE EIA 2013 Energy Conference',
          title: "Algerian shale production is projected to account for one-third of the country's total natural gas production by 2040.",
          likelihood: 3
        },
        {
          end_year: 2020,
          intensity: 16,
          sector: 'Financial services',
          topic: 'shale gas',
          insight: 'Shale gas production drives world natural gas production growth',
          url: 'http://www.eia.gov/todayinenergy/detail.cfm?id=27512',
          region: 'Northern Africa',
          start_year: '',
          impact: '',
          added: 'August, 16 2016 05:07:20',
          published: 'August, 15 2016 00:00:00',
          country: 'Algeria',
          relevance: 4,
          pestle: 'Economic',
          source: 'DOE EIA 2013 Energy Conference',
          title: 'Algeria has begun a pilot shale gas well project and developed a 20-year investment plan to produce shale gas commercially by 2020.',
          likelihood: 4
        },
        {
          end_year: 2040,
          intensity: 16,
          sector: 'Energy',
          topic: 'gas',
          insight: 'Shale gas production drives world natural gas production growth',
          url: 'http://www.eia.gov/todayinenergy/detail.cfm?id=27512',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'August, 16 2016 05:07:19',
          published: 'August, 15 2016 00:00:00',
          country: 'Canada',
          relevance: 4,
          pestle: 'Industries',
          source: 'DOE EIA 2013 Energy Conference',
          title: "Shale gas production in Canada is projected to continue increasing and to account for almost 30% of Canada's total natural gas production by 2040.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 4,
          sector: '',
          topic: 'ice',
          insight: "It'll do a power of good for Australia to shift to electric vehicles",
          url: 'https://www.theguardian.com/sustainable-business/2016/aug/12/itll-do-a-power-of-good-for-australia-to-shift-to-electric-vehicles',
          region: 'Oceania',
          start_year: '',
          impact: '',
          added: 'August, 16 2016 02:56:36',
          published: 'August, 12 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Environmental',
          source: 'Guardian',
          title: 'With higher prices for oil, and lower prices for batteries and electric buses, the cost of moving the bus fleet to electric could be 30% less than continuing to operate Ice buses in Australia.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Great Australian Bight oil rigs would significantly increase spill risk - report',
          url: 'https://www.theguardian.com/environment/2016/aug/15/great-australian-bight-oil-rigs-would-significantly-increase-spill-risk-report?CMP=share_btn_tw',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 16 2016 02:55:36',
          published: 'August, 15 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Industries',
          source: 'Guardian',
          title: 'Plans to drill for oil in the pristine Great Australian Bight marine park will significantly increase the risk of oil spills.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Government',
          topic: 'technology',
          insight: 'Extinction Closing in on Hundreds of Species in Dwindling Asian Forests, Duke Study Finds',
          url: 'http://voices.nationalgeographic.com/2016/08/10/extinction-looms-closer-for-hundreds-of-species-in-dwindling-southeast-asian-forests-duke-study-finds/',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 16 2016 01:31:44',
          published: 'August, 10 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Political',
          source: 'National Geographic Society (blogs)',
          title: 'Increased use of remote-sensing technologies could help scientists and governments better identify which remaining natural forests should be made a conservation priority.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'gas',
          insight: "Iran's Strategic Goal: 'Anti-American Hydrocarbon Consortium'",
          url: 'http://sputniknews.com/middleeast/20160814/1044252757/iran-oil-gas.html',
          region: 'Eastern Europe',
          start_year: '',
          impact: '',
          added: 'August, 16 2016 00:55:03',
          published: 'August, 14 2016 00:00:00',
          country: 'Iran',
          relevance: 2,
          pestle: 'Industries',
          source: 'Sputnik News',
          title: "Iran's oil and gas ambitions will not go unnoticed by other large energy players as Saudi Arabia and Russia.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: '',
          topic: '',
          insight: "Iran's Strategic Goal: 'Anti-American Hydrocarbon Consortium'",
          url: 'http://sputniknews.com/middleeast/20160814/1044252757/iran-oil-gas.html',
          region: 'Southern Asia',
          start_year: '',
          impact: '',
          added: 'August, 16 2016 00:55:03',
          published: 'August, 14 2016 00:00:00',
          country: 'Iran',
          relevance: 2,
          pestle: '',
          source: 'Sputnik News',
          title: 'By increasing oil and gas production and exports to the international energy market, Iran will be able to create some kind of an "anti-American hydrocarbon consortium."',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 8,
          sector: 'Energy',
          topic: 'gas',
          insight: "Iran's Strategic Goal: 'Anti-American Hydrocarbon Consortium'",
          url: 'http://sputniknews.com/middleeast/20160814/1044252757/iran-oil-gas.html',
          region: 'Southern Asia',
          start_year: '',
          impact: '',
          added: 'August, 16 2016 00:55:02',
          published: 'August, 14 2016 00:00:00',
          country: 'Iran',
          relevance: 2,
          pestle: 'Economic',
          source: 'Sputnik News',
          title: 'Iran hopes the substantial amount of foreign investment will help it revitalize its oil and gas sector with the goal of increasing its production capacity to 5 million barrels per day.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Transport',
          topic: 'oil',
          insight: 'Oil companies need a new long-term strategy if they want to survive',
          url: 'http://www.businessinsider.com/oil-companies-need-a-new-long-term-strategy-if-they-want-to-survive-2016-8?IR=T',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'August, 15 2016 04:05:42',
          published: 'August, 14 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Social',
          source: 'Business Insider',
          title: 'The introduction of semi and fully autonomous cars and drones to replace domestic delivery will surely have a substantial impact on global oil demand.',
          likelihood: 3
        },
        {
          end_year: 2046,
          intensity: 3,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Oil companies need a new long-term strategy if they want to survive',
          url: 'http://www.businessinsider.com/oil-companies-need-a-new-long-term-strategy-if-they-want-to-survive-2016-8?IR=T',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'August, 15 2016 04:05:42',
          published: 'August, 14 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Industries',
          source: 'Business Insider',
          title: 'Speedy penetration of EVs will certainly displace sizeable oil demand in decades to come and could be detrimental for the oil industry.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Oil companies need a new long-term strategy if they want to survive',
          url: 'http://www.businessinsider.com/oil-companies-need-a-new-long-term-strategy-if-they-want-to-survive-2016-8?IR=T',
          region: 'Southern Asia',
          start_year: '',
          impact: '',
          added: 'August, 15 2016 04:05:41',
          published: 'August, 14 2016 00:00:00',
          country: 'India',
          relevance: 2,
          pestle: 'Industries',
          source: 'Business Insider',
          title: "India's oil demand is expected to grow as the ownership of vehicles is still expected to increase significantly.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 2,
          sector: '',
          topic: '',
          insight: 'The Gray Rhinos Of 2016',
          url: 'http://seekingalpha.com/article/3998891-gray-rhinos-2016',
          region: 'Eastern Europe',
          start_year: '',
          impact: '',
          added: 'August, 15 2016 01:48:51',
          published: 'August, 11 2016 00:00:00',
          country: 'Russia',
          relevance: 1,
          pestle: '',
          source: 'Seeking Alpha',
          title: 'Increasing U.S. Russia cooperation in Syria reduces the risk of an accidental conflict between the two nations.',
          likelihood: 2
        },
        {
          end_year: 2030,
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Fossil Fuels',
          url: 'http://instituteforenergyresearch.org/topics/encyclopedia/fossil-fuels/',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'August, 14 2016 04:12:44',
          published: '',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'IER',
          title: "Less than half the world's total conventional oil reserves will have been exhausted by 2030.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 8,
          sector: 'Energy',
          topic: 'gas',
          insight: 'The Moral Case for Fossil Fuels',
          url: 'https://wattsupwiththat.com/2016/08/12/the-moral-case-for-fossil-fuels/',
          region: 'world',
          start_year: '',
          impact: '',
          added: 'August, 14 2016 04:12:36',
          published: 'August, 12 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'Ocean Acidification',
          title: "In 2040 fossil fuels will still produce 78% of the world's energy. Oil will grow at a 0.7% annual rate and natural gas will grow 1.6% per year.",
          likelihood: 4
        },
        {
          end_year: 2035,
          intensity: 12,
          sector: '',
          topic: '',
          insight: '5th Electric Vehicles Virtual Summit 2016',
          url: 'http://www.smartgridobserver.com/index-evvs82416.htm',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'August, 14 2016 03:19:02',
          published: 'August, 24 2016 00:00:00',
          country: 'United States of America',
          relevance: 3,
          pestle: '',
          source: 'Smart Grid Observer',
          title: 'More than five million EVs will be on U.S. roads by 2035.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: '',
          topic: '',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20August%202016.pdf',
          region: 'Eastern Asia',
          start_year: 2017,
          impact: '',
          added: 'August, 14 2016 02:01:57',
          published: 'August, 10 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: '',
          source: 'OPEC',
          title: 'Fewer new offshore oil developments in China are expected to come online in 2017.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 9,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20August%202016.pdf',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'August, 14 2016 02:01:55',
          published: 'August, 10 2016 00:00:00',
          country: 'United States of America',
          relevance: 3,
          pestle: 'Industries',
          source: 'OPEC',
          title: 'Total US crude oil is forecast to decline by 0.42 mb/d to average 8.47 mb/d.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: '',
          topic: '',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20August%202016.pdf',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'August, 14 2016 02:01:55',
          published: 'August, 10 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: '',
          source: 'OPEC',
          title: 'The forecast for non-OPEC supply in 2017 is associated with a high level of risk.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 20,
          sector: '',
          topic: '',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20August%202016.pdf',
          region: 'Eastern Asia',
          start_year: 2017,
          impact: '',
          added: 'August, 14 2016 02:01:55',
          published: 'August, 10 2016 00:00:00',
          country: '',
          relevance: 5,
          pestle: '',
          source: 'OPEC',
          title: 'Oil supply in the OECD, FSU and China in 2017 is expected to contract by 0.24 mb/d, 0.11 mb/d and 0.06 mb/d.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 8,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20August%202016.pdf',
          region: 'Eastern Asia',
          start_year: 2016,
          impact: '',
          added: 'August, 14 2016 02:01:54',
          published: 'August, 10 2016 00:00:00',
          country: 'China',
          relevance: 4,
          pestle: 'Industries',
          source: 'OPEC',
          title: 'Declining oil output in China could be attributed to hefty spending cuts in 2016 by major Chinese oil companies.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20August%202016.pdf',
          region: 'Eastern Europe',
          start_year: 2016,
          impact: '',
          added: 'August, 14 2016 02:01:53',
          published: 'August, 10 2016 00:00:00',
          country: 'Russia',
          relevance: 4,
          pestle: 'Industries',
          source: 'OPEC',
          title: 'Russia Russian oil output is expected to increase by 0.13 mb/d to average 10.98 mb/d in 2016.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20August%202016.pdf',
          region: 'Eastern Europe',
          start_year: 2016,
          impact: '',
          added: 'August, 14 2016 02:01:53',
          published: 'August, 10 2016 00:00:00',
          country: 'Russia',
          relevance: 4,
          pestle: 'Industries',
          source: 'OPEC',
          title: 'In 2016, oil production in Russia will increase.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20August%202016.pdf',
          region: 'South America',
          start_year: 2016,
          impact: '',
          added: 'August, 14 2016 02:01:52',
          published: 'August, 10 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'OPEC',
          title: "Latin America's oil supply is now expected to decline in 2016 after the drop in oil prices.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20August%202016.pdf',
          region: 'South-Eastern Asia',
          start_year: '',
          impact: '',
          added: 'August, 14 2016 02:01:51',
          published: 'August, 10 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'OPEC',
          title: 'Total oil output in Malaysia and Thailand is forecast to grow by 50 tb/d, while oil production in India, Brunei and Vietnam will decrease in 2016.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Manufacturing',
          topic: 'production',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20August%202016.pdf',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'August, 14 2016 02:01:48',
          published: 'August, 10 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'OPEC',
          title: 'OECD Total OECD liquids production in 2016 is expected to contract by 0.58 mb/d to average 24.66 mb/d.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Manufacturing',
          topic: 'production',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20August%202016.pdf',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'August, 14 2016 02:01:48',
          published: 'August, 10 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'OPEC',
          title: 'OPEC NGL production is forecast to grow by 0.16 mb/d and 0.15 mb/d to average 6.29 mb/d and 6.43 mb/d in 2016 and 2017.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20August%202016.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 14 2016 02:01:47',
          published: 'August, 10 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Economic',
          source: 'OPEC',
          title: 'Transportation fuels are expected to lead oil demand growth.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Transport',
          topic: 'transportation',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20August%202016.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 14 2016 02:01:46',
          published: 'August, 10 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Industries',
          source: 'OPEC',
          title: 'The high historical baseline and reduced price elasticities for road transportation fuels represent risks to the downside.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20August%202016.pdf',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'August, 14 2016 02:01:46',
          published: 'August, 10 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'OPEC',
          title: '2017 OECD Americas oil demand is expected to be higher by 0.20 mb/d compared with 2016.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20August%202016.pdf',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'August, 14 2016 02:01:46',
          published: 'August, 10 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'OPEC',
          title: '2016 Mexican oil demand is expected to remain flat y-o-y as projected during last month.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 8,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20August%202016.pdf',
          region: 'Northern America',
          start_year: 2016,
          impact: '',
          added: 'August, 14 2016 02:01:45',
          published: 'August, 10 2016 00:00:00',
          country: 'United States of America',
          relevance: 4,
          pestle: 'Economic',
          source: 'OPEC',
          title: "US oil demand in 2016 remains strongly dependent on the development of the US economy and oil price developments with risks being balanced as compared to last month's projections.",
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Manufacturing',
          topic: 'production',
          insight: 'Monthly Oil Market Report',
          url: 'http://www.opec.org/opec_web/static_files_project/media/downloads/publications/MOMR%20August%202016.pdf',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'August, 14 2016 02:01:42',
          published: 'August, 10 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'OPEC',
          title: 'OPEC NGL production is forecast to grow by 0.16 mb/d and 0.15 mb/d in 2016 and 2017.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Government',
          topic: 'growth',
          insight: 'Monday - August 08, 2016',
          url: 'http://www.freenewspos.com/en/latest-news-article/b/1781720/industry/monday-august-08-2016',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 14 2016 01:55:03',
          published: 'August, 08 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Political',
          source: 'Freenewspos',
          title: 'Increasing environmental concerns coupled with stringent regulations on PP nonwoven fabrics from government bodies such as EPA is expected to hamper the market growth over the forecast period.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'MI Prospects',
          url: 'http://cereals.ahdb.org.uk/media/1110352/mi-prospects-vol-19-3.pdf',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'August, 14 2016 01:09:33',
          published: 'August, 10 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'AHDB',
          title: 'World production of sunmeal is forecast at a record high of 18.4Mt for 2016/17.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 16,
          sector: '',
          topic: 'growth',
          insight: 'Alpha edge - August 2016',
          url: 'http://www.slideshare.net/social_citadelle/alpha-edge-august-2016',
          region: 'World',
          start_year: 2016,
          impact: '',
          added: 'August, 14 2016 00:56:38',
          published: 'August, 09 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'SlideShare',
          title: 'Growth in the volume of world trade is expected to remain sluggish in 2016 at 2.8%, the same as in 2015.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Daily Agenda: European Equities Stage Modest Rally',
          url: 'http://www.institutionalinvestor.com/article/3577697/banking-and-capital-marketsdaily-agenda/daily-agenda-european-equities-stage-modest-rally.html',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'August, 13 2016 01:28:09',
          published: 'August, 11 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'Institutional Investor',
          title: 'The current overhang in crude oil inventories globally will be offset by refinery demand in the second half of 2016.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 4,
          sector: '',
          topic: 'market',
          insight: 'Film Machinery Has Huge Demand In Countries Showing Growing Economies And High GDP',
          url: 'http://vita.mil-embedded.com/news/film-growing-economies-high-gdp/',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'August, 13 2016 01:16:12',
          published: 'August, 12 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'VITA Technologies',
          title: 'Ever-increasing cost of machinery and focus of the global market on bio-degradable films could impede the market to a certain extent.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Manufacturing',
          topic: 'production',
          insight: 'How Plasma Pulse Technology Is Boosting Oil Production',
          url: 'http://www.wallstreetdaily.com/2016/08/10/oil-plasma-pulse-technology/',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'August, 13 2016 00:56:08',
          published: 'August, 10 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'Wall Street Daily',
          title: 'Lower rig counts and declining production amid stabilizing global demand forecasts will eventually build a floor for recovery.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Energy',
          topic: 'oil',
          insight: "'Blue whirl' fires could help oil spill clean-up",
          url: 'http://www.theengineer.co.uk/blue-whirl-fires-could-help-oil-spill-clean-up/',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 13 2016 00:37:14',
          published: 'August, 09 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Industries',
          source: 'The Engineer',
          title: "Researchers have discovered a new type of fire tornado called a 'blue whirl', which burns fuel more efficiently than other fire whirls, and could be used to aid oil spill clean-up.",
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Manufacturing',
          topic: 'production',
          insight: 'A European Strategy for Low-Emission Mobility',
          url: 'http://ec.europa.eu/transport/themes/strategies/news/doc/2016-07-20-decarbonisation/swd%282016%29244.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 12 2016 05:57:05',
          published: 'July, 20 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'Europa',
          title: 'Biomass and biowaste will continue to dominate the fuel mix of EU domestic renewable production.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 9,
          sector: 'Energy',
          topic: 'oil',
          insight: 'A European Strategy for Low-Emission Mobility',
          url: 'http://ec.europa.eu/transport/themes/strategies/news/doc/2016-07-20-decarbonisation/swd%282016%29244.pdf',
          region: '',
          start_year: 2050,
          impact: '',
          added: 'August, 12 2016 05:56:54',
          published: 'July, 20 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'Europa',
          title: 'Oil is likely to remain in the energy mix even in 2050 and will mainly fuel parts of long distance passenger and freight transport.',
          likelihood: 3
        },
        {
          end_year: 2030,
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'A European Strategy for Low-Emission Mobility',
          url: 'http://ec.europa.eu/transport/themes/strategies/news/doc/2016-07-20-decarbonisation/swd%282016%29244.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 12 2016 05:56:54',
          published: 'July, 20 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'Europa',
          title: 'In the EU oil products used in transport are projected to decrease by 51 to 67 Mtoe (13-17%) by 2030 compared to 2010 levels.',
          likelihood: 3
        },
        {
          end_year: 2030,
          intensity: 9,
          sector: 'Energy',
          topic: 'energy',
          insight: 'A European Strategy for Low-Emission Mobility',
          url: 'http://ec.europa.eu/transport/themes/strategies/news/doc/2016-07-20-decarbonisation/swd%282016%29244.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 12 2016 05:56:49',
          published: 'July, 20 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'Europa',
          title: 'EUCO27 and EUCO30 scenarios are projected to result in significant improvements in energy intensity of passenger transport by 2030.',
          likelihood: 3
        },
        {
          end_year: 2030,
          intensity: 16,
          sector: 'Energy',
          topic: 'energy',
          insight: 'A European Strategy for Low-Emission Mobility',
          url: 'http://ec.europa.eu/transport/themes/strategies/news/doc/2016-07-20-decarbonisation/swd%282016%29244.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 12 2016 05:56:46',
          published: 'July, 20 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'Europa',
          title: 'EU energy use in transport is projected to decrease by 5% between 2010 and 2030 and to slightly increase post-2030.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Energy',
          topic: 'oil',
          insight: 'A European Strategy for Low-Emission Mobility',
          url: 'http://ec.europa.eu/transport/themes/strategies/news/doc/2016-07-20-decarbonisation/swd%282016%29244.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 12 2016 05:56:46',
          published: 'July, 20 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Environmental',
          source: 'Europa',
          title: 'International maritime transport activity is projected to continue growing strongly with rising demand for oil, coal, steel and other primary resources.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 3,
          sector: '',
          topic: 'market',
          insight: 'A European Strategy for Low-Emission Mobility',
          url: 'http://ec.europa.eu/transport/themes/strategies/news/doc/2016-07-20-decarbonisation/swd%282016%29244.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 12 2016 05:56:44',
          published: 'July, 20 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Economic',
          source: 'Europa',
          title: 'The market share of internal combustion engine (ICE) electric hybrids is expected to increase due to their lower fuel consumption compared to conventional ICE vehicles.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'A European Strategy for Low-Emission Mobility',
          url: 'http://ec.europa.eu/transport/themes/strategies/news/doc/2016-07-20-decarbonisation/swd%282016%29244.pdf',
          region: '',
          start_year: 2020,
          impact: '',
          added: 'August, 12 2016 05:56:44',
          published: 'July, 20 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'Europa',
          title: 'Oil price is projected to reach 87 $/barrel in 2020 (in year 2013-prices).',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: '',
          sector: '',
          topic: '',
          insight: 'IEA Sees Oil Glut Easing',
          url: 'http://www.bloomberg.com/news/articles/2016-08-11/iea-sees-oil-market-rebalancing-despite-record-gulf-production?&cmpid%3D=socialflow-twitter-business',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 12 2016 05:23:52',
          published: 'August, 11 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: '',
          source: 'Bloomberg Business',
          title: 'Global oil markets will continue to re-balance this year as a pick-up in demand from refiners absorbs record output from several Persian Gulf producers.',
          likelihood: ''
        },
        {
          end_year: '',
          intensity: 12,
          sector: '',
          topic: '',
          insight: 'NEW$ & VIEW$ (10 August 2016): NFIB; Productivity Uncertainty',
          url: 'http://www.bearnobull.com/2016/08/10/new-view-10-august-2016-nfib-productivity-uncertainty/',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'August, 12 2016 01:34:16',
          published: 'August, 10 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: '',
          source: 'Bearnobull',
          title: 'For 2017, demand for OPEC crude is forecast at 33 million barrels a day.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 12,
          sector: '',
          topic: '',
          insight: 'NEW$ & VIEW$ (10 August 2016): NFIB; Productivity Uncertainty',
          url: 'http://www.bearnobull.com/2016/08/10/new-view-10-august-2016-nfib-productivity-uncertainty/',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 12 2016 01:34:16',
          published: 'August, 10 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: '',
          source: 'Bearnobull',
          title: 'In 2017, non-OPEC supply is expected to decline by 150,000 barrels a day.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'NEW$ & VIEW$ (10 August 2016): NFIB; Productivity Uncertainty',
          url: 'http://www.bearnobull.com/2016/08/10/new-view-10-august-2016-nfib-productivity-uncertainty/',
          region: 'World',
          start_year: 2017,
          impact: '',
          added: 'August, 12 2016 01:34:14',
          published: 'August, 10 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'Bearnobull',
          title: 'For 2017, world oil demand is forecast to grow by 1.15 million barrels a day.',
          likelihood: 4
        },
        {
          end_year: 2022,
          intensity: 30,
          sector: 'Energy',
          topic: 'gasoline',
          insight: 'India Seeks to Expand Biofuels Market to $7.5 Billion by 2022',
          url: 'http://www.bloomberg.com/news/articles/2016-08-10/india-seeks-to-expand-biofuels-market-to-7-5-billion-by-2022',
          region: '',
          start_year: '',
          impact: 3,
          added: 'August, 12 2016 00:48:50',
          published: 'August, 10 2016 00:00:00',
          country: '',
          relevance: 5,
          pestle: 'Economic',
          source: 'Bloomberg Business',
          title: 'Blending five percent of biodiesel with regular diesel and 10 percent ethanol with gasoline could boost the market to 500 billion rupees ($7.5 billion) by 2022.',
          likelihood: 2
        },
        {
          end_year: 2017,
          intensity: 12,
          sector: '',
          topic: '',
          insight: "Venezuela's Hyperinflation Sees Record Highs of Bitcoin Use",
          url: 'https://www.cryptocoinsnews.com/venezuelas-hyperinflation-sees-record-highs-bitcoin-use/',
          region: 'South America',
          start_year: 2016,
          impact: '',
          added: 'August, 11 2016 02:06:04',
          published: 'August, 10 2016 00:00:00',
          country: 'Venezuela',
          relevance: 3,
          pestle: '',
          source: 'CCN: Financial Bitcoin & Cryptocurrency News',
          title: 'Inflation in Venezuela is predicted to rise to 500 percent in 2016 and further next year.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'gasoline',
          insight: "Love of Fried Food Could Curb India's Crude Oil Imports",
          url: 'http://www.bloomberg.com/news/articles/2016-08-08/emerging-oil-giant-sees-a-deep-fried-path-to-lower-crude-imports?&cmpid%3D=socialflow-twitter-business',
          region: 'Southern Asia',
          start_year: '',
          impact: '',
          added: 'August, 10 2016 05:36:35',
          published: 'August, 08 2016 00:00:00',
          country: 'India',
          relevance: 2,
          pestle: 'Industries',
          source: 'Bloomberg Business',
          title: 'India in a decade could achieve 20 percent blending of ethanol in gasoline and as much as 10 percent of biodiesel in diesel.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Energy',
          topic: 'gas',
          insight: 'Junk Bond Default Rate Still Climbing',
          url: 'http://blogs.barrons.com/incomeinvesting/2016/08/09/junk-bond-default-rate-still-climbing/?mod=bol-social-tw',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'August, 10 2016 05:25:27',
          published: '',
          country: 'United States of America',
          relevance: 3,
          pestle: 'Industries',
          source: 'Fitch',
          title: 'Commodity sectors are expected to remain under stress with an overall default rate forecast of 10.0% for Metals & Mining and 7.2% for Oil & Gas for US issuers over the coming year.',
          likelihood: 4
        },
        {
          end_year: 2022,
          intensity: 10,
          sector: 'Energy',
          topic: 'energy',
          insight: "U.S. energy independence looks 'tantalizingly close'",
          url: 'http://money.cnn.com/2016/08/09/investing/us-energy-independence-oil-opec/index.html',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'August, 10 2016 02:52:39',
          published: 'August, 09 2016 00:00:00',
          country: 'United States of America',
          relevance: 5,
          pestle: 'Industries',
          source: 'CNNMoney',
          title: 'The EIA thinks the U.S. could achieve complete energy independence by 2022.',
          likelihood: 2
        },
        {
          end_year: 2020,
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: "U.S. energy independence looks 'tantalizingly close'",
          url: 'http://money.cnn.com/2016/08/09/investing/us-energy-independence-oil-opec/index.html',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'August, 10 2016 02:52:37',
          published: 'August, 09 2016 00:00:00',
          country: 'United States of America',
          relevance: 4,
          pestle: 'Industries',
          source: 'CNNMoney',
          title: 'By 2020, the U.S. will import just 11% of its daily oil needs.',
          likelihood: 4
        },
        {
          end_year: 2020,
          intensity: '',
          sector: '',
          topic: '',
          insight: "U.S. energy independence looks 'tantalizingly close'",
          url: 'http://money.cnn.com/2016/08/09/investing/us-energy-independence-oil-opec/index.html',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'August, 10 2016 02:52:36',
          published: 'August, 09 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: '',
          source: 'CNNMoney',
          title: 'The shale oil and gas revolution of the last couple of decades has made the improbable goal of American energy independence close to reality. Analysts at Raymond James recently predicted the U.S. will be tantalizingly close by 2020.',
          likelihood: ''
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Energy',
          topic: 'gas',
          insight: 'REmap: Roadmap for a Renewable Energy Future, 2016 Edition',
          url: 'http://www.irena.org/DocumentDownloads/Publications/IRENA_REmap_2016_edition_report.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 09 2016 10:12:12',
          published: 'March, 16 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Environmental',
          source: 'IRENA',
          title: 'Oil, gas, and coal prices are currently low and could remain so as renewables continue to grow.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'power',
          insight: 'REmap: Roadmap for a Renewable Energy Future, 2016 Edition',
          url: 'http://www.irena.org/DocumentDownloads/Publications/IRENA_REmap_2016_edition_report.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 09 2016 10:12:07',
          published: 'March, 16 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Political',
          source: 'IRENA',
          title: "The European Union's Nearly Zero-Emissions Buildings will include on-site solar power production.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 8,
          sector: 'Energy',
          topic: 'energy',
          insight: 'REmap: Roadmap for a Renewable Energy Future, 2016 Edition',
          url: 'http://www.irena.org/DocumentDownloads/Publications/IRENA_REmap_2016_edition_report.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 09 2016 10:11:59',
          published: 'March, 16 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'IRENA',
          title: 'Total renewable energy use (as primary energy) will increase by about 46% in REmap.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Energy',
          topic: 'production',
          insight: 'REmap: Roadmap for a Renewable Energy Future, 2016 Edition',
          url: 'http://www.irena.org/DocumentDownloads/Publications/IRENA_REmap_2016_edition_report.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 09 2016 10:11:57',
          published: 'March, 16 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Industries',
          source: 'IRENA',
          title: 'The production costs of biofuels are expected to decrease.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Energy',
          topic: 'energy',
          insight: 'REmap: Roadmap for a Renewable Energy Future, 2016 Edition',
          url: 'http://www.irena.org/DocumentDownloads/Publications/IRENA_REmap_2016_edition_report.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 09 2016 10:11:39',
          published: 'March, 16 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Technological',
          source: 'IRENA',
          title: 'New non-renewable energy technologies could be more costly.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Energy',
          topic: 'power',
          insight: 'REmap: Roadmap for a Renewable Energy Future, 2016 Edition',
          url: 'http://www.irena.org/DocumentDownloads/Publications/IRENA_REmap_2016_edition_report.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 09 2016 10:11:39',
          published: 'March, 16 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Political',
          source: 'IRENA',
          title: 'One can expect lower coal prices to pose little threat to the uptake of renewables in the power sector.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Energy',
          topic: 'power',
          insight: 'REmap: Roadmap for a Renewable Energy Future, 2016 Edition',
          url: 'http://www.irena.org/DocumentDownloads/Publications/IRENA_REmap_2016_edition_report.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 09 2016 10:11:35',
          published: 'March, 16 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Political',
          source: 'IRENA',
          title: 'Renewable power generation will have to increase still more.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 3,
          sector: '',
          topic: 'economy',
          insight: 'Is Banking Better in Bed?',
          url: 'http://www.bloomberg.com/news/articles/2016-08-04/is-banking-better-in-bed?&cmpid%3D=socialflow-twitter-business&cmpid=socialflow-twitter-businessweek',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 08 2016 11:03:26',
          published: 'August, 04 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Economic',
          source: 'Bloomberg Business',
          title: 'Efforts to stimulate the economy by making rates superlow or even negative are self-defeating because savers will become even thriftier to reach their nest egg targets.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: '',
          sector: 'Energy',
          topic: 'gas',
          insight: 'World Economic Outlook, April 2016; Special Feature: Commodity Market Developments and Forecasts, with a Focus on the Energy Transition in an Era of Low Fossil Fuel Prices',
          url: 'https://www.imf.org/external/pubs/ft/weo/2016/01/pdf/SF_Commod.pdf',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'August, 07 2016 05:16:56',
          published: 'April, 12 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'International Monetary Fund (IMF)',
          title: 'Natural gas consumption has increased steadily since the 1970s, now accounting for nearly 25 percent of global primary energy consumption. Global demand for natural gas is projected to increase strongly over the medium term.',
          likelihood: ''
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Energy',
          topic: 'oil',
          insight: 'World Economic Outlook, April 2016; Special Feature: Commodity Market Developments and Forecasts, with a Focus on the Energy Transition in an Era of Low Fossil Fuel Prices',
          url: 'https://www.imf.org/external/pubs/ft/weo/2016/01/pdf/SF_Commod.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 07 2016 05:16:56',
          published: 'April, 12 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Economic',
          source: 'International Monetary Fund (IMF)',
          title: 'The expansion of the middle class in emerging giants is expected to increase dramatically the demand for transport services and the level of car ownership and to support oil demand growth.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 3,
          sector: '',
          topic: '',
          insight: 'World Economic Outlook, April 2016; Special Feature: Commodity Market Developments and Forecasts, with a Focus on the Energy Transition in an Era of Low Fossil Fuel Prices',
          url: 'https://www.imf.org/external/pubs/ft/weo/2016/01/pdf/SF_Commod.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 07 2016 05:16:55',
          published: 'April, 12 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: '',
          source: 'International Monetary Fund (IMF)',
          title: 'Non-OPEC supply is expected to shrink for the first time in eight years.',
          likelihood: 3
        },
        {
          end_year: 2017,
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'World Economic Outlook, April 2016; Special Feature: Commodity Market Developments and Forecasts, with a Focus on the Energy Transition in an Era of Low Fossil Fuel Prices',
          url: 'https://www.imf.org/external/pubs/ft/weo/2016/01/pdf/SF_Commod.pdf',
          region: 'World',
          start_year: 2016,
          impact: '',
          added: 'August, 07 2016 05:16:55',
          published: 'April, 12 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'International Monetary Fund (IMF)',
          title: 'For the next year, world oil demand is expected to grow at the much slower pace of 1.2 mbd.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: '',
          topic: 'economy',
          insight: 'Background (Manufacturing)',
          url: 'http://www.investphilippines.info/arangkada/seven-winners/manufacturing-logistics/manufacturing/background-manufacturing/',
          region: 'South-Eastern Asia',
          start_year: '',
          impact: '',
          added: 'August, 07 2016 05:03:09',
          published: '',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'Arangkada Philippines',
          title: 'The Philippines will move towards becoming an economy of traders and smugglers rather than manufacturers.',
          likelihood: 3
        },
        {
          end_year: 2020,
          intensity: 16,
          sector: '',
          topic: 'information',
          insight: 'Telecom & IT Market Report Catalog',
          url: 'https://www.giiresearch.com/catalog/telecom.pdf',
          region: 'World',
          start_year: 2016,
          impact: '',
          added: 'August, 07 2016 04:50:40',
          published: 'July, 20 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'Global Information Inc',
          title: "Technavio's analysts forecast the global maritime information market to grow at a CAGR of 9.39% during the period 2016-2020.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 36,
          sector: 'Retail',
          topic: 'export',
          insight: 'Outlook for U.S. Agricultural Trade',
          url: 'http://www.ers.usda.gov/media/1893531/ag-trade-file.pdf',
          region: 'Northern America',
          start_year: '',
          impact: 3,
          added: 'August, 07 2016 04:30:29',
          published: 'August, 27 2015 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'USDA',
          title: 'Soybean export value is forecast to drop $3.2 billion to $18.1 billion while soybean meal is projected $1.0 billion lower at $4.0 billion. Soybean oil export value is also forecast to fall. Growing exports from South America are expected to hinder sales from the United States.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 48,
          sector: 'Energy',
          topic: 'export',
          insight: 'Outlook for U.S. Agricultural Trade',
          url: 'http://www.ers.usda.gov/media/1893531/ag-trade-file.pdf',
          region: 'Northern America',
          start_year: '',
          impact: 3,
          added: 'August, 07 2016 04:30:28',
          published: 'August, 27 2015 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'USDA',
          title: 'U.S. soybean export value is forecast to drop $3.2 billion to $18.1 billion while soybean meal is projected $1.0 billion lower at $4.0 billion. Soybean oil export value is also forecast to fall.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 3,
          sector: '',
          topic: '',
          insight: 'Outlook for U.S. Agricultural Trade',
          url: 'http://www.ers.usda.gov/media/1893531/ag-trade-file.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 07 2016 04:30:25',
          published: 'August, 27 2015 00:00:00',
          country: '',
          relevance: 1,
          pestle: '',
          source: 'USDA',
          title: 'The EU is expected to continue its slow recovery.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 16,
          sector: '',
          topic: 'debt',
          insight: 'Outlook for U.S. Agricultural Trade',
          url: 'http://www.ers.usda.gov/media/1893531/ag-trade-file.pdf',
          region: 'Eastern Asia',
          start_year: 2016,
          impact: '',
          added: 'August, 07 2016 04:30:24',
          published: 'August, 27 2015 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'USDA',
          title: 'The rest of South and Southeast Asia, excluding India and Japan, is expected to remain steady in 2015 and 2016 despite widespread medium-term concern about debt levels, inflation, and slowing demand from China.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Retail',
          topic: 'export',
          insight: 'Outlook for U.S. Agricultural Trade',
          url: 'http://www.ers.usda.gov/media/1893531/ag-trade-file.pdf',
          region: 'Eastern Asia',
          start_year: '',
          impact: '',
          added: 'August, 07 2016 04:30:24',
          published: 'August, 27 2015 00:00:00',
          country: 'Japan',
          relevance: 2,
          pestle: 'Economic',
          source: 'USDA',
          title: 'Japan is expected to avoid a recession as easing credit conditions have supported domestic demand and export expansion.',
          likelihood: 3
        },
        {
          end_year: 2026,
          intensity: 9,
          sector: '',
          topic: 'market',
          insight: '3D Printing Materials 2016-2026: Status, Opportunities, Market Forecasts',
          url: 'http://www.idtechex.com/research/reports/3d-printing-materials-2016-2026-status-opportunities-market-forecasts-000487.asp',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 07 2016 04:14:27',
          published: 'August, 01 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'ID TECH INDEX',
          title: '3D printing key materials are expected to have a total market of over $9B by 2026.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Government',
          topic: 'government',
          insight: "Turkey-Russia Rapprochement and Prospects for 'Turkish Stream'",
          url: 'http://www.jamestown.org/single/?tx_ttnews[tt_news]=45706&tx_ttnews[backPid]=381&cHash=fd8abfc89642690bcd59e3c732bdd5fc',
          region: 'Western Asia',
          start_year: '',
          impact: '',
          added: 'August, 07 2016 04:05:12',
          published: 'August, 02 2016 00:00:00',
          country: 'Turkey',
          relevance: 2,
          pestle: 'Political',
          source: 'The Jamestown Foundation',
          title: 'The state of emergency declared following the latest coup attempt in Turkey could enable the government in Ankara to legislate without going through the parliament.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 24,
          sector: '',
          topic: 'market',
          insight: 'Passamaquoddy Bay & LNG',
          url: 'http://www.savepassamaquoddybay.org/news_archives/2016/news_2016_08aug.html',
          region: '',
          start_year: '',
          impact: 3,
          added: 'August, 07 2016 03:59:41',
          published: '',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'savepassamaquoddybay',
          title: "Royal Dutch Shell's $54 billion purchase of BG Group could turn out to be a major loser if LNG markets remain depressed for years to come.",
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 12,
          sector: '',
          topic: 'gdp',
          insight: 'Economic Update',
          url: 'https://atradius.nl/documents/atradius_economic_research-economic_update_august_2016.pdf',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'August, 07 2016 02:57:44',
          published: 'July, 26 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'atradius',
          title: 'Latin American GDP is still forecast to contract 0.5% in 2016.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 4,
          sector: '',
          topic: '',
          insight: 'Economic Update',
          url: 'https://atradius.nl/documents/atradius_economic_research-economic_update_august_2016.pdf',
          region: 'Eastern Europe',
          start_year: '',
          impact: '',
          added: 'August, 07 2016 02:57:44',
          published: 'July, 26 2016 00:00:00',
          country: 'Russia',
          relevance: 1,
          pestle: '',
          source: 'atradius',
          title: 'The recession in Russia is now forecast to be slightly more mild (-0.9% now forecast for 2016 instead of - 1.2%).',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Battery Fuel for Electric Cars',
          url: 'http://dailyquiddity.blogspot.co.uk/2016/08/battery-fuel-for-electric-cars.html',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 07 2016 02:24:09',
          published: 'August, 02 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'dailyquiddity',
          title: 'An existing fuel-oil tank could be replaced by a bi-ION tank.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Intelligence Report Series',
          url: 'http://www.westpandi.com/globalassets/loss-prevention/mast-reports/mast-intelligence-report---03-august-2016.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 07 2016 02:21:06',
          published: 'August, 03 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Industries',
          source: 'westpandi',
          title: "Any foreign oil tankers approaching the Libyan coast will be attacked by the country's air force.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: '',
          topic: 'growth',
          insight: 'Bank of England Inflation Report August 2016',
          url: 'http://www.bankofengland.co.uk/publications/Documents/inflationreport/2016/aug.pdf',
          region: 'Northern Europe',
          start_year: '',
          impact: '',
          added: 'August, 07 2016 01:40:21',
          published: 'July, 29 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'bankofengland',
          title: 'UK household consumption growth is projected to slow gradually.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Electric Vehicle Battery Market to be Driven by Growing Concerns Regarding Environmental Pollution',
          url: 'http://vita.mil-embedded.com/news/electric-regarding-environmental-pollution/',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 06 2016 01:33:07',
          published: 'August, 03 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Technological',
          source: 'VITA Technologies',
          title: 'Stringent environmental regulations in the European Union and fluctuating crude oil prices will further encourage the demand for electric vehicle batteries.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Energy',
          topic: 'oil',
          insight: 'New catalyst is a step toward renewable plastics',
          url: 'http://www.futurity.org/catalyst-biodegradable-plastics-1218682-2/',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 06 2016 01:17:36',
          published: 'August, 04 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Environmental',
          source: 'Futurity',
          title: 'A new catalyst could make biodegradable plastics derived from renewable materials-promising alternatives to plastics made from oil.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: '',
          sector: 'Energy',
          topic: 'gas',
          insight: 'Cheap oil has killed nearly 200,000 U.S. jobs',
          url: 'http://money.cnn.com/2016/08/04/investing/200000-oil-jobs-lost/index.html',
          region: '',
          start_year: 2018,
          impact: '',
          added: 'August, 05 2016 06:10:03',
          published: 'August, 04 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'CNNMoney',
          title: 'Oil and gas needs to hire between 80,000 and 100,000 people by the end of 2018 just to keep up.',
          likelihood: ''
        },
        {
          end_year: '',
          intensity: 2,
          sector: '',
          topic: '',
          insight: 'States show they can sometimes stop earthquakes',
          url: 'http://phys.org/news/2016-08-states-earthquakes.html',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'August, 05 2016 05:05:24',
          published: 'August, 01 2016 00:00:00',
          country: 'United States of America',
          relevance: 1,
          pestle: '',
          source: 'Phys Org',
          title: 'About 7 million people in the Central and Eastern U.S. are at risk of man-made earthquakes powerful enough to crack walls.',
          likelihood: 2
        },
        {
          end_year: 2017,
          intensity: 8,
          sector: '',
          topic: '',
          insight: 'NEW$ & VIEW$ (4 August 2016)',
          url: 'http://www.bearnobull.com/2016/08/04/new-view-4-august-2016/',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'August, 05 2016 02:21:16',
          published: 'August, 04 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: '',
          source: 'Bearnobull',
          title: 'Brent crude, the international oil-price benchmark, will average $56 a barrel next year.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Support services',
          topic: 'business',
          insight: 'Can Nick Hurd deliver where others have failed and marry climate and industrial policy?',
          url: 'http://www.businessgreen.com/bg/blog-post/2466648/can-nick-hurd-deliver-where-others-have-failed-and-marry-climate-and-industrial-policy',
          region: 'Northern Europe',
          start_year: '',
          impact: '',
          added: 'August, 03 2016 03:50:08',
          published: 'August, 01 2016 00:00:00',
          country: 'United Kingdom',
          relevance: 2,
          pestle: 'Organization',
          source: 'Business Green',
          title: 'A properly integrated low carbon industrial strategy has to send a signal that the UK will not be indefinitely open for high carbon business.',
          likelihood: 3
        },
        {
          end_year: 2017,
          intensity: 16,
          sector: 'Security',
          topic: 'oil',
          insight: 'Uncertain times for remittances',
          url: 'http://country.eiu.com/article.aspx?articleid=1894460173&Country=India&topic=Economy&subtopic=Forecast&subsubtopic=External+sector',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 03 2016 03:48:23',
          published: 'August, 01 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'EIU',
          title: 'The Economist Intelligence Unit does not expect a marked recovery in oil prices before 2017 and investor confidence is likely to lag.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: "Thousands of Indian workers face 'food crisis' in Saudi Arabia",
          url: 'http://money.cnn.com/2016/08/01/news/india-saudi-arabia-workers-food/index.html',
          region: 'Western Asia',
          start_year: '',
          impact: '',
          added: 'August, 03 2016 01:49:30',
          published: 'August, 01 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'CNNMoney',
          title: "An ambitious plan to break Saudi Arabia's dependence on oil but that will not happen for years.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Oil Prices Slump Under $40 A Barrel',
          url: 'http://blogs.barrons.com/focusonfunds/2016/08/01/oil-prices-slump-under-40-a-barrel/?mod=bol-social-tw',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 03 2016 00:39:10',
          published: '',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'Fitch',
          title: 'Lots of profit taking could ensue in natural resources-related stocks as well as emerging-markets should oil prices sink well below $40.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Energy',
          topic: 'oil',
          insight: "The Stockholder's Dilemma: Dow Dips, Nasdaq Gains as Oil Gets Crushed, Data Disappoints",
          url: 'http://blogs.barrons.com/stockstowatchtoday/2016/08/01/the-stockholders-dilemma-dow-dips-nasdaq-gains-as-oil-gets-crushed-data-disappoints/?mod=bol-social-tw',
          region: '',
          start_year: '',
          impact: '',
          added: 'August, 03 2016 00:39:07',
          published: '',
          country: '',
          relevance: 1,
          pestle: 'Economic',
          source: 'Fitch',
          title: 'The recent slide in oil prices represents a potential risk as investors remain wary of another sharp downturn that could again act as a headwind for stock prices.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: "It's not so bad: oil recovery and unemployment decline",
          url: 'http://aboutbbos.com/news/market-reviews/oil-recovery-unemployment-decline/',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'August, 02 2016 02:19:09',
          published: 'March, 02 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'About Best Binary Options Strategy',
          title: 'The demand for commodities, in particular crude oil, base metals and gold will remain healthy in 2016.',
          likelihood: 4
        },
        {
          end_year: 2020,
          intensity: 8,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Leapfrogging to higher energy productivity in China',
          url: 'http://www.mckinsey.com/business-functions/sustainability-and-resource-productivity/our-insights/leapfrogging-to-higher-energy-productivity-in-china?cid=other-eml-cls-mip-mck-oth-1608',
          region: 'Eastern Asia',
          start_year: '',
          impact: '',
          added: 'August, 01 2016 22:09:00',
          published: 'July, 01 2007 00:00:00',
          country: 'China',
          relevance: 4,
          pestle: 'Environmental',
          source: 'McKinsey & Company',
          title: 'Lower energy demand would mean that China could cut its projected oil imports by up to 15 percent and its CO 2 emissions by at least 20 percent by 2020-while helping reduce other environmental costs.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 24,
          sector: 'Energy',
          topic: 'oil',
          insight: 'MENA Quarterly Economic Brief, July 2016: Whither Oil Prices?',
          url: 'http://www.worldbank.org/en/region/mena/publication/mena-quarterly-economic-brief-july-2016?CID=MENA_TT_MENA_EN_EXT',
          region: 'World',
          start_year: 2020,
          impact: '',
          added: 'August, 01 2016 01:26:56',
          published: '',
          country: '',
          relevance: 6,
          pestle: 'Economic',
          source: 'World Bank',
          title: 'The world oil market will work through its current oversupply and rebalance in early 2020 at market-clearing prices that will be in the range of $53 to $60 a barrel.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'oil',
          insight: '"Weathered" Gulf Oil May Threaten Development of Commercial Fish',
          url: 'http://insights.globalspec.com/article/2980/weathered-gulf-oil-may-threaten-development-of-commercial-fish?from_rss=1',
          region: 'Central America',
          start_year: '',
          impact: '',
          added: 'August, 01 2016 00:57:13',
          published: 'July, 29 2016 00:00:00',
          country: 'Mexico',
          relevance: 2,
          pestle: 'Environmental',
          source: 'IHS Engineering 360',
          title: 'Ultraviolet light is changing the structure of the oil spilled during the Deepwater Horizon (DWH) accident in the Gulf of Mexico into something more toxic, possibly further threatening commercially and ecologically important fishes.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: '',
          topic: 'growth',
          insight: 'Recommendation for a COUNCIL DECISION giving notice to Spain to take measures for the deficit reduction judged necessary in order to remedy the situation of excessive deficit',
          url: 'http://ec.europa.eu/economy_finance/economic_governance/sgp/pdf/30_edps/other_documents/2016-07-27_es_commission_swd_en.pdf',
          region: '',
          start_year: 2018,
          impact: '',
          added: 'July, 31 2016 05:53:09',
          published: 'July, 27 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'European Council',
          title: 'EU inflation is predicted to recover gradually over 2017 on the back of higher oil prices, and a slightly lower euro towards the dollar, with nominal GDP growth reaching 3.6% in 2017, 0.3 pps. less than expected in spring. Growth is projected to ease further in 2018 to 2.1%.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Recommendation for a COUNCIL DECISION giving notice to Spain to take measures for the deficit reduction judged necessary in order to remedy the situation of excessive deficit',
          url: 'http://ec.europa.eu/economy_finance/economic_governance/sgp/pdf/30_edps/other_documents/2016-07-27_es_commission_swd_en.pdf',
          region: 'Southern Europe',
          start_year: '',
          impact: '',
          added: 'July, 31 2016 05:53:09',
          published: 'July, 27 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'European Council',
          title: 'Inflation in Spain is predicted to recover gradually over 2017 on the back of higher oil prices.',
          likelihood: 3
        },
        {
          end_year: 2019,
          intensity: 3,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Royal Bank of Scotland: 2016 Will Be A "Cataclysmic Year" And "Investors Should Be Afraid"',
          url: 'http://www.activistpost.com/2016/01/royal-bank-of-scotland-2016-will-be-a-cataclysmic-year-and-investors-should-be-afraid.html',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'July, 31 2016 05:14:20',
          published: 'January, 13 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Industries',
          source: 'Activist Post',
          title: 'The price of oil is probably going to stay very low for years to come..',
          likelihood: 3
        },
        {
          end_year: 2030,
          intensity: 48,
          sector: 'Food & agriculture',
          topic: 'climate change',
          insight: 'Climate Change News - July 25, 2016',
          url: 'http://www.eesi.org/newsletters/view/climate-change-news-july-25-2016',
          region: 'World',
          start_year: '',
          impact: 4,
          added: 'July, 31 2016 02:35:13',
          published: 'July, 25 2016 00:00:00',
          country: '',
          relevance: 6,
          pestle: 'Environmental',
          source: 'Newsletter',
          title: 'Higher temperatures related to climate change could shrink global economic output by over $2 trillion by 2030.',
          likelihood: 2
        },
        {
          end_year: 2040,
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Draft Technical Assessment Report: Midterm Evaluation of Light-Duty Vehicle Greenhouse Gas Emission Standards and Corporate Average Fuel Economy Standards for Model Years 2022-2025 (EPA-420-D-16-900, July 2016)',
          url: 'https://www3.epa.gov/otaq/climate/documents/mte/420d16900.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 31 2016 01:10:51',
          published: 'July, 15 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'U.S. Environmental Protection Agency',
          title: "The Energy Information Administration's AEO 2015 projected a wide range of possible oil prices out to 2040.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 24,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Global Money Trends Magazine',
          url: 'http://globalmoneytrends.com/wp-content/uploads/2016/07/August-1-2016-GMT-Newsletter.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 31 2016 01:03:40',
          published: 'July, 29 2016 00:00:00',
          country: '',
          relevance: 6,
          pestle: 'Industries',
          source: 'Global Money Trends Magazine',
          title: 'Analysts for Goldman Sachs <GS> predicted crude oil prices would stay in the $45-to -$50 /barrel range till mid-2017.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Global Money Trends Magazine',
          url: 'http://globalmoneytrends.com/wp-content/uploads/2016/07/August-1-2016-GMT-Newsletter.pdf',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'July, 31 2016 01:03:39',
          published: 'July, 29 2016 00:00:00',
          country: 'United States of America',
          relevance: 2,
          pestle: 'Political',
          source: 'Global Money Trends Magazine',
          title: 'Production levels in the United States are going to begin to decline again because the oil debt crisis is about to explode.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 20,
          sector: 'Energy',
          topic: 'oil',
          insight: "Goldman says oil's rebalancing remains fragile amid macro headwinds",
          url: 'http://www.reuters.com/article/us-research-crude-goldman-idUSKCN1090F0?feedType=RSS&feedName=businessNews',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 30 2016 01:40:11',
          published: 'July, 29 2016 00:00:00',
          country: '',
          relevance: 5,
          pestle: 'Industries',
          source: 'Reuters',
          title: 'Oil prices will remain in a $45 a barrel to $50 a barrel trading range through mid-2017.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Energy',
          topic: 'gas',
          insight: 'US Demand for Solvents to Reach 9.6 Billion Pounds',
          url: 'http://www.prnewswire.com/news-releases/us-demand-for-solvents-to-reach-96-billion-pounds-300304950.html',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 29 2016 04:08:34',
          published: 'July, 28 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Industries',
          source: 'PR Newswire',
          title: 'Rising crude oil and natural gas prices will impact the competitiveness of conventional solvents.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Food & agriculture',
          topic: 'food',
          insight: 'US Demand for Solvents to Reach 9.6 Billion Pounds',
          url: 'http://www.prnewswire.com/news-releases/us-demand-for-solvents-to-reach-96-billion-pounds-300304950.html',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 29 2016 04:08:34',
          published: 'July, 28 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Industries',
          source: 'PR Newswire',
          title: 'Green solvent demand will outpace conventional solvent demand in food production, chemical processing, cosmetics and toiletries.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: '',
          topic: 'growth',
          insight: 'SAP forum readies Africa for digital economy',
          url: 'http://cajnewsafrica.com/2016/07/27/sap-forum-readies-africa-for-digital-economy/',
          region: 'Western Africa',
          start_year: '',
          impact: '',
          added: 'July, 28 2016 00:56:08',
          published: 'July, 27 2016 00:00:00',
          country: 'Ghana',
          relevance: 2,
          pestle: 'Economic',
          source: 'CAJ News Africa',
          title: "Ghana's real gross domestic product (GDP) growth is projected to rebound to 5,2 percent in 2016 from 3,4 in 2015.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 9,
          sector: 'Water',
          topic: 'water',
          insight: 'Worldwide Water and Wastewater Treatment Chemicals Consumption to Reach 6.2 Million Tons by end of 2016: Persistence Market Research',
          url: 'http://www.prnewswire.com/news-releases/worldwide-water-and-wastewater-treatment-chemicals-consumption-to-reach-62-million-tons-by-end-of-2016-persistence-market-research-588228542.html',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'July, 27 2016 00:37:58',
          published: 'July, 26 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'PR Newswire',
          title: 'Mining will remain the top 3 end-users in the global water and wastewater treatment chemicals market.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 20,
          sector: 'Energy',
          topic: 'gas',
          insight: 'Republicans Reveal an Anti-Urban, Anti-Public Transit Platform',
          url: 'http://www.planetizen.com/node/87530',
          region: 'World',
          start_year: 2017,
          impact: '',
          added: 'July, 26 2016 02:34:38',
          published: 'July, 21 2016 00:00:00',
          country: '',
          relevance: 5,
          pestle: 'Industries',
          source: 'Planetizen',
          title: 'Gas prices are projected to remain low until the EIA expects global oil inventory draws to begin in the third quarter of 2017.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Energy',
          topic: 'gas',
          insight: 'NIOSH Research Rounds',
          url: 'http://www.cdc.gov/niosh/research-rounds/resroundsv2n1.html#b',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 25 2016 05:17:40',
          published: 'July, 01 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Healthcare',
          source: 'CDC',
          title: 'Workers face a significant health risk from inhalation of RCS during hydraulic fracturing and other oil and gas extraction tasks.',
          likelihood: 2
        },
        {
          end_year: 2019,
          intensity: 3,
          sector: 'Energy',
          topic: 'gas',
          insight: 'Navigating the transformation of the gas market: Adapting to survive in a period of change',
          url: 'http://www.strategyand.pwc.com/reports/navigating-transformation-gas-market',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'July, 25 2016 01:17:34',
          published: 'July, 06 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Industries',
          source: 'Strategy & Formerly Booz & Company',
          title: 'Gas prices will be influenced by oil prices for several years.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Energy',
          topic: 'gas',
          insight: 'Navigating the transformation of the gas market: Adapting to survive in a period of change',
          url: 'http://www.strategyand.pwc.com/reports/navigating-transformation-gas-market',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 25 2016 01:17:33',
          published: 'July, 06 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'Strategy & Formerly Booz & Company',
          title: 'Natural gas use in transportation will balloon by more than 200 percent between 2014 and 2035.',
          likelihood: 4
        },
        {
          end_year: 2017,
          intensity: 4,
          sector: '',
          topic: '',
          insight: 'Most Global Oil Projects Seen Working Below $60 on Cost Cuts',
          url: 'http://www.bloomberg.com/news/articles/2016-07-13/bulk-of-global-oil-projects-seen-working-below-60-on-cost-cuts',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'July, 25 2016 00:49:17',
          published: 'July, 13 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: '',
          source: 'Bloomberg Business',
          title: 'Non-OPEC output will drop just 100,000 next year.',
          likelihood: 4
        },
        {
          end_year: 2025,
          intensity: 24,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Most Global Oil Projects Seen Working Below $60 on Cost Cuts',
          url: 'http://www.bloomberg.com/news/articles/2016-07-13/bulk-of-global-oil-projects-seen-working-below-60-on-cost-cuts',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'July, 25 2016 00:49:16',
          published: 'July, 13 2016 00:00:00',
          country: '',
          relevance: 6,
          pestle: 'Industries',
          source: 'Bloomberg Business',
          title: 'Oil explorers will be able to add 9 million barrels a day to global supply by 2025 with Brent crude under $60.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 12,
          sector: '',
          topic: '',
          insight: 'UK Economic Outlook',
          url: 'http://www.pwc.co.uk/assets/pdf/ukeo/ukeo-july-2016-summary-report.pdf',
          region: 'World',
          start_year: 2017,
          impact: '',
          added: 'July, 24 2016 05:23:54',
          published: 'July, 14 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: '',
          source: 'PriceWaterhouseCoopers',
          title: 'Global inflation is expected to pick up somewhat in 2017 as past commodity price decreases gradually fall out of 12-month inflation rate calculations.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Nigeria Economic Recession Imminent - IMF',
          url: 'http://naija-news.com/2016/07/20/nigeria-economic-recession-imminent-imf/',
          region: 'Western Africa',
          start_year: '',
          impact: '',
          added: 'July, 24 2016 05:14:46',
          published: 'July, 20 2016 00:00:00',
          country: 'Nigeria',
          relevance: 2,
          pestle: 'Economic',
          source: 'News.com',
          title: 'A combination of plunging oil revenues and weakened investor confidence will push Nigeria into recession.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 2,
          sector: '',
          topic: '',
          insight: "Fight or flight: America's choice in the Middle East",
          url: 'http://www.brookings.edu/blogs/markaz/posts/2016/02/16-americas-choice-in-middle-east-pollack',
          region: 'Northern Africa',
          start_year: '',
          impact: '',
          added: 'July, 24 2016 04:22:05',
          published: 'February, 16 2016 00:00:00',
          country: 'Egypt',
          relevance: 1,
          pestle: '',
          source: 'Brookings Institute',
          title: 'Stepping back from the Middle East means risking the near-term collapse of Egypt, Jordan, Lebanon.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 3,
          sector: '',
          topic: 'market',
          insight: 'InnovateUK Directory of Projects at Nuclear Innovation Showcase - Collaboration Nation 2016',
          url: 'https://nda.blog.gov.uk/wp-content/uploads/sites/165/2016/03/InnovateUK-Directory-of-Projects-at-Nuclear-Innovation-Showcase-Collaboration-Nation-2016.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 24 2016 03:12:32',
          published: 'March, 22 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Economic',
          source: 'Innovate UK',
          title: 'A single-window neutron detector with a conversion layer will be the first product to reach the market.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Aerospace & defence',
          topic: 'power',
          insight: 'InnovateUK Directory of Projects at Nuclear Innovation Showcase - Collaboration Nation 2016',
          url: 'https://nda.blog.gov.uk/wp-content/uploads/sites/165/2016/03/InnovateUK-Directory-of-Projects-at-Nuclear-Innovation-Showcase-Collaboration-Nation-2016.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 24 2016 03:12:32',
          published: 'March, 22 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Political',
          source: 'Innovate UK',
          title: 'A cost-effective and compact neutron sensor for use in harsh environments will become available to the nuclear industry (nuclear power plant monitoring and development, defence and the oil-well industries as well as the high energy and nuclear physics communities).',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Water',
          topic: 'water',
          insight: 'Wetland Breaking News',
          url: 'http://www.aswm.org/news/wetland-breaking-news/9462-wetland-breaking-news-june-2017',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 24 2016 02:23:26',
          published: '',
          country: '',
          relevance: 1,
          pestle: 'Environmental',
          source: 'aswm',
          title: 'Water-scarce California could have almost three times as much fresh groundwater as previously thought.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Aerospace & defence',
          topic: 'oil',
          insight: 'Past Imperfect, Future Tense: Iran’s Oil Industry Post-Sanctions',
          url: 'http://www.agsiw.org/wp-content/uploads/2016/05/Munro_Iran-PostSanctions_web.pdf',
          region: 'Southern Asia',
          start_year: '',
          impact: '',
          added: 'July, 24 2016 01:47:53',
          published: 'May, 26 2016 00:00:00',
          country: 'Iran',
          relevance: 2,
          pestle: 'Political',
          source: 'The Arab Gulf States Institute Washington',
          title: "Sustaining the enormous amount of political willpower that was garnered to achieve the landmark nuclear agreement will be challenging but critical for a resurgence of Iran's oil sector.",
          likelihood: 3
        },
        {
          end_year: 2021,
          intensity: 60,
          sector: '',
          topic: '',
          insight: 'Past Imperfect, Future Tense: Iran’s Oil Industry Post-Sanctions',
          url: 'http://www.agsiw.org/wp-content/uploads/2016/05/Munro_Iran-PostSanctions_web.pdf',
          region: 'Southern Asia',
          start_year: 2016,
          impact: 3,
          added: 'July, 24 2016 01:47:51',
          published: 'May, 26 2016 00:00:00',
          country: 'Iran',
          relevance: 5,
          pestle: '',
          source: 'The Arab Gulf States Institute Washington',
          title: 'Iran has projected it will need around $135 billion for the upstream sector in the sixth Five-Year Development Plan that runs from 2016-21.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 3,
          sector: '',
          topic: 'growth',
          insight: 'Government of Russia Playing Significant Role in Strengthening Domestic Manufacturing and Use of Reciprocating Compressors, finds TMR',
          url: 'http://embedded-computing.com/news/government-russia-compressors-finds-tmr/',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 23 2016 02:14:33',
          published: 'July, 22 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Economic',
          source: 'Embedded Computing Design',
          title: 'End users such as chemical, petrochemicals, industrial metallic tools, and metal processing are predicted to register mediocre growth over the course of the forecast period.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 48,
          sector: 'Financial services',
          topic: 'policy',
          insight: 'Green choices: policymakers, investors and consumers...',
          url: 'http://www.eea.europa.eu/signals/signals-2016/articles/green-choices-policy-makers-investors',
          region: '',
          start_year: '',
          impact: 3,
          added: 'July, 22 2016 05:14:38',
          published: 'June, 29 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'European Environment Agency',
          title: "Close to 20 % of the EU's Cohesion Policy funds (around EUR 70 billion over the period 2014-2020) is expected to support transport investments.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Libya: OPEC member plots big oil comeback',
          url: 'http://money.cnn.com/2016/07/20/investing/libya-oil-comeback-opec/index.html',
          region: 'Northern Africa',
          start_year: '',
          impact: '',
          added: 'July, 22 2016 01:32:33',
          published: 'July, 20 2016 00:00:00',
          country: 'Libya',
          relevance: 3,
          pestle: 'Political',
          source: 'CNNMoney',
          title: 'Libya could enter the ongoing OPEC price war with an advantage because its high-quality oil is easily refined and turned into products like gasoline.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'oil',
          insight: "America's biggest oil boom came under Obama",
          url: 'http://money.cnn.com/2016/07/21/investing/trump-energy-plan-obama-oil-boom/index.html',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'July, 22 2016 01:32:22',
          published: 'July, 21 2016 00:00:00',
          country: 'United States of America',
          relevance: 2,
          pestle: 'Industries',
          source: 'CNNMoney',
          title: 'U.S. oil production could double under Trump.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 15,
          sector: 'Energy',
          topic: 'oil',
          insight: "America's biggest oil boom came under Obama",
          url: 'http://money.cnn.com/2016/07/21/investing/trump-energy-plan-obama-oil-boom/index.html',
          region: 'Northern America',
          start_year: 2028,
          impact: '',
          added: 'July, 22 2016 01:32:22',
          published: 'July, 21 2016 00:00:00',
          country: 'United States of America',
          relevance: 5,
          pestle: 'Industries',
          source: 'CNNMoney',
          title: 'The EIA predicted the U.S. would achieve energy independence in 2028 if oil prices continue a modest and slow rise.',
          likelihood: 3
        },
        {
          end_year: 2019,
          intensity: '',
          sector: '',
          topic: 'market',
          insight: 'Anglo American and Commodity Market News July (wk3) 2016',
          url: 'http://briandcolwell.com/2016/07/anglo-american-and-commodity-market-news-july-wk3-2016/.html',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'July, 21 2016 02:55:11',
          published: 'July, 21 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'briandcolwell',
          title: 'Although copper lags behind the 2016 performances of oil and gold, it seems like the bottom was reached back in January, which is a good news. Moreover a copper market deficit is expected to emerge in the coming years.',
          likelihood: ''
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Support services',
          topic: 'administration',
          insight: 'I worked in the CIA under Bush. Obama is right to not say "radical Islam."',
          url: 'http://www.vox.com/2016/6/28/12046626/phrase-islamic-radicalism-meaningless-counterproductive',
          region: 'Western Asia',
          start_year: '',
          impact: '',
          added: 'July, 20 2016 04:32:51',
          published: 'June, 28 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Organization',
          source: 'Vox',
          title: 'Some expect future U.S. administrations to take a tougher approach toward Saudi Arabia on the question of radical religious ideology.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 12,
          sector: '',
          topic: 'gdp',
          insight: 'World Economic Outlook Update July 2016',
          url: 'http://www.imf.org/external/pubs/ft/weo/2016/update/02/index.htm?hootPostID=245b9e705fe59ab0f4cb86d05dc3e445',
          region: 'Western Africa',
          start_year: 2016,
          impact: '',
          added: 'July, 20 2016 01:46:54',
          published: 'July, 19 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'IMF',
          title: 'In Nigeria, economic activity is now projected to contract in 2016, as the economy adjusts to foreign currency shortages as a result of lower oil receipts, low power generation, and weak investor confidence. GDP is projected to remain flat in 2016.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'oil',
          insight: "Comparative SWOT & Strategy Focus - 2016-2020 - World's 7 Leading Construction Equipment Manufacturers - Caterpillar, Komatsu, Volvo, CNH, Hitachi, Sandvik, John Deere",
          url: 'http://www.prnewswire.com/news-releases/comparative-swot--strategy-focus---2016-2020---worlds-7-leading-construction-equipment-manufacturers---caterpillar-komatsu-volvo-cnh-hitachi-sandvik-john-deere-300301085.html',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'July, 20 2016 01:22:24',
          published: 'July, 19 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'PR Newswire',
          title: 'The global economy remains highly vulnerable to adverse shocks with market turbulence, oil price crash, weak commodity prices & continued geo-political conflict as key threats & risk factors.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Manufacturing',
          topic: 'factory',
          insight: 'US Manufacturing Posts Stronger Gains Than Forecast in June',
          url: 'http://www.industryweek.com/competitiveness/us-manufacturing-posts-stronger-gains-forecast-june',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 20 2016 00:42:39',
          published: 'July, 15 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Industries',
          source: 'Industry Week',
          title: 'Trimmer inventories and a pickup in household demand will underpin factory activity.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 9,
          sector: 'Energy',
          topic: 'oil',
          insight: 'US Strategy for a Post-Western World',
          url: 'http://www.atlanticcouncil.org/images/files/publication_pdfs/403/Envisioning2030_web.pdf.pdf',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'July, 19 2016 18:16:20',
          published: 'December, 07 2012 00:00:00',
          country: 'United States of America',
          relevance: 3,
          pestle: 'Economic',
          source: 'Atlantic Council ',
          title: 'Many analysts project a soft oil market with very low US and EU growth and slower growth in BRIC economies.',
          likelihood: 3
        },
        {
          end_year: 2035,
          intensity: 9,
          sector: '',
          topic: 'farm',
          insight: 'DCDC Strategic Trends Programme: Future Operating Environment 2035',
          url: 'https://www.gov.uk/government/uploads/system/uploads/attachment_data/file/484861/20151203-DCDC_FOE_35.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 19 2016 16:01:29',
          published: 'August, 10 2015 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Environmental',
          source: 'U.K. Ministry of Defense',
          title: 'There will be at least 100 times as many wind farms as there are today by 2035.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 9,
          sector: 'Energy',
          topic: 'gas',
          insight: 'DCDC Strategic Trends Programme: Future Operating Environment 2035',
          url: 'https://www.gov.uk/government/uploads/system/uploads/attachment_data/file/484861/20151203-DCDC_FOE_35.pdf',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'July, 19 2016 16:01:29',
          published: 'August, 10 2015 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'U.K. Ministry of Defense',
          title: 'Offshore energy supplies will expand by 2035 - offshore oil production is expected to be 48% of world supply and natural gas will see a 60% increase.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Retail',
          topic: 'export',
          insight: 'Brexit Impact on the US',
          url: 'http://futureinfocus.com/brexit-impact-on-the-us/',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'July, 19 2016 02:41:27',
          published: 'July, 01 2016 00:00:00',
          country: 'United States of America',
          relevance: 2,
          pestle: 'Economic',
          source: 'Future in Focus',
          title: 'The reduction of US exports will itself be an almost-certain consequence of Brexit.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 2,
          sector: '',
          topic: '',
          insight: 'The Huge Mistake Saudi Arabia And OPEC Are Making In Their Overly Optimistic 2017 Oil Outlook',
          url: 'http://seekingalpha.com/article/3988020-huge-mistake-saudi-arabia-opec-making-overly-optimistic-2017-oil-outlook?lift_email_rec=true',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 19 2016 01:31:49',
          published: 'July, 13 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: '',
          source: 'Seeking Alpha',
          title: "Shale producers could surprise once again to the upside and if that's how it works out the additional supply from OPEC could bring about an increase in supply that outpaces demand.",
          likelihood: 2
        },
        {
          end_year: 2017,
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'The Huge Mistake Saudi Arabia And OPEC Are Making In Their Overly Optimistic 2017 Oil Outlook',
          url: 'http://seekingalpha.com/article/3988020-huge-mistake-saudi-arabia-opec-making-overly-optimistic-2017-oil-outlook?lift_email_rec=true',
          region: 'Southern Asia',
          start_year: 2016,
          impact: '',
          added: 'July, 19 2016 01:31:49',
          published: 'July, 13 2016 00:00:00',
          country: 'India',
          relevance: 2,
          pestle: 'Industries',
          source: 'Seeking Alpha',
          title: "India's demand will carry oil next year.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'The Huge Mistake Saudi Arabia And OPEC Are Making In Their Overly Optimistic 2017 Oil Outlook',
          url: 'http://seekingalpha.com/article/3988020-huge-mistake-saudi-arabia-opec-making-overly-optimistic-2017-oil-outlook?lift_email_rec=true',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'July, 19 2016 01:31:49',
          published: 'July, 13 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'Seeking Alpha',
          title: 'Expectations are oil demand for 2017 will reach 95.3 million barrels per day.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'The Huge Mistake Saudi Arabia And OPEC Are Making In Their Overly Optimistic 2017 Oil Outlook',
          url: 'http://seekingalpha.com/article/3988020-huge-mistake-saudi-arabia-opec-making-overly-optimistic-2017-oil-outlook?lift_email_rec=true',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'July, 19 2016 01:31:49',
          published: 'July, 13 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'Seeking Alpha',
          title: 'In its most recent report OPEC said the surplus for oil will decline in 2017, driven primarily by an increase in demand and a drop in supply from the U.S., Norway and Mexico.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Media & entertainment',
          topic: 'technology',
          insight: 'Forward 2035',
          url: 'http://www.dst.defence.gov.au/sites/default/files/publications/documents/Forward-2035.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 18 2016 20:18:10',
          published: 'October, 29 2014 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Political',
          source: 'Australian Government Department of Defence',
          title: 'Technologies in communications and new forms of networking will enable citizens to coalesce and challenge governments and multi-billion dollar corporations.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Retail',
          topic: 'transport',
          insight: 'Forward 2035',
          url: 'http://www.dst.defence.gov.au/sites/default/files/publications/documents/Forward-2035.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 18 2016 20:18:02',
          published: 'October, 29 2014 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Industries',
          source: 'Australian Government Department of Defence',
          title: 'Trialled and/ or commercialised.19 Increased emphasis will be placed on "cleaner" forms of transport.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Energy',
          topic: 'energy',
          insight: 'Forward 2035',
          url: 'http://www.dst.defence.gov.au/sites/default/files/publications/documents/Forward-2035.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 18 2016 20:18:02',
          published: 'October, 29 2014 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Environmental',
          source: 'Australian Government Department of Defence',
          title: 'There will be an increased need to use non-energy resources sustainably.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'energy',
          insight: 'Forward 2035',
          url: 'http://www.dst.defence.gov.au/sites/default/files/publications/documents/Forward-2035.pdf',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'July, 18 2016 20:18:01',
          published: 'October, 29 2014 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'Australian Government Department of Defence',
          title: 'Greater global demand for energy will continue.',
          likelihood: 3
        },
        {
          end_year: 2017,
          intensity: 16,
          sector: 'Media & entertainment',
          topic: 'communication',
          insight: 'Investor Relations Must Get Up to Speed on Sustainability',
          url: 'http://sloanreview.mit.edu/article/investor-relations-are-getting-up-to-speed-on-sustainability/',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 18 2016 03:13:51',
          published: 'July, 12 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Social',
          source: 'MIT Sloan Management Review',
          title: 'By 2017, all European companies will have to comply with an EU Sustainability Disclosure mandate for sustainability communications.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 9,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Driving efficiency in logistics',
          url: 'https://www.scania.com/group/en/driving-efficiency-in-logistics/',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'July, 18 2016 01:16:16',
          published: '',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'Scania Group',
          title: 'Most global oil demand will come from the transport sector in non-OECD countries.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 3,
          sector: '',
          topic: 'storm',
          insight: 'Water Services Magazine',
          url: 'http://watercanada.net/wp-content/themes/water/services/magazine_dl.php?code=20160701&res=full',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 17 2016 06:01:10',
          published: 'June, 30 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Environmental',
          source: 'watercanada',
          title: 'Intense storms will become more frequent.',
          likelihood: 3
        },
        {
          end_year: 2040,
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Hooked! The Unyielding Grip of Fossil Fuels on Global Life',
          url: 'http://www.commondreams.org/views/2016/07/14/hooked-unyielding-grip-fossil-fuels-global-life',
          region: 'Eastern Asia',
          start_year: '',
          impact: '',
          added: 'July, 17 2016 04:16:17',
          published: 'July, 14 2016 00:00:00',
          country: 'China',
          relevance: 4,
          pestle: 'Industries',
          source: 'Common Dreams',
          title: 'Oil use is expected to grow in China by 57% between 2012 and 2040.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 3,
          sector: '',
          topic: '',
          insight: 'Hooked! The Unyielding Grip of Fossil Fuels on Global Life',
          url: 'http://www.commondreams.org/views/2016/07/14/hooked-unyielding-grip-fossil-fuels-global-life',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'July, 17 2016 04:16:16',
          published: 'July, 14 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: '',
          source: 'Common Dreams',
          title: 'Most of the increase in demand for petroleum-based fuels is expected to occur in the developing world.',
          likelihood: 3
        },
        {
          end_year: 2040,
          intensity: 12,
          sector: 'Environment',
          topic: 'greenhouse gas',
          insight: 'Hooked! The Unyielding Grip of Fossil Fuels on Global Life',
          url: 'http://www.commondreams.org/views/2016/07/14/hooked-unyielding-grip-fossil-fuels-global-life',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 17 2016 04:16:13',
          published: 'July, 14 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Environmental',
          source: 'Common Dreams',
          title: 'Greenhouse gas emissions are expected to rise by an estimated 34% between 2012 and 2040 (from 32.3 billion to 43.2 billion metric tons).',
          likelihood: 4
        },
        {
          end_year: 2040,
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Hooked! The Unyielding Grip of Fossil Fuels on Global Life',
          url: 'http://www.commondreams.org/views/2016/07/14/hooked-unyielding-grip-fossil-fuels-global-life',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 17 2016 04:16:11',
          published: 'July, 14 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'Common Dreams',
          title: 'Oil consumption is expected to increase by 34% from 90 million to 121 million barrels per day by 2040.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'energy',
          insight: 'Hooked! The Unyielding Grip of Fossil Fuels on Global Life',
          url: 'http://www.commondreams.org/views/2016/07/14/hooked-unyielding-grip-fossil-fuels-global-life',
          region: 'World',
          start_year: 2040,
          impact: '',
          added: 'July, 17 2016 04:16:10',
          published: 'July, 14 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'Common Dreams',
          title: 'In 2040, fossil fuels will still have a grip on a staggering 78% of the world energy market.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Ecological impacts of palm oil expansion in Indonesia',
          url: 'http://www.theicct.org/sites/default/files/publications/Indonesia-palm-oil-expansion_ICCT_july2016.pdf',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'July, 17 2016 03:21:33',
          published: 'July, 08 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'theicct',
          title: 'Palm oil is expected to grow as a global commodity.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'biofuel',
          insight: 'Ecological impacts of palm oil expansion in Indonesia',
          url: 'http://www.theicct.org/sites/default/files/publications/Indonesia-palm-oil-expansion_ICCT_july2016.pdf',
          region: 'South-Eastern Asia',
          start_year: '',
          impact: '',
          added: 'July, 17 2016 03:21:33',
          published: 'July, 08 2016 00:00:00',
          country: 'Indonesia',
          relevance: 2,
          pestle: 'Industries',
          source: 'theicct',
          title: "15% of Indonesia's road fuel demand could potentially be displaced by biofuel made from palm residues without negatively impacting sustainable plantation practices.",
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Ecological impacts of palm oil expansion in Indonesia',
          url: 'http://www.theicct.org/sites/default/files/publications/Indonesia-palm-oil-expansion_ICCT_july2016.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 17 2016 03:21:33',
          published: 'July, 08 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Industries',
          source: 'theicct',
          title: 'Planting oil palm on degraded sites could lead to net increases in landscape carbon in only 10 years.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Ecological impacts of palm oil expansion in Indonesia',
          url: 'http://www.theicct.org/sites/default/files/publications/Indonesia-palm-oil-expansion_ICCT_july2016.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 17 2016 03:21:32',
          published: 'July, 08 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Economic',
          source: 'theicct',
          title: 'Lakes are threatened by palm oil expansion.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Ecological impacts of palm oil expansion in Indonesia',
          url: 'http://www.theicct.org/sites/default/files/publications/Indonesia-palm-oil-expansion_ICCT_july2016.pdf',
          region: 'South-Eastern Asia',
          start_year: '',
          impact: '',
          added: 'July, 17 2016 03:21:19',
          published: 'July, 08 2016 00:00:00',
          country: 'Indonesia',
          relevance: 2,
          pestle: 'Industries',
          source: 'theicct',
          title: 'One-third of new oil palm plantations in Indonesia and Malaysia will be established on peat soils.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'energy',
          insight: 'Ecological impacts of palm oil expansion in Indonesia',
          url: 'http://www.theicct.org/sites/default/files/publications/Indonesia-palm-oil-expansion_ICCT_july2016.pdf',
          region: 'South-Eastern Asia',
          start_year: '',
          impact: '',
          added: 'July, 17 2016 03:21:18',
          published: 'July, 08 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Environmental',
          source: 'theicct',
          title: "Without a new vision for biofuel production, there is great risk that this part of Indonesia's renewable energy policy will increase rather than reduce Indonesian emissions.",
          likelihood: 2
        },
        {
          end_year: 2025,
          intensity: 20,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Ecological impacts of palm oil expansion in Indonesia',
          url: 'http://www.theicct.org/sites/default/files/publications/Indonesia-palm-oil-expansion_ICCT_july2016.pdf',
          region: 'South-Eastern Asia',
          start_year: '',
          impact: '',
          added: 'July, 17 2016 03:21:18',
          published: 'July, 08 2016 00:00:00',
          country: '',
          relevance: 5,
          pestle: 'Industries',
          source: 'theicct',
          title: 'Total harvested oil palm area in Indonesia grew from 4.1 million ha in 2006 to an estimated 8.9 million ha in 2015 and is projected to reach 17 million ha by 2025.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Ecological impacts of palm oil expansion in Indonesia',
          url: 'http://www.theicct.org/sites/default/files/publications/Indonesia-palm-oil-expansion_ICCT_july2016.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 17 2016 03:21:18',
          published: 'July, 08 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Industries',
          source: 'theicct',
          title: 'Policies that continue to promote growing for the use of palm and other oils in biofuel will thus likely exceed the capacity of the industry to expand sustainably.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Ecological impacts of palm oil expansion in Indonesia',
          url: 'http://www.theicct.org/sites/default/files/publications/Indonesia-palm-oil-expansion_ICCT_july2016.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 17 2016 03:21:18',
          published: 'July, 08 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Industries',
          source: 'theicct',
          title: 'New oil palm plantations sited on degraded or Imperata grasslands could realize significant carbon savings with low biodiversity impacts.',
          likelihood: 2
        },
        {
          end_year: 2019,
          intensity: 6,
          sector: 'Energy',
          topic: 'energy',
          insight: 'Inflation Report – July 2016',
          url: 'http://www.nbp.pl/en/publikacje/raport_inflacja/iraport_july2016.pdf',
          region: 'World',
          start_year: 2016,
          impact: '',
          added: 'July, 17 2016 02:44:19',
          published: 'July, 08 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'nbp',
          title: 'In the coming years the price of energy commodities in the global markets will remain at a moderate level.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 9,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Inflation Report – July 2016',
          url: 'http://www.nbp.pl/en/publikacje/raport_inflacja/iraport_july2016.pdf',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'July, 17 2016 02:44:18',
          published: 'July, 08 2016 00:00:00',
          country: 'United States of America',
          relevance: 3,
          pestle: 'Economic',
          source: 'nbp',
          title: 'Oil production growth in the OPEC countries will be largely offset by deepening declines in oil production in the United States.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Inflation Report – July 2016',
          url: 'http://www.nbp.pl/en/publikacje/raport_inflacja/iraport_july2016.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 17 2016 02:44:18',
          published: 'July, 08 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'nbp',
          title: 'In the absence of agreement as to the measures aimed at increasing oil prices, high oil production in the OPEC countries should be expected.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Inflation Report – July 2016',
          url: 'http://www.nbp.pl/en/publikacje/raport_inflacja/iraport_july2016.pdf',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'July, 17 2016 02:44:17',
          published: 'July, 08 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'nbp',
          title: 'Oil prices in the global markets are expected to stabilise.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 4,
          sector: '',
          topic: 'growth',
          insight: "Indonesia's top diesel buyer says biofuel rule unworkable",
          url: 'http://sustainability.thomsonreuters.com/2016/07/11/indonesias-top-diesel-buyer-says-biofuel-rule-unworkable/',
          region: 'South-Eastern Asia',
          start_year: '',
          impact: '',
          added: 'July, 17 2016 02:41:14',
          published: 'July, 11 2016 00:00:00',
          country: 'Indonesia',
          relevance: 2,
          pestle: 'Economic',
          source: 'Thomson Reuters ',
          title: "Less-than-expected growth in bio consumption by Indonesia's largest diesel buyer could weigh on palm prices as more supplies are diverted to the global market.",
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: '',
          topic: '',
          insight: 'PIRA Energy Market Recap for the Week Ending July 5, 2016',
          url: 'http://www.ssuchronicle.com/2016/07/06/pira-energy-market-recap-for-the-week-ending-july-5-2016/',
          region: 'South-Eastern Asia',
          start_year: '',
          impact: '',
          added: 'July, 17 2016 02:15:56',
          published: 'July, 06 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: '',
          source: 'University Chronicle',
          title: "Vietnam's oil product imports will rise further through next year with growing demand.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Energy',
          topic: 'oil',
          insight: 'PIRA Energy Market Recap for the Week Ending July 5, 2016',
          url: 'http://www.ssuchronicle.com/2016/07/06/pira-energy-market-recap-for-the-week-ending-july-5-2016/',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 17 2016 02:15:56',
          published: 'July, 06 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Industries',
          source: 'University Chronicle',
          title: 'The economic fallout of Brexit will only potentially delay the pace of oil price recovery and will not derail it.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'PIRA Energy Market Recap for the Week Ending July 5, 2016',
          url: 'http://www.ssuchronicle.com/2016/07/06/pira-energy-market-recap-for-the-week-ending-july-5-2016/',
          region: 'World',
          start_year: 2017,
          impact: '',
          added: 'July, 17 2016 02:15:55',
          published: 'July, 06 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Industries',
          source: 'University Chronicle',
          title: 'Oil prices will move higher as the global stock surplus falls substantively in 2H16 and 2017.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: '',
          sector: '',
          topic: '',
          insight: 'R2P Monitor',
          url: 'http://www.globalr2p.org/media/files/r2p_monitor_july2016_final.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 17 2016 01:51:31',
          published: 'July, 15 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: '',
          source: 'globalr2p',
          title: 'Conflicts have the potential to fracture Nigerian society.',
          likelihood: ''
        },
        {
          end_year: 2020,
          intensity: 12,
          sector: 'Information Technology',
          topic: 'robot',
          insight: '62 market research reports study robotics industry',
          url: 'http://robohub.org/62-market-research-reports-study-robotics-industry/',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'July, 16 2016 02:44:49',
          published: 'July, 11 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'Robothub',
          title: 'Forecasts the industrial robotics market in APAC to grow at a CAGR of 8.7% during the period 2016-2020 in the top 5 segments.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Retail',
          topic: 'consumer',
          insight: "Looking For Opportunity In The Heart of Brexit's Power Vacuum",
          url: 'http://www.digitalistmag.com/finance/2016/07/12/looking-for-opportunity-in-the-heart-of-brexits-power-vacuum-04315781',
          region: 'Europe',
          start_year: '',
          impact: '',
          added: 'July, 16 2016 02:24:46',
          published: 'July, 12 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Social',
          source: 'Digitalist Magazine',
          title: 'There is risk for an impact on the general consumer sentiment across Europe.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 2,
          sector: '',
          topic: '',
          insight: 'Daily Agenda: Bank of England Hold Rates as Pound Spikes',
          url: 'http://www.institutionalinvestor.com/article/3570381/banking-and-capital-marketsdaily-agenda/daily-agenda-bank-of-england-hold-rates-as-pound-spikes.html',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'July, 16 2016 01:28:37',
          published: 'July, 14 2016 00:00:00',
          country: 'United States of America',
          relevance: 1,
          pestle: '',
          source: 'Institutional Investor',
          title: 'Fed sees U.S. Brexit risks.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Hot Commodities: One Step Forward, Some Steps Back',
          url: 'https://www.lawfareblog.com/hot-commodities-one-step-forward-some-steps-back',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 16 2016 01:16:29',
          published: 'July, 13 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Industries',
          source: 'Lawfare',
          title: 'Rhetoric promoting the rise in American oil production and related decline in the relevance of Middle Eastern producers (and thus of geopolitical concerns) is misplaced-and in fact quite the opposite could be true.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Retail',
          topic: 'export',
          insight: 'Hot Commodities: One Step Forward, Some Steps Back',
          url: 'https://www.lawfareblog.com/hot-commodities-one-step-forward-some-steps-back',
          region: 'Northern Africa',
          start_year: '',
          impact: '',
          added: 'July, 16 2016 01:16:28',
          published: 'July, 13 2016 00:00:00',
          country: 'Libya',
          relevance: 2,
          pestle: 'Economic',
          source: 'Lawfare',
          title: "Libya anticipates it will resume oil exports from the Es Sider and Ras Lanuf oil ports (two of the country's largest) within a week.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Government',
          topic: 'government',
          insight: 'Oil, Greed, and Grievances in the Middle East and North Africa',
          url: 'https://www.newsecuritybeat.org/2016/07/oil-greed-grievances-middle-east-north-africa/',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 16 2016 01:12:21',
          published: 'July, 12 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Political',
          source: 'New Security Beat',
          title: 'Countries threatened by larger-scale insurgencies might want to consider giving regional groups some share in central government decision-making.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Futureseek Daily Link Review; 11 July 2016',
          url: 'https://futureseek.wordpress.com/2016/07/10/futureseek-daily-link-review-11-july-2016/',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 16 2016 00:57:46',
          published: 'July, 10 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Technological',
          source: 'Futureseek Link Digest',
          title: '20 times more sensitivity gravity sensor will transform oil discoveries.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Financial services',
          topic: 'investment',
          insight: 'In World Of $50 Oil, Shale Beats Deepwater',
          url: 'http://oilprice.com/Energy/Crude-Oil/In-World-Of-50-Oil-Shale-Beats-Deepwater.html',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'July, 15 2016 04:21:22',
          published: 'July, 13 2016 00:00:00',
          country: 'United States of America',
          relevance: 2,
          pestle: 'Economic',
          source: 'oilprice.com',
          title: 'In short, future investment dollars will increasingly find their way into U.S. shale at the expense of deepwater.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 8,
          sector: 'Environment',
          topic: 'gas',
          insight: '7 companies to watch in carbon capture and storage',
          url: 'https://www.greenbiz.com/article/companies-watch-carbon-capture-and-storage',
          region: 'Oceania',
          start_year: '',
          impact: '',
          added: 'July, 15 2016 03:52:55',
          published: 'July, 14 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Environmental',
          source: 'GreenBiz',
          title: 'Each year 3 to 4 million tons of naturally occurring carbon dioxide produced with the natural gas on Gorgon Island in Western Australia will be captured and injected into a deep sandstone formation around 1.5 miles beneath the island.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Press Release: Diverse Coalition Applauds Introduction of Carbon Capture Incentive Legislation in the U.S. Senate',
          url: 'http://www.betterenergy.org/NEORI-Intro-CCS-Leg-Senate-2016',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 14 2016 01:58:49',
          published: '',
          country: '',
          relevance: 1,
          pestle: 'Technological',
          source: 'betterenergy',
          title: "According to a recent U.S. Department of Energy study, an increased supply of CO2 could enable the EOR industry to produce an additional 21-63 billion barrels of oil with today's technology and store 10-20 billion tons of CO2, or up to four years' worth of national emissions.",
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 16,
          sector: '',
          topic: 'gdp',
          insight: 'Bank of Canada holds trend setting rate at 0.5%',
          url: 'http://www.repmag.ca/news/bank-of-canada-holds-trend-setting-rate-at-0-5-210397.aspx',
          region: 'Northern America',
          start_year: 2016,
          impact: '',
          added: 'July, 14 2016 01:33:13',
          published: 'July, 13 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'Real Estate Professional',
          title: 'Real GDP in Canada is expected to grow by 1.3% in 2016.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: "So much for the death of America's bull market. U.S. stocks zoomed to their first record high in more than a year on Monday.",
          url: 'http://money.cnn.com/2016/07/11/investing/stocks-record-high-dow-jones-sp-500/index.html',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'July, 13 2016 02:16:13',
          published: 'July, 11 2016 00:00:00',
          country: 'United States of America',
          relevance: 2,
          pestle: 'Industries',
          source: 'CNNMoney',
          title: 'Corporate profits are expected to shrink for the fourth-consecutive quarter as the one-two punch of cheap oil and the strong U.S. dollar continue to dent bottom lines.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: '',
          topic: 'material',
          insight: "China's engagement in Africa: From natural resources to human resources",
          url: 'http://www.brookings.edu/events/2016/07/13-china-africa-natural-human-resources',
          region: 'Eastern Asia',
          start_year: '',
          impact: '',
          added: 'July, 13 2016 02:06:12',
          published: 'July, 13 2016 00:00:00',
          country: 'China',
          relevance: 2,
          pestle: 'Industries',
          source: 'Brookings Institute',
          title: "China's appetite for raw materials will continue to diminish.",
          likelihood: 3
        },
        {
          end_year: 2017,
          intensity: 16,
          sector: '',
          topic: 'economy',
          insight: 'Structural Forces Weigh on Future U.S. Growth',
          url: 'http://www.imf.org/external/pubs/ft/survey/so/2016/CAR071216A.htm?hootPostID=2f029158f4f3b68339c4e76597056947',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'July, 13 2016 01:08:54',
          published: 'July, 12 2016 00:00:00',
          country: 'United States of America',
          relevance: 4,
          pestle: 'Economic',
          source: 'IMF',
          title: 'The U.S. economy is expected to bounce back to 2.5 percent by 2017.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Energy',
          topic: 'growth',
          insight: 'Sensors and Embedded Systems in the Internet of Things (IoT): Market Analysis and Forecasts 2016 - 2021',
          url: 'http://www.mindcommerce.com/sensors_and_embedded_systems_in_the_internet_of_things_(iot)_market_analysis_and_forecasts_2016__2021.php?platform=hootsuite',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 12 2016 02:31:47',
          published: 'July, 01 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Economic',
          source: 'Mind Commerce',
          title: 'Use of IoT and embedded system will be high in EMEA due to positive response to Industrial IoT and growth of embedded systems in electrical grids, automobile and healthcare.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Energy',
          topic: 'gas',
          insight: 'Low Power Wide Area Network Market Worth 24.46 Billion USD by 2021',
          url: 'http://finance.yahoo.com/news/low-power-wide-area-network-143000826.html',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 12 2016 02:04:30',
          published: 'July, 11 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Economic',
          source: 'Yahoo Finance',
          title: 'Among verticals, oil and gas will lead the LPWAN market with a wide range of organizations adopting LPWAN solutions in all regions.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 24,
          sector: 'Energy',
          topic: 'oil',
          insight: 'John Hofmeister and T. Boone Pickens Discuss Future of U.S. Energy',
          url: 'http://www.pickensplan.com/john-hofmeister-and-t-boone-pickens-discuss-future-of-u-s-energy/',
          region: 'World',
          start_year: 2016,
          impact: '',
          added: 'July, 12 2016 01:40:31',
          published: 'July, 08 2016 00:00:00',
          country: '',
          relevance: 6,
          pestle: 'Industries',
          source: 'Pickens Plan',
          title: 'World oil prices will be $80 per barrel by the end of 2016 and will be at or near $100 per barrel by the end of 2017.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Energy',
          topic: 'oil',
          insight: 'The State of World Fisheries and Aquaculture 2016',
          url: 'http://www.fao.org/3/a-i5555e.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 12 2016 01:13:23',
          published: 'July, 06 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Industries',
          source: 'FAO',
          title: 'Fish oil is expected to be increasingly processed for direct human use as it is considered beneficial for a wide range of biological functions.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Energy',
          topic: 'oil',
          insight: 'The State of World Fisheries and Aquaculture 2016',
          url: 'http://www.fao.org/3/a-i5555e.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 12 2016 01:13:22',
          published: 'July, 06 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Economic',
          source: 'FAO',
          title: 'Fishmeal and fish oil will be more frequently used as strategic ingredients to enhance growth at specific stages of fish production.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Energy',
          topic: 'oil',
          insight: 'The State of World Fisheries and Aquaculture 2016',
          url: 'http://www.fao.org/3/a-i5555e.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 12 2016 01:13:10',
          published: 'July, 06 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Environmental',
          source: 'FAO',
          title: 'The percentage of fishmeal and fish oil in compound feeds in aquaculture will continue its downward trend.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Manufacturing',
          topic: 'production',
          insight: 'The State of World Fisheries and Aquaculture 2016',
          url: 'http://www.fao.org/3/a-i5555e.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 12 2016 01:13:07',
          published: 'July, 06 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Environmental',
          source: 'FAO',
          title: 'Developing countries will maintain their key role in aquaculture production.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Energy',
          topic: 'oil',
          insight: 'The State of World Fisheries and Aquaculture 2016',
          url: 'http://www.fao.org/3/a-i5555e.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 12 2016 01:12:11',
          published: 'July, 06 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Industries',
          source: 'FAO',
          title: 'Long-term fish oil prices are not expected revert to lower levels.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Manufacturing',
          topic: 'production',
          insight: 'The State of World Fisheries and Aquaculture 2016',
          url: 'http://www.fao.org/3/a-i5555e.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 12 2016 01:12:11',
          published: 'July, 06 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Industries',
          source: 'FAO',
          title: 'Any increase in fishmeal production will need to come from recycling by-products.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: '',
          topic: 'Washington',
          insight: "Saudi Arabia's Quiet Revolution",
          url: 'https://rusi.org/publication/newsbrief/saudi-arabia%E2%80%99s-quiet-revolution',
          region: 'Western Asia',
          start_year: '',
          impact: '',
          added: 'July, 11 2016 03:16:04',
          published: 'July, 05 2016 00:00:00',
          country: 'Syria',
          relevance: 2,
          pestle: 'Political',
          source: 'RUSI',
          title: 'The fate of Syria will be decided by Moscow and Washington rather than by any of the other diplomatic players.',
          likelihood: 3
        },
        {
          end_year: 2020,
          intensity: 48,
          sector: 'Energy',
          topic: 'oil',
          insight: "Saudi Arabia's Quiet Revolution",
          url: 'https://rusi.org/publication/newsbrief/saudi-arabia%E2%80%99s-quiet-revolution',
          region: 'Western Asia',
          start_year: 2016,
          impact: 3,
          added: 'July, 11 2016 03:16:03',
          published: 'July, 05 2016 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'RUSI',
          title: 'In Saudi Arabia, non-oil revenue in the next four years is expected to rise from $43 billion to $141 billion.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Iraq: what happened to the oil after the war?',
          url: 'https://theconversation.com/iraq-what-happened-to-the-oil-after-the-war-62188',
          region: 'Western Asia',
          start_year: '',
          impact: '',
          added: 'July, 11 2016 02:27:10',
          published: 'July, 08 2016 00:00:00',
          country: 'Iraq',
          relevance: 2,
          pestle: 'Industries',
          source: 'The Conversation',
          title: 'Iraq could have become a beacon of oil industry privatisation.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: '',
          sector: '',
          topic: 'market',
          insight: 'Hydrocarbon Solvents Market Growth to 2021 Driven by Aliphatic and Paints & Coating Industry',
          url: 'http://www.prnewswire.com/news-releases/hydrocarbon-solvents-market-growth-to-2021-driven-by-aliphatic-and-paints--coating-industry-586001681.html',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 11 2016 02:17:13',
          published: 'July, 08 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Economic',
          source: 'PR Newswire',
          title: 'The hydrocarbon solvents market is forecast to grow at a CAGR of 2.23% during 2016.',
          likelihood: ''
        },
        {
          end_year: '',
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: "Oil's rebound is over, so expect a third-quarter slide: Barclays",
          url: 'http://www.cnbc.com/2016/07/08/oils-rebound-is-over-so-expect-a-third-quarter-slide-barclays.html?_source=twitter',
          region: '',
          start_year: 2017,
          impact: '',
          added: 'July, 11 2016 01:40:15',
          published: 'July, 10 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'CNBC ',
          title: 'Cohen thinks oil prices will go further down in the third quarter of this year before staging a rebound around the fourth quarter of 2017.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Financial services',
          topic: 'unemployment',
          insight: 'Euro Area At The Crossroads: No Time For Complacency',
          url: 'http://www.imf.org/external/pubs/ft/survey/so/2016/CAR070816A.htm?hootPostID=80985784c69193e65dbf320e05b9efe5',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 11 2016 01:32:19',
          published: 'July, 08 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Economic',
          source: 'IMF',
          title: 'In the Euro area, inflation remains too low, and weak investment, still high unemployment, and the aging of the population will continue to hurt productivity.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 9,
          sector: '',
          topic: 'economy',
          insight: 'The Global Cyber Game',
          url: 'http://static1.squarespace.com/static/570ce46bd51cd428a1ef3190/t/570fb2f3c2ea51967d3e72d9/1460646696585/The%20Global%20Cyber%20Game.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 10 2016 23:01:08',
          published: 'April, 22 2014 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'Hardin Tibbs',
          title: "'Information economy' is probably halfway through an S-shaped growth curve and will mature sometime between the 2020s and the 2040s.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'oil',
          insight: 'New haze fears as palm oil firms ditch Indonesia pact',
          url: 'http://sustainability.thomsonreuters.com/2016/07/05/new-haze-fears-as-palm-oil-firms-ditch-indonesia-pact/',
          region: 'South-Eastern Asia',
          start_year: '',
          impact: '',
          added: 'July, 10 2016 04:18:39',
          published: 'July, 05 2016 00:00:00',
          country: 'Indonesia',
          relevance: 2,
          pestle: 'Industries',
          source: 'Thomson Reuters ',
          title: 'Environmentalists have warned of greater risks of haze and forest fires in Southeast Asia after major palm oil firms ditched a landmark "zero deforestation" pact in Indonesia.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Palm oil regaining its competitiveness against soybean oil',
          url: 'http://www.theborneopost.com/2016/07/02/palm-oil-regaining-its-competitiveness-against-soybean-oil/',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'July, 10 2016 04:18:31',
          published: 'July, 01 2016 00:00:00',
          country: 'United States of America',
          relevance: 2,
          pestle: 'Industries',
          source: 'BorneoPost Online',
          title: 'The higher US dollar/ringgit rate improves CPO competitiveness against soybean oil (which is priced in US dollar) as CPO price (when translated to US dollar) will be lower.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Palm oil regaining its competitiveness against soybean oil',
          url: 'http://www.theborneopost.com/2016/07/02/palm-oil-regaining-its-competitiveness-against-soybean-oil/',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'July, 10 2016 04:18:31',
          published: 'July, 01 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'BorneoPost Online',
          title: 'Palm oil is regaining its competitiveness level against soybean oil and it will likely win global market share of vegetable oils going forward.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Environment',
          topic: 'pollution',
          insight: 'July 7, 2016',
          url: 'http://www.worldhealth.net/newsletter/20160707_NEWS/',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 10 2016 03:43:03',
          published: '',
          country: '',
          relevance: 1,
          pestle: 'Environmental',
          source: 'World Health',
          title: 'Levels of air pollution within European recommended levels have been linked to an increased risk of severe heart attack.',
          likelihood: 2
        },
        {
          end_year: 2025,
          intensity: 16,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Peak Oil Review - July 4 2016',
          url: 'http://www.resilience.org/stories/2016-07-04/peak-oil-review-july-4-2016',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'July, 10 2016 02:19:36',
          published: 'July, 04 2016 00:00:00',
          country: 'Canada',
          relevance: 4,
          pestle: 'Industries',
          source: 'Resilience',
          title: "Canada's oil sands production will grow by 42 percent to 3.4 million barrels per day by 2025.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 48,
          sector: 'Manufacturing',
          topic: 'car',
          insight: 'Peak Oil Review - July 4 2016',
          url: 'http://www.resilience.org/stories/2016-07-04/peak-oil-review-july-4-2016',
          region: 'Southern Asia',
          start_year: '',
          impact: 3,
          added: 'July, 10 2016 02:19:34',
          published: 'July, 04 2016 00:00:00',
          country: 'India',
          relevance: 4,
          pestle: 'Social',
          source: 'Resilience',
          title: "India's $13 billion pay increase for federal employees will boost car and motorcycle purchases.",
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Financial services',
          topic: 'money',
          insight: 'Peak Oil Review - July 4 2016',
          url: 'http://www.resilience.org/stories/2016-07-04/peak-oil-review-july-4-2016',
          region: 'Western Asia',
          start_year: '',
          impact: '',
          added: 'July, 10 2016 02:19:30',
          published: 'July, 04 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'Resilience',
          title: 'Investing large amounts of money in the volatile Middle East carries considerable political risk.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Environmental Peacebuilding Update',
          url: 'http://www.environmentalpeacebuilding.org/assets/NewsletterPDFArchive/EP-Update-Issue-65.pdf',
          region: 'Southern Asia',
          start_year: '',
          impact: '',
          added: 'July, 10 2016 02:09:53',
          published: 'July, 05 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Political',
          source: 'environmentalpeacebuilding',
          title: 'Iran and the Kurdistan Regional Government (KRG) have hammered out the technical details of a plan to build a pipeline that could transfer as much as 250,000 barrels a day of Kurdish oil to Iran.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 3,
          sector: '',
          topic: '',
          insight: 'Greener Earth News',
          url: 'http://www.greenerearthnews.com/index.php/2016/07/',
          region: 'South-Eastern Asia',
          start_year: '',
          impact: '',
          added: 'July, 10 2016 02:09:42',
          published: 'July, 09 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: '',
          source: 'greenerearthnews',
          title: 'The forests of Indonesia and Malaysia are projected to disappear completely in 20 years if deforestation is not curbed.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Greener Earth News',
          url: 'http://www.greenerearthnews.com/index.php/2016/07/',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 10 2016 02:09:42',
          published: 'July, 09 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Industries',
          source: 'greenerearthnews',
          title: 'Experts have pinpointed the destruction of Sumatran and Bornean rainforests in order to produce palm oil as one of the greatest threats to orangutan survival.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 12,
          sector: '',
          topic: '',
          insight: '3 rd Global Geologists Annual Meeting July 18-19, 2016 Brisbane, Australia',
          url: 'http://annualmeeting.conferenceseries.com/geologists/',
          region: 'Asia',
          start_year: 2020,
          impact: '',
          added: 'July, 10 2016 01:57:42',
          published: 'July, 11 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: '',
          source: 'conferenceseries',
          title: 'Iron ore consumption in Asia is expected to increase at a CAGR of 5.2% to reach 2.6 billion metric tons in 2020.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Energy',
          topic: 'gas',
          insight: 'Guide to NT Petroleum Environment Regulations 2016',
          url: 'https://nt.gov.au/__data/assets/pdf_file/0005/295907/guide-to-nt-petroleum-environment-regulations-2016.pdf',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 10 2016 01:55:59',
          published: 'July, 05 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Industries',
          source: 'Australian Government',
          title: 'Objective-based regulation is considered to be the most suitable form of regulation to manage the environmental risks associated with oil and gas activities.',
          likelihood: 2
        },
        {
          end_year: 2026,
          intensity: 4,
          sector: '',
          topic: '',
          insight: 'Lower methane emissions, kick your beef habit',
          url: 'http://www.dailytexanonline.com/2016/07/03/lower-methane-emissions-kick-your-beef-habit',
          region: 'Northern America',
          start_year: 2016,
          impact: '',
          added: 'July, 10 2016 01:44:40',
          published: 'July, 03 2016 00:00:00',
          country: 'United States of America',
          relevance: 1,
          pestle: '',
          source: 'dailytexanonline',
          title: 'U.S. beef consumption is forecasted to decrease by three percent over the next decade.',
          likelihood: 4
        },
        {
          end_year: 2021,
          intensity: 6,
          sector: 'Energy',
          topic: 'energy',
          insight: 'Strong Growth Ahead for Lithium Ion Battery Market',
          url: 'https://epsnews.com/2016/07/06/lithium-ion-battery-market/',
          region: 'World',
          start_year: 2016,
          impact: '',
          added: 'July, 10 2016 01:30:45',
          published: 'July, 06 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Economic',
          source: 'EPS News',
          title: 'Anticipated growth in global energy demand is expected to boost adoption of lithium-ion batteries over the course of next five years.',
          likelihood: 3
        },
        {
          end_year: 2020,
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Strong Growth Ahead for Lithium Ion Battery Market',
          url: 'https://epsnews.com/2016/07/06/lithium-ion-battery-market/',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 10 2016 01:30:44',
          published: 'July, 06 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'EPS News',
          title: 'Demand for energy is forecast to increase from 12,928.4 Million Ton Oil Equivalent (MTOE) in 2014 to 17,000 MTOE by 2020.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'oil',
          insight: 'How the Crude Oil Market Is Rebalancing',
          url: 'http://marketrealist.com/2016/07/crude-oil-market-rebalancing/',
          region: 'Western Africa',
          start_year: '',
          impact: '',
          added: 'July, 10 2016 01:26:37',
          published: 'July, 04 2016 00:00:00',
          country: 'Nigeria',
          relevance: 2,
          pestle: 'Industries',
          source: 'marketrealist',
          title: 'Fresh militant attacks in Nigeria will continue to impact oil prices.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'security',
          insight: 'India Is Cutting Oil Deals Worldwide',
          url: 'http://www.bloomberg.com/news/articles/2016-07-07/india-is-cutting-oil-deals-worldwide',
          region: 'Southern Asia',
          start_year: '',
          impact: '',
          added: 'July, 08 2016 03:55:38',
          published: 'July, 07 2016 00:00:00',
          country: 'India',
          relevance: 2,
          pestle: 'Political',
          source: 'Bloomberg Business',
          title: "Strong bilateral relations will ensure India's energy security for a long term.",
          likelihood: 3
        },
        {
          end_year: '',
          intensity: '',
          sector: 'Support services',
          topic: 'gas',
          insight: 'The Obama administration just made Arctic drilling hard to do - but not impossible',
          url: 'https://www.washingtonpost.com/news/energy-environment/wp/2016/07/07/the-obama-administration-just-made-arctic-drilling-hard-to-do-but-not-impossible/?postshare=8501467924405527&tid=ss_tw',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 08 2016 03:08:25',
          published: '',
          country: '',
          relevance: 1,
          pestle: 'Environmental',
          source: 'Washington Post',
          title: 'The Obama administration finalized rules that will require companies to have strict safety and environmental protection plans in place before they drill for oil or natural gas in the Arctic Ocean.',
          likelihood: ''
        },
        {
          end_year: 2035,
          intensity: 16,
          sector: 'Energy',
          topic: 'coal',
          insight: 'A Just Transition for U.S. Fossil Fuel Industry Workers',
          url: 'http://prospect.org/article/just-transition-us-fossil-fuel-industry-workers',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'July, 07 2016 02:48:41',
          published: 'July, 06 2016 00:00:00',
          country: 'United States of America',
          relevance: 4,
          pestle: 'Environmental',
          source: 'The American Prospect',
          title: 'By 2035, U.S. coal consumption will need to fall by 60 percent.',
          likelihood: 4
        },
        {
          end_year: '',
          intensity: 9,
          sector: 'Retail',
          topic: 'energy',
          insight: 'ExxonMobil Investigated over Questionable Oil Deal in Nigeria',
          url: 'https://face2faceafrica.com/article/exxonmobil-investigated-over-questionable-oil-deal-in-nigeria',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'July, 07 2016 02:34:44',
          published: 'June, 24 2016 00:00:00',
          country: 'United States of America',
          relevance: 3,
          pestle: 'Political',
          source: 'Face2face Africa',
          title: 'The US Securities and Exchange Commission is expected to make a ruling on the Dodd-Frank Wall Street Reform and Consumer Protection Act that requires all energy companies to disclose the specific payments they make to foreign governments for mining and drilling rights.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Environment',
          topic: 'energy',
          insight: "McKinsey: Cars, petrochemicals in oil-market 'tug of war'",
          url: 'http://www.ogj.com/articles/2016/07/mckinsey-cars-petrochemicals-in-oil-market-tug-of-war.html',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 07 2016 02:27:55',
          published: 'June, 07 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Economic',
          source: 'Oil and Gas Journal',
          title: 'Carbon dioxide emissions related to energy will flatten and start to subside about 2035 as efficiency of combustion engines improves.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 6,
          sector: 'Energy',
          topic: 'energy',
          insight: "McKinsey: Cars, petrochemicals in oil-market 'tug of war'",
          url: 'http://www.ogj.com/articles/2016/07/mckinsey-cars-petrochemicals-in-oil-market-tug-of-war.html',
          region: 'Europe',
          start_year: '',
          impact: '',
          added: 'July, 07 2016 02:27:51',
          published: 'June, 07 2016 00:00:00',
          country: '',
          relevance: 2,
          pestle: 'Industries',
          source: 'Oil and Gas Journal',
          title: 'Energy demand will grow in emerging and developing countries and decline in Europe and North America.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Manufacturing',
          topic: 'war',
          insight: "McKinsey: Cars, petrochemicals in oil-market 'tug of war'",
          url: 'http://www.ogj.com/articles/2016/07/mckinsey-cars-petrochemicals-in-oil-market-tug-of-war.html',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 07 2016 02:27:51',
          published: 'June, 07 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Political',
          source: 'Oil and Gas Journal',
          title: 'Demand for liquid hydrocarbons will become a tug of war between growth the petrochemical sector and declining demand from passenger cars.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'gas',
          insight: 'India needs to shore up the share of natural gas in its energy portfolio',
          url: 'http://www.vccircle.com/infracircle/india-needs-shore-share-natural-gas-energy-portfolio/',
          region: 'Southern Asia',
          start_year: '',
          impact: '',
          added: 'July, 07 2016 02:27:42',
          published: 'July, 06 2016 00:00:00',
          country: 'India',
          relevance: 2,
          pestle: 'Industries',
          source: 'Infracircle',
          title: 'A well-diversified fuel basket for India could perforce imply much higher contributions of natural gas.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Energy',
          topic: 'fracking',
          insight: 'Thanks to Fracking U.S. Has More Reserves Than Russia and Saudi Arabia',
          url: 'https://www.uschamber.com/above-the-fold/thanks-fracking-us-has-more-reserves-russia-and-saudi-arabia?&sf30328543=1',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 07 2016 01:39:05',
          published: 'July, 05 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Political',
          source: 'uschamber',
          title: "Fracking's importance will not be going away anytime soon.",
          likelihood: 3
        },
        {
          end_year: 2017,
          intensity: 3,
          sector: '',
          topic: '',
          insight: "Italy's Eni says drilling off Cyprus to start next year",
          url: 'http://www.energynewscyprus.com/italys-eni-says-drilling-off-cyprus-to-start-next-year-3/',
          region: 'Western Asia',
          start_year: '',
          impact: '',
          added: 'July, 07 2016 00:50:44',
          published: 'July, 07 2016 00:00:00',
          country: 'Cyprus',
          relevance: 1,
          pestle: '',
          source: 'energy news cyprus',
          title: 'Exploratory drilling off Cyprus southern shore will begin next year.',
          likelihood: 3
        },
        {
          end_year: 2025,
          intensity: 12,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Is peak oil demand in sight?',
          url: 'http://www.mckinsey.com/industries/oil-and-gas/our-insights/Is-peak-oil-demand-in-sight?cid=other-eml-alt-mip-mck-oth-1607',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 06 2016 17:13:58',
          published: 'June, 01 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Economic',
          source: 'McKinsey & Company',
          title: 'Oil demand growth will flatten to 0.4 percent by 2025.',
          likelihood: 4
        },
        {
          end_year: 2036,
          intensity: 18,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Seaways turns elsewhere for submersible support',
          url: 'http://www.imeche.org/news/news-article/seaways-turns-elsewhere-for-submersible-support',
          region: '',
          start_year: 2016,
          impact: 3,
          added: 'July, 06 2016 04:00:02',
          published: 'July, 04 2016 00:00:00',
          country: '',
          relevance: 3,
          pestle: 'Industries',
          source: 'Imeche',
          title: 'Decommissioning more than 400 oil platforms in the North Sea could cost up to £70 billion over the next 20 years.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 2,
          sector: '',
          topic: '',
          insight: 'Our Planet: The Environmental Dimension of the 2030 Agenda',
          url: 'http://apps.unep.org/publications/index.php?option=com_pub&task=download&file=012101_en',
          region: 'Central America',
          start_year: '',
          impact: '',
          added: 'July, 06 2016 03:51:54',
          published: 'May, 13 2016 00:00:00',
          country: 'Belize',
          relevance: 1,
          pestle: '',
          source: 'UNEP',
          title: 'The Belize barrier reef is under threat from overfishing.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 2,
          sector: '',
          topic: '',
          insight: 'Our Planet: The Environmental Dimension of the 2030 Agenda',
          url: 'http://apps.unep.org/publications/index.php?option=com_pub&task=download&file=012101_en',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'July, 06 2016 03:51:53',
          published: 'May, 13 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: '',
          source: 'UNEP',
          title: 'Almost half of all natural World Heritage sites are threatened by harmful industrial activities and operations.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Energy',
          topic: 'oil',
          insight: "Britain's Plummeting Pound Is Bad News for America",
          url: 'http://foreignpolicy.com/2016/07/05/britains-plummeting-pound-is-bad-news-for-america/',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 06 2016 01:54:35',
          published: 'July, 05 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Industries',
          source: 'Foreign Policy',
          title: 'The continued fallout from Brexit could keep oil prices lower for longer.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 4,
          sector: 'Energy',
          topic: 'oil',
          insight: 'U.S. has more untapped oil than Saudi Arabia or Russia',
          url: 'http://money.cnn.com/2016/07/05/investing/us-untapped-oil/index.html',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'July, 06 2016 01:26:08',
          published: 'July, 05 2016 00:00:00',
          country: 'United States of America',
          relevance: 2,
          pestle: 'Industries',
          source: 'CNNMoney',
          title: 'The U.S. could shoulder even more of the weight of global oil production in the future.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: '',
          sector: 'Energy',
          topic: 'oil',
          insight: "Nomura's Kwan Sees Big Data Among Game Changers in Oil, Gas Industry",
          url: 'http://www.rigzone.com/news/oil_gas/a/145268/Nomuras_Kwan_Sees_Big_Data_Among_Game_Changers_in_Oil_Gas_Industry/?all=HG2',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'July, 05 2016 02:16:13',
          published: 'June, 28 2016 00:00:00',
          country: '',
          relevance: 5,
          pestle: 'Environmental',
          source: 'Rigzone',
          title: 'Exploration in deepwater and ultra-deepwater is not expected anytime soon despite signs that oil prices could reach $70 per barrel by end of 2016.',
          likelihood: ''
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Energy',
          topic: 'gas',
          insight: "Nomura's Kwan Sees Big Data Among Game Changers in Oil, Gas Industry",
          url: 'http://www.rigzone.com/news/oil_gas/a/145268/Nomuras_Kwan_Sees_Big_Data_Among_Game_Changers_in_Oil_Gas_Industry/?all=HG2',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 05 2016 02:16:13',
          published: 'June, 28 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Social',
          source: 'Rigzone',
          title: 'Robots are being deployed in refineries and natural gas pipelines to investigate problems, toxic spills, oil spills or managing risk in hazardous areas.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 2,
          sector: '',
          topic: '',
          insight: 'Biogas buses are the green solution for cities',
          url: 'http://euinmyregion.blogactiv.eu/2016/07/04/biogas-buses-are-the-green-solution-for-cities/',
          region: 'Eastern Europe',
          start_year: '',
          impact: '',
          added: 'July, 05 2016 00:55:08',
          published: 'July, 04 2016 00:00:00',
          country: 'Poland',
          relevance: 1,
          pestle: '',
          source: 'Europe in My Region',
          title: 'Combustion of methane in buses could significantly improve air quality (especially in Poland).',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Supergelators Could Make for More Effective Oil Spill Cleanup',
          url: 'http://insights.globalspec.com/article/2880/supergelators-could-make-for-more-effective-oil-spill-cleanup?from_rss=1',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 04 2016 02:06:29',
          published: 'June, 30 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Environmental',
          source: 'IHS Engineering 360',
          title: 'Newly developed supergelators could help clean oil spills more efficiently and avoid the secondary pollution associated with some alternative cleanup methods.',
          likelihood: 2
        },
        {
          end_year: '',
          intensity: 3,
          sector: 'Energy',
          topic: 'oil',
          insight: 'Advances in energy-storage technology, burgeoning electric car market driving lithium and graphite uptake',
          url: 'http://www.engineeringnews.co.za/article/advances-in-energy-storage-technology-burgeoning-electric-car-market-driving-lithium-and-graphite-uptake-2016-07-01',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 04 2016 01:36:39',
          published: 'July, 01 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Economic',
          source: 'Engineering News',
          title: 'The low price of oil is leading to questions about the projected high demand for EV sales.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 2,
          sector: 'Financial services',
          topic: 'oil',
          insight: 'Global oil demand to slow in 2016: IEA',
          url: 'http://www.cnbc.com/2015/07/10/global-oil-demand-to-slow-in-2016-iea.html',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 03 2016 06:00:29',
          published: 'July, 10 2015 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Economic',
          source: 'CNBC ',
          title: 'A possible Greek exit from European Monetary Union (euro zone) could dampen not only Greek oil product demand, but also potentially curb deliveries across the continent if macro-economic activity were to weaken.',
          likelihood: 2
        },
        {
          end_year: 2016,
          intensity: '',
          sector: 'Manufacturing',
          topic: 'growth',
          insight: 'IEA Says Oil Prices May Fall Even Further Before Supply Fades in 2016',
          url: 'http://www.bloomberg.com/news/articles/2015-07-10/iea-says-oil-price-may-fall-further-before-supply-fades-in-2016',
          region: 'Northern America',
          start_year: '',
          impact: '',
          added: 'July, 03 2016 06:00:25',
          published: 'July, 10 2015 00:00:00',
          country: 'United States of America',
          relevance: 4,
          pestle: 'Economic',
          source: 'Bloomberg Business',
          title: 'U.S. production growth will slow to 300,000 barrels day next year from 900,000 a day in 2015.',
          likelihood: ''
        },
        {
          end_year: '',
          intensity: 16,
          sector: '',
          topic: 'growth',
          insight: 'IEA Says Oil Prices May Fall Even Further Before Supply Fades in 2016',
          url: 'http://www.bloomberg.com/news/articles/2015-07-10/iea-says-oil-price-may-fall-further-before-supply-fades-in-2016',
          region: '',
          start_year: 2016,
          impact: '',
          added: 'July, 03 2016 06:00:25',
          published: 'July, 10 2015 00:00:00',
          country: '',
          relevance: 4,
          pestle: 'Economic',
          source: 'Bloomberg Business',
          title: 'Non-OPEC supply growth is expected to grind to a halt in 2016.',
          likelihood: 4
        },
        {
          end_year: 2016,
          intensity: 3,
          sector: 'Retail',
          topic: 'export',
          insight: 'IEA Says Oil Prices May Fall Even Further Before Supply Fades in 2016',
          url: 'http://www.bloomberg.com/news/articles/2015-07-10/iea-says-oil-price-may-fall-further-before-supply-fades-in-2016',
          region: '',
          start_year: '',
          impact: '',
          added: 'July, 03 2016 06:00:23',
          published: 'July, 10 2015 00:00:00',
          country: '',
          relevance: 1,
          pestle: 'Economic',
          source: 'Bloomberg Business',
          title: 'There will be no overall production growth outside the Organization of Petroleum Exporting Countries next year for the first time since 2008.',
          likelihood: 3
        },
        {
          end_year: '',
          intensity: 2,
          sector: '',
          topic: '',
          insight: 'Greenhouse gas',
          url: 'https://en.wikipedia.org/wiki/Greenhouse_gas',
          region: 'World',
          start_year: '',
          impact: '',
          added: 'July, 03 2016 05:28:48',
          published: 'July, 03 2016 00:00:00',
          country: '',
          relevance: 1,
          pestle: '',
          source: 'Wikipedia',
          title: "Earth's surface temperature could exceed historical values as early as 2047.",
          likelihood: 2
        }
      ]
    }
  }

  render () {
    return (
      <MDBDataTable data={this.data} className='table' />
    )
  }
}

export default SearchTable
